// Real JEE cutoff data from official sources
// Total: 121 colleges, 827 branches with 5-year trends (2020-2024)
export const colleges = [
  {
    "id": 1,
    "name": "Assam University, Silchar",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Agricultural Engineering",
        "code": "AE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 233102,
              "ews": 40384,
              "obc": 109630,
              "sc": 25710,
              "st": 7509
            },
            "2023": {
              "general": 228439,
              "ews": 39576,
              "obc": 107437,
              "sc": 25195,
              "st": 7358
            },
            "2022": {
              "general": 223777,
              "ews": 38768,
              "obc": 105244,
              "sc": 24681,
              "st": 7208
            },
            "2021": {
              "general": 219115,
              "ews": 37960,
              "obc": 103052,
              "sc": 24167,
              "st": 7058
            },
            "2020": {
              "general": 214453,
              "ews": 37153,
              "obc": 100859,
              "sc": 23653,
              "st": 6908
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 96305,
              "ews": 20014,
              "obc": 54011,
              "sc": 16105,
              "st": 4500
            },
            "2023": {
              "general": 94378,
              "ews": 19613,
              "obc": 52930,
              "sc": 15782,
              "st": 4410
            },
            "2022": {
              "general": 92452,
              "ews": 19213,
              "obc": 51850,
              "sc": 15460,
              "st": 4320
            },
            "2021": {
              "general": 90526,
              "ews": 18813,
              "obc": 50770,
              "sc": 15138,
              "st": 4230
            },
            "2020": {
              "general": 88600,
              "ews": 18412,
              "obc": 49690,
              "sc": 14816,
              "st": 4140
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 123822,
              "ews": 24543,
              "obc": 68473,
              "sc": 19772,
              "st": 6665
            },
            "2023": {
              "general": 121345,
              "ews": 24052,
              "obc": 67103,
              "sc": 19376,
              "st": 6531
            },
            "2022": {
              "general": 118869,
              "ews": 23561,
              "obc": 65734,
              "sc": 18981,
              "st": 6398
            },
            "2021": {
              "general": 116392,
              "ews": 23070,
              "obc": 64364,
              "sc": 18585,
              "st": 6265
            },
            "2020": {
              "general": 113916,
              "ews": 22579,
              "obc": 62995,
              "sc": 18190,
              "st": 6131
            }
          }
        },
        "fees": 150000,
        "seats": 61
      }
    ]
  },
  {
    "id": 2,
    "name": "Atal Bihari Vajpayee Indian Institute of Information Technology & Management Gwalior",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 7511,
              "ews": 1216,
              "obc": 3314,
              "sc": 2195,
              "st": 1216
            },
            "2023": {
              "general": 7360,
              "ews": 1191,
              "obc": 3247,
              "sc": 2151,
              "st": 1191
            },
            "2022": {
              "general": 7210,
              "ews": 1167,
              "obc": 3181,
              "sc": 2107,
              "st": 1167
            },
            "2021": {
              "general": 7060,
              "ews": 1143,
              "obc": 3115,
              "sc": 2063,
              "st": 1143
            },
            "2020": {
              "general": 6910,
              "ews": 1118,
              "obc": 3048,
              "sc": 2019,
              "st": 1118
            }
          }
        },
        "fees": 150000,
        "seats": 62
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 16203,
              "ews": 2803,
              "obc": 6543,
              "sc": 4700,
              "st": 1671
            },
            "2023": {
              "general": 15878,
              "ews": 2746,
              "obc": 6412,
              "sc": 4606,
              "st": 1637
            },
            "2022": {
              "general": 15554,
              "ews": 2690,
              "obc": 6281,
              "sc": 4512,
              "st": 1604
            },
            "2021": {
              "general": 15230,
              "ews": 2634,
              "obc": 6150,
              "sc": 4418,
              "st": 1570
            },
            "2020": {
              "general": 14906,
              "ews": 2578,
              "obc": 6019,
              "sc": 4324,
              "st": 1537
            }
          }
        },
        "fees": 150000,
        "seats": 62
      },
      {
        "name": "Integrated B. Tech.",
        "code": "IBT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 15788,
              "ews": 2568,
              "obc": 7224,
              "sc": 4683,
              "st": 2526
            },
            "2023": {
              "general": 15472,
              "ews": 2516,
              "obc": 7079,
              "sc": 4589,
              "st": 2475
            },
            "2022": {
              "general": 15156,
              "ews": 2465,
              "obc": 6935,
              "sc": 4495,
              "st": 2424
            },
            "2021": {
              "general": 14840,
              "ews": 2413,
              "obc": 6790,
              "sc": 4402,
              "st": 2374
            },
            "2020": {
              "general": 14524,
              "ews": 2362,
              "obc": 6646,
              "sc": 4308,
              "st": 2323
            }
          }
        },
        "fees": 150000,
        "seats": 62
      },
      {
        "name": "Mathematics and Scientific Computing",
        "code": "MSC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 9613,
              "ews": 1724,
              "obc": 4762,
              "sc": 3476,
              "st": 1494
            },
            "2023": {
              "general": 9420,
              "ews": 1689,
              "obc": 4666,
              "sc": 3406,
              "st": 1464
            },
            "2022": {
              "general": 9228,
              "ews": 1655,
              "obc": 4571,
              "sc": 3336,
              "st": 1434
            },
            "2021": {
              "general": 9036,
              "ews": 1620,
              "obc": 4476,
              "sc": 3267,
              "st": 1404
            },
            "2020": {
              "general": 8843,
              "ews": 1586,
              "obc": 4381,
              "sc": 3197,
              "st": 1374
            }
          }
        },
        "fees": 150000,
        "seats": 62
      }
    ]
  },
  {
    "id": 3,
    "name": "Birla Institute of Technology, Deoghar Off-Campus",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 94698,
              "ews": 18265,
              "obc": 19630,
              "sc": 19161,
              "st": 23576
            },
            "2023": {
              "general": 92804,
              "ews": 17899,
              "obc": 19237,
              "sc": 18777,
              "st": 23104
            },
            "2022": {
              "general": 90910,
              "ews": 17534,
              "obc": 18844,
              "sc": 18394,
              "st": 22632
            },
            "2021": {
              "general": 89016,
              "ews": 17169,
              "obc": 18452,
              "sc": 18011,
              "st": 22161
            },
            "2020": {
              "general": 87122,
              "ews": 16803,
              "obc": 18059,
              "sc": 17628,
              "st": 21689
            }
          }
        },
        "fees": 150000,
        "seats": 63
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 112616,
              "ews": 22332,
              "obc": 21470,
              "sc": 26828,
              "st": 30030
            },
            "2023": {
              "general": 110363,
              "ews": 21885,
              "obc": 21040,
              "sc": 26291,
              "st": 29429
            },
            "2022": {
              "general": 108111,
              "ews": 21438,
              "obc": 20611,
              "sc": 25754,
              "st": 28828
            },
            "2021": {
              "general": 105859,
              "ews": 20992,
              "obc": 20181,
              "sc": 25218,
              "st": 28228
            },
            "2020": {
              "general": 103606,
              "ews": 20545,
              "obc": 19752,
              "sc": 24681,
              "st": 27627
            }
          }
        },
        "fees": 150000,
        "seats": 63
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 114823,
              "ews": 21708,
              "obc": 21032,
              "sc": 27318,
              "st": 36343
            },
            "2023": {
              "general": 112526,
              "ews": 21273,
              "obc": 20611,
              "sc": 26771,
              "st": 35616
            },
            "2022": {
              "general": 110230,
              "ews": 20839,
              "obc": 20190,
              "sc": 26225,
              "st": 34889
            },
            "2021": {
              "general": 107933,
              "ews": 20405,
              "obc": 19770,
              "sc": 25678,
              "st": 34162
            },
            "2020": {
              "general": 105637,
              "ews": 19971,
              "obc": 19349,
              "sc": 25132,
              "st": 33435
            }
          }
        },
        "fees": 150000,
        "seats": 63
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 117358,
              "ews": 23135,
              "obc": 22422,
              "sc": 27848,
              "st": 44305
            },
            "2023": {
              "general": 115010,
              "ews": 22672,
              "obc": 21973,
              "sc": 27291,
              "st": 43418
            },
            "2022": {
              "general": 112663,
              "ews": 22209,
              "obc": 21525,
              "sc": 26734,
              "st": 42532
            },
            "2021": {
              "general": 110316,
              "ews": 21746,
              "obc": 21076,
              "sc": 26177,
              "st": 41646
            },
            "2020": {
              "general": 107969,
              "ews": 21284,
              "obc": 20628,
              "sc": 25620,
              "st": 40760
            }
          }
        },
        "fees": 150000,
        "seats": 63
      }
    ]
  },
  {
    "id": 4,
    "name": "Birla Institute of Technology, Mesra, Ranchi",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 9022,
              "ews": 6218,
              "obc": 917,
              "sc": 3677,
              "st": 215
            },
            "2023": {
              "general": 8841,
              "ews": 6093,
              "obc": 898,
              "sc": 3603,
              "st": 210
            },
            "2022": {
              "general": 8661,
              "ews": 5969,
              "obc": 880,
              "sc": 3529,
              "st": 206
            },
            "2021": {
              "general": 8480,
              "ews": 5844,
              "obc": 861,
              "sc": 3456,
              "st": 202
            },
            "2020": {
              "general": 8300,
              "ews": 5720,
              "obc": 843,
              "sc": 3382,
              "st": 197
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Artificial Intelligence and Machine Learning",
        "code": "AIML",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 32648,
              "ews": 8278,
              "obc": 8649,
              "sc": 11295,
              "st": 8510
            },
            "2023": {
              "general": 31995,
              "ews": 8112,
              "obc": 8476,
              "sc": 11069,
              "st": 8339
            },
            "2022": {
              "general": 31342,
              "ews": 7946,
              "obc": 8303,
              "sc": 10843,
              "st": 8169
            },
            "2021": {
              "general": 30689,
              "ews": 7781,
              "obc": 8130,
              "sc": 10617,
              "st": 7999
            },
            "2020": {
              "general": 30036,
              "ews": 7615,
              "obc": 7957,
              "sc": 10391,
              "st": 7829
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Bio Technology",
        "code": "BT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 91376,
              "ews": 21535,
              "obc": 19014,
              "sc": 21374,
              "st": 23727
            },
            "2023": {
              "general": 89548,
              "ews": 21104,
              "obc": 18633,
              "sc": 20946,
              "st": 23252
            },
            "2022": {
              "general": 87720,
              "ews": 20673,
              "obc": 18253,
              "sc": 20519,
              "st": 22777
            },
            "2021": {
              "general": 85893,
              "ews": 20242,
              "obc": 17873,
              "sc": 20091,
              "st": 22303
            },
            "2020": {
              "general": 84065,
              "ews": 19812,
              "obc": 17492,
              "sc": 19664,
              "st": 21828
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 81587,
              "ews": 15939,
              "obc": 19046,
              "sc": 23614,
              "st": 20337
            },
            "2023": {
              "general": 79955,
              "ews": 15620,
              "obc": 18665,
              "sc": 23141,
              "st": 19930
            },
            "2022": {
              "general": 78323,
              "ews": 15301,
              "obc": 18284,
              "sc": 22669,
              "st": 19523
            },
            "2021": {
              "general": 76691,
              "ews": 14982,
              "obc": 17903,
              "sc": 22197,
              "st": 19116
            },
            "2020": {
              "general": 75060,
              "ews": 14663,
              "obc": 17522,
              "sc": 21724,
              "st": 18710
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 75023,
              "ews": 13358,
              "obc": 18688,
              "sc": 19045,
              "st": 13010
            },
            "2023": {
              "general": 73522,
              "ews": 13090,
              "obc": 18314,
              "sc": 18664,
              "st": 12749
            },
            "2022": {
              "general": 72022,
              "ews": 12823,
              "obc": 17940,
              "sc": 18283,
              "st": 12489
            },
            "2021": {
              "general": 70521,
              "ews": 12556,
              "obc": 17566,
              "sc": 17902,
              "st": 12229
            },
            "2020": {
              "general": 69021,
              "ews": 12289,
              "obc": 17192,
              "sc": 17521,
              "st": 11969
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 29325,
              "ews": 7644,
              "obc": 8172,
              "sc": 11042,
              "st": 7292
            },
            "2023": {
              "general": 28738,
              "ews": 7491,
              "obc": 8008,
              "sc": 10821,
              "st": 7146
            },
            "2022": {
              "general": 28152,
              "ews": 7338,
              "obc": 7845,
              "sc": 10600,
              "st": 7000
            },
            "2021": {
              "general": 27565,
              "ews": 7185,
              "obc": 7681,
              "sc": 10379,
              "st": 6854
            },
            "2020": {
              "general": 26979,
              "ews": 7032,
              "obc": 7518,
              "sc": 10158,
              "st": 6708
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 52629,
              "ews": 9993,
              "obc": 14272,
              "sc": 16403,
              "st": 15107
            },
            "2023": {
              "general": 51576,
              "ews": 9793,
              "obc": 13986,
              "sc": 16074,
              "st": 14804
            },
            "2022": {
              "general": 50523,
              "ews": 9593,
              "obc": 13701,
              "sc": 15746,
              "st": 14502
            },
            "2021": {
              "general": 49471,
              "ews": 9393,
              "obc": 13415,
              "sc": 15418,
              "st": 14200
            },
            "2020": {
              "general": 48418,
              "ews": 9193,
              "obc": 13130,
              "sc": 15090,
              "st": 13898
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 48761,
              "ews": 9639,
              "obc": 12830,
              "sc": 16058,
              "st": 11639
            },
            "2023": {
              "general": 47785,
              "ews": 9446,
              "obc": 12573,
              "sc": 15736,
              "st": 11406
            },
            "2022": {
              "general": 46810,
              "ews": 9253,
              "obc": 12316,
              "sc": 15415,
              "st": 11173
            },
            "2021": {
              "general": 45835,
              "ews": 9060,
              "obc": 12060,
              "sc": 15094,
              "st": 10940
            },
            "2020": {
              "general": 44860,
              "ews": 8867,
              "obc": 11803,
              "sc": 14773,
              "st": 10707
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Food Engineering and Technology",
        "code": "FET",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 97810,
              "ews": 19905,
              "obc": 19950,
              "sc": 27311,
              "st": 32498
            },
            "2023": {
              "general": 95853,
              "ews": 19506,
              "obc": 19551,
              "sc": 26764,
              "st": 31848
            },
            "2022": {
              "general": 93897,
              "ews": 19108,
              "obc": 19152,
              "sc": 26218,
              "st": 31198
            },
            "2021": {
              "general": 91941,
              "ews": 18710,
              "obc": 18753,
              "sc": 25672,
              "st": 30548
            },
            "2020": {
              "general": 89985,
              "ews": 18312,
              "obc": 18354,
              "sc": 25126,
              "st": 29898
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 65352,
              "ews": 10745,
              "obc": 14332,
              "sc": 17040,
              "st": 43112
            },
            "2023": {
              "general": 64044,
              "ews": 10530,
              "obc": 14045,
              "sc": 16699,
              "st": 42249
            },
            "2022": {
              "general": 62737,
              "ews": 10315,
              "obc": 13758,
              "sc": 16358,
              "st": 41387
            },
            "2021": {
              "general": 61430,
              "ews": 10100,
              "obc": 13472,
              "sc": 16017,
              "st": 40525
            },
            "2020": {
              "general": 60123,
              "ews": 9885,
              "obc": 13185,
              "sc": 15676,
              "st": 39663
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 63477,
              "ews": 13316,
              "obc": 17740,
              "sc": 18705,
              "st": 21703
            },
            "2023": {
              "general": 62207,
              "ews": 13049,
              "obc": 17385,
              "sc": 18330,
              "st": 21268
            },
            "2022": {
              "general": 60937,
              "ews": 12783,
              "obc": 17030,
              "sc": 17956,
              "st": 20834
            },
            "2021": {
              "general": 59668,
              "ews": 12517,
              "obc": 16675,
              "sc": 17582,
              "st": 20400
            },
            "2020": {
              "general": 58398,
              "ews": 12250,
              "obc": 16320,
              "sc": 17208,
              "st": 19966
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Physics",
        "code": "P",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 96905,
              "ews": 22452,
              "obc": 19988,
              "sc": 25447,
              "st": 4389
            },
            "2023": {
              "general": 94966,
              "ews": 22002,
              "obc": 19588,
              "sc": 24938,
              "st": 4301
            },
            "2022": {
              "general": 93028,
              "ews": 21553,
              "obc": 19188,
              "sc": 24429,
              "st": 4213
            },
            "2021": {
              "general": 91090,
              "ews": 21104,
              "obc": 18788,
              "sc": 23920,
              "st": 4125
            },
            "2020": {
              "general": 89152,
              "ews": 20655,
              "obc": 18388,
              "sc": 23411,
              "st": 4037
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Production and Industrial Engineering",
        "code": "PIE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 92177,
              "ews": 18122,
              "obc": 19600,
              "sc": 27737,
              "st": 6182
            },
            "2023": {
              "general": 90333,
              "ews": 17759,
              "obc": 19208,
              "sc": 27182,
              "st": 6058
            },
            "2022": {
              "general": 88489,
              "ews": 17397,
              "obc": 18816,
              "sc": 26627,
              "st": 5934
            },
            "2021": {
              "general": 86646,
              "ews": 17034,
              "obc": 18424,
              "sc": 26072,
              "st": 5811
            },
            "2020": {
              "general": 84802,
              "ews": 16672,
              "obc": 18032,
              "sc": 25518,
              "st": 5687
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Quantitative Economics & Data Science",
        "code": "QEDS",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 70085,
              "ews": 16723,
              "obc": 16276,
              "sc": 25108,
              "st": 3795
            },
            "2023": {
              "general": 68683,
              "ews": 16388,
              "obc": 15950,
              "sc": 24605,
              "st": 3719
            },
            "2022": {
              "general": 67281,
              "ews": 16054,
              "obc": 15624,
              "sc": 24103,
              "st": 3643
            },
            "2021": {
              "general": 65879,
              "ews": 15719,
              "obc": 15299,
              "sc": 23601,
              "st": 3567
            },
            "2020": {
              "general": 64478,
              "ews": 15385,
              "obc": 14973,
              "sc": 23099,
              "st": 3491
            }
          }
        },
        "fees": 150000,
        "seats": 64
      }
    ]
  },
  {
    "id": 5,
    "name": "Birla Institute of Technology, Patna Off-Campus",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Artificial Intelligence and Machine Learning",
        "code": "AIML",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 69875,
              "ews": 13203,
              "obc": 19685,
              "sc": 17330,
              "st": 8801
            },
            "2023": {
              "general": 68477,
              "ews": 12938,
              "obc": 19291,
              "sc": 16983,
              "st": 8624
            },
            "2022": {
              "general": 67080,
              "ews": 12674,
              "obc": 18897,
              "sc": 16636,
              "st": 8448
            },
            "2021": {
              "general": 65682,
              "ews": 12410,
              "obc": 18503,
              "sc": 16290,
              "st": 8272
            },
            "2020": {
              "general": 64285,
              "ews": 12146,
              "obc": 18110,
              "sc": 15943,
              "st": 8096
            }
          }
        },
        "fees": 150000,
        "seats": 65
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 104872,
              "ews": 17526,
              "obc": 25750,
              "sc": 19423,
              "st": 10783
            },
            "2023": {
              "general": 102774,
              "ews": 17175,
              "obc": 25235,
              "sc": 19034,
              "st": 10567
            },
            "2022": {
              "general": 100677,
              "ews": 16824,
              "obc": 24720,
              "sc": 18646,
              "st": 10351
            },
            "2021": {
              "general": 98579,
              "ews": 16474,
              "obc": 24205,
              "sc": 18257,
              "st": 10136
            },
            "2020": {
              "general": 96482,
              "ews": 16123,
              "obc": 23690,
              "sc": 17869,
              "st": 9920
            }
          }
        },
        "fees": 150000,
        "seats": 65
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 60303,
              "ews": 10605,
              "obc": 18060,
              "sc": 13561,
              "st": 7165
            },
            "2023": {
              "general": 59096,
              "ews": 10392,
              "obc": 17698,
              "sc": 13289,
              "st": 7021
            },
            "2022": {
              "general": 57890,
              "ews": 10180,
              "obc": 17337,
              "sc": 13018,
              "st": 6878
            },
            "2021": {
              "general": 56684,
              "ews": 9968,
              "obc": 16976,
              "sc": 12747,
              "st": 6735
            },
            "2020": {
              "general": 55478,
              "ews": 9756,
              "obc": 16615,
              "sc": 12476,
              "st": 6591
            }
          }
        },
        "fees": 150000,
        "seats": 65
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 89963,
              "ews": 15530,
              "obc": 21624,
              "sc": 20796,
              "st": 9936
            },
            "2023": {
              "general": 88163,
              "ews": 15219,
              "obc": 21191,
              "sc": 20380,
              "st": 9737
            },
            "2022": {
              "general": 86364,
              "ews": 14908,
              "obc": 20759,
              "sc": 19964,
              "st": 9538
            },
            "2021": {
              "general": 84565,
              "ews": 14598,
              "obc": 20326,
              "sc": 19548,
              "st": 9339
            },
            "2020": {
              "general": 82765,
              "ews": 14287,
              "obc": 19894,
              "sc": 19132,
              "st": 9141
            }
          }
        },
        "fees": 150000,
        "seats": 65
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 82737,
              "ews": 14176,
              "obc": 20810,
              "sc": 18751,
              "st": 8260
            },
            "2023": {
              "general": 81082,
              "ews": 13892,
              "obc": 20393,
              "sc": 18375,
              "st": 8094
            },
            "2022": {
              "general": 79427,
              "ews": 13608,
              "obc": 19977,
              "sc": 18000,
              "st": 7929
            },
            "2021": {
              "general": 77772,
              "ews": 13325,
              "obc": 19561,
              "sc": 17625,
              "st": 7764
            },
            "2020": {
              "general": 76118,
              "ews": 13041,
              "obc": 19145,
              "sc": 17250,
              "st": 7599
            }
          }
        },
        "fees": 150000,
        "seats": 65
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 100020,
              "ews": 17255,
              "obc": 23327,
              "sc": 21792,
              "st": 10369
            },
            "2023": {
              "general": 98019,
              "ews": 16909,
              "obc": 22860,
              "sc": 21356,
              "st": 10161
            },
            "2022": {
              "general": 96019,
              "ews": 16564,
              "obc": 22393,
              "sc": 20920,
              "st": 9954
            },
            "2021": {
              "general": 94018,
              "ews": 16219,
              "obc": 21927,
              "sc": 20484,
              "st": 9746
            },
            "2020": {
              "general": 92018,
              "ews": 15874,
              "obc": 21460,
              "sc": 20048,
              "st": 9539
            }
          }
        },
        "fees": 150000,
        "seats": 65
      }
    ]
  },
  {
    "id": 6,
    "name": "CU Jharkhand",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Integrated B. Tech. - M. Tech in Civil Engineering",
        "code": "IBTMT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 104869,
              "ews": 17729,
              "obc": 36779,
              "sc": 16616,
              "st": 7583
            },
            "2023": {
              "general": 102771,
              "ews": 17374,
              "obc": 36043,
              "sc": 16283,
              "st": 7431
            },
            "2022": {
              "general": 100674,
              "ews": 17019,
              "obc": 35307,
              "sc": 15951,
              "st": 7279
            },
            "2021": {
              "general": 98576,
              "ews": 16665,
              "obc": 34572,
              "sc": 15619,
              "st": 7128
            },
            "2020": {
              "general": 96479,
              "ews": 16310,
              "obc": 33836,
              "sc": 15286,
              "st": 6976
            }
          }
        },
        "fees": 150000,
        "seats": 66
      },
      {
        "name": "Integrated B. Tech. - M. Tech in Computer Science & Engineering",
        "code": "IBTMT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 74180,
              "ews": 13666,
              "obc": 28743,
              "sc": 13422,
              "st": 6539
            },
            "2023": {
              "general": 72696,
              "ews": 13392,
              "obc": 28168,
              "sc": 13153,
              "st": 6408
            },
            "2022": {
              "general": 71212,
              "ews": 13119,
              "obc": 27593,
              "sc": 12885,
              "st": 6277
            },
            "2021": {
              "general": 69729,
              "ews": 12846,
              "obc": 27018,
              "sc": 12616,
              "st": 6146
            },
            "2020": {
              "general": 68245,
              "ews": 12572,
              "obc": 26443,
              "sc": 12348,
              "st": 6015
            }
          }
        },
        "fees": 150000,
        "seats": 66
      },
      {
        "name": "Integrated B. Tech. - M. Tech in Electrical Engineering",
        "code": "IBTMT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 90811,
              "ews": 15540,
              "obc": 34293,
              "sc": 15385,
              "st": 7627
            },
            "2023": {
              "general": 88994,
              "ews": 15229,
              "obc": 33607,
              "sc": 15077,
              "st": 7474
            },
            "2022": {
              "general": 87178,
              "ews": 14918,
              "obc": 32921,
              "sc": 14769,
              "st": 7321
            },
            "2021": {
              "general": 85362,
              "ews": 14607,
              "obc": 32235,
              "sc": 14461,
              "st": 7169
            },
            "2020": {
              "general": 83546,
              "ews": 14296,
              "obc": 31549,
              "sc": 14154,
              "st": 7016
            }
          }
        },
        "fees": 150000,
        "seats": 66
      },
      {
        "name": "Integrated B. Tech.- M. Tech in Metallurgical & Materials Engineering",
        "code": "IBTMT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 105570,
              "ews": 17773,
              "obc": 37033,
              "sc": 16455,
              "st": 7932
            },
            "2023": {
              "general": 103458,
              "ews": 17417,
              "obc": 36292,
              "sc": 16125,
              "st": 7773
            },
            "2022": {
              "general": 101347,
              "ews": 17062,
              "obc": 35551,
              "sc": 15796,
              "st": 7614
            },
            "2021": {
              "general": 99235,
              "ews": 16706,
              "obc": 34811,
              "sc": 15467,
              "st": 7456
            },
            "2020": {
              "general": 97124,
              "ews": 16351,
              "obc": 34070,
              "sc": 15138,
              "st": 7297
            }
          }
        },
        "fees": 150000,
        "seats": 66
      }
    ]
  },
  {
    "id": 7,
    "name": "Central University of Haryana",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 85215,
              "ews": 15379,
              "obc": 30875,
              "sc": 14625,
              "st": 5619
            },
            "2023": {
              "general": 83510,
              "ews": 15071,
              "obc": 30257,
              "sc": 14332,
              "st": 5506
            },
            "2022": {
              "general": 81806,
              "ews": 14763,
              "obc": 29640,
              "sc": 14040,
              "st": 5394
            },
            "2021": {
              "general": 80102,
              "ews": 14456,
              "obc": 29022,
              "sc": 13747,
              "st": 5281
            },
            "2020": {
              "general": 78397,
              "ews": 14148,
              "obc": 28405,
              "sc": 13455,
              "st": 5169
            }
          }
        },
        "fees": 150000,
        "seats": 67
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 54382,
              "ews": 9413,
              "obc": 20895,
              "sc": 10498,
              "st": 5557
            },
            "2023": {
              "general": 53294,
              "ews": 9224,
              "obc": 20477,
              "sc": 10288,
              "st": 5445
            },
            "2022": {
              "general": 52206,
              "ews": 9036,
              "obc": 20059,
              "sc": 10078,
              "st": 5334
            },
            "2021": {
              "general": 51119,
              "ews": 8848,
              "obc": 19641,
              "sc": 9868,
              "st": 5223
            },
            "2020": {
              "general": 50031,
              "ews": 8659,
              "obc": 19223,
              "sc": 9658,
              "st": 5112
            }
          }
        },
        "fees": 150000,
        "seats": 67
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 71498,
              "ews": 13148,
              "obc": 27280,
              "sc": 12094,
              "st": 6549
            },
            "2023": {
              "general": 70068,
              "ews": 12885,
              "obc": 26734,
              "sc": 11852,
              "st": 6418
            },
            "2022": {
              "general": 68638,
              "ews": 12622,
              "obc": 26188,
              "sc": 11610,
              "st": 6287
            },
            "2021": {
              "general": 67208,
              "ews": 12359,
              "obc": 25643,
              "sc": 11368,
              "st": 6156
            },
            "2020": {
              "general": 65778,
              "ews": 12096,
              "obc": 25097,
              "sc": 11126,
              "st": 6025
            }
          }
        },
        "fees": 150000,
        "seats": 67
      },
      {
        "name": "Printing and Packaging Technology",
        "code": "PPT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 91556,
              "ews": 15750,
              "obc": 33700,
              "sc": 14786,
              "st": 6912
            },
            "2023": {
              "general": 89724,
              "ews": 15435,
              "obc": 33026,
              "sc": 14490,
              "st": 6773
            },
            "2022": {
              "general": 87893,
              "ews": 15120,
              "obc": 32352,
              "sc": 14194,
              "st": 6635
            },
            "2021": {
              "general": 86062,
              "ews": 14805,
              "obc": 31678,
              "sc": 13898,
              "st": 6497
            },
            "2020": {
              "general": 84231,
              "ews": 14490,
              "obc": 31004,
              "sc": 13603,
              "st": 6359
            }
          }
        },
        "fees": 150000,
        "seats": 67
      }
    ]
  },
  {
    "id": 8,
    "name": "Central University of Jammu",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 67208,
              "ews": 11483,
              "obc": 23852,
              "sc": 11742,
              "st": 6350
            },
            "2023": {
              "general": 65863,
              "ews": 11253,
              "obc": 23374,
              "sc": 11507,
              "st": 6223
            },
            "2022": {
              "general": 64519,
              "ews": 11023,
              "obc": 22897,
              "sc": 11272,
              "st": 6096
            },
            "2021": {
              "general": 63175,
              "ews": 10794,
              "obc": 22420,
              "sc": 11037,
              "st": 5969
            },
            "2020": {
              "general": 61831,
              "ews": 10564,
              "obc": 21943,
              "sc": 10802,
              "st": 5842
            }
          }
        },
        "fees": 150000,
        "seats": 68
      },
      {
        "name": "Computer Science and Engineering with specialization in Cyber Security",
        "code": "CSECS",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 70845,
              "ews": 11962,
              "obc": 24927,
              "sc": 12436,
              "st": 6433
            },
            "2023": {
              "general": 69428,
              "ews": 11722,
              "obc": 24428,
              "sc": 12187,
              "st": 6304
            },
            "2022": {
              "general": 68011,
              "ews": 11483,
              "obc": 23929,
              "sc": 11938,
              "st": 6175
            },
            "2021": {
              "general": 66594,
              "ews": 11244,
              "obc": 23431,
              "sc": 11689,
              "st": 6047
            },
            "2020": {
              "general": 65177,
              "ews": 11005,
              "obc": 22932,
              "sc": 11441,
              "st": 5918
            }
          }
        },
        "fees": 150000,
        "seats": 68
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 71325,
              "ews": 13350,
              "obc": 27275,
              "sc": 13897,
              "st": 6997
            },
            "2023": {
              "general": 69898,
              "ews": 13083,
              "obc": 26729,
              "sc": 13619,
              "st": 6857
            },
            "2022": {
              "general": 68472,
              "ews": 12816,
              "obc": 26184,
              "sc": 13341,
              "st": 6717
            },
            "2021": {
              "general": 67045,
              "ews": 12549,
              "obc": 25638,
              "sc": 13063,
              "st": 6577
            },
            "2020": {
              "general": 65619,
              "ews": 12282,
              "obc": 25093,
              "sc": 12785,
              "st": 6437
            }
          }
        },
        "fees": 150000,
        "seats": 68
      }
    ]
  },
  {
    "id": 9,
    "name": "Central University of Rajasthan, Rajasthan",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Bio Medical Engineering",
        "code": "BME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 76513,
              "ews": 13743,
              "obc": 29595,
              "sc": 13535,
              "st": 5959
            },
            "2023": {
              "general": 74982,
              "ews": 13468,
              "obc": 29003,
              "sc": 13264,
              "st": 5839
            },
            "2022": {
              "general": 73452,
              "ews": 13193,
              "obc": 28411,
              "sc": 12993,
              "st": 5720
            },
            "2021": {
              "general": 71922,
              "ews": 12918,
              "obc": 27819,
              "sc": 12722,
              "st": 5601
            },
            "2020": {
              "general": 70391,
              "ews": 12643,
              "obc": 27227,
              "sc": 12452,
              "st": 5482
            }
          }
        },
        "fees": 150000,
        "seats": 69
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 46057,
              "ews": 8471,
              "obc": 18173,
              "sc": 10339,
              "st": 4438
            },
            "2023": {
              "general": 45135,
              "ews": 8301,
              "obc": 17809,
              "sc": 10132,
              "st": 4349
            },
            "2022": {
              "general": 44214,
              "ews": 8132,
              "obc": 17446,
              "sc": 9925,
              "st": 4260
            },
            "2021": {
              "general": 43293,
              "ews": 7962,
              "obc": 17082,
              "sc": 9718,
              "st": 4171
            },
            "2020": {
              "general": 42372,
              "ews": 7793,
              "obc": 16719,
              "sc": 9511,
              "st": 4082
            }
          }
        },
        "fees": 150000,
        "seats": 69
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 56006,
              "ews": 9765,
              "obc": 20964,
              "sc": 11096,
              "st": 4627
            },
            "2023": {
              "general": 54885,
              "ews": 9569,
              "obc": 20544,
              "sc": 10874,
              "st": 4534
            },
            "2022": {
              "general": 53765,
              "ews": 9374,
              "obc": 20125,
              "sc": 10652,
              "st": 4441
            },
            "2021": {
              "general": 52645,
              "ews": 9179,
              "obc": 19706,
              "sc": 10430,
              "st": 4349
            },
            "2020": {
              "general": 51525,
              "ews": 8983,
              "obc": 19286,
              "sc": 10208,
              "st": 4256
            }
          }
        },
        "fees": 150000,
        "seats": 69
      }
    ]
  },
  {
    "id": 10,
    "name": "Central institute of Technology Kokrajar, Assam",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 63539,
              "obc": 21512,
              "sc": 12214
            },
            "2023": {
              "general": 62268,
              "obc": 21081,
              "sc": 11969
            },
            "2022": {
              "general": 60997,
              "obc": 20651,
              "sc": 11725
            },
            "2021": {
              "general": 59726,
              "obc": 20221,
              "sc": 11481
            },
            "2020": {
              "general": 58455,
              "obc": 19791,
              "sc": 11236
            }
          }
        },
        "fees": 150000,
        "seats": 70
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 54826,
              "ews": 9585,
              "obc": 19530,
              "sc": 10212
            },
            "2023": {
              "general": 53729,
              "ews": 9393,
              "obc": 19139,
              "sc": 10007
            },
            "2022": {
              "general": 52632,
              "ews": 9201,
              "obc": 18748,
              "sc": 9803
            },
            "2021": {
              "general": 51536,
              "ews": 9009,
              "obc": 18358,
              "sc": 9599
            },
            "2020": {
              "general": 50439,
              "ews": 8818,
              "obc": 17967,
              "sc": 9395
            }
          }
        },
        "fees": 150000,
        "seats": 70
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 60026,
              "obc": 21560
            },
            "2023": {
              "general": 58825,
              "obc": 21128
            },
            "2022": {
              "general": 57624,
              "obc": 20697
            },
            "2021": {
              "general": 56424,
              "obc": 20266
            },
            "2020": {
              "general": 55223,
              "obc": 19835
            }
          }
        },
        "fees": 150000,
        "seats": 70
      },
      {
        "name": "Food Engineering and Technology",
        "code": "FET",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 80446,
              "obc": 29380,
              "sc": 15171
            },
            "2023": {
              "general": 78837,
              "obc": 28792,
              "sc": 14867
            },
            "2022": {
              "general": 77228,
              "obc": 28204,
              "sc": 14564
            },
            "2021": {
              "general": 75619,
              "obc": 27617,
              "sc": 14260
            },
            "2020": {
              "general": 74010,
              "obc": 27029,
              "sc": 13957
            }
          }
        },
        "fees": 150000,
        "seats": 70
      },
      {
        "name": "Instrumentation Engineering",
        "code": "IE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 65512,
              "obc": 24082,
              "st": 5109
            },
            "2023": {
              "general": 64201,
              "obc": 23600,
              "st": 5006
            },
            "2022": {
              "general": 62891,
              "obc": 23118,
              "st": 4904
            },
            "2021": {
              "general": 61581,
              "obc": 22637,
              "st": 4802
            },
            "2020": {
              "general": 60271,
              "obc": 22155,
              "st": 4700
            }
          }
        },
        "fees": 150000,
        "seats": 70
      }
    ]
  },
  {
    "id": 11,
    "name": "Chhattisgarh Swami Vivekanada Technical University, Bhilai (CSVTU Bhilai)",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 93633,
              "ews": 16574,
              "obc": 33469,
              "sc": 14870,
              "st": 6609
            },
            "2023": {
              "general": 91760,
              "ews": 16242,
              "obc": 32799,
              "sc": 14572,
              "st": 6476
            },
            "2022": {
              "general": 89887,
              "ews": 15911,
              "obc": 32130,
              "sc": 14275,
              "st": 6344
            },
            "2021": {
              "general": 88015,
              "ews": 15579,
              "obc": 31460,
              "sc": 13977,
              "st": 6212
            },
            "2020": {
              "general": 86142,
              "ews": 15248,
              "obc": 30791,
              "sc": 13680,
              "st": 6080
            }
          }
        },
        "fees": 150000,
        "seats": 71
      },
      {
        "name": "Computer Science Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 62590,
              "ews": 11138,
              "obc": 22694,
              "sc": 12088,
              "st": 5621
            },
            "2023": {
              "general": 61338,
              "ews": 10915,
              "obc": 22240,
              "sc": 11846,
              "st": 5508
            },
            "2022": {
              "general": 60086,
              "ews": 10692,
              "obc": 21786,
              "sc": 11604,
              "st": 5396
            },
            "2021": {
              "general": 58834,
              "ews": 10469,
              "obc": 21332,
              "sc": 11362,
              "st": 5283
            },
            "2020": {
              "general": 57582,
              "ews": 10246,
              "obc": 20878,
              "sc": 11120,
              "st": 5171
            }
          }
        },
        "fees": 150000,
        "seats": 71
      }
    ]
  },
  {
    "id": 12,
    "name": "Dr. B R Ambedkar National Institute of Technology, Jalandhar",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Bio Technology",
        "code": "BT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 45639,
              "ews": 7763,
              "obc": 15403,
              "sc": 7678,
              "st": 2875
            },
            "2023": {
              "general": 44726,
              "ews": 7607,
              "obc": 15094,
              "sc": 7524,
              "st": 2817
            },
            "2022": {
              "general": 43813,
              "ews": 7452,
              "obc": 14786,
              "sc": 7370,
              "st": 2760
            },
            "2021": {
              "general": 42900,
              "ews": 7297,
              "obc": 14478,
              "sc": 7217,
              "st": 2702
            },
            "2020": {
              "general": 41987,
              "ews": 7141,
              "obc": 14170,
              "sc": 7063,
              "st": 2645
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 35742,
              "ews": 5939,
              "obc": 12138,
              "sc": 6723,
              "st": 2493
            },
            "2023": {
              "general": 35027,
              "ews": 5820,
              "obc": 11895,
              "sc": 6588,
              "st": 2443
            },
            "2022": {
              "general": 34312,
              "ews": 5701,
              "obc": 11652,
              "sc": 6454,
              "st": 2393
            },
            "2021": {
              "general": 33597,
              "ews": 5582,
              "obc": 11409,
              "sc": 6319,
              "st": 2343
            },
            "2020": {
              "general": 32882,
              "ews": 5463,
              "obc": 11166,
              "sc": 6185,
              "st": 2293
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 41378,
              "ews": 6734,
              "obc": 13715,
              "sc": 5927,
              "st": 1307
            },
            "2023": {
              "general": 40550,
              "ews": 6599,
              "obc": 13440,
              "sc": 5808,
              "st": 1280
            },
            "2022": {
              "general": 39722,
              "ews": 6464,
              "obc": 13166,
              "sc": 5689,
              "st": 1254
            },
            "2021": {
              "general": 38895,
              "ews": 6329,
              "obc": 12892,
              "sc": 5571,
              "st": 1228
            },
            "2020": {
              "general": 38067,
              "ews": 6195,
              "obc": 12617,
              "sc": 5452,
              "st": 1202
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 9578,
              "ews": 1576,
              "obc": 3693,
              "sc": 2109,
              "st": 812
            },
            "2023": {
              "general": 9386,
              "ews": 1544,
              "obc": 3619,
              "sc": 2066,
              "st": 795
            },
            "2022": {
              "general": 9194,
              "ews": 1512,
              "obc": 3545,
              "sc": 2024,
              "st": 779
            },
            "2021": {
              "general": 9003,
              "ews": 1481,
              "obc": 3471,
              "sc": 1982,
              "st": 763
            },
            "2020": {
              "general": 8811,
              "ews": 1449,
              "obc": 3397,
              "sc": 1940,
              "st": 747
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Data Science and Engineering",
        "code": "DSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 12940,
              "ews": 2073,
              "obc": 5049,
              "sc": 2827,
              "st": 1140
            },
            "2023": {
              "general": 12681,
              "ews": 2031,
              "obc": 4948,
              "sc": 2770,
              "st": 1117
            },
            "2022": {
              "general": 12422,
              "ews": 1990,
              "obc": 4847,
              "sc": 2713,
              "st": 1094
            },
            "2021": {
              "general": 12163,
              "ews": 1948,
              "obc": 4746,
              "sc": 2657,
              "st": 1071
            },
            "2020": {
              "general": 11904,
              "ews": 1907,
              "obc": 4645,
              "sc": 2600,
              "st": 1048
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 19817,
              "ews": 3322,
              "obc": 7077,
              "sc": 4170,
              "st": 1355
            },
            "2023": {
              "general": 19420,
              "ews": 3255,
              "obc": 6935,
              "sc": 4086,
              "st": 1327
            },
            "2022": {
              "general": 19024,
              "ews": 3189,
              "obc": 6793,
              "sc": 4003,
              "st": 1300
            },
            "2021": {
              "general": 18627,
              "ews": 3122,
              "obc": 6652,
              "sc": 3919,
              "st": 1273
            },
            "2020": {
              "general": 18231,
              "ews": 3056,
              "obc": 6510,
              "sc": 3836,
              "st": 1246
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 14347,
              "ews": 2321,
              "obc": 5482,
              "sc": 3338,
              "st": 1167
            },
            "2023": {
              "general": 14060,
              "ews": 2274,
              "obc": 5372,
              "sc": 3271,
              "st": 1143
            },
            "2022": {
              "general": 13773,
              "ews": 2228,
              "obc": 5262,
              "sc": 3204,
              "st": 1120
            },
            "2021": {
              "general": 13486,
              "ews": 2181,
              "obc": 5153,
              "sc": 3137,
              "st": 1096
            },
            "2020": {
              "general": 13199,
              "ews": 2135,
              "obc": 5043,
              "sc": 3070,
              "st": 1073
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Electronics and VLSI Engineering",
        "code": "EVE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 15751,
              "ews": 2595,
              "obc": 5925,
              "sc": 3701,
              "st": 1405
            },
            "2023": {
              "general": 15435,
              "ews": 2543,
              "obc": 5806,
              "sc": 3626,
              "st": 1376
            },
            "2022": {
              "general": 15120,
              "ews": 2491,
              "obc": 5688,
              "sc": 3552,
              "st": 1348
            },
            "2021": {
              "general": 14805,
              "ews": 2439,
              "obc": 5569,
              "sc": 3478,
              "st": 1320
            },
            "2020": {
              "general": 14490,
              "ews": 2387,
              "obc": 5451,
              "sc": 3404,
              "st": 1292
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Industrial and Production Engineering",
        "code": "IPE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 43369,
              "ews": 7426,
              "obc": 15719,
              "sc": 7340,
              "st": 2929
            },
            "2023": {
              "general": 42501,
              "ews": 7277,
              "obc": 15404,
              "sc": 7193,
              "st": 2870
            },
            "2022": {
              "general": 41634,
              "ews": 7128,
              "obc": 15090,
              "sc": 7046,
              "st": 2811
            },
            "2021": {
              "general": 40766,
              "ews": 6980,
              "obc": 14775,
              "sc": 6899,
              "st": 2753
            },
            "2020": {
              "general": 39899,
              "ews": 6831,
              "obc": 14461,
              "sc": 6752,
              "st": 2694
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 13375,
              "ews": 2110,
              "obc": 4946,
              "sc": 3060,
              "st": 1173
            },
            "2023": {
              "general": 13107,
              "ews": 2067,
              "obc": 4847,
              "sc": 2998,
              "st": 1149
            },
            "2022": {
              "general": 12840,
              "ews": 2025,
              "obc": 4748,
              "sc": 2937,
              "st": 1126
            },
            "2021": {
              "general": 12572,
              "ews": 1983,
              "obc": 4649,
              "sc": 2876,
              "st": 1102
            },
            "2020": {
              "general": 12305,
              "ews": 1941,
              "obc": 4550,
              "sc": 2815,
              "st": 1079
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Instrumentation and Control Engineering",
        "code": "ICE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 29692,
              "ews": 5449,
              "obc": 10876,
              "sc": 6410,
              "st": 2605
            },
            "2023": {
              "general": 29098,
              "ews": 5340,
              "obc": 10658,
              "sc": 6281,
              "st": 2552
            },
            "2022": {
              "general": 28504,
              "ews": 5231,
              "obc": 10440,
              "sc": 6153,
              "st": 2500
            },
            "2021": {
              "general": 27910,
              "ews": 5122,
              "obc": 10223,
              "sc": 6025,
              "st": 2448
            },
            "2020": {
              "general": 27316,
              "ews": 5013,
              "obc": 10005,
              "sc": 5897,
              "st": 2396
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 12482,
              "ews": 2240,
              "obc": 5294,
              "sc": 3466,
              "st": 1088
            },
            "2023": {
              "general": 12232,
              "ews": 2195,
              "obc": 5188,
              "sc": 3396,
              "st": 1066
            },
            "2022": {
              "general": 11982,
              "ews": 2150,
              "obc": 5082,
              "sc": 3327,
              "st": 1044
            },
            "2021": {
              "general": 11733,
              "ews": 2105,
              "obc": 4976,
              "sc": 3258,
              "st": 1022
            },
            "2020": {
              "general": 11483,
              "ews": 2060,
              "obc": 4870,
              "sc": 3188,
              "st": 1000
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 29253,
              "ews": 5002,
              "obc": 10357,
              "sc": 5626,
              "st": 2293
            },
            "2023": {
              "general": 28667,
              "ews": 4901,
              "obc": 10149,
              "sc": 5513,
              "st": 2247
            },
            "2022": {
              "general": 28082,
              "ews": 4801,
              "obc": 9942,
              "sc": 5400,
              "st": 2201
            },
            "2021": {
              "general": 27497,
              "ews": 4701,
              "obc": 9735,
              "sc": 5288,
              "st": 2155
            },
            "2020": {
              "general": 26912,
              "ews": 4601,
              "obc": 9528,
              "sc": 5175,
              "st": 2109
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Textile Technology",
        "code": "TT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 48138,
              "ews": 7997,
              "obc": 16803,
              "sc": 8412,
              "st": 3388
            },
            "2023": {
              "general": 47175,
              "ews": 7837,
              "obc": 16466,
              "sc": 8243,
              "st": 3320
            },
            "2022": {
              "general": 46212,
              "ews": 7677,
              "obc": 16130,
              "sc": 8075,
              "st": 3252
            },
            "2021": {
              "general": 45249,
              "ews": 7517,
              "obc": 15794,
              "sc": 7907,
              "st": 3184
            },
            "2020": {
              "general": 44286,
              "ews": 7357,
              "obc": 15458,
              "sc": 7739,
              "st": 3116
            }
          }
        },
        "fees": 150000,
        "seats": 72
      }
    ]
  },
  {
    "id": 13,
    "name": "Gati Shakti Vishwavidyalaya, Vadodara",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "B.Tech in Artificial Intelligenece and Data Science",
        "code": "BAIDS",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 52365,
              "ews": 9763,
              "obc": 21497,
              "sc": 12049,
              "st": 5658
            },
            "2023": {
              "general": 51317,
              "ews": 9567,
              "obc": 21067,
              "sc": 11808,
              "st": 5544
            },
            "2022": {
              "general": 50270,
              "ews": 9372,
              "obc": 20637,
              "sc": 11567,
              "st": 5431
            },
            "2021": {
              "general": 49223,
              "ews": 9177,
              "obc": 20207,
              "sc": 11326,
              "st": 5318
            },
            "2020": {
              "general": 48175,
              "ews": 8981,
              "obc": 19777,
              "sc": 11085,
              "st": 5205
            }
          }
        },
        "fees": 150000,
        "seats": 73
      },
      {
        "name": "B.Tech in Aviation Engineering",
        "code": "BAE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 63096,
              "ews": 12450,
              "obc": 25743,
              "sc": 12397,
              "st": 6478
            },
            "2023": {
              "general": 61834,
              "ews": 12201,
              "obc": 25228,
              "sc": 12149,
              "st": 6348
            },
            "2022": {
              "general": 60572,
              "ews": 11952,
              "obc": 24713,
              "sc": 11901,
              "st": 6218
            },
            "2021": {
              "general": 59310,
              "ews": 11703,
              "obc": 24198,
              "sc": 11653,
              "st": 6089
            },
            "2020": {
              "general": 58048,
              "ews": 11454,
              "obc": 23683,
              "sc": 11405,
              "st": 5959
            }
          }
        },
        "fees": 150000,
        "seats": 73
      },
      {
        "name": "B.Tech in Civil Engineering",
        "code": "BCE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 83617,
              "ews": 14666,
              "obc": 29633,
              "sc": 15461,
              "st": 7095
            },
            "2023": {
              "general": 81944,
              "ews": 14372,
              "obc": 29040,
              "sc": 15151,
              "st": 6953
            },
            "2022": {
              "general": 80272,
              "ews": 14079,
              "obc": 28447,
              "sc": 14842,
              "st": 6811
            },
            "2021": {
              "general": 78599,
              "ews": 13786,
              "obc": 27855,
              "sc": 14533,
              "st": 6669
            },
            "2020": {
              "general": 76927,
              "ews": 13492,
              "obc": 27262,
              "sc": 14224,
              "st": 6527
            }
          }
        },
        "fees": 150000,
        "seats": 73
      },
      {
        "name": "B.Tech in Electrical Engineering",
        "code": "BEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 67669,
              "ews": 13079,
              "obc": 26380,
              "sc": 13490,
              "st": 4829
            },
            "2023": {
              "general": 66315,
              "ews": 12817,
              "obc": 25852,
              "sc": 13220,
              "st": 4732
            },
            "2022": {
              "general": 64962,
              "ews": 12555,
              "obc": 25324,
              "sc": 12950,
              "st": 4635
            },
            "2021": {
              "general": 63608,
              "ews": 12294,
              "obc": 24797,
              "sc": 12680,
              "st": 4539
            },
            "2020": {
              "general": 62255,
              "ews": 12032,
              "obc": 24269,
              "sc": 12410,
              "st": 4442
            }
          }
        },
        "fees": 150000,
        "seats": 73
      },
      {
        "name": "B.Tech in Electronics & Communication Engineering",
        "code": "BECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 60414,
              "ews": 11652,
              "obc": 23770,
              "sc": 12852,
              "st": 6158
            },
            "2023": {
              "general": 59205,
              "ews": 11418,
              "obc": 23294,
              "sc": 12594,
              "st": 6034
            },
            "2022": {
              "general": 57997,
              "ews": 11185,
              "obc": 22819,
              "sc": 12337,
              "st": 5911
            },
            "2021": {
              "general": 56789,
              "ews": 10952,
              "obc": 22343,
              "sc": 12080,
              "st": 5788
            },
            "2020": {
              "general": 55580,
              "ews": 10719,
              "obc": 21868,
              "sc": 11823,
              "st": 5665
            }
          }
        },
        "fees": 150000,
        "seats": 73
      },
      {
        "name": "B.Tech in Mechanical Engineering",
        "code": "BME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 71188,
              "ews": 13343,
              "obc": 27528,
              "sc": 13332,
              "st": 5954
            },
            "2023": {
              "general": 69764,
              "ews": 13076,
              "obc": 26977,
              "sc": 13065,
              "st": 5834
            },
            "2022": {
              "general": 68340,
              "ews": 12809,
              "obc": 26426,
              "sc": 12798,
              "st": 5715
            },
            "2021": {
              "general": 66916,
              "ews": 12542,
              "obc": 25876,
              "sc": 12532,
              "st": 5596
            },
            "2020": {
              "general": 65492,
              "ews": 12275,
              "obc": 25325,
              "sc": 12265,
              "st": 5477
            }
          }
        },
        "fees": 150000,
        "seats": 73
      }
    ]
  },
  {
    "id": 14,
    "name": "Ghani Khan Choudhary Institute of Engineering and Technology, Malda, West Bengal",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil and Environmental Engineering",
        "code": "CEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 91265,
              "ews": 15730,
              "obc": 31225,
              "sc": 14017,
              "st": 7195
            },
            "2023": {
              "general": 89439,
              "ews": 15415,
              "obc": 30600,
              "sc": 13736,
              "st": 7051
            },
            "2022": {
              "general": 87614,
              "ews": 15100,
              "obc": 29976,
              "sc": 13456,
              "st": 6907
            },
            "2021": {
              "general": 85789,
              "ews": 14786,
              "obc": 29351,
              "sc": 13175,
              "st": 6763
            },
            "2020": {
              "general": 83963,
              "ews": 14471,
              "obc": 28727,
              "sc": 12895,
              "st": 6619
            }
          }
        },
        "fees": 150000,
        "seats": 74
      },
      {
        "name": "Computer Science Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 50083,
              "ews": 9000,
              "obc": 19852,
              "sc": 10827,
              "st": 5088
            },
            "2023": {
              "general": 49081,
              "ews": 8820,
              "obc": 19454,
              "sc": 10610,
              "st": 4986
            },
            "2022": {
              "general": 48079,
              "ews": 8640,
              "obc": 19057,
              "sc": 10393,
              "st": 4884
            },
            "2021": {
              "general": 47078,
              "ews": 8460,
              "obc": 18660,
              "sc": 10177,
              "st": 4782
            },
            "2020": {
              "general": 46076,
              "ews": 8280,
              "obc": 18263,
              "sc": 9960,
              "st": 4680
            }
          }
        },
        "fees": 150000,
        "seats": 74
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 81113,
              "ews": 13544,
              "obc": 26724,
              "sc": 13973,
              "st": 6208
            },
            "2023": {
              "general": 79490,
              "ews": 13273,
              "obc": 26189,
              "sc": 13693,
              "st": 6083
            },
            "2022": {
              "general": 77868,
              "ews": 13002,
              "obc": 25655,
              "sc": 13414,
              "st": 5959
            },
            "2021": {
              "general": 76246,
              "ews": 12731,
              "obc": 25120,
              "sc": 13134,
              "st": 5835
            },
            "2020": {
              "general": 74623,
              "ews": 12460,
              "obc": 24586,
              "sc": 12855,
              "st": 5711
            }
          }
        },
        "fees": 150000,
        "seats": 74
      },
      {
        "name": "Food Technology",
        "code": "FT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 100988,
              "ews": 17292,
              "obc": 34960,
              "sc": 16016,
              "st": 6756
            },
            "2023": {
              "general": 98968,
              "ews": 16946,
              "obc": 34260,
              "sc": 15695,
              "st": 6620
            },
            "2022": {
              "general": 96948,
              "ews": 16600,
              "obc": 33561,
              "sc": 15375,
              "st": 6485
            },
            "2021": {
              "general": 94928,
              "ews": 16254,
              "obc": 32862,
              "sc": 15055,
              "st": 6350
            },
            "2020": {
              "general": 92908,
              "ews": 15908,
              "obc": 32163,
              "sc": 14734,
              "st": 6215
            }
          }
        },
        "fees": 150000,
        "seats": 74
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 82007,
              "ews": 13552,
              "obc": 30167,
              "sc": 13292,
              "st": 7471
            },
            "2023": {
              "general": 80366,
              "ews": 13280,
              "obc": 29563,
              "sc": 13026,
              "st": 7321
            },
            "2022": {
              "general": 78726,
              "ews": 13009,
              "obc": 28960,
              "sc": 12760,
              "st": 7172
            },
            "2021": {
              "general": 77086,
              "ews": 12738,
              "obc": 28356,
              "sc": 12494,
              "st": 7022
            },
            "2020": {
              "general": 75446,
              "ews": 12467,
              "obc": 27753,
              "sc": 12228,
              "st": 6873
            }
          }
        },
        "fees": 150000,
        "seats": 74
      }
    ]
  },
  {
    "id": 15,
    "name": "Gurukula Kangri Vishwavidyalaya, Haridwar",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 69184,
              "ews": 12160,
              "obc": 25262,
              "sc": 12619,
              "st": 6288
            },
            "2023": {
              "general": 67800,
              "ews": 11916,
              "obc": 24756,
              "sc": 12366,
              "st": 6162
            },
            "2022": {
              "general": 66416,
              "ews": 11673,
              "obc": 24251,
              "sc": 12114,
              "st": 6036
            },
            "2021": {
              "general": 65032,
              "ews": 11430,
              "obc": 23746,
              "sc": 11861,
              "st": 5910
            },
            "2020": {
              "general": 63649,
              "ews": 11187,
              "obc": 23241,
              "sc": 11609,
              "st": 5784
            }
          }
        },
        "fees": 150000,
        "seats": 75
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 74723,
              "ews": 13434,
              "obc": 28888,
              "sc": 13249,
              "st": 5636
            },
            "2023": {
              "general": 73228,
              "ews": 13165,
              "obc": 28310,
              "sc": 12984,
              "st": 5523
            },
            "2022": {
              "general": 71734,
              "ews": 12896,
              "obc": 27732,
              "sc": 12719,
              "st": 5410
            },
            "2021": {
              "general": 70239,
              "ews": 12627,
              "obc": 27154,
              "sc": 12454,
              "st": 5297
            },
            "2020": {
              "general": 68745,
              "ews": 12359,
              "obc": 26576,
              "sc": 12189,
              "st": 5185
            }
          }
        },
        "fees": 150000,
        "seats": 75
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 80060,
              "ews": 13708,
              "obc": 28315,
              "sc": 14018,
              "st": 6861
            },
            "2023": {
              "general": 78458,
              "ews": 13433,
              "obc": 27748,
              "sc": 13737,
              "st": 6723
            },
            "2022": {
              "general": 76857,
              "ews": 13159,
              "obc": 27182,
              "sc": 13457,
              "st": 6586
            },
            "2021": {
              "general": 75256,
              "ews": 12885,
              "obc": 26616,
              "sc": 13176,
              "st": 6449
            },
            "2020": {
              "general": 73655,
              "ews": 12611,
              "obc": 26049,
              "sc": 12896,
              "st": 6312
            }
          }
        },
        "fees": 150000,
        "seats": 75
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 92938,
              "ews": 16347,
              "obc": 33595,
              "sc": 15456,
              "st": 7213
            },
            "2023": {
              "general": 91079,
              "ews": 16020,
              "obc": 32923,
              "sc": 15146,
              "st": 7068
            },
            "2022": {
              "general": 89220,
              "ews": 15693,
              "obc": 32251,
              "sc": 14837,
              "st": 6924
            },
            "2021": {
              "general": 87361,
              "ews": 15366,
              "obc": 31579,
              "sc": 14528,
              "st": 6780
            },
            "2020": {
              "general": 85502,
              "ews": 15039,
              "obc": 30907,
              "sc": 14219,
              "st": 6635
            }
          }
        },
        "fees": 150000,
        "seats": 75
      }
    ]
  },
  {
    "id": 16,
    "name": "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY SENAPATI MANIPUR",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 47949,
              "ews": 8361,
              "obc": 18020,
              "sc": 10623,
              "st": 4697
            },
            "2023": {
              "general": 46990,
              "ews": 8193,
              "obc": 17659,
              "sc": 10410,
              "st": 4603
            },
            "2022": {
              "general": 46031,
              "ews": 8026,
              "obc": 17299,
              "sc": 10198,
              "st": 4509
            },
            "2021": {
              "general": 45072,
              "ews": 7859,
              "obc": 16938,
              "sc": 9985,
              "st": 4415
            },
            "2020": {
              "general": 44113,
              "ews": 7692,
              "obc": 16578,
              "sc": 9773,
              "st": 4321
            }
          }
        },
        "fees": 150000,
        "seats": 76
      },
      {
        "name": "Computer Science and Engineering with specialization in Artificial Intelligence and Data Science",
        "code": "CSEAI",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 44519,
              "ews": 8337,
              "obc": 17578,
              "sc": 10255,
              "st": 4768
            },
            "2023": {
              "general": 43628,
              "ews": 8170,
              "obc": 17226,
              "sc": 10049,
              "st": 4672
            },
            "2022": {
              "general": 42738,
              "ews": 8003,
              "obc": 16874,
              "sc": 9844,
              "st": 4577
            },
            "2021": {
              "general": 41847,
              "ews": 7836,
              "obc": 16523,
              "sc": 9639,
              "st": 4481
            },
            "2020": {
              "general": 40957,
              "ews": 7670,
              "obc": 16171,
              "sc": 9434,
              "st": 4386
            }
          }
        },
        "fees": 150000,
        "seats": 76
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 54987,
              "ews": 9338,
              "obc": 19371,
              "sc": 11153,
              "st": 5101
            },
            "2023": {
              "general": 53887,
              "ews": 9151,
              "obc": 18983,
              "sc": 10929,
              "st": 4998
            },
            "2022": {
              "general": 52787,
              "ews": 8964,
              "obc": 18596,
              "sc": 10706,
              "st": 4896
            },
            "2021": {
              "general": 51687,
              "ews": 8777,
              "obc": 18208,
              "sc": 10483,
              "st": 4794
            },
            "2020": {
              "general": 50588,
              "ews": 8590,
              "obc": 17821,
              "sc": 10260,
              "st": 4692
            }
          }
        },
        "fees": 150000,
        "seats": 76
      },
      {
        "name": "Electronics and Communication Engineering with specialization in VLSI and Embedded Systems",
        "code": "ECEVE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 55098,
              "ews": 9358,
              "obc": 18952,
              "sc": 11145,
              "st": 5124
            },
            "2023": {
              "general": 53996,
              "ews": 9170,
              "obc": 18572,
              "sc": 10922,
              "st": 5021
            },
            "2022": {
              "general": 52894,
              "ews": 8983,
              "obc": 18193,
              "sc": 10699,
              "st": 4919
            },
            "2021": {
              "general": 51792,
              "ews": 8796,
              "obc": 17814,
              "sc": 10476,
              "st": 4816
            },
            "2020": {
              "general": 50690,
              "ews": 8609,
              "obc": 17435,
              "sc": 10253,
              "st": 4714
            }
          }
        },
        "fees": 150000,
        "seats": 76
      }
    ]
  },
  {
    "id": 17,
    "name": "Indian Institute of Carpet Technology, Bhadohi",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Carpet and Textile Technology",
        "code": "CTT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 103566,
              "ews": 17298,
              "obc": 36895,
              "sc": 15639,
              "st": 6282
            },
            "2023": {
              "general": 101494,
              "ews": 16952,
              "obc": 36157,
              "sc": 15326,
              "st": 6156
            },
            "2022": {
              "general": 99423,
              "ews": 16606,
              "obc": 35419,
              "sc": 15013,
              "st": 6030
            },
            "2021": {
              "general": 97352,
              "ews": 16260,
              "obc": 34681,
              "sc": 14700,
              "st": 5905
            },
            "2020": {
              "general": 95280,
              "ews": 15914,
              "obc": 33943,
              "sc": 14387,
              "st": 5779
            }
          }
        },
        "fees": 150000,
        "seats": 77
      }
    ]
  },
  {
    "id": 18,
    "name": "Indian Institute of Engineering Science and Technology, Shibpur",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Aerospace Engineering",
        "code": "AE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 20369,
              "ews": 3770,
              "obc": 7881,
              "sc": 2498,
              "st": 1739
            },
            "2023": {
              "general": 19961,
              "ews": 3694,
              "obc": 7723,
              "sc": 2448,
              "st": 1704
            },
            "2022": {
              "general": 19554,
              "ews": 3619,
              "obc": 7565,
              "sc": 2398,
              "st": 1669
            },
            "2021": {
              "general": 19146,
              "ews": 3543,
              "obc": 7408,
              "sc": 2348,
              "st": 1634
            },
            "2020": {
              "general": 18739,
              "ews": 3468,
              "obc": 7250,
              "sc": 2298,
              "st": 1599
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 1280,
              "ews": 1041,
              "obc": 724,
              "sc": 259,
              "st": 123
            },
            "2023": {
              "general": 1254,
              "ews": 1020,
              "obc": 709,
              "sc": 253,
              "st": 120
            },
            "2022": {
              "general": 1228,
              "ews": 999,
              "obc": 695,
              "sc": 248,
              "st": 118
            },
            "2021": {
              "general": 1203,
              "ews": 978,
              "obc": 680,
              "sc": 243,
              "st": 115
            },
            "2020": {
              "general": 1177,
              "ews": 957,
              "obc": 666,
              "sc": 238,
              "st": 113
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 46450,
              "ews": 8024,
              "obc": 16352,
              "sc": 8378,
              "st": 2056
            },
            "2023": {
              "general": 45521,
              "ews": 7863,
              "obc": 16024,
              "sc": 8210,
              "st": 2014
            },
            "2022": {
              "general": 44592,
              "ews": 7703,
              "obc": 15697,
              "sc": 8042,
              "st": 1973
            },
            "2021": {
              "general": 43663,
              "ews": 7542,
              "obc": 15370,
              "sc": 7875,
              "st": 1932
            },
            "2020": {
              "general": 42734,
              "ews": 7382,
              "obc": 15043,
              "sc": 7707,
              "st": 1891
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 13340,
              "ews": 2108,
              "obc": 5642,
              "sc": 3155,
              "st": 1349
            },
            "2023": {
              "general": 13073,
              "ews": 2065,
              "obc": 5529,
              "sc": 3091,
              "st": 1322
            },
            "2022": {
              "general": 12806,
              "ews": 2023,
              "obc": 5416,
              "sc": 3028,
              "st": 1295
            },
            "2021": {
              "general": 12539,
              "ews": 1981,
              "obc": 5303,
              "sc": 2965,
              "st": 1268
            },
            "2020": {
              "general": 12272,
              "ews": 1939,
              "obc": 5190,
              "sc": 2902,
              "st": 1241
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 27029,
              "ews": 4506,
              "obc": 9688,
              "sc": 5983,
              "st": 2259
            },
            "2023": {
              "general": 26488,
              "ews": 4415,
              "obc": 9494,
              "sc": 5863,
              "st": 2213
            },
            "2022": {
              "general": 25947,
              "ews": 4325,
              "obc": 9300,
              "sc": 5743,
              "st": 2168
            },
            "2021": {
              "general": 25407,
              "ews": 4235,
              "obc": 9106,
              "sc": 5624,
              "st": 2123
            },
            "2020": {
              "general": 24866,
              "ews": 4145,
              "obc": 8912,
              "sc": 5504,
              "st": 2078
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Electronics and Telecommunication Engineering",
        "code": "ETE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 20098,
              "ews": 3368,
              "obc": 7642,
              "sc": 4795,
              "st": 1646
            },
            "2023": {
              "general": 19696,
              "ews": 3300,
              "obc": 7489,
              "sc": 4699,
              "st": 1613
            },
            "2022": {
              "general": 19294,
              "ews": 3233,
              "obc": 7336,
              "sc": 4603,
              "st": 1580
            },
            "2021": {
              "general": 18892,
              "ews": 3165,
              "obc": 7183,
              "sc": 4507,
              "st": 1547
            },
            "2020": {
              "general": 18490,
              "ews": 3098,
              "obc": 7030,
              "sc": 4411,
              "st": 1514
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 16272,
              "ews": 2649,
              "obc": 6398,
              "sc": 3977,
              "st": 1819
            },
            "2023": {
              "general": 15946,
              "ews": 2596,
              "obc": 6270,
              "sc": 3897,
              "st": 1782
            },
            "2022": {
              "general": 15621,
              "ews": 2543,
              "obc": 6142,
              "sc": 3817,
              "st": 1746
            },
            "2021": {
              "general": 15295,
              "ews": 2490,
              "obc": 6014,
              "sc": 3738,
              "st": 1709
            },
            "2020": {
              "general": 14970,
              "ews": 2437,
              "obc": 5886,
              "sc": 3658,
              "st": 1673
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 34817,
              "ews": 5753,
              "obc": 12182,
              "sc": 7265,
              "st": 2461
            },
            "2023": {
              "general": 34120,
              "ews": 5637,
              "obc": 11938,
              "sc": 7119,
              "st": 2411
            },
            "2022": {
              "general": 33424,
              "ews": 5522,
              "obc": 11694,
              "sc": 6974,
              "st": 2362
            },
            "2021": {
              "general": 32727,
              "ews": 5407,
              "obc": 11451,
              "sc": 6829,
              "st": 2313
            },
            "2020": {
              "general": 32031,
              "ews": 5292,
              "obc": 11207,
              "sc": 6683,
              "st": 2264
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Metallurgy and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 48919,
              "ews": 7962,
              "obc": 17070,
              "sc": 8417,
              "st": 3201
            },
            "2023": {
              "general": 47940,
              "ews": 7802,
              "obc": 16728,
              "sc": 8248,
              "st": 3136
            },
            "2022": {
              "general": 46962,
              "ews": 7643,
              "obc": 16387,
              "sc": 8080,
              "st": 3072
            },
            "2021": {
              "general": 45983,
              "ews": 7484,
              "obc": 16045,
              "sc": 7911,
              "st": 3008
            },
            "2020": {
              "general": 45005,
              "ews": 7325,
              "obc": 15704,
              "sc": 7743,
              "st": 2944
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Mining Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 50765,
              "ews": 8455,
              "obc": 17416,
              "sc": 8856,
              "st": 3372
            },
            "2023": {
              "general": 49749,
              "ews": 8285,
              "obc": 17067,
              "sc": 8678,
              "st": 3304
            },
            "2022": {
              "general": 48734,
              "ews": 8116,
              "obc": 16719,
              "sc": 8501,
              "st": 3237
            },
            "2021": {
              "general": 47719,
              "ews": 7947,
              "obc": 16371,
              "sc": 8324,
              "st": 3169
            },
            "2020": {
              "general": 46703,
              "ews": 7778,
              "obc": 16022,
              "sc": 8147,
              "st": 3102
            }
          }
        },
        "fees": 150000,
        "seats": 78
      }
    ]
  },
  {
    "id": 19,
    "name": "Indian Institute of Handloom Technology(IIHT), Varanasi",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Handloom and Textile Technology",
        "code": "HTT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 98324,
              "ews": 17463,
              "obc": 36050,
              "sc": 14947,
              "st": 7346
            },
            "2023": {
              "general": 96357,
              "ews": 17113,
              "obc": 35329,
              "sc": 14648,
              "st": 7199
            },
            "2022": {
              "general": 94391,
              "ews": 16764,
              "obc": 34608,
              "sc": 14349,
              "st": 7052
            },
            "2021": {
              "general": 92424,
              "ews": 16415,
              "obc": 33887,
              "sc": 14050,
              "st": 6905
            },
            "2020": {
              "general": 90458,
              "ews": 16065,
              "obc": 33166,
              "sc": 13751,
              "st": 6758
            }
          }
        },
        "fees": 150000,
        "seats": 79
      }
    ]
  },
  {
    "id": 20,
    "name": "Indian Institute of Handloom Technology, Salem",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Handloom and Textile Technology",
        "code": "HTT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 94061,
              "ews": 16709,
              "obc": 34958,
              "sc": 14193,
              "st": 6904
            },
            "2023": {
              "general": 92179,
              "ews": 16374,
              "obc": 34258,
              "sc": 13909,
              "st": 6765
            },
            "2022": {
              "general": 90298,
              "ews": 16040,
              "obc": 33559,
              "sc": 13625,
              "st": 6627
            },
            "2021": {
              "general": 88417,
              "ews": 15706,
              "obc": 32860,
              "sc": 13341,
              "st": 6489
            },
            "2020": {
              "general": 86536,
              "ews": 15372,
              "obc": 32161,
              "sc": 13057,
              "st": 6351
            }
          }
        },
        "fees": 150000,
        "seats": 80
      }
    ]
  },
  {
    "id": 21,
    "name": "Indian Institute of Information Technology (IIIT) Nagpur",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 26132,
              "ews": 4721,
              "obc": 11648,
              "sc": 7944,
              "st": 3640
            },
            "2023": {
              "general": 25609,
              "ews": 4626,
              "obc": 11415,
              "sc": 7785,
              "st": 3567
            },
            "2022": {
              "general": 25086,
              "ews": 4532,
              "obc": 11182,
              "sc": 7626,
              "st": 3494
            },
            "2021": {
              "general": 24564,
              "ews": 4437,
              "obc": 10949,
              "sc": 7467,
              "st": 3421
            },
            "2020": {
              "general": 24041,
              "ews": 4343,
              "obc": 10716,
              "sc": 7308,
              "st": 3348
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Computer Science Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 29120,
              "ews": 5264,
              "obc": 12913,
              "sc": 8418,
              "st": 4174
            },
            "2023": {
              "general": 28537,
              "ews": 5158,
              "obc": 12654,
              "sc": 8249,
              "st": 4090
            },
            "2022": {
              "general": 27955,
              "ews": 5053,
              "obc": 12396,
              "sc": 8081,
              "st": 4007
            },
            "2021": {
              "general": 27372,
              "ews": 4948,
              "obc": 12138,
              "sc": 7912,
              "st": 3923
            },
            "2020": {
              "general": 26790,
              "ews": 4842,
              "obc": 11879,
              "sc": 7744,
              "st": 3840
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 33744,
              "ews": 6287,
              "obc": 14997,
              "sc": 9340,
              "st": 4481
            },
            "2023": {
              "general": 33069,
              "ews": 6161,
              "obc": 14697,
              "sc": 9153,
              "st": 4391
            },
            "2022": {
              "general": 32394,
              "ews": 6035,
              "obc": 14397,
              "sc": 8966,
              "st": 4301
            },
            "2021": {
              "general": 31719,
              "ews": 5909,
              "obc": 14097,
              "sc": 8779,
              "st": 4212
            },
            "2020": {
              "general": 31044,
              "ews": 5784,
              "obc": 13797,
              "sc": 8592,
              "st": 4122
            }
          }
        },
        "fees": 150000,
        "seats": 81
      }
    ]
  },
  {
    "id": 22,
    "name": "Indian Institute of Information Technology (IIIT) Pune",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 16691,
              "ews": 3187,
              "obc": 7985,
              "sc": 5476,
              "st": 2905
            },
            "2023": {
              "general": 16357,
              "ews": 3123,
              "obc": 7825,
              "sc": 5366,
              "st": 2846
            },
            "2022": {
              "general": 16023,
              "ews": 3059,
              "obc": 7665,
              "sc": 5256,
              "st": 2788
            },
            "2021": {
              "general": 15689,
              "ews": 2995,
              "obc": 7505,
              "sc": 5147,
              "st": 2730
            },
            "2020": {
              "general": 15355,
              "ews": 2932,
              "obc": 7346,
              "sc": 5037,
              "st": 2672
            }
          }
        },
        "fees": 150000,
        "seats": 82
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 22733,
              "ews": 4019,
              "obc": 10916,
              "sc": 7837,
              "st": 3346
            },
            "2023": {
              "general": 22278,
              "ews": 3938,
              "obc": 10697,
              "sc": 7680,
              "st": 3279
            },
            "2022": {
              "general": 21823,
              "ews": 3858,
              "obc": 10479,
              "sc": 7523,
              "st": 3212
            },
            "2021": {
              "general": 21369,
              "ews": 3777,
              "obc": 10261,
              "sc": 7366,
              "st": 3145
            },
            "2020": {
              "general": 20914,
              "ews": 3697,
              "obc": 10042,
              "sc": 7210,
              "st": 3078
            }
          }
        },
        "fees": 150000,
        "seats": 82
      }
    ]
  },
  {
    "id": 23,
    "name": "Indian Institute of Information Technology (IIIT) Ranchi",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 29448,
              "ews": 5113,
              "obc": 13175,
              "sc": 8131,
              "st": 4267
            },
            "2023": {
              "general": 28859,
              "ews": 5010,
              "obc": 12911,
              "sc": 7968,
              "st": 4181
            },
            "2022": {
              "general": 28270,
              "ews": 4908,
              "obc": 12648,
              "sc": 7805,
              "st": 4096
            },
            "2021": {
              "general": 27681,
              "ews": 4806,
              "obc": 12384,
              "sc": 7643,
              "st": 4010
            },
            "2020": {
              "general": 27092,
              "ews": 4703,
              "obc": 12121,
              "sc": 7480,
              "st": 3925
            }
          }
        },
        "fees": 150000,
        "seats": 83
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 37678,
              "ews": 6658,
              "obc": 15941,
              "sc": 9958,
              "st": 4628
            },
            "2023": {
              "general": 36924,
              "ews": 6524,
              "obc": 15622,
              "sc": 9758,
              "st": 4535
            },
            "2022": {
              "general": 36170,
              "ews": 6391,
              "obc": 15303,
              "sc": 9559,
              "st": 4442
            },
            "2021": {
              "general": 35417,
              "ews": 6258,
              "obc": 14984,
              "sc": 9360,
              "st": 4350
            },
            "2020": {
              "general": 34663,
              "ews": 6125,
              "obc": 14665,
              "sc": 9161,
              "st": 4257
            }
          }
        },
        "fees": 150000,
        "seats": 83
      }
    ]
  },
  {
    "id": 24,
    "name": "Indian Institute of Information Technology (IIIT), Sri City, Chittoor",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Artificial Intelligence and Data Science",
        "code": "AIDS",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 26394,
              "ews": 4748,
              "obc": 11898,
              "sc": 7771,
              "st": 3553
            },
            "2023": {
              "general": 25866,
              "ews": 4653,
              "obc": 11660,
              "sc": 7615,
              "st": 3481
            },
            "2022": {
              "general": 25338,
              "ews": 4558,
              "obc": 11422,
              "sc": 7460,
              "st": 3410
            },
            "2021": {
              "general": 24810,
              "ews": 4463,
              "obc": 11184,
              "sc": 7304,
              "st": 3339
            },
            "2020": {
              "general": 24282,
              "ews": 4368,
              "obc": 10946,
              "sc": 7149,
              "st": 3268
            }
          }
        },
        "fees": 150000,
        "seats": 84
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 25240,
              "ews": 4709,
              "obc": 10911,
              "sc": 8007,
              "st": 3926
            },
            "2023": {
              "general": 24735,
              "ews": 4614,
              "obc": 10692,
              "sc": 7846,
              "st": 3847
            },
            "2022": {
              "general": 24230,
              "ews": 4520,
              "obc": 10474,
              "sc": 7686,
              "st": 3768
            },
            "2021": {
              "general": 23725,
              "ews": 4426,
              "obc": 10256,
              "sc": 7526,
              "st": 3690
            },
            "2020": {
              "general": 23220,
              "ews": 4332,
              "obc": 10038,
              "sc": 7366,
              "st": 3611
            }
          }
        },
        "fees": 150000,
        "seats": 84
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 34733,
              "ews": 6155,
              "obc": 13610,
              "sc": 9628,
              "st": 4141
            },
            "2023": {
              "general": 34038,
              "ews": 6031,
              "obc": 13337,
              "sc": 9435,
              "st": 4058
            },
            "2022": {
              "general": 33343,
              "ews": 5908,
              "obc": 13065,
              "sc": 9242,
              "st": 3975
            },
            "2021": {
              "general": 32649,
              "ews": 5785,
              "obc": 12793,
              "sc": 9050,
              "st": 3892
            },
            "2020": {
              "general": 31954,
              "ews": 5662,
              "obc": 12521,
              "sc": 8857,
              "st": 3809
            }
          }
        },
        "fees": 150000,
        "seats": 84
      }
    ]
  },
  {
    "id": 25,
    "name": "Indian Institute of Information Technology (IIIT)Kota, Rajasthan",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Artificial Intelligence and Data Engineering",
        "code": "AIDE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 25393,
              "ews": 4529,
              "obc": 10784,
              "sc": 7363,
              "st": 3475
            },
            "2023": {
              "general": 24885,
              "ews": 4438,
              "obc": 10568,
              "sc": 7215,
              "st": 3405
            },
            "2022": {
              "general": 24377,
              "ews": 4347,
              "obc": 10352,
              "sc": 7068,
              "st": 3336
            },
            "2021": {
              "general": 23869,
              "ews": 4257,
              "obc": 10136,
              "sc": 6921,
              "st": 3266
            },
            "2020": {
              "general": 23361,
              "ews": 4166,
              "obc": 9921,
              "sc": 6773,
              "st": 3197
            }
          }
        },
        "fees": 150000,
        "seats": 85
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 23319,
              "ews": 4189,
              "obc": 10271,
              "sc": 7199,
              "st": 3364
            },
            "2023": {
              "general": 22852,
              "ews": 4105,
              "obc": 10065,
              "sc": 7055,
              "st": 3296
            },
            "2022": {
              "general": 22386,
              "ews": 4021,
              "obc": 9860,
              "sc": 6911,
              "st": 3229
            },
            "2021": {
              "general": 21919,
              "ews": 3937,
              "obc": 9654,
              "sc": 6767,
              "st": 3162
            },
            "2020": {
              "general": 21453,
              "ews": 3853,
              "obc": 9449,
              "sc": 6623,
              "st": 3094
            }
          }
        },
        "fees": 150000,
        "seats": 85
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 32686,
              "ews": 5607,
              "obc": 14210,
              "sc": 8465,
              "st": 3604
            },
            "2023": {
              "general": 32032,
              "ews": 5494,
              "obc": 13925,
              "sc": 8295,
              "st": 3531
            },
            "2022": {
              "general": 31378,
              "ews": 5382,
              "obc": 13641,
              "sc": 8126,
              "st": 3459
            },
            "2021": {
              "general": 30724,
              "ews": 5270,
              "obc": 13357,
              "sc": 7957,
              "st": 3387
            },
            "2020": {
              "general": 30071,
              "ews": 5158,
              "obc": 13073,
              "sc": 7787,
              "st": 3315
            }
          }
        },
        "fees": 150000,
        "seats": 85
      }
    ]
  },
  {
    "id": 26,
    "name": "Indian Institute of Information Technology Bhagalpur",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 37010,
              "ews": 6487,
              "obc": 15196,
              "sc": 9090,
              "st": 4905
            },
            "2023": {
              "general": 36269,
              "ews": 6357,
              "obc": 14892,
              "sc": 8908,
              "st": 4806
            },
            "2022": {
              "general": 35529,
              "ews": 6227,
              "obc": 14588,
              "sc": 8726,
              "st": 4708
            },
            "2021": {
              "general": 34789,
              "ews": 6097,
              "obc": 14284,
              "sc": 8544,
              "st": 4610
            },
            "2020": {
              "general": 34049,
              "ews": 5968,
              "obc": 13980,
              "sc": 8362,
              "st": 4512
            }
          }
        },
        "fees": 150000,
        "seats": 86
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 40879,
              "ews": 6821,
              "obc": 16654,
              "sc": 9990,
              "st": 4974
            },
            "2023": {
              "general": 40061,
              "ews": 6684,
              "obc": 16320,
              "sc": 9790,
              "st": 4874
            },
            "2022": {
              "general": 39243,
              "ews": 6548,
              "obc": 15987,
              "sc": 9590,
              "st": 4775
            },
            "2021": {
              "general": 38426,
              "ews": 6411,
              "obc": 15654,
              "sc": 9390,
              "st": 4675
            },
            "2020": {
              "general": 37608,
              "ews": 6275,
              "obc": 15321,
              "sc": 9190,
              "st": 4576
            }
          }
        },
        "fees": 150000,
        "seats": 86
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 37811,
              "ews": 6423,
              "obc": 16189,
              "sc": 10021,
              "st": 4987
            },
            "2023": {
              "general": 37054,
              "ews": 6294,
              "obc": 15865,
              "sc": 9820,
              "st": 4887
            },
            "2022": {
              "general": 36298,
              "ews": 6166,
              "obc": 15541,
              "sc": 9620,
              "st": 4787
            },
            "2021": {
              "general": 35542,
              "ews": 6037,
              "obc": 15217,
              "sc": 9419,
              "st": 4687
            },
            "2020": {
              "general": 34786,
              "ews": 5909,
              "obc": 14893,
              "sc": 9219,
              "st": 4588
            }
          }
        },
        "fees": 150000,
        "seats": 86
      },
      {
        "name": "Mechatronics and Automation Engineering",
        "code": "MAE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 45334,
              "ews": 7604,
              "obc": 17728,
              "sc": 10438,
              "st": 5139
            },
            "2023": {
              "general": 44427,
              "ews": 7451,
              "obc": 17373,
              "sc": 10229,
              "st": 5036
            },
            "2022": {
              "general": 43520,
              "ews": 7299,
              "obc": 17018,
              "sc": 10020,
              "st": 4933
            },
            "2021": {
              "general": 42613,
              "ews": 7147,
              "obc": 16664,
              "sc": 9811,
              "st": 4830
            },
            "2020": {
              "general": 41707,
              "ews": 6995,
              "obc": 16309,
              "sc": 9602,
              "st": 4727
            }
          }
        },
        "fees": 150000,
        "seats": 86
      }
    ]
  },
  {
    "id": 27,
    "name": "Indian Institute of Information Technology Bhopal",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 22017,
              "ews": 3784,
              "obc": 10316,
              "sc": 5621,
              "st": 2816
            },
            "2023": {
              "general": 21576,
              "ews": 3708,
              "obc": 10109,
              "sc": 5508,
              "st": 2759
            },
            "2022": {
              "general": 21136,
              "ews": 3632,
              "obc": 9903,
              "sc": 5396,
              "st": 2703
            },
            "2021": {
              "general": 20695,
              "ews": 3556,
              "obc": 9697,
              "sc": 5283,
              "st": 2647
            },
            "2020": {
              "general": 20255,
              "ews": 3481,
              "obc": 9490,
              "sc": 5171,
              "st": 2590
            }
          }
        },
        "fees": 150000,
        "seats": 87
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 33296,
              "ews": 5889,
              "obc": 14255,
              "sc": 8851,
              "st": 4632
            },
            "2023": {
              "general": 32630,
              "ews": 5771,
              "obc": 13969,
              "sc": 8673,
              "st": 4539
            },
            "2022": {
              "general": 31964,
              "ews": 5653,
              "obc": 13684,
              "sc": 8496,
              "st": 4446
            },
            "2021": {
              "general": 31298,
              "ews": 5535,
              "obc": 13399,
              "sc": 8319,
              "st": 4354
            },
            "2020": {
              "general": 30632,
              "ews": 5417,
              "obc": 13114,
              "sc": 8142,
              "st": 4261
            }
          }
        },
        "fees": 150000,
        "seats": 87
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 27958,
              "ews": 5099,
              "obc": 12164,
              "sc": 7949,
              "st": 4354
            },
            "2023": {
              "general": 27398,
              "ews": 4997,
              "obc": 11920,
              "sc": 7790,
              "st": 4266
            },
            "2022": {
              "general": 26839,
              "ews": 4895,
              "obc": 11677,
              "sc": 7631,
              "st": 4179
            },
            "2021": {
              "general": 26280,
              "ews": 4793,
              "obc": 11434,
              "sc": 7472,
              "st": 4092
            },
            "2020": {
              "general": 25721,
              "ews": 4691,
              "obc": 11190,
              "sc": 7313,
              "st": 4005
            }
          }
        },
        "fees": 150000,
        "seats": 87
      }
    ]
  },
  {
    "id": 28,
    "name": "Indian Institute of Information Technology Design & Manufacturing Kurnool, Andhra Pradesh",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Artificial Intelligence and Data Science",
        "code": "AIDS",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 35599,
              "ews": 5884,
              "obc": 13985,
              "sc": 6190,
              "st": 2934
            },
            "2023": {
              "general": 34887,
              "ews": 5766,
              "obc": 13705,
              "sc": 6066,
              "st": 2875
            },
            "2022": {
              "general": 34175,
              "ews": 5648,
              "obc": 13425,
              "sc": 5942,
              "st": 2816
            },
            "2021": {
              "general": 33463,
              "ews": 5530,
              "obc": 13145,
              "sc": 5818,
              "st": 2757
            },
            "2020": {
              "general": 32751,
              "ews": 5413,
              "obc": 12866,
              "sc": 5694,
              "st": 2699
            }
          }
        },
        "fees": 150000,
        "seats": 88
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 34900,
              "ews": 5988,
              "obc": 14516,
              "sc": 6939,
              "st": 1814
            },
            "2023": {
              "general": 34202,
              "ews": 5868,
              "obc": 14225,
              "sc": 6800,
              "st": 1777
            },
            "2022": {
              "general": 33504,
              "ews": 5748,
              "obc": 13935,
              "sc": 6661,
              "st": 1741
            },
            "2021": {
              "general": 32806,
              "ews": 5628,
              "obc": 13645,
              "sc": 6522,
              "st": 1705
            },
            "2020": {
              "general": 32108,
              "ews": 5508,
              "obc": 13354,
              "sc": 6383,
              "st": 1668
            }
          }
        },
        "fees": 150000,
        "seats": 88
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 40519,
              "ews": 6914,
              "obc": 16402,
              "sc": 7695,
              "st": 3398
            },
            "2023": {
              "general": 39708,
              "ews": 6775,
              "obc": 16073,
              "sc": 7541,
              "st": 3330
            },
            "2022": {
              "general": 38898,
              "ews": 6637,
              "obc": 15745,
              "sc": 7387,
              "st": 3262
            },
            "2021": {
              "general": 38087,
              "ews": 6499,
              "obc": 15417,
              "sc": 7233,
              "st": 3194
            },
            "2020": {
              "general": 37277,
              "ews": 6360,
              "obc": 15089,
              "sc": 7079,
              "st": 3126
            }
          }
        },
        "fees": 150000,
        "seats": 88
      },
      {
        "name": "Electronics and Communication Engineering with specialization in Design and Manufacturing",
        "code": "ECEDM",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 39691,
              "ews": 6650,
              "obc": 15836,
              "sc": 7677,
              "st": 3301
            },
            "2023": {
              "general": 38897,
              "ews": 6517,
              "obc": 15519,
              "sc": 7523,
              "st": 3234
            },
            "2022": {
              "general": 38103,
              "ews": 6384,
              "obc": 15202,
              "sc": 7369,
              "st": 3168
            },
            "2021": {
              "general": 37309,
              "ews": 6251,
              "obc": 14885,
              "sc": 7216,
              "st": 3102
            },
            "2020": {
              "general": 36515,
              "ews": 6118,
              "obc": 14569,
              "sc": 7062,
              "st": 3036
            }
          }
        },
        "fees": 150000,
        "seats": 88
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 48823,
              "ews": 8425,
              "obc": 17912,
              "sc": 8903,
              "st": 3824
            },
            "2023": {
              "general": 47846,
              "ews": 8256,
              "obc": 17553,
              "sc": 8724,
              "st": 3747
            },
            "2022": {
              "general": 46870,
              "ews": 8088,
              "obc": 17195,
              "sc": 8546,
              "st": 3671
            },
            "2021": {
              "general": 45893,
              "ews": 7919,
              "obc": 16837,
              "sc": 8368,
              "st": 3594
            },
            "2020": {
              "general": 44917,
              "ews": 7751,
              "obc": 16479,
              "sc": 8190,
              "st": 3518
            }
          }
        },
        "fees": 150000,
        "seats": 88
      },
      {
        "name": "Mechanical Engineering with specialization in Design and Manufacturing",
        "code": "MEDM",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 46952,
              "ews": 8051,
              "obc": 17262,
              "sc": 8833,
              "st": 3817
            },
            "2023": {
              "general": 46012,
              "ews": 7889,
              "obc": 16916,
              "sc": 8656,
              "st": 3740
            },
            "2022": {
              "general": 45073,
              "ews": 7728,
              "obc": 16571,
              "sc": 8479,
              "st": 3664
            },
            "2021": {
              "general": 44134,
              "ews": 7567,
              "obc": 16226,
              "sc": 8303,
              "st": 3587
            },
            "2020": {
              "general": 43195,
              "ews": 7406,
              "obc": 15881,
              "sc": 8126,
              "st": 3511
            }
          }
        },
        "fees": 150000,
        "seats": 88
      }
    ]
  },
  {
    "id": 29,
    "name": "Indian Institute of Information Technology Guwahati",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 19084,
              "ews": 3381,
              "obc": 8305,
              "sc": 5027,
              "st": 2701
            },
            "2023": {
              "general": 18702,
              "ews": 3313,
              "obc": 8138,
              "sc": 4926,
              "st": 2646
            },
            "2022": {
              "general": 18320,
              "ews": 3245,
              "obc": 7972,
              "sc": 4825,
              "st": 2592
            },
            "2021": {
              "general": 17938,
              "ews": 3178,
              "obc": 7806,
              "sc": 4725,
              "st": 2538
            },
            "2020": {
              "general": 17557,
              "ews": 3110,
              "obc": 7640,
              "sc": 4624,
              "st": 2484
            }
          }
        },
        "fees": 150000,
        "seats": 89
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 28111,
              "ews": 5410,
              "obc": 13246,
              "sc": 6919,
              "st": 3345
            },
            "2023": {
              "general": 27548,
              "ews": 5301,
              "obc": 12981,
              "sc": 6780,
              "st": 3278
            },
            "2022": {
              "general": 26986,
              "ews": 5193,
              "obc": 12716,
              "sc": 6642,
              "st": 3211
            },
            "2021": {
              "general": 26424,
              "ews": 5085,
              "obc": 12451,
              "sc": 6503,
              "st": 3144
            },
            "2020": {
              "general": 25862,
              "ews": 4977,
              "obc": 12186,
              "sc": 6365,
              "st": 3077
            }
          }
        },
        "fees": 150000,
        "seats": 89
      }
    ]
  },
  {
    "id": 30,
    "name": "Indian Institute of Information Technology Lucknow",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science",
        "code": "CS",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 9123,
              "ews": 1550,
              "obc": 4134,
              "sc": 3112,
              "st": 1776
            },
            "2023": {
              "general": 8940,
              "ews": 1519,
              "obc": 4051,
              "sc": 3049,
              "st": 1740
            },
            "2022": {
              "general": 8758,
              "ews": 1488,
              "obc": 3968,
              "sc": 2987,
              "st": 1704
            },
            "2021": {
              "general": 8575,
              "ews": 1457,
              "obc": 3885,
              "sc": 2925,
              "st": 1669
            },
            "2020": {
              "general": 8393,
              "ews": 1426,
              "obc": 3803,
              "sc": 2863,
              "st": 1633
            }
          }
        },
        "fees": 150000,
        "seats": 90
      },
      {
        "name": "Computer Science and Artificial Intelligence",
        "code": "CSAI",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 9011,
              "ews": 1510,
              "obc": 4029,
              "sc": 2693,
              "st": 1751
            },
            "2023": {
              "general": 8830,
              "ews": 1479,
              "obc": 3948,
              "sc": 2639,
              "st": 1715
            },
            "2022": {
              "general": 8650,
              "ews": 1449,
              "obc": 3867,
              "sc": 2585,
              "st": 1680
            },
            "2021": {
              "general": 8470,
              "ews": 1419,
              "obc": 3787,
              "sc": 2531,
              "st": 1645
            },
            "2020": {
              "general": 8290,
              "ews": 1389,
              "obc": 3706,
              "sc": 2477,
              "st": 1610
            }
          }
        },
        "fees": 150000,
        "seats": 90
      },
      {
        "name": "Computer Science and Business",
        "code": "CSB",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 10174,
              "ews": 1743,
              "obc": 4884,
              "sc": 3577,
              "st": 2318
            },
            "2023": {
              "general": 9970,
              "ews": 1708,
              "obc": 4786,
              "sc": 3505,
              "st": 2271
            },
            "2022": {
              "general": 9767,
              "ews": 1673,
              "obc": 4688,
              "sc": 3433,
              "st": 2225
            },
            "2021": {
              "general": 9563,
              "ews": 1638,
              "obc": 4590,
              "sc": 3362,
              "st": 2178
            },
            "2020": {
              "general": 9360,
              "ews": 1603,
              "obc": 4493,
              "sc": 3290,
              "st": 2132
            }
          }
        },
        "fees": 150000,
        "seats": 90
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 10583,
              "ews": 1785,
              "obc": 4929,
              "sc": 3888,
              "st": 2178
            },
            "2023": {
              "general": 10371,
              "ews": 1749,
              "obc": 4830,
              "sc": 3810,
              "st": 2134
            },
            "2022": {
              "general": 10159,
              "ews": 1713,
              "obc": 4731,
              "sc": 3732,
              "st": 2090
            },
            "2021": {
              "general": 9948,
              "ews": 1677,
              "obc": 4633,
              "sc": 3654,
              "st": 2047
            },
            "2020": {
              "general": 9736,
              "ews": 1642,
              "obc": 4534,
              "sc": 3576,
              "st": 2003
            }
          }
        },
        "fees": 150000,
        "seats": 90
      }
    ]
  },
  {
    "id": 31,
    "name": "Indian Institute of Information Technology Surat",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 23136,
              "ews": 4218,
              "obc": 10871,
              "sc": 7562,
              "st": 3089
            },
            "2023": {
              "general": 22673,
              "ews": 4133,
              "obc": 10653,
              "sc": 7410,
              "st": 3027
            },
            "2022": {
              "general": 22210,
              "ews": 4049,
              "obc": 10436,
              "sc": 7259,
              "st": 2965
            },
            "2021": {
              "general": 21747,
              "ews": 3964,
              "obc": 10218,
              "sc": 7108,
              "st": 2903
            },
            "2020": {
              "general": 21285,
              "ews": 3880,
              "obc": 10001,
              "sc": 6957,
              "st": 2841
            }
          }
        },
        "fees": 150000,
        "seats": 91
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 31699,
              "ews": 6101,
              "obc": 14703,
              "sc": 8782,
              "st": 3755
            },
            "2023": {
              "general": 31065,
              "ews": 5978,
              "obc": 14408,
              "sc": 8606,
              "st": 3679
            },
            "2022": {
              "general": 30431,
              "ews": 5856,
              "obc": 14114,
              "sc": 8430,
              "st": 3604
            },
            "2021": {
              "general": 29797,
              "ews": 5734,
              "obc": 13820,
              "sc": 8255,
              "st": 3529
            },
            "2020": {
              "general": 29163,
              "ews": 5612,
              "obc": 13526,
              "sc": 8079,
              "st": 3454
            }
          }
        },
        "fees": 150000,
        "seats": 91
      }
    ]
  },
  {
    "id": 32,
    "name": "Indian Institute of Information Technology Tiruchirappalli",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 27705,
              "ews": 4914,
              "obc": 11661,
              "sc": 5985,
              "st": 2170
            },
            "2023": {
              "general": 27150,
              "ews": 4815,
              "obc": 11427,
              "sc": 5865,
              "st": 2126
            },
            "2022": {
              "general": 26596,
              "ews": 4717,
              "obc": 11194,
              "sc": 5745,
              "st": 2083
            },
            "2021": {
              "general": 26042,
              "ews": 4619,
              "obc": 10961,
              "sc": 5625,
              "st": 2039
            },
            "2020": {
              "general": 25488,
              "ews": 4520,
              "obc": 10728,
              "sc": 5506,
              "st": 1996
            }
          }
        },
        "fees": 150000,
        "seats": 92
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 33973,
              "ews": 6463,
              "obc": 14660,
              "sc": 7890,
              "st": 3061
            },
            "2023": {
              "general": 33293,
              "ews": 6333,
              "obc": 14366,
              "sc": 7732,
              "st": 2999
            },
            "2022": {
              "general": 32614,
              "ews": 6204,
              "obc": 14073,
              "sc": 7574,
              "st": 2938
            },
            "2021": {
              "general": 31934,
              "ews": 6075,
              "obc": 13780,
              "sc": 7416,
              "st": 2877
            },
            "2020": {
              "general": 31255,
              "ews": 5945,
              "obc": 13487,
              "sc": 7258,
              "st": 2816
            }
          }
        },
        "fees": 150000,
        "seats": 92
      }
    ]
  },
  {
    "id": 33,
    "name": "Indian Institute of Information Technology(IIIT) Dharwad",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 35437,
              "ews": 6322,
              "obc": 15301,
              "sc": 9227,
              "st": 3974
            },
            "2023": {
              "general": 34728,
              "ews": 6195,
              "obc": 14994,
              "sc": 9042,
              "st": 3894
            },
            "2022": {
              "general": 34019,
              "ews": 6069,
              "obc": 14688,
              "sc": 8857,
              "st": 3815
            },
            "2021": {
              "general": 33310,
              "ews": 5942,
              "obc": 14382,
              "sc": 8673,
              "st": 3735
            },
            "2020": {
              "general": 32602,
              "ews": 5816,
              "obc": 14076,
              "sc": 8488,
              "st": 3656
            }
          }
        },
        "fees": 150000,
        "seats": 93
      },
      {
        "name": "Data Science and Artificial Intelligence",
        "code": "DSAI",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 36980,
              "ews": 6737,
              "obc": 15939,
              "sc": 9779,
              "st": 4440
            },
            "2023": {
              "general": 36240,
              "ews": 6602,
              "obc": 15620,
              "sc": 9583,
              "st": 4351
            },
            "2022": {
              "general": 35500,
              "ews": 6467,
              "obc": 15301,
              "sc": 9387,
              "st": 4262
            },
            "2021": {
              "general": 34761,
              "ews": 6332,
              "obc": 14982,
              "sc": 9192,
              "st": 4173
            },
            "2020": {
              "general": 34021,
              "ews": 6198,
              "obc": 14663,
              "sc": 8996,
              "st": 4084
            }
          }
        },
        "fees": 150000,
        "seats": 93
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 39481,
              "ews": 6995,
              "obc": 16297,
              "sc": 10168,
              "st": 4515
            },
            "2023": {
              "general": 38691,
              "ews": 6855,
              "obc": 15971,
              "sc": 9964,
              "st": 4424
            },
            "2022": {
              "general": 37901,
              "ews": 6715,
              "obc": 15645,
              "sc": 9761,
              "st": 4334
            },
            "2021": {
              "general": 37112,
              "ews": 6575,
              "obc": 15319,
              "sc": 9557,
              "st": 4244
            },
            "2020": {
              "general": 36322,
              "ews": 6435,
              "obc": 14993,
              "sc": 9354,
              "st": 4153
            }
          }
        },
        "fees": 150000,
        "seats": 93
      }
    ]
  },
  {
    "id": 34,
    "name": "Indian Institute of Information Technology(IIIT) Kalyani, West Bengal",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 37647,
              "ews": 6769,
              "obc": 16089,
              "sc": 8961,
              "st": 4176
            },
            "2023": {
              "general": 36894,
              "ews": 6633,
              "obc": 15767,
              "sc": 8781,
              "st": 4092
            },
            "2022": {
              "general": 36141,
              "ews": 6498,
              "obc": 15445,
              "sc": 8602,
              "st": 4008
            },
            "2021": {
              "general": 35388,
              "ews": 6362,
              "obc": 15123,
              "sc": 8423,
              "st": 3925
            },
            "2020": {
              "general": 34635,
              "ews": 6227,
              "obc": 14801,
              "sc": 8244,
              "st": 3841
            }
          }
        },
        "fees": 150000,
        "seats": 94
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 40447,
              "ews": 7001,
              "obc": 16832,
              "sc": 9654,
              "st": 4823
            },
            "2023": {
              "general": 39638,
              "ews": 6860,
              "obc": 16495,
              "sc": 9460,
              "st": 4726
            },
            "2022": {
              "general": 38829,
              "ews": 6720,
              "obc": 16158,
              "sc": 9267,
              "st": 4630
            },
            "2021": {
              "general": 38020,
              "ews": 6580,
              "obc": 15822,
              "sc": 9074,
              "st": 4533
            },
            "2020": {
              "general": 37211,
              "ews": 6440,
              "obc": 15485,
              "sc": 8881,
              "st": 4437
            }
          }
        },
        "fees": 150000,
        "seats": 94
      }
    ]
  },
  {
    "id": 35,
    "name": "Indian Institute of Information Technology(IIIT) Kilohrad, Sonepat, Haryana",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 27277,
              "ews": 4884,
              "obc": 12711,
              "sc": 7823,
              "st": 4159
            },
            "2023": {
              "general": 26731,
              "ews": 4786,
              "obc": 12456,
              "sc": 7666,
              "st": 4075
            },
            "2022": {
              "general": 26185,
              "ews": 4688,
              "obc": 12202,
              "sc": 7510,
              "st": 3992
            },
            "2021": {
              "general": 25640,
              "ews": 4590,
              "obc": 11948,
              "sc": 7353,
              "st": 3909
            },
            "2020": {
              "general": 25094,
              "ews": 4493,
              "obc": 11694,
              "sc": 7197,
              "st": 3826
            }
          }
        },
        "fees": 150000,
        "seats": 95
      },
      {
        "name": "CSE",
        "code": "C",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 30095,
              "ews": 5215,
              "obc": 14014,
              "sc": 8786,
              "st": 4317
            },
            "2023": {
              "general": 29493,
              "ews": 5110,
              "obc": 13733,
              "sc": 8610,
              "st": 4230
            },
            "2022": {
              "general": 28891,
              "ews": 5006,
              "obc": 13453,
              "sc": 8434,
              "st": 4144
            },
            "2021": {
              "general": 28289,
              "ews": 4902,
              "obc": 13173,
              "sc": 8258,
              "st": 4057
            },
            "2020": {
              "general": 27687,
              "ews": 4797,
              "obc": 12892,
              "sc": 8083,
              "st": 3971
            }
          }
        },
        "fees": 150000,
        "seats": 95
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 30466,
              "ews": 5244,
              "obc": 14024,
              "sc": 8553,
              "st": 4397
            },
            "2023": {
              "general": 29856,
              "ews": 5139,
              "obc": 13743,
              "sc": 8381,
              "st": 4309
            },
            "2022": {
              "general": 29247,
              "ews": 5034,
              "obc": 13463,
              "sc": 8210,
              "st": 4221
            },
            "2021": {
              "general": 28638,
              "ews": 4929,
              "obc": 13182,
              "sc": 8039,
              "st": 4133
            },
            "2020": {
              "general": 28028,
              "ews": 4824,
              "obc": 12902,
              "sc": 7868,
              "st": 4045
            }
          }
        },
        "fees": 150000,
        "seats": 95
      }
    ]
  },
  {
    "id": 36,
    "name": "Indian Institute of Information Technology(IIIT) Kottayam",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 33689,
              "ews": 6228,
              "obc": 14269,
              "sc": 9791,
              "st": 4140
            },
            "2023": {
              "general": 33015,
              "ews": 6103,
              "obc": 13983,
              "sc": 9595,
              "st": 4057
            },
            "2022": {
              "general": 32341,
              "ews": 5978,
              "obc": 13698,
              "sc": 9399,
              "st": 3974
            },
            "2021": {
              "general": 31667,
              "ews": 5854,
              "obc": 13412,
              "sc": 9203,
              "st": 3891
            },
            "2020": {
              "general": 30993,
              "ews": 5729,
              "obc": 13127,
              "sc": 9007,
              "st": 3808
            }
          }
        },
        "fees": 150000,
        "seats": 96
      },
      {
        "name": "Computer Science and Engineering with specialization in Artificial Intelligence and Data Science",
        "code": "CSEAI",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 30619,
              "ews": 5364,
              "obc": 11945,
              "sc": 8046,
              "st": 3731
            },
            "2023": {
              "general": 30006,
              "ews": 5256,
              "obc": 11706,
              "sc": 7885,
              "st": 3656
            },
            "2022": {
              "general": 29394,
              "ews": 5149,
              "obc": 11467,
              "sc": 7724,
              "st": 3581
            },
            "2021": {
              "general": 28781,
              "ews": 5042,
              "obc": 11228,
              "sc": 7563,
              "st": 3507
            },
            "2020": {
              "general": 28169,
              "ews": 4934,
              "obc": 10989,
              "sc": 7402,
              "st": 3432
            }
          }
        },
        "fees": 150000,
        "seats": 96
      },
      {
        "name": "Computer Science and Engineering with specialization in Cyber Security",
        "code": "CSECS",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 34641,
              "ews": 6356,
              "obc": 14494,
              "sc": 9215,
              "st": 4198
            },
            "2023": {
              "general": 33948,
              "ews": 6228,
              "obc": 14204,
              "sc": 9030,
              "st": 4114
            },
            "2022": {
              "general": 33255,
              "ews": 6101,
              "obc": 13914,
              "sc": 8846,
              "st": 4030
            },
            "2021": {
              "general": 32562,
              "ews": 5974,
              "obc": 13624,
              "sc": 8662,
              "st": 3946
            },
            "2020": {
              "general": 31869,
              "ews": 5847,
              "obc": 13334,
              "sc": 8477,
              "st": 3862
            }
          }
        },
        "fees": 150000,
        "seats": 96
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 36849,
              "ews": 6710,
              "obc": 14983,
              "sc": 9967,
              "st": 4152
            },
            "2023": {
              "general": 36112,
              "ews": 6575,
              "obc": 14683,
              "sc": 9767,
              "st": 4068
            },
            "2022": {
              "general": 35375,
              "ews": 6441,
              "obc": 14383,
              "sc": 9568,
              "st": 3985
            },
            "2021": {
              "general": 34638,
              "ews": 6307,
              "obc": 14084,
              "sc": 9368,
              "st": 3902
            },
            "2020": {
              "general": 33901,
              "ews": 6173,
              "obc": 13784,
              "sc": 9169,
              "st": 3819
            }
          }
        },
        "fees": 150000,
        "seats": 96
      }
    ]
  },
  {
    "id": 37,
    "name": "Indian Institute of Information Technology(IIIT) Una, Himachal Pradesh",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 28979,
              "ews": 5056,
              "obc": 12728,
              "sc": 7826,
              "st": 4468
            },
            "2023": {
              "general": 28399,
              "ews": 4954,
              "obc": 12473,
              "sc": 7669,
              "st": 4378
            },
            "2022": {
              "general": 27819,
              "ews": 4853,
              "obc": 12218,
              "sc": 7512,
              "st": 4289
            },
            "2021": {
              "general": 27240,
              "ews": 4752,
              "obc": 11964,
              "sc": 7356,
              "st": 4199
            },
            "2020": {
              "general": 26660,
              "ews": 4651,
              "obc": 11709,
              "sc": 7199,
              "st": 4110
            }
          }
        },
        "fees": 150000,
        "seats": 97
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 34911,
              "ews": 6161,
              "obc": 15599,
              "sc": 9273,
              "st": 4802
            },
            "2023": {
              "general": 34212,
              "ews": 6037,
              "obc": 15287,
              "sc": 9087,
              "st": 4705
            },
            "2022": {
              "general": 33514,
              "ews": 5914,
              "obc": 14975,
              "sc": 8902,
              "st": 4609
            },
            "2021": {
              "general": 32816,
              "ews": 5791,
              "obc": 14663,
              "sc": 8716,
              "st": 4513
            },
            "2020": {
              "general": 32118,
              "ews": 5668,
              "obc": 14351,
              "sc": 8531,
              "st": 4417
            }
          }
        },
        "fees": 150000,
        "seats": 97
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 30996,
              "ews": 5543,
              "obc": 13728,
              "sc": 8770,
              "st": 4616
            },
            "2023": {
              "general": 30376,
              "ews": 5432,
              "obc": 13453,
              "sc": 8594,
              "st": 4523
            },
            "2022": {
              "general": 29756,
              "ews": 5321,
              "obc": 13178,
              "sc": 8419,
              "st": 4431
            },
            "2021": {
              "general": 29136,
              "ews": 5210,
              "obc": 12904,
              "sc": 8243,
              "st": 4339
            },
            "2020": {
              "general": 28516,
              "ews": 5099,
              "obc": 12629,
              "sc": 8068,
              "st": 4246
            }
          }
        },
        "fees": 150000,
        "seats": 97
      }
    ]
  },
  {
    "id": 38,
    "name": "Indian Institute of Information Technology(IIIT), Vadodara, Gujrat",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 20679,
              "ews": 3721,
              "obc": 9562,
              "sc": 7036,
              "st": 3451
            },
            "2023": {
              "general": 20265,
              "ews": 3646,
              "obc": 9370,
              "sc": 6895,
              "st": 3381
            },
            "2022": {
              "general": 19851,
              "ews": 3572,
              "obc": 9179,
              "sc": 6754,
              "st": 3312
            },
            "2021": {
              "general": 19438,
              "ews": 3497,
              "obc": 8988,
              "sc": 6613,
              "st": 3243
            },
            "2020": {
              "general": 19024,
              "ews": 3423,
              "obc": 8797,
              "sc": 6473,
              "st": 3174
            }
          }
        },
        "fees": 150000,
        "seats": 98
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 22366,
              "ews": 3879,
              "obc": 10845,
              "sc": 8030,
              "st": 3507
            },
            "2023": {
              "general": 21918,
              "ews": 3801,
              "obc": 10628,
              "sc": 7869,
              "st": 3436
            },
            "2022": {
              "general": 21471,
              "ews": 3723,
              "obc": 10411,
              "sc": 7708,
              "st": 3366
            },
            "2021": {
              "general": 21024,
              "ews": 3646,
              "obc": 10194,
              "sc": 7548,
              "st": 3296
            },
            "2020": {
              "general": 20576,
              "ews": 3568,
              "obc": 9977,
              "sc": 7387,
              "st": 3226
            }
          }
        },
        "fees": 150000,
        "seats": 98
      }
    ]
  },
  {
    "id": 39,
    "name": "Indian Institute of Information Technology, Agartala",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 37788,
              "ews": 6602,
              "obc": 15595,
              "sc": 9014,
              "st": 4278
            },
            "2023": {
              "general": 37032,
              "ews": 6469,
              "obc": 15283,
              "sc": 8833,
              "st": 4192
            },
            "2022": {
              "general": 36276,
              "ews": 6337,
              "obc": 14971,
              "sc": 8653,
              "st": 4106
            },
            "2021": {
              "general": 35520,
              "ews": 6205,
              "obc": 14659,
              "sc": 8473,
              "st": 4021
            },
            "2020": {
              "general": 34764,
              "ews": 6073,
              "obc": 14347,
              "sc": 8292,
              "st": 3935
            }
          }
        },
        "fees": 150000,
        "seats": 99
      }
    ]
  },
  {
    "id": 40,
    "name": "Indian Institute of Information Technology, Allahabad",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 7478,
              "ews": 1279,
              "obc": 3556,
              "sc": 2399,
              "st": 1310
            },
            "2023": {
              "general": 7328,
              "ews": 1253,
              "obc": 3484,
              "sc": 2351,
              "st": 1283
            },
            "2022": {
              "general": 7178,
              "ews": 1227,
              "obc": 3413,
              "sc": 2303,
              "st": 1257
            },
            "2021": {
              "general": 7029,
              "ews": 1202,
              "obc": 3342,
              "sc": 2255,
              "st": 1231
            },
            "2020": {
              "general": 6879,
              "ews": 1176,
              "obc": 3271,
              "sc": 2207,
              "st": 1205
            }
          }
        },
        "fees": 150000,
        "seats": 60
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 4854,
              "ews": 854,
              "obc": 2449,
              "sc": 1529,
              "st": 871
            },
            "2023": {
              "general": 4756,
              "ews": 836,
              "obc": 2400,
              "sc": 1498,
              "st": 853
            },
            "2022": {
              "general": 4659,
              "ews": 819,
              "obc": 2351,
              "sc": 1467,
              "st": 836
            },
            "2021": {
              "general": 4562,
              "ews": 802,
              "obc": 2302,
              "sc": 1437,
              "st": 818
            },
            "2020": {
              "general": 4465,
              "ews": 785,
              "obc": 2253,
              "sc": 1406,
              "st": 801
            }
          }
        },
        "fees": 150000,
        "seats": 60
      },
      {
        "name": "Information Technology-Business Informatics",
        "code": "ITI",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 5202,
              "ews": 963,
              "obc": 2513,
              "sc": 1695,
              "st": 916
            },
            "2023": {
              "general": 5097,
              "ews": 943,
              "obc": 2462,
              "sc": 1661,
              "st": 897
            },
            "2022": {
              "general": 4993,
              "ews": 924,
              "obc": 2412,
              "sc": 1627,
              "st": 879
            },
            "2021": {
              "general": 4889,
              "ews": 905,
              "obc": 2362,
              "sc": 1593,
              "st": 861
            },
            "2020": {
              "general": 4785,
              "ews": 885,
              "obc": 2311,
              "sc": 1559,
              "st": 842
            }
          }
        },
        "fees": 150000,
        "seats": 60
      }
    ]
  },
  {
    "id": 41,
    "name": "Indian Institute of Information Technology, Design & Manufacturing, Kancheepuram",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "B.Tech in Mechanical Engineering and M.Tech in AI and Robotics",
        "code": "BMEMA",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 36776,
              "ews": 7184,
              "obc": 15433,
              "sc": 7866,
              "st": 2782
            },
            "2023": {
              "general": 36040,
              "ews": 7040,
              "obc": 15124,
              "sc": 7708,
              "st": 2726
            },
            "2022": {
              "general": 35304,
              "ews": 6896,
              "obc": 14815,
              "sc": 7551,
              "st": 2670
            },
            "2021": {
              "general": 34569,
              "ews": 6752,
              "obc": 14507,
              "sc": 7394,
              "st": 2615
            },
            "2020": {
              "general": 33833,
              "ews": 6609,
              "obc": 14198,
              "sc": 7236,
              "st": 2559
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "B.Tech. in Electronics and Communication Engineering and M.Tech. in Communication Systems",
        "code": "BECEM",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 31004,
              "ews": 5569,
              "obc": 11387,
              "sc": 6619,
              "st": 2960
            },
            "2023": {
              "general": 30383,
              "ews": 5457,
              "obc": 11159,
              "sc": 6486,
              "st": 2900
            },
            "2022": {
              "general": 29763,
              "ews": 5346,
              "obc": 10931,
              "sc": 6354,
              "st": 2841
            },
            "2021": {
              "general": 29143,
              "ews": 5234,
              "obc": 10703,
              "sc": 6221,
              "st": 2782
            },
            "2020": {
              "general": 28523,
              "ews": 5123,
              "obc": 10476,
              "sc": 6089,
              "st": 2723
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "B.Tech. in Electronics and Communication Engineering and M.Tech. in VLSI Design",
        "code": "BECEM",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 25720,
              "ews": 5284,
              "obc": 11284,
              "sc": 6008,
              "st": 2651
            },
            "2023": {
              "general": 25205,
              "ews": 5178,
              "obc": 11058,
              "sc": 5887,
              "st": 2597
            },
            "2022": {
              "general": 24691,
              "ews": 5072,
              "obc": 10832,
              "sc": 5767,
              "st": 2544
            },
            "2021": {
              "general": 24176,
              "ews": 4966,
              "obc": 10606,
              "sc": 5647,
              "st": 2491
            },
            "2020": {
              "general": 23662,
              "ews": 4861,
              "obc": 10381,
              "sc": 5527,
              "st": 2438
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 21440,
              "ews": 3873,
              "obc": 8479,
              "sc": 5281,
              "st": 2375
            },
            "2023": {
              "general": 21011,
              "ews": 3795,
              "obc": 8309,
              "sc": 5175,
              "st": 2327
            },
            "2022": {
              "general": 20582,
              "ews": 3718,
              "obc": 8139,
              "sc": 5069,
              "st": 2280
            },
            "2021": {
              "general": 20153,
              "ews": 3640,
              "obc": 7970,
              "sc": 4964,
              "st": 2232
            },
            "2020": {
              "general": 19724,
              "ews": 3563,
              "obc": 7800,
              "sc": 4858,
              "st": 2185
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "Computer Science and Engineering with Major in Artificial Intelligence",
        "code": "CSEMA",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 17585,
              "ews": 3093,
              "obc": 7532,
              "sc": 4455,
              "st": 2148
            },
            "2023": {
              "general": 17233,
              "ews": 3031,
              "obc": 7381,
              "sc": 4365,
              "st": 2105
            },
            "2022": {
              "general": 16881,
              "ews": 2969,
              "obc": 7230,
              "sc": 4276,
              "st": 2062
            },
            "2021": {
              "general": 16529,
              "ews": 2907,
              "obc": 7080,
              "sc": 4187,
              "st": 2019
            },
            "2020": {
              "general": 16178,
              "ews": 2845,
              "obc": 6929,
              "sc": 4098,
              "st": 1976
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 25385,
              "ews": 4555,
              "obc": 9440,
              "sc": 6140,
              "st": 2533
            },
            "2023": {
              "general": 24877,
              "ews": 4463,
              "obc": 9251,
              "sc": 6017,
              "st": 2482
            },
            "2022": {
              "general": 24369,
              "ews": 4372,
              "obc": 9062,
              "sc": 5894,
              "st": 2431
            },
            "2021": {
              "general": 23861,
              "ews": 4281,
              "obc": 8873,
              "sc": 5771,
              "st": 2381
            },
            "2020": {
              "general": 23354,
              "ews": 4190,
              "obc": 8684,
              "sc": 5648,
              "st": 2330
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 41878,
              "ews": 7441,
              "obc": 15810,
              "sc": 8018,
              "st": 3320
            },
            "2023": {
              "general": 41040,
              "ews": 7292,
              "obc": 15493,
              "sc": 7857,
              "st": 3253
            },
            "2022": {
              "general": 40202,
              "ews": 7143,
              "obc": 15177,
              "sc": 7697,
              "st": 3187
            },
            "2021": {
              "general": 39365,
              "ews": 6994,
              "obc": 14861,
              "sc": 7536,
              "st": 3120
            },
            "2020": {
              "general": 38527,
              "ews": 6845,
              "obc": 14545,
              "sc": 7376,
              "st": 3054
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "Smart Manufacturing",
        "code": "SM",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 44503,
              "ews": 8587,
              "obc": 16665,
              "sc": 9063,
              "st": 3652
            },
            "2023": {
              "general": 43612,
              "ews": 8415,
              "obc": 16331,
              "sc": 8881,
              "st": 3578
            },
            "2022": {
              "general": 42722,
              "ews": 8243,
              "obc": 15998,
              "sc": 8700,
              "st": 3505
            },
            "2021": {
              "general": 41832,
              "ews": 8071,
              "obc": 15665,
              "sc": 8519,
              "st": 3432
            },
            "2020": {
              "general": 40942,
              "ews": 7900,
              "obc": 15331,
              "sc": 8337,
              "st": 3359
            }
          }
        },
        "fees": 150000,
        "seats": 61
      }
    ]
  },
  {
    "id": 42,
    "name": "Indian Institute of Information Technology, Vadodara International Campus Diu (IIITVICD)",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 30343,
              "ews": 5354,
              "obc": 14723,
              "sc": 9163,
              "st": 4568
            },
            "2023": {
              "general": 29736,
              "ews": 5246,
              "obc": 14428,
              "sc": 8979,
              "st": 4476
            },
            "2022": {
              "general": 29129,
              "ews": 5139,
              "obc": 14134,
              "sc": 8796,
              "st": 4385
            },
            "2021": {
              "general": 28522,
              "ews": 5032,
              "obc": 13839,
              "sc": 8613,
              "st": 4293
            },
            "2020": {
              "general": 27915,
              "ews": 4925,
              "obc": 13545,
              "sc": 8429,
              "st": 4202
            }
          }
        },
        "fees": 150000,
        "seats": 62
      }
    ]
  },
  {
    "id": 43,
    "name": "Indian Institute of Technology (BHU) Varanasi",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 21448,
              "ews": 3439,
              "obc": 8033,
              "sc": 4321
            },
            "2023": {
              "general": 21019,
              "ews": 3370,
              "obc": 7872,
              "sc": 4234
            },
            "2022": {
              "general": 20590,
              "ews": 3301,
              "obc": 7711,
              "sc": 4148
            },
            "2021": {
              "general": 20161,
              "ews": 3232,
              "obc": 7551,
              "sc": 4061
            },
            "2020": {
              "general": 19732,
              "ews": 3163,
              "obc": 7390,
              "sc": 3975
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Biochemical Engineering with M.Tech. in Biochemical Engineering and Biotechnology",
        "code": "BEMBE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 12152,
              "ews": 2090,
              "obc": 5443,
              "sc": 2954,
              "st": 1350
            },
            "2023": {
              "general": 11908,
              "ews": 2048,
              "obc": 5334,
              "sc": 2894,
              "st": 1323
            },
            "2022": {
              "general": 11665,
              "ews": 2006,
              "obc": 5225,
              "sc": 2835,
              "st": 1296
            },
            "2021": {
              "general": 11422,
              "ews": 1964,
              "obc": 5116,
              "sc": 2776,
              "st": 1269
            },
            "2020": {
              "general": 11179,
              "ews": 1922,
              "obc": 5007,
              "sc": 2717,
              "st": 1242
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Bioengineering with M.Tech in Biomedical Technology",
        "code": "BMBT",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 12872,
              "ews": 2081,
              "obc": 5323,
              "sc": 3010,
              "st": 1461
            },
            "2023": {
              "general": 12614,
              "ews": 2039,
              "obc": 5216,
              "sc": 2949,
              "st": 1431
            },
            "2022": {
              "general": 12357,
              "ews": 1997,
              "obc": 5110,
              "sc": 2889,
              "st": 1402
            },
            "2021": {
              "general": 12099,
              "ews": 1956,
              "obc": 5003,
              "sc": 2829,
              "st": 1373
            },
            "2020": {
              "general": 11842,
              "ews": 1914,
              "obc": 4897,
              "sc": 2769,
              "st": 1344
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Ceramic Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 12524,
              "ews": 2055,
              "obc": 5501,
              "sc": 3005,
              "st": 1456
            },
            "2023": {
              "general": 12273,
              "ews": 2013,
              "obc": 5390,
              "sc": 2944,
              "st": 1426
            },
            "2022": {
              "general": 12023,
              "ews": 1972,
              "obc": 5280,
              "sc": 2884,
              "st": 1397
            },
            "2021": {
              "general": 11772,
              "ews": 1931,
              "obc": 5170,
              "sc": 2824,
              "st": 1368
            },
            "2020": {
              "general": 11522,
              "ews": 1890,
              "obc": 5060,
              "sc": 2764,
              "st": 1339
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 7489,
              "ews": 1283,
              "obc": 3387,
              "sc": 2068,
              "st": 939
            },
            "2023": {
              "general": 7339,
              "ews": 1257,
              "obc": 3319,
              "sc": 2026,
              "st": 920
            },
            "2022": {
              "general": 7189,
              "ews": 1231,
              "obc": 3251,
              "sc": 1985,
              "st": 901
            },
            "2021": {
              "general": 7039,
              "ews": 1206,
              "obc": 3183,
              "sc": 1943,
              "st": 882
            },
            "2020": {
              "general": 6889,
              "ews": 1180,
              "obc": 3116,
              "sc": 1902,
              "st": 863
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 10339,
              "ews": 1683,
              "obc": 4123,
              "sc": 2064,
              "st": 800
            },
            "2023": {
              "general": 10132,
              "ews": 1649,
              "obc": 4040,
              "sc": 2022,
              "st": 784
            },
            "2022": {
              "general": 9925,
              "ews": 1615,
              "obc": 3958,
              "sc": 1981,
              "st": 768
            },
            "2021": {
              "general": 9718,
              "ews": 1582,
              "obc": 3875,
              "sc": 1940,
              "st": 752
            },
            "2020": {
              "general": 9511,
              "ews": 1548,
              "obc": 3793,
              "sc": 1898,
              "st": 736
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1457,
              "ews": 247,
              "obc": 727,
              "sc": 340,
              "st": 279
            },
            "2023": {
              "general": 1427,
              "ews": 242,
              "obc": 712,
              "sc": 333,
              "st": 273
            },
            "2022": {
              "general": 1398,
              "ews": 237,
              "obc": 697,
              "sc": 326,
              "st": 267
            },
            "2021": {
              "general": 1369,
              "ews": 232,
              "obc": 683,
              "sc": 319,
              "st": 262
            },
            "2020": {
              "general": 1340,
              "ews": 227,
              "obc": 668,
              "sc": 312,
              "st": 256
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3517,
              "ews": 564,
              "obc": 1496,
              "sc": 916,
              "st": 497
            },
            "2023": {
              "general": 3446,
              "ews": 552,
              "obc": 1466,
              "sc": 897,
              "st": 487
            },
            "2022": {
              "general": 3376,
              "ews": 541,
              "obc": 1436,
              "sc": 879,
              "st": 477
            },
            "2021": {
              "general": 3305,
              "ews": 530,
              "obc": 1406,
              "sc": 861,
              "st": 467
            },
            "2020": {
              "general": 3235,
              "ews": 518,
              "obc": 1376,
              "sc": 842,
              "st": 457
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Electrical Engineering with M.Tech. in Power Electronics",
        "code": "EEMPE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4473,
              "ews": 637,
              "obc": 1851,
              "sc": 1221,
              "st": 468
            },
            "2023": {
              "general": 4383,
              "ews": 624,
              "obc": 1813,
              "sc": 1196,
              "st": 458
            },
            "2022": {
              "general": 4294,
              "ews": 611,
              "obc": 1776,
              "sc": 1172,
              "st": 449
            },
            "2021": {
              "general": 4204,
              "ews": 598,
              "obc": 1739,
              "sc": 1147,
              "st": 439
            },
            "2020": {
              "general": 4115,
              "ews": 586,
              "obc": 1702,
              "sc": 1123,
              "st": 430
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Electronics Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2667,
              "ews": 462,
              "obc": 1320,
              "sc": 808,
              "st": 421
            },
            "2023": {
              "general": 2613,
              "ews": 452,
              "obc": 1293,
              "sc": 791,
              "st": 412
            },
            "2022": {
              "general": 2560,
              "ews": 443,
              "obc": 1267,
              "sc": 775,
              "st": 404
            },
            "2021": {
              "general": 2506,
              "ews": 434,
              "obc": 1240,
              "sc": 759,
              "st": 395
            },
            "2020": {
              "general": 2453,
              "ews": 425,
              "obc": 1214,
              "sc": 743,
              "st": 387
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 7649,
              "ews": 1777,
              "obc": 3874,
              "sc": 2138,
              "st": 1271
            },
            "2023": {
              "general": 7496,
              "ews": 1741,
              "obc": 3796,
              "sc": 2095,
              "st": 1245
            },
            "2022": {
              "general": 7343,
              "ews": 1705,
              "obc": 3719,
              "sc": 2052,
              "st": 1220
            },
            "2021": {
              "general": 7190,
              "ews": 1670,
              "obc": 3641,
              "sc": 2009,
              "st": 1194
            },
            "2020": {
              "general": 7037,
              "ews": 1634,
              "obc": 3564,
              "sc": 1966,
              "st": 1169
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Industrial Chemistry",
        "code": "IC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 12241,
              "ews": 2077,
              "obc": 5474,
              "sc": 2983,
              "st": 1465
            },
            "2023": {
              "general": 11996,
              "ews": 2035,
              "obc": 5364,
              "sc": 2923,
              "st": 1435
            },
            "2022": {
              "general": 11751,
              "ews": 1993,
              "obc": 5255,
              "sc": 2863,
              "st": 1406
            },
            "2021": {
              "general": 11506,
              "ews": 1952,
              "obc": 5145,
              "sc": 2804,
              "st": 1377
            },
            "2020": {
              "general": 11261,
              "ews": 1910,
              "obc": 5036,
              "sc": 2744,
              "st": 1347
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Materials Science and Technology",
        "code": "MST",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 11530,
              "ews": 1889,
              "obc": 5276,
              "sc": 2797,
              "st": 1448
            },
            "2023": {
              "general": 11299,
              "ews": 1851,
              "obc": 5170,
              "sc": 2741,
              "st": 1419
            },
            "2022": {
              "general": 11068,
              "ews": 1813,
              "obc": 5064,
              "sc": 2685,
              "st": 1390
            },
            "2021": {
              "general": 10838,
              "ews": 1775,
              "obc": 4959,
              "sc": 2629,
              "st": 1361
            },
            "2020": {
              "general": 10607,
              "ews": 1737,
              "obc": 4853,
              "sc": 2573,
              "st": 1332
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2129,
              "ews": 346,
              "obc": 993,
              "sc": 672,
              "st": 385
            },
            "2023": {
              "general": 2086,
              "ews": 339,
              "obc": 973,
              "sc": 658,
              "st": 377
            },
            "2022": {
              "general": 2043,
              "ews": 332,
              "obc": 953,
              "sc": 645,
              "st": 369
            },
            "2021": {
              "general": 2001,
              "ews": 325,
              "obc": 933,
              "sc": 631,
              "st": 361
            },
            "2020": {
              "general": 1958,
              "ews": 318,
              "obc": 913,
              "sc": 618,
              "st": 354
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 7244,
              "ews": 1248,
              "obc": 3138,
              "sc": 1781,
              "st": 1006
            },
            "2023": {
              "general": 7099,
              "ews": 1223,
              "obc": 3075,
              "sc": 1745,
              "st": 985
            },
            "2022": {
              "general": 6954,
              "ews": 1198,
              "obc": 3012,
              "sc": 1709,
              "st": 965
            },
            "2021": {
              "general": 6809,
              "ews": 1173,
              "obc": 2949,
              "sc": 1674,
              "st": 945
            },
            "2020": {
              "general": 6664,
              "ews": 1148,
              "obc": 2886,
              "sc": 1638,
              "st": 925
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Metallurgical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 11097,
              "ews": 1892,
              "obc": 4737,
              "sc": 2740,
              "st": 1356
            },
            "2023": {
              "general": 10875,
              "ews": 1854,
              "obc": 4642,
              "sc": 2685,
              "st": 1328
            },
            "2022": {
              "general": 10653,
              "ews": 1816,
              "obc": 4547,
              "sc": 2630,
              "st": 1301
            },
            "2021": {
              "general": 10431,
              "ews": 1778,
              "obc": 4452,
              "sc": 2575,
              "st": 1274
            },
            "2020": {
              "general": 10209,
              "ews": 1740,
              "obc": 4358,
              "sc": 2520,
              "st": 1247
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Mining Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 13562,
              "ews": 2250,
              "obc": 5338,
              "sc": 3044,
              "st": 1140
            },
            "2023": {
              "general": 13290,
              "ews": 2205,
              "obc": 5231,
              "sc": 2983,
              "st": 1117
            },
            "2022": {
              "general": 13019,
              "ews": 2160,
              "obc": 5124,
              "sc": 2922,
              "st": 1094
            },
            "2021": {
              "general": 12748,
              "ews": 2115,
              "obc": 5017,
              "sc": 2861,
              "st": 1071
            },
            "2020": {
              "general": 12477,
              "ews": 2070,
              "obc": 4910,
              "sc": 2800,
              "st": 1048
            }
          }
        },
        "fees": 200000,
        "seats": 63
      },
      {
        "name": "Pharmaceutical Engineering & Technology",
        "code": "PET",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 13626,
              "ews": 2100,
              "obc": 5509,
              "sc": 3135,
              "st": 1478
            },
            "2023": {
              "general": 13353,
              "ews": 2058,
              "obc": 5398,
              "sc": 3072,
              "st": 1448
            },
            "2022": {
              "general": 13080,
              "ews": 2016,
              "obc": 5288,
              "sc": 3009,
              "st": 1418
            },
            "2021": {
              "general": 12808,
              "ews": 1974,
              "obc": 5178,
              "sc": 2946,
              "st": 1389
            },
            "2020": {
              "general": 12535,
              "ews": 1932,
              "obc": 5068,
              "sc": 2884,
              "st": 1359
            }
          }
        },
        "fees": 200000,
        "seats": 63
      }
    ]
  },
  {
    "id": 44,
    "name": "Indian Institute of Technology (ISM) Dhanbad",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Applied Geology",
        "code": "AG",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 14988,
              "ews": 2368,
              "obc": 5668,
              "sc": 3113,
              "st": 1458
            },
            "2023": {
              "general": 14688,
              "ews": 2320,
              "obc": 5554,
              "sc": 3050,
              "st": 1428
            },
            "2022": {
              "general": 14388,
              "ews": 2273,
              "obc": 5441,
              "sc": 2988,
              "st": 1399
            },
            "2021": {
              "general": 14088,
              "ews": 2225,
              "obc": 5327,
              "sc": 2926,
              "st": 1370
            },
            "2020": {
              "general": 13788,
              "ews": 2178,
              "obc": 5214,
              "sc": 2863,
              "st": 1341
            }
          }
        },
        "fees": 200000,
        "seats": 64
      },
      {
        "name": "Applied Geophysics",
        "code": "AG",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 14663,
              "ews": 2351,
              "obc": 5719,
              "sc": 2996,
              "st": 1451
            },
            "2023": {
              "general": 14369,
              "ews": 2303,
              "obc": 5604,
              "sc": 2936,
              "st": 1421
            },
            "2022": {
              "general": 14076,
              "ews": 2256,
              "obc": 5490,
              "sc": 2876,
              "st": 1392
            },
            "2021": {
              "general": 13783,
              "ews": 2209,
              "obc": 5375,
              "sc": 2816,
              "st": 1363
            },
            "2020": {
              "general": 13489,
              "ews": 2162,
              "obc": 5261,
              "sc": 2756,
              "st": 1334
            }
          }
        },
        "fees": 200000,
        "seats": 64
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 10226,
              "ews": 1593,
              "obc": 4295,
              "sc": 2365,
              "st": 1092
            },
            "2023": {
              "general": 10021,
              "ews": 1561,
              "obc": 4209,
              "sc": 2317,
              "st": 1070
            },
            "2022": {
              "general": 9816,
              "ews": 1529,
              "obc": 4123,
              "sc": 2270,
              "st": 1048
            },
            "2021": {
              "general": 9612,
              "ews": 1497,
              "obc": 4037,
              "sc": 2223,
              "st": 1026
            },
            "2020": {
              "general": 9407,
              "ews": 1465,
              "obc": 3951,
              "sc": 2175,
              "st": 1004
            }
          }
        },
        "fees": 200000,
        "seats": 64
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 11671,
              "ews": 1851,
              "obc": 4523,
              "sc": 2354,
              "st": 912
            },
            "2023": {
              "general": 11437,
              "ews": 1813,
              "obc": 4432,
              "sc": 2306,
              "st": 893
            },
            "2022": {
              "general": 11204,
              "ews": 1776,
              "obc": 4342,
              "sc": 2259,
              "st": 875
            },
            "2021": {
              "general": 10970,
              "ews": 1739,
              "obc": 4251,
              "sc": 2212,
              "st": 857
            },
            "2020": {
              "general": 10737,
              "ews": 1702,
              "obc": 4161,
              "sc": 2165,
              "st": 839
            }
          }
        },
        "fees": 200000,
        "seats": 64
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3610,
              "ews": 445,
              "obc": 1263,
              "sc": 699,
              "st": 304
            },
            "2023": {
              "general": 3537,
              "ews": 436,
              "obc": 1237,
              "sc": 685,
              "st": 297
            },
            "2022": {
              "general": 3465,
              "ews": 427,
              "obc": 1212,
              "sc": 671,
              "st": 291
            },
            "2021": {
              "general": 3393,
              "ews": 418,
              "obc": 1187,
              "sc": 657,
              "st": 285
            },
            "2020": {
              "general": 3321,
              "ews": 409,
              "obc": 1161,
              "sc": 643,
              "st": 279
            }
          }
        },
        "fees": 200000,
        "seats": 64
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6751,
              "ews": 1121,
              "obc": 2721,
              "sc": 1518,
              "st": 801
            },
            "2023": {
              "general": 6615,
              "ews": 1098,
              "obc": 2666,
              "sc": 1487,
              "st": 784
            },
            "2022": {
              "general": 6480,
              "ews": 1076,
              "obc": 2612,
              "sc": 1457,
              "st": 768
            },
            "2021": {
              "general": 6345,
              "ews": 1053,
              "obc": 2557,
              "sc": 1426,
              "st": 752
            },
            "2020": {
              "general": 6210,
              "ews": 1031,
              "obc": 2503,
              "sc": 1396,
              "st": 736
            }
          }
        },
        "fees": 200000,
        "seats": 64
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5346,
              "ews": 821,
              "obc": 2073,
              "sc": 1199,
              "st": 673
            },
            "2023": {
              "general": 5239,
              "ews": 804,
              "obc": 2031,
              "sc": 1175,
              "st": 659
            },
            "2022": {
              "general": 5132,
              "ews": 788,
              "obc": 1990,
              "sc": 1151,
              "st": 646
            },
            "2021": {
              "general": 5025,
              "ews": 771,
              "obc": 1948,
              "sc": 1127,
              "st": 632
            },
            "2020": {
              "general": 4918,
              "ews": 755,
              "obc": 1907,
              "sc": 1103,
              "st": 619
            }
          }
        },
        "fees": 200000,
        "seats": 64
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 9717,
              "ews": 1557,
              "obc": 4206,
              "sc": 2389,
              "st": 1360
            },
            "2023": {
              "general": 9522,
              "ews": 1525,
              "obc": 4121,
              "sc": 2341,
              "st": 1332
            },
            "2022": {
              "general": 9328,
              "ews": 1494,
              "obc": 4037,
              "sc": 2293,
              "st": 1305
            },
            "2021": {
              "general": 9133,
              "ews": 1463,
              "obc": 3953,
              "sc": 2245,
              "st": 1278
            },
            "2020": {
              "general": 8939,
              "ews": 1432,
              "obc": 3869,
              "sc": 2197,
              "st": 1251
            }
          }
        },
        "fees": 200000,
        "seats": 64
      },
      {
        "name": "Environmental Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 14389,
              "ews": 2265,
              "obc": 5635,
              "sc": 3006,
              "st": 1441
            },
            "2023": {
              "general": 14101,
              "ews": 2219,
              "obc": 5522,
              "sc": 2945,
              "st": 1412
            },
            "2022": {
              "general": 13813,
              "ews": 2174,
              "obc": 5409,
              "sc": 2885,
              "st": 1383
            },
            "2021": {
              "general": 13525,
              "ews": 2129,
              "obc": 5296,
              "sc": 2825,
              "st": 1354
            },
            "2020": {
              "general": 13237,
              "ews": 2083,
              "obc": 5184,
              "sc": 2765,
              "st": 1325
            }
          }
        },
        "fees": 200000,
        "seats": 64
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4381,
              "ews": 623,
              "obc": 1663,
              "sc": 976,
              "st": 531
            },
            "2023": {
              "general": 4293,
              "ews": 610,
              "obc": 1629,
              "sc": 956,
              "st": 520
            },
            "2022": {
              "general": 4205,
              "ews": 598,
              "obc": 1596,
              "sc": 936,
              "st": 509
            },
            "2021": {
              "general": 4118,
              "ews": 585,
              "obc": 1563,
              "sc": 917,
              "st": 499
            },
            "2020": {
              "general": 4030,
              "ews": 573,
              "obc": 1529,
              "sc": 897,
              "st": 488
            }
          }
        },
        "fees": 200000,
        "seats": 64
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 9009,
              "ews": 1450,
              "obc": 3687,
              "sc": 2079,
              "st": 1064
            },
            "2023": {
              "general": 8828,
              "ews": 1421,
              "obc": 3613,
              "sc": 2037,
              "st": 1042
            },
            "2022": {
              "general": 8648,
              "ews": 1392,
              "obc": 3539,
              "sc": 1995,
              "st": 1021
            },
            "2021": {
              "general": 8468,
              "ews": 1363,
              "obc": 3465,
              "sc": 1954,
              "st": 1000
            },
            "2020": {
              "general": 8288,
              "ews": 1334,
              "obc": 3392,
              "sc": 1912,
              "st": 978
            }
          }
        },
        "fees": 200000,
        "seats": 64
      },
      {
        "name": "Mineral and Metallurgical Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 13157,
              "ews": 2186,
              "obc": 5312,
              "sc": 2559,
              "st": 1340
            },
            "2023": {
              "general": 12893,
              "ews": 2142,
              "obc": 5205,
              "sc": 2507,
              "st": 1313
            },
            "2022": {
              "general": 12630,
              "ews": 2098,
              "obc": 5099,
              "sc": 2456,
              "st": 1286
            },
            "2021": {
              "general": 12367,
              "ews": 2054,
              "obc": 4993,
              "sc": 2405,
              "st": 1259
            },
            "2020": {
              "general": 12104,
              "ews": 2011,
              "obc": 4887,
              "sc": 2354,
              "st": 1232
            }
          }
        },
        "fees": 200000,
        "seats": 64
      },
      {
        "name": "Mining Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 13888,
              "ews": 2140,
              "obc": 5314,
              "sc": 2822,
              "st": 1171
            },
            "2023": {
              "general": 13610,
              "ews": 2097,
              "obc": 5207,
              "sc": 2765,
              "st": 1147
            },
            "2022": {
              "general": 13332,
              "ews": 2054,
              "obc": 5101,
              "sc": 2709,
              "st": 1124
            },
            "2021": {
              "general": 13054,
              "ews": 2011,
              "obc": 4995,
              "sc": 2652,
              "st": 1100
            },
            "2020": {
              "general": 12776,
              "ews": 1968,
              "obc": 4888,
              "sc": 2596,
              "st": 1077
            }
          }
        },
        "fees": 200000,
        "seats": 64
      },
      {
        "name": "Mining Machinery Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 14440,
              "ews": 2216,
              "obc": 5574,
              "sc": 2991,
              "st": 1338
            },
            "2023": {
              "general": 14151,
              "ews": 2171,
              "obc": 5462,
              "sc": 2931,
              "st": 1311
            },
            "2022": {
              "general": 13862,
              "ews": 2127,
              "obc": 5351,
              "sc": 2871,
              "st": 1284
            },
            "2021": {
              "general": 13573,
              "ews": 2083,
              "obc": 5239,
              "sc": 2811,
              "st": 1257
            },
            "2020": {
              "general": 13284,
              "ews": 2038,
              "obc": 5128,
              "sc": 2751,
              "st": 1230
            }
          }
        },
        "fees": 200000,
        "seats": 64
      },
      {
        "name": "Petroleum Engineering",
        "code": "PE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 11724,
              "ews": 1811,
              "obc": 4494,
              "sc": 2501,
              "st": 1112
            },
            "2023": {
              "general": 11489,
              "ews": 1774,
              "obc": 4404,
              "sc": 2450,
              "st": 1089
            },
            "2022": {
              "general": 11255,
              "ews": 1738,
              "obc": 4314,
              "sc": 2400,
              "st": 1067
            },
            "2021": {
              "general": 11020,
              "ews": 1702,
              "obc": 4224,
              "sc": 2350,
              "st": 1045
            },
            "2020": {
              "general": 10786,
              "ews": 1666,
              "obc": 4134,
              "sc": 2300,
              "st": 1023
            }
          }
        },
        "fees": 200000,
        "seats": 64
      }
    ]
  },
  {
    "id": 45,
    "name": "Indian Institute of Technology Bhilai",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5932,
              "ews": 945,
              "obc": 2470,
              "sc": 1021,
              "st": 612
            },
            "2023": {
              "general": 5813,
              "ews": 926,
              "obc": 2420,
              "sc": 1000,
              "st": 599
            },
            "2022": {
              "general": 5694,
              "ews": 907,
              "obc": 2371,
              "sc": 980,
              "st": 587
            },
            "2021": {
              "general": 5576,
              "ews": 888,
              "obc": 2321,
              "sc": 959,
              "st": 575
            },
            "2020": {
              "general": 5457,
              "ews": 869,
              "obc": 2272,
              "sc": 939,
              "st": 563
            }
          }
        },
        "fees": 200000,
        "seats": 65
      },
      {
        "name": "Data Science and Artificial Intelligence",
        "code": "DSAI",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6738,
              "ews": 1086,
              "obc": 2712,
              "sc": 1332,
              "st": 687
            },
            "2023": {
              "general": 6603,
              "ews": 1064,
              "obc": 2657,
              "sc": 1305,
              "st": 673
            },
            "2022": {
              "general": 6468,
              "ews": 1042,
              "obc": 2603,
              "sc": 1278,
              "st": 659
            },
            "2021": {
              "general": 6333,
              "ews": 1020,
              "obc": 2549,
              "sc": 1252,
              "st": 645
            },
            "2020": {
              "general": 6198,
              "ews": 999,
              "obc": 2495,
              "sc": 1225,
              "st": 632
            }
          }
        },
        "fees": 200000,
        "seats": 65
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 9561,
              "ews": 1528,
              "obc": 3998,
              "sc": 2112,
              "st": 1068
            },
            "2023": {
              "general": 9369,
              "ews": 1497,
              "obc": 3918,
              "sc": 2069,
              "st": 1046
            },
            "2022": {
              "general": 9178,
              "ews": 1466,
              "obc": 3838,
              "sc": 2027,
              "st": 1025
            },
            "2021": {
              "general": 8987,
              "ews": 1436,
              "obc": 3758,
              "sc": 1985,
              "st": 1003
            },
            "2020": {
              "general": 8796,
              "ews": 1405,
              "obc": 3678,
              "sc": 1943,
              "st": 982
            }
          }
        },
        "fees": 200000,
        "seats": 65
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 8725,
              "ews": 1279,
              "obc": 3450,
              "sc": 1889,
              "st": 850
            },
            "2023": {
              "general": 8550,
              "ews": 1253,
              "obc": 3381,
              "sc": 1851,
              "st": 833
            },
            "2022": {
              "general": 8376,
              "ews": 1227,
              "obc": 3312,
              "sc": 1813,
              "st": 816
            },
            "2021": {
              "general": 8201,
              "ews": 1202,
              "obc": 3243,
              "sc": 1775,
              "st": 799
            },
            "2020": {
              "general": 8027,
              "ews": 1176,
              "obc": 3174,
              "sc": 1737,
              "st": 782
            }
          }
        },
        "fees": 200000,
        "seats": 65
      },
      {
        "name": "Materials Science and Metallurgical Engineering",
        "code": "MSME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 14622,
              "ews": 2245,
              "obc": 5702,
              "sc": 3057,
              "st": 1379
            },
            "2023": {
              "general": 14329,
              "ews": 2200,
              "obc": 5587,
              "sc": 2995,
              "st": 1351
            },
            "2022": {
              "general": 14037,
              "ews": 2155,
              "obc": 5473,
              "sc": 2934,
              "st": 1323
            },
            "2021": {
              "general": 13744,
              "ews": 2110,
              "obc": 5359,
              "sc": 2873,
              "st": 1296
            },
            "2020": {
              "general": 13452,
              "ews": 2065,
              "obc": 5245,
              "sc": 2812,
              "st": 1268
            }
          }
        },
        "fees": 200000,
        "seats": 65
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 11628,
              "ews": 1883,
              "obc": 4757,
              "sc": 2558,
              "st": 1183
            },
            "2023": {
              "general": 11395,
              "ews": 1845,
              "obc": 4661,
              "sc": 2506,
              "st": 1159
            },
            "2022": {
              "general": 11162,
              "ews": 1807,
              "obc": 4566,
              "sc": 2455,
              "st": 1135
            },
            "2021": {
              "general": 10930,
              "ews": 1770,
              "obc": 4471,
              "sc": 2404,
              "st": 1112
            },
            "2020": {
              "general": 10697,
              "ews": 1732,
              "obc": 4376,
              "sc": 2353,
              "st": 1088
            }
          }
        },
        "fees": 200000,
        "seats": 65
      },
      {
        "name": "Mechatronics Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 9811,
              "ews": 1739,
              "obc": 4511,
              "sc": 2189,
              "st": 1327
            },
            "2023": {
              "general": 9614,
              "ews": 1704,
              "obc": 4420,
              "sc": 2145,
              "st": 1300
            },
            "2022": {
              "general": 9418,
              "ews": 1669,
              "obc": 4330,
              "sc": 2101,
              "st": 1273
            },
            "2021": {
              "general": 9222,
              "ews": 1634,
              "obc": 4240,
              "sc": 2057,
              "st": 1247
            },
            "2020": {
              "general": 9026,
              "ews": 1599,
              "obc": 4150,
              "sc": 2013,
              "st": 1220
            }
          }
        },
        "fees": 200000,
        "seats": 65
      }
    ]
  },
  {
    "id": 46,
    "name": "Indian Institute of Technology Bhubaneswar",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 13317,
              "ews": 2105,
              "obc": 5138,
              "sc": 2562,
              "st": 977
            },
            "2023": {
              "general": 13050,
              "ews": 2062,
              "obc": 5035,
              "sc": 2510,
              "st": 957
            },
            "2022": {
              "general": 12784,
              "ews": 2020,
              "obc": 4932,
              "sc": 2459,
              "st": 937
            },
            "2021": {
              "general": 12517,
              "ews": 1978,
              "obc": 4829,
              "sc": 2408,
              "st": 918
            },
            "2020": {
              "general": 12251,
              "ews": 1936,
              "obc": 4726,
              "sc": 2357,
              "st": 898
            }
          }
        },
        "fees": 200000,
        "seats": 66
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3454,
              "ews": 415,
              "obc": 1225,
              "sc": 596,
              "st": 356
            },
            "2023": {
              "general": 3384,
              "ews": 406,
              "obc": 1200,
              "sc": 584,
              "st": 348
            },
            "2022": {
              "general": 3315,
              "ews": 398,
              "obc": 1176,
              "sc": 572,
              "st": 341
            },
            "2021": {
              "general": 3246,
              "ews": 390,
              "obc": 1151,
              "sc": 560,
              "st": 334
            },
            "2020": {
              "general": 3177,
              "ews": 381,
              "obc": 1127,
              "sc": 548,
              "st": 327
            }
          }
        },
        "fees": 200000,
        "seats": 66
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6685,
              "ews": 1151,
              "obc": 2868,
              "sc": 1674,
              "st": 792
            },
            "2023": {
              "general": 6551,
              "ews": 1127,
              "obc": 2810,
              "sc": 1640,
              "st": 776
            },
            "2022": {
              "general": 6417,
              "ews": 1104,
              "obc": 2753,
              "sc": 1607,
              "st": 760
            },
            "2021": {
              "general": 6283,
              "ews": 1081,
              "obc": 2695,
              "sc": 1573,
              "st": 744
            },
            "2020": {
              "general": 6150,
              "ews": 1058,
              "obc": 2638,
              "sc": 1540,
              "st": 728
            }
          }
        },
        "fees": 200000,
        "seats": 66
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5025,
              "ews": 738,
              "obc": 1990,
              "sc": 1239,
              "st": 538
            },
            "2023": {
              "general": 4924,
              "ews": 723,
              "obc": 1950,
              "sc": 1214,
              "st": 527
            },
            "2022": {
              "general": 4824,
              "ews": 708,
              "obc": 1910,
              "sc": 1189,
              "st": 516
            },
            "2021": {
              "general": 4723,
              "ews": 693,
              "obc": 1870,
              "sc": 1164,
              "st": 505
            },
            "2020": {
              "general": 4623,
              "ews": 678,
              "obc": 1830,
              "sc": 1139,
              "st": 494
            }
          }
        },
        "fees": 200000,
        "seats": 66
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 10179,
              "ews": 1755,
              "obc": 4378,
              "sc": 2104,
              "st": 1160
            },
            "2023": {
              "general": 9975,
              "ews": 1719,
              "obc": 4290,
              "sc": 2061,
              "st": 1136
            },
            "2022": {
              "general": 9771,
              "ews": 1684,
              "obc": 4202,
              "sc": 2019,
              "st": 1113
            },
            "2021": {
              "general": 9568,
              "ews": 1649,
              "obc": 4115,
              "sc": 1977,
              "st": 1090
            },
            "2020": {
              "general": 9364,
              "ews": 1614,
              "obc": 4027,
              "sc": 1935,
              "st": 1067
            }
          }
        },
        "fees": 200000,
        "seats": 66
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 9533,
              "ews": 1489,
              "obc": 3776,
              "sc": 2223,
              "st": 1035
            },
            "2023": {
              "general": 9342,
              "ews": 1459,
              "obc": 3700,
              "sc": 2178,
              "st": 1014
            },
            "2022": {
              "general": 9151,
              "ews": 1429,
              "obc": 3624,
              "sc": 2134,
              "st": 993
            },
            "2021": {
              "general": 8961,
              "ews": 1399,
              "obc": 3549,
              "sc": 2089,
              "st": 972
            },
            "2020": {
              "general": 8770,
              "ews": 1369,
              "obc": 3473,
              "sc": 2045,
              "st": 952
            }
          }
        },
        "fees": 200000,
        "seats": 66
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 13863,
              "ews": 2170,
              "obc": 5284,
              "sc": 2774,
              "st": 1223
            },
            "2023": {
              "general": 13585,
              "ews": 2126,
              "obc": 5178,
              "sc": 2718,
              "st": 1198
            },
            "2022": {
              "general": 13308,
              "ews": 2083,
              "obc": 5072,
              "sc": 2663,
              "st": 1174
            },
            "2021": {
              "general": 13031,
              "ews": 2039,
              "obc": 4966,
              "sc": 2607,
              "st": 1149
            },
            "2020": {
              "general": 12753,
              "ews": 1996,
              "obc": 4861,
              "sc": 2552,
              "st": 1125
            }
          }
        },
        "fees": 200000,
        "seats": 66
      }
    ]
  },
  {
    "id": 47,
    "name": "Indian Institute of Technology Bombay",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Aerospace Engineering",
        "code": "AE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2394,
              "ews": 618,
              "obc": 1470,
              "sc": 678,
              "st": 471
            },
            "2023": {
              "general": 2346,
              "ews": 605,
              "obc": 1440,
              "sc": 664,
              "st": 461
            },
            "2022": {
              "general": 2298,
              "ews": 593,
              "obc": 1411,
              "sc": 650,
              "st": 452
            },
            "2021": {
              "general": 2250,
              "ews": 580,
              "obc": 1381,
              "sc": 637,
              "st": 442
            },
            "2020": {
              "general": 2202,
              "ews": 568,
              "obc": 1352,
              "sc": 623,
              "st": 433
            }
          }
        },
        "fees": 200000,
        "seats": 67
      },
      {
        "name": "BS in Mathematics",
        "code": "BM",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1191,
              "ews": 360,
              "obc": 1291,
              "sc": 545,
              "st": 247
            },
            "2023": {
              "general": 1167,
              "ews": 352,
              "obc": 1265,
              "sc": 534,
              "st": 242
            },
            "2022": {
              "general": 1143,
              "ews": 345,
              "obc": 1239,
              "sc": 523,
              "st": 237
            },
            "2021": {
              "general": 1119,
              "ews": 338,
              "obc": 1213,
              "sc": 512,
              "st": 232
            },
            "2020": {
              "general": 1095,
              "ews": 331,
              "obc": 1187,
              "sc": 501,
              "st": 227
            }
          }
        },
        "fees": 200000,
        "seats": 67
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2529,
              "ews": 485,
              "obc": 1337,
              "sc": 783,
              "st": 413
            },
            "2023": {
              "general": 2478,
              "ews": 475,
              "obc": 1310,
              "sc": 767,
              "st": 404
            },
            "2022": {
              "general": 2427,
              "ews": 465,
              "obc": 1283,
              "sc": 751,
              "st": 396
            },
            "2021": {
              "general": 2377,
              "ews": 455,
              "obc": 1256,
              "sc": 736,
              "st": 388
            },
            "2020": {
              "general": 2326,
              "ews": 446,
              "obc": 1230,
              "sc": 720,
              "st": 379
            }
          }
        },
        "fees": 200000,
        "seats": 67
      },
      {
        "name": "Chemistry",
        "code": "C",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 7065,
              "ews": 1338,
              "obc": 3506,
              "sc": 1936,
              "st": 1036
            },
            "2023": {
              "general": 6923,
              "ews": 1311,
              "obc": 3435,
              "sc": 1897,
              "st": 1015
            },
            "2022": {
              "general": 6782,
              "ews": 1284,
              "obc": 3365,
              "sc": 1858,
              "st": 994
            },
            "2021": {
              "general": 6641,
              "ews": 1257,
              "obc": 3295,
              "sc": 1819,
              "st": 973
            },
            "2020": {
              "general": 6499,
              "ews": 1230,
              "obc": 3225,
              "sc": 1781,
              "st": 953
            }
          }
        },
        "fees": 200000,
        "seats": 67
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3987,
              "ews": 769,
              "obc": 1979,
              "sc": 998,
              "st": 331
            },
            "2023": {
              "general": 3907,
              "ews": 753,
              "obc": 1939,
              "sc": 978,
              "st": 324
            },
            "2022": {
              "general": 3827,
              "ews": 738,
              "obc": 1899,
              "sc": 958,
              "st": 317
            },
            "2021": {
              "general": 3747,
              "ews": 722,
              "obc": 1860,
              "sc": 938,
              "st": 311
            },
            "2020": {
              "general": 3668,
              "ews": 707,
              "obc": 1820,
              "sc": 918,
              "st": 304
            }
          }
        },
        "fees": 200000,
        "seats": 67
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 68,
              "ews": 23,
              "obc": 50,
              "sc": 32,
              "st": 13
            },
            "2023": {
              "general": 66,
              "ews": 22,
              "obc": 49,
              "sc": 31,
              "st": 12
            },
            "2022": {
              "general": 65,
              "ews": 22,
              "obc": 48,
              "sc": 30,
              "st": 12
            },
            "2021": {
              "general": 63,
              "ews": 21,
              "obc": 47,
              "sc": 30,
              "st": 12
            },
            "2020": {
              "general": 62,
              "ews": 21,
              "obc": 46,
              "sc": 29,
              "st": 11
            }
          }
        },
        "fees": 200000,
        "seats": 67
      },
      {
        "name": "Economics",
        "code": "E",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2400,
              "ews": 412,
              "obc": 1255,
              "sc": 722,
              "st": 222
            },
            "2023": {
              "general": 2352,
              "ews": 403,
              "obc": 1229,
              "sc": 707,
              "st": 217
            },
            "2022": {
              "general": 2304,
              "ews": 395,
              "obc": 1204,
              "sc": 693,
              "st": 213
            },
            "2021": {
              "general": 2256,
              "ews": 387,
              "obc": 1179,
              "sc": 678,
              "st": 208
            },
            "2020": {
              "general": 2208,
              "ews": 379,
              "obc": 1154,
              "sc": 664,
              "st": 204
            }
          }
        },
        "fees": 200000,
        "seats": 67
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 934,
              "ews": 197,
              "obc": 546,
              "sc": 274,
              "st": 221
            },
            "2023": {
              "general": 915,
              "ews": 193,
              "obc": 535,
              "sc": 268,
              "st": 216
            },
            "2022": {
              "general": 896,
              "ews": 189,
              "obc": 524,
              "sc": 263,
              "st": 212
            },
            "2021": {
              "general": 877,
              "ews": 185,
              "obc": 513,
              "sc": 257,
              "st": 207
            },
            "2020": {
              "general": 859,
              "ews": 181,
              "obc": 502,
              "sc": 252,
              "st": 203
            }
          }
        },
        "fees": 200000,
        "seats": 67
      },
      {
        "name": "Energy Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2557,
              "ews": 568,
              "obc": 1650,
              "sc": 990,
              "st": 669
            },
            "2023": {
              "general": 2505,
              "ews": 556,
              "obc": 1617,
              "sc": 970,
              "st": 655
            },
            "2022": {
              "general": 2454,
              "ews": 545,
              "obc": 1584,
              "sc": 950,
              "st": 642
            },
            "2021": {
              "general": 2403,
              "ews": 533,
              "obc": 1551,
              "sc": 930,
              "st": 628
            },
            "2020": {
              "general": 2352,
              "ews": 522,
              "obc": 1518,
              "sc": 910,
              "st": 615
            }
          }
        },
        "fees": 200000,
        "seats": 67
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1569,
              "ews": 567,
              "obc": 1552,
              "sc": 763,
              "st": 682
            },
            "2023": {
              "general": 1537,
              "ews": 555,
              "obc": 1520,
              "sc": 747,
              "st": 668
            },
            "2022": {
              "general": 1506,
              "ews": 544,
              "obc": 1489,
              "sc": 732,
              "st": 654
            },
            "2021": {
              "general": 1474,
              "ews": 532,
              "obc": 1458,
              "sc": 717,
              "st": 641
            },
            "2020": {
              "general": 1443,
              "ews": 521,
              "obc": 1427,
              "sc": 701,
              "st": 627
            }
          }
        },
        "fees": 200000,
        "seats": 67
      },
      {
        "name": "Environmental Science and Engineering",
        "code": "ESE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4718,
              "ews": 1060,
              "obc": 2716,
              "sc": 1267,
              "st": 830
            },
            "2023": {
              "general": 4623,
              "ews": 1038,
              "obc": 2661,
              "sc": 1241,
              "st": 813
            },
            "2022": {
              "general": 4529,
              "ews": 1017,
              "obc": 2607,
              "sc": 1216,
              "st": 796
            },
            "2021": {
              "general": 4434,
              "ews": 996,
              "obc": 2553,
              "sc": 1190,
              "st": 780
            },
            "2020": {
              "general": 4340,
              "ews": 975,
              "obc": 2498,
              "sc": 1165,
              "st": 763
            }
          }
        },
        "fees": 200000,
        "seats": 67
      },
      {
        "name": "Industrial Engineering and Operations Research",
        "code": "IEOR",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1726,
              "ews": 303,
              "obc": 1196,
              "sc": 999,
              "st": 351
            },
            "2023": {
              "general": 1691,
              "ews": 296,
              "obc": 1172,
              "sc": 979,
              "st": 343
            },
            "2022": {
              "general": 1656,
              "ews": 290,
              "obc": 1148,
              "sc": 959,
              "st": 336
            },
            "2021": {
              "general": 1622,
              "ews": 284,
              "obc": 1124,
              "sc": 939,
              "st": 329
            },
            "2020": {
              "general": 1587,
              "ews": 278,
              "obc": 1100,
              "sc": 919,
              "st": 322
            }
          }
        },
        "fees": 200000,
        "seats": 67
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1685,
              "ews": 340,
              "obc": 942,
              "sc": 476,
              "st": 309
            },
            "2023": {
              "general": 1651,
              "ews": 333,
              "obc": 923,
              "sc": 466,
              "st": 302
            },
            "2022": {
              "general": 1617,
              "ews": 326,
              "obc": 904,
              "sc": 456,
              "st": 296
            },
            "2021": {
              "general": 1583,
              "ews": 319,
              "obc": 885,
              "sc": 447,
              "st": 290
            },
            "2020": {
              "general": 1550,
              "ews": 312,
              "obc": 866,
              "sc": 437,
              "st": 284
            }
          }
        },
        "fees": 200000,
        "seats": 67
      },
      {
        "name": "Metallurgical Engineering and Materials Science",
        "code": "MEMS",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4175,
              "ews": 907,
              "obc": 2136,
              "sc": 1369,
              "st": 641
            },
            "2023": {
              "general": 4091,
              "ews": 888,
              "obc": 2093,
              "sc": 1341,
              "st": 628
            },
            "2022": {
              "general": 4008,
              "ews": 870,
              "obc": 2050,
              "sc": 1314,
              "st": 615
            },
            "2021": {
              "general": 3924,
              "ews": 852,
              "obc": 2007,
              "sc": 1286,
              "st": 602
            },
            "2020": {
              "general": 3841,
              "ews": 834,
              "obc": 1965,
              "sc": 1259,
              "st": 589
            }
          }
        },
        "fees": 200000,
        "seats": 67
      }
    ]
  },
  {
    "id": 48,
    "name": "Indian Institute of Technology Delhi",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Biotechnology and Biochemical Engineering",
        "code": "BBE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4819,
              "ews": 1026,
              "obc": 2747,
              "sc": 1536,
              "st": 819
            },
            "2023": {
              "general": 4722,
              "ews": 1005,
              "obc": 2692,
              "sc": 1505,
              "st": 802
            },
            "2022": {
              "general": 4626,
              "ews": 984,
              "obc": 2637,
              "sc": 1474,
              "st": 786
            },
            "2021": {
              "general": 4529,
              "ews": 964,
              "obc": 2582,
              "sc": 1443,
              "st": 769
            },
            "2020": {
              "general": 4433,
              "ews": 943,
              "obc": 2527,
              "sc": 1413,
              "st": 753
            }
          }
        },
        "fees": 200000,
        "seats": 68
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3593,
              "ews": 594,
              "obc": 1855,
              "sc": 887,
              "st": 501
            },
            "2023": {
              "general": 3521,
              "ews": 582,
              "obc": 1817,
              "sc": 869,
              "st": 490
            },
            "2022": {
              "general": 3449,
              "ews": 570,
              "obc": 1780,
              "sc": 851,
              "st": 480
            },
            "2021": {
              "general": 3377,
              "ews": 558,
              "obc": 1743,
              "sc": 833,
              "st": 470
            },
            "2020": {
              "general": 3305,
              "ews": 546,
              "obc": 1706,
              "sc": 816,
              "st": 460
            }
          }
        },
        "fees": 200000,
        "seats": 68
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4158,
              "ews": 778,
              "obc": 2045,
              "sc": 852,
              "st": 188
            },
            "2023": {
              "general": 4074,
              "ews": 762,
              "obc": 2004,
              "sc": 834,
              "st": 184
            },
            "2022": {
              "general": 3991,
              "ews": 746,
              "obc": 1963,
              "sc": 817,
              "st": 180
            },
            "2021": {
              "general": 3908,
              "ews": 731,
              "obc": 1922,
              "sc": 800,
              "st": 176
            },
            "2020": {
              "general": 3825,
              "ews": 715,
              "obc": 1881,
              "sc": 783,
              "st": 172
            }
          }
        },
        "fees": 200000,
        "seats": 68
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 204,
              "ews": 54,
              "obc": 169,
              "sc": 80,
              "st": 42
            },
            "2023": {
              "general": 199,
              "ews": 52,
              "obc": 165,
              "sc": 78,
              "st": 41
            },
            "2022": {
              "general": 195,
              "ews": 51,
              "obc": 162,
              "sc": 76,
              "st": 40
            },
            "2021": {
              "general": 191,
              "ews": 50,
              "obc": 158,
              "sc": 75,
              "st": 39
            },
            "2020": {
              "general": 187,
              "ews": 49,
              "obc": 155,
              "sc": 73,
              "st": 38
            }
          }
        },
        "fees": 200000,
        "seats": 68
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 810,
              "ews": 214,
              "obc": 493,
              "sc": 288,
              "st": 159
            },
            "2023": {
              "general": 793,
              "ews": 209,
              "obc": 483,
              "sc": 282,
              "st": 155
            },
            "2022": {
              "general": 777,
              "ews": 205,
              "obc": 473,
              "sc": 276,
              "st": 152
            },
            "2021": {
              "general": 761,
              "ews": 201,
              "obc": 463,
              "sc": 270,
              "st": 149
            },
            "2020": {
              "general": 745,
              "ews": 196,
              "obc": 453,
              "sc": 264,
              "st": 146
            }
          }
        },
        "fees": 200000,
        "seats": 68
      },
      {
        "name": "Energy Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2646,
              "ews": 565,
              "obc": 1896,
              "sc": 1092,
              "st": 645
            },
            "2023": {
              "general": 2593,
              "ews": 553,
              "obc": 1858,
              "sc": 1070,
              "st": 632
            },
            "2022": {
              "general": 2540,
              "ews": 542,
              "obc": 1820,
              "sc": 1048,
              "st": 619
            },
            "2021": {
              "general": 2487,
              "ews": 531,
              "obc": 1782,
              "sc": 1026,
              "st": 606
            },
            "2020": {
              "general": 2434,
              "ews": 519,
              "obc": 1744,
              "sc": 1004,
              "st": 593
            }
          }
        },
        "fees": 200000,
        "seats": 68
      },
      {
        "name": "Engineering and Computational Mechanics",
        "code": "ECM",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1194,
              "ews": 307,
              "obc": 640,
              "sc": 407,
              "st": 245
            },
            "2023": {
              "general": 1170,
              "ews": 300,
              "obc": 627,
              "sc": 398,
              "st": 240
            },
            "2022": {
              "general": 1146,
              "ews": 294,
              "obc": 614,
              "sc": 390,
              "st": 235
            },
            "2021": {
              "general": 1122,
              "ews": 288,
              "obc": 601,
              "sc": 382,
              "st": 230
            },
            "2020": {
              "general": 1098,
              "ews": 282,
              "obc": 588,
              "sc": 374,
              "st": 225
            }
          }
        },
        "fees": 200000,
        "seats": 68
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2449,
              "ews": 715,
              "obc": 1915,
              "sc": 1104,
              "st": 746
            },
            "2023": {
              "general": 2400,
              "ews": 700,
              "obc": 1876,
              "sc": 1081,
              "st": 731
            },
            "2022": {
              "general": 2351,
              "ews": 686,
              "obc": 1838,
              "sc": 1059,
              "st": 716
            },
            "2021": {
              "general": 2302,
              "ews": 672,
              "obc": 1800,
              "sc": 1037,
              "st": 701
            },
            "2020": {
              "general": 2253,
              "ews": 657,
              "obc": 1761,
              "sc": 1015,
              "st": 686
            }
          }
        },
        "fees": 200000,
        "seats": 68
      },
      {
        "name": "Materials Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3787,
              "ews": 910,
              "obc": 2455,
              "sc": 1408,
              "st": 813
            },
            "2023": {
              "general": 3711,
              "ews": 891,
              "obc": 2405,
              "sc": 1379,
              "st": 796
            },
            "2022": {
              "general": 3635,
              "ews": 873,
              "obc": 2356,
              "sc": 1351,
              "st": 780
            },
            "2021": {
              "general": 3559,
              "ews": 855,
              "obc": 2307,
              "sc": 1323,
              "st": 764
            },
            "2020": {
              "general": 3484,
              "ews": 837,
              "obc": 2258,
              "sc": 1295,
              "st": 747
            }
          }
        },
        "fees": 200000,
        "seats": 68
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 417,
              "ews": 84,
              "obc": 270,
              "sc": 170,
              "st": 170
            },
            "2023": {
              "general": 408,
              "ews": 82,
              "obc": 264,
              "sc": 166,
              "st": 166
            },
            "2022": {
              "general": 400,
              "ews": 80,
              "obc": 259,
              "sc": 163,
              "st": 163
            },
            "2021": {
              "general": 391,
              "ews": 78,
              "obc": 253,
              "sc": 159,
              "st": 159
            },
            "2020": {
              "general": 383,
              "ews": 77,
              "obc": 248,
              "sc": 156,
              "st": 156
            }
          }
        },
        "fees": 200000,
        "seats": 68
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1774,
              "ews": 387,
              "obc": 1010,
              "sc": 500,
              "st": 310
            },
            "2023": {
              "general": 1738,
              "ews": 379,
              "obc": 989,
              "sc": 490,
              "st": 303
            },
            "2022": {
              "general": 1703,
              "ews": 371,
              "obc": 969,
              "sc": 480,
              "st": 297
            },
            "2021": {
              "general": 1667,
              "ews": 363,
              "obc": 949,
              "sc": 470,
              "st": 291
            },
            "2020": {
              "general": 1632,
              "ews": 356,
              "obc": 929,
              "sc": 460,
              "st": 285
            }
          }
        },
        "fees": 200000,
        "seats": 68
      },
      {
        "name": "Production and Industrial Engineering",
        "code": "PIE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3089,
              "ews": 722,
              "obc": 2172,
              "sc": 1335,
              "st": 810
            },
            "2023": {
              "general": 3027,
              "ews": 707,
              "obc": 2128,
              "sc": 1308,
              "st": 793
            },
            "2022": {
              "general": 2965,
              "ews": 693,
              "obc": 2085,
              "sc": 1281,
              "st": 777
            },
            "2021": {
              "general": 2903,
              "ews": 678,
              "obc": 2041,
              "sc": 1254,
              "st": 761
            },
            "2020": {
              "general": 2841,
              "ews": 664,
              "obc": 1998,
              "sc": 1228,
              "st": 745
            }
          }
        },
        "fees": 200000,
        "seats": 68
      },
      {
        "name": "Textile Technology",
        "code": "TT",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6028,
              "ews": 1139,
              "obc": 3184,
              "sc": 1780,
              "st": 991
            },
            "2023": {
              "general": 5907,
              "ews": 1116,
              "obc": 3120,
              "sc": 1744,
              "st": 971
            },
            "2022": {
              "general": 5786,
              "ews": 1093,
              "obc": 3056,
              "sc": 1708,
              "st": 951
            },
            "2021": {
              "general": 5666,
              "ews": 1070,
              "obc": 2992,
              "sc": 1673,
              "st": 931
            },
            "2020": {
              "general": 5545,
              "ews": 1047,
              "obc": 2929,
              "sc": 1637,
              "st": 911
            }
          }
        },
        "fees": 200000,
        "seats": 68
      }
    ]
  },
  {
    "id": 49,
    "name": "Indian Institute of Technology Dharwad",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Chemical and Biochemical Engineering",
        "code": "CBE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 14784,
              "ews": 2314,
              "obc": 5382,
              "sc": 3121,
              "st": 1337
            },
            "2023": {
              "general": 14488,
              "ews": 2267,
              "obc": 5274,
              "sc": 3058,
              "st": 1310
            },
            "2022": {
              "general": 14192,
              "ews": 2221,
              "obc": 5166,
              "sc": 2996,
              "st": 1283
            },
            "2021": {
              "general": 13896,
              "ews": 2175,
              "obc": 5059,
              "sc": 2933,
              "st": 1256
            },
            "2020": {
              "general": 13601,
              "ews": 2128,
              "obc": 4951,
              "sc": 2871,
              "st": 1230
            }
          }
        },
        "fees": 200000,
        "seats": 69
      },
      {
        "name": "Civil and Infrastructure Engineering",
        "code": "CIE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 14819,
              "ews": 2271,
              "obc": 5421,
              "sc": 2669,
              "st": 1147
            },
            "2023": {
              "general": 14522,
              "ews": 2225,
              "obc": 5312,
              "sc": 2615,
              "st": 1124
            },
            "2022": {
              "general": 14226,
              "ews": 2180,
              "obc": 5204,
              "sc": 2562,
              "st": 1101
            },
            "2021": {
              "general": 13929,
              "ews": 2134,
              "obc": 5095,
              "sc": 2508,
              "st": 1078
            },
            "2020": {
              "general": 13633,
              "ews": 2089,
              "obc": 4987,
              "sc": 2455,
              "st": 1055
            }
          }
        },
        "fees": 200000,
        "seats": 69
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5601,
              "ews": 882,
              "obc": 2225,
              "sc": 1295,
              "st": 607
            },
            "2023": {
              "general": 5488,
              "ews": 864,
              "obc": 2180,
              "sc": 1269,
              "st": 594
            },
            "2022": {
              "general": 5376,
              "ews": 846,
              "obc": 2136,
              "sc": 1243,
              "st": 582
            },
            "2021": {
              "general": 5264,
              "ews": 829,
              "obc": 2091,
              "sc": 1217,
              "st": 570
            },
            "2020": {
              "general": 5152,
              "ews": 811,
              "obc": 2047,
              "sc": 1191,
              "st": 558
            }
          }
        },
        "fees": 200000,
        "seats": 69
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 8881,
              "ews": 1363,
              "obc": 3742,
              "sc": 1982,
              "st": 906
            },
            "2023": {
              "general": 8703,
              "ews": 1335,
              "obc": 3667,
              "sc": 1942,
              "st": 887
            },
            "2022": {
              "general": 8525,
              "ews": 1308,
              "obc": 3592,
              "sc": 1902,
              "st": 869
            },
            "2021": {
              "general": 8348,
              "ews": 1281,
              "obc": 3517,
              "sc": 1863,
              "st": 851
            },
            "2020": {
              "general": 8170,
              "ews": 1253,
              "obc": 3442,
              "sc": 1823,
              "st": 833
            }
          }
        },
        "fees": 200000,
        "seats": 69
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 8363,
              "ews": 1167,
              "obc": 3294,
              "sc": 1712,
              "st": 803
            },
            "2023": {
              "general": 8195,
              "ews": 1143,
              "obc": 3228,
              "sc": 1677,
              "st": 786
            },
            "2022": {
              "general": 8028,
              "ews": 1120,
              "obc": 3162,
              "sc": 1643,
              "st": 770
            },
            "2021": {
              "general": 7861,
              "ews": 1096,
              "obc": 3096,
              "sc": 1609,
              "st": 754
            },
            "2020": {
              "general": 7693,
              "ews": 1073,
              "obc": 3030,
              "sc": 1575,
              "st": 738
            }
          }
        },
        "fees": 200000,
        "seats": 69
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 11700,
              "ews": 2123,
              "obc": 5234,
              "sc": 3051,
              "st": 1442
            },
            "2023": {
              "general": 11466,
              "ews": 2080,
              "obc": 5129,
              "sc": 2989,
              "st": 1413
            },
            "2022": {
              "general": 11232,
              "ews": 2038,
              "obc": 5024,
              "sc": 2928,
              "st": 1384
            },
            "2021": {
              "general": 10998,
              "ews": 1995,
              "obc": 4919,
              "sc": 2867,
              "st": 1355
            },
            "2020": {
              "general": 10764,
              "ews": 1953,
              "obc": 4815,
              "sc": 2806,
              "st": 1326
            }
          }
        },
        "fees": 200000,
        "seats": 69
      },
      {
        "name": "Interdisciplinary Sciences",
        "code": "IS",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 16053,
              "ews": 2461,
              "obc": 6099,
              "sc": 3201,
              "st": 1529
            },
            "2023": {
              "general": 15731,
              "ews": 2411,
              "obc": 5977,
              "sc": 3136,
              "st": 1498
            },
            "2022": {
              "general": 15410,
              "ews": 2362,
              "obc": 5855,
              "sc": 3072,
              "st": 1467
            },
            "2021": {
              "general": 15089,
              "ews": 2313,
              "obc": 5733,
              "sc": 3008,
              "st": 1437
            },
            "2020": {
              "general": 14768,
              "ews": 2264,
              "obc": 5611,
              "sc": 2944,
              "st": 1406
            }
          }
        },
        "fees": 200000,
        "seats": 69
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6946,
              "ews": 1059,
              "obc": 2689,
              "sc": 1479,
              "st": 788
            },
            "2023": {
              "general": 6807,
              "ews": 1037,
              "obc": 2635,
              "sc": 1449,
              "st": 772
            },
            "2022": {
              "general": 6668,
              "ews": 1016,
              "obc": 2581,
              "sc": 1419,
              "st": 756
            },
            "2021": {
              "general": 6529,
              "ews": 995,
              "obc": 2527,
              "sc": 1390,
              "st": 740
            },
            "2020": {
              "general": 6390,
              "ews": 974,
              "obc": 2473,
              "sc": 1360,
              "st": 724
            }
          }
        },
        "fees": 200000,
        "seats": 69
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 12239,
              "ews": 1803,
              "obc": 4839,
              "sc": 2586,
              "st": 1151
            },
            "2023": {
              "general": 11994,
              "ews": 1766,
              "obc": 4742,
              "sc": 2534,
              "st": 1127
            },
            "2022": {
              "general": 11749,
              "ews": 1730,
              "obc": 4645,
              "sc": 2482,
              "st": 1104
            },
            "2021": {
              "general": 11504,
              "ews": 1694,
              "obc": 4548,
              "sc": 2430,
              "st": 1081
            },
            "2020": {
              "general": 11259,
              "ews": 1658,
              "obc": 4451,
              "sc": 2379,
              "st": 1058
            }
          }
        },
        "fees": 200000,
        "seats": 69
      }
    ]
  },
  {
    "id": 50,
    "name": "Indian Institute of Technology Gandhinagar",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Artificial Intelligence",
        "code": "AI",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2175,
              "ews": 305,
              "obc": 1072,
              "sc": 649,
              "st": 249
            },
            "2023": {
              "general": 2131,
              "ews": 298,
              "obc": 1050,
              "sc": 636,
              "st": 244
            },
            "2022": {
              "general": 2088,
              "ews": 292,
              "obc": 1029,
              "sc": 623,
              "st": 239
            },
            "2021": {
              "general": 2044,
              "ews": 286,
              "obc": 1007,
              "sc": 610,
              "st": 234
            },
            "2020": {
              "general": 2001,
              "ews": 280,
              "obc": 986,
              "sc": 597,
              "st": 229
            }
          }
        },
        "fees": 200000,
        "seats": 70
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 7803,
              "ews": 1337,
              "obc": 3731,
              "sc": 2124,
              "st": 1116
            },
            "2023": {
              "general": 7646,
              "ews": 1310,
              "obc": 3656,
              "sc": 2081,
              "st": 1093
            },
            "2022": {
              "general": 7490,
              "ews": 1283,
              "obc": 3581,
              "sc": 2039,
              "st": 1071
            },
            "2021": {
              "general": 7334,
              "ews": 1256,
              "obc": 3507,
              "sc": 1996,
              "st": 1049
            },
            "2020": {
              "general": 7178,
              "ews": 1230,
              "obc": 3432,
              "sc": 1954,
              "st": 1026
            }
          }
        },
        "fees": 200000,
        "seats": 70
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 9448,
              "ews": 1674,
              "obc": 4112,
              "sc": 2284,
              "st": 651
            },
            "2023": {
              "general": 9259,
              "ews": 1640,
              "obc": 4029,
              "sc": 2238,
              "st": 637
            },
            "2022": {
              "general": 9070,
              "ews": 1607,
              "obc": 3947,
              "sc": 2192,
              "st": 624
            },
            "2021": {
              "general": 8881,
              "ews": 1573,
              "obc": 3865,
              "sc": 2146,
              "st": 611
            },
            "2020": {
              "general": 8692,
              "ews": 1540,
              "obc": 3783,
              "sc": 2101,
              "st": 598
            }
          }
        },
        "fees": 200000,
        "seats": 70
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2171,
              "ews": 394,
              "obc": 1036,
              "sc": 490,
              "st": 367
            },
            "2023": {
              "general": 2127,
              "ews": 386,
              "obc": 1015,
              "sc": 480,
              "st": 359
            },
            "2022": {
              "general": 2084,
              "ews": 378,
              "obc": 994,
              "sc": 470,
              "st": 352
            },
            "2021": {
              "general": 2040,
              "ews": 370,
              "obc": 973,
              "sc": 460,
              "st": 344
            },
            "2020": {
              "general": 1997,
              "ews": 362,
              "obc": 953,
              "sc": 450,
              "st": 337
            }
          }
        },
        "fees": 200000,
        "seats": 70
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4368,
              "ews": 904,
              "obc": 2274,
              "sc": 1615,
              "st": 710
            },
            "2023": {
              "general": 4280,
              "ews": 885,
              "obc": 2228,
              "sc": 1582,
              "st": 695
            },
            "2022": {
              "general": 4193,
              "ews": 867,
              "obc": 2183,
              "sc": 1550,
              "st": 681
            },
            "2021": {
              "general": 4105,
              "ews": 849,
              "obc": 2137,
              "sc": 1518,
              "st": 667
            },
            "2020": {
              "general": 4018,
              "ews": 831,
              "obc": 2092,
              "sc": 1485,
              "st": 653
            }
          }
        },
        "fees": 200000,
        "seats": 70
      },
      {
        "name": "Integrated Circuit Design & Technology",
        "code": "ICDT",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4208,
              "ews": 747,
              "obc": 2460,
              "sc": 1558,
              "st": 1069
            },
            "2023": {
              "general": 4123,
              "ews": 732,
              "obc": 2410,
              "sc": 1526,
              "st": 1047
            },
            "2022": {
              "general": 4039,
              "ews": 717,
              "obc": 2361,
              "sc": 1495,
              "st": 1026
            },
            "2021": {
              "general": 3955,
              "ews": 702,
              "obc": 2312,
              "sc": 1464,
              "st": 1004
            },
            "2020": {
              "general": 3871,
              "ews": 687,
              "obc": 2263,
              "sc": 1433,
              "st": 983
            }
          }
        },
        "fees": 200000,
        "seats": 70
      },
      {
        "name": "Materials Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 10226,
              "ews": 1891,
              "obc": 4621,
              "sc": 2616,
              "st": 1269
            },
            "2023": {
              "general": 10021,
              "ews": 1853,
              "obc": 4528,
              "sc": 2563,
              "st": 1243
            },
            "2022": {
              "general": 9816,
              "ews": 1815,
              "obc": 4436,
              "sc": 2511,
              "st": 1218
            },
            "2021": {
              "general": 9612,
              "ews": 1777,
              "obc": 4343,
              "sc": 2459,
              "st": 1192
            },
            "2020": {
              "general": 9407,
              "ews": 1739,
              "obc": 4251,
              "sc": 2406,
              "st": 1167
            }
          }
        },
        "fees": 200000,
        "seats": 70
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 7248,
              "ews": 1436,
              "obc": 3498,
              "sc": 2060,
              "st": 944
            },
            "2023": {
              "general": 7103,
              "ews": 1407,
              "obc": 3428,
              "sc": 2018,
              "st": 925
            },
            "2022": {
              "general": 6958,
              "ews": 1378,
              "obc": 3358,
              "sc": 1977,
              "st": 906
            },
            "2021": {
              "general": 6813,
              "ews": 1349,
              "obc": 3288,
              "sc": 1936,
              "st": 887
            },
            "2020": {
              "general": 6668,
              "ews": 1321,
              "obc": 3218,
              "sc": 1895,
              "st": 868
            }
          }
        },
        "fees": 200000,
        "seats": 70
      }
    ]
  },
  {
    "id": 51,
    "name": "Indian Institute of Technology Goa",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4700,
              "ews": 727,
              "obc": 2002,
              "sc": 1024,
              "st": 519
            },
            "2023": {
              "general": 4606,
              "ews": 712,
              "obc": 1961,
              "sc": 1003,
              "st": 508
            },
            "2022": {
              "general": 4512,
              "ews": 697,
              "obc": 1921,
              "sc": 983,
              "st": 498
            },
            "2021": {
              "general": 4418,
              "ews": 683,
              "obc": 1881,
              "sc": 962,
              "st": 487
            },
            "2020": {
              "general": 4324,
              "ews": 668,
              "obc": 1841,
              "sc": 942,
              "st": 477
            }
          }
        },
        "fees": 200000,
        "seats": 71
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 8052,
              "ews": 1406,
              "obc": 3443,
              "sc": 1884,
              "st": 961
            },
            "2023": {
              "general": 7890,
              "ews": 1377,
              "obc": 3374,
              "sc": 1846,
              "st": 941
            },
            "2022": {
              "general": 7729,
              "ews": 1349,
              "obc": 3305,
              "sc": 1808,
              "st": 922
            },
            "2021": {
              "general": 7568,
              "ews": 1321,
              "obc": 3236,
              "sc": 1770,
              "st": 903
            },
            "2020": {
              "general": 7407,
              "ews": 1293,
              "obc": 3167,
              "sc": 1733,
              "st": 884
            }
          }
        },
        "fees": 200000,
        "seats": 71
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6197,
              "ews": 980,
              "obc": 2593,
              "sc": 1557,
              "st": 814
            },
            "2023": {
              "general": 6073,
              "ews": 960,
              "obc": 2541,
              "sc": 1525,
              "st": 797
            },
            "2022": {
              "general": 5949,
              "ews": 940,
              "obc": 2489,
              "sc": 1494,
              "st": 781
            },
            "2021": {
              "general": 5825,
              "ews": 921,
              "obc": 2437,
              "sc": 1463,
              "st": 765
            },
            "2020": {
              "general": 5701,
              "ews": 901,
              "obc": 2385,
              "sc": 1432,
              "st": 748
            }
          }
        },
        "fees": 200000,
        "seats": 71
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 10869,
              "ews": 1758,
              "obc": 4553,
              "sc": 2350,
              "st": 1110
            },
            "2023": {
              "general": 10651,
              "ews": 1722,
              "obc": 4461,
              "sc": 2303,
              "st": 1087
            },
            "2022": {
              "general": 10434,
              "ews": 1687,
              "obc": 4370,
              "sc": 2256,
              "st": 1065
            },
            "2021": {
              "general": 10216,
              "ews": 1652,
              "obc": 4279,
              "sc": 2209,
              "st": 1043
            },
            "2020": {
              "general": 9999,
              "ews": 1617,
              "obc": 4188,
              "sc": 2162,
              "st": 1021
            }
          }
        },
        "fees": 200000,
        "seats": 71
      }
    ]
  },
  {
    "id": 52,
    "name": "Indian Institute of Technology Guwahati",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Biosciences and Bioengineering",
        "code": "BB",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 8400,
              "ews": 1486,
              "obc": 4033,
              "sc": 2588,
              "st": 1312
            },
            "2023": {
              "general": 8232,
              "ews": 1456,
              "obc": 3952,
              "sc": 2536,
              "st": 1285
            },
            "2022": {
              "general": 8064,
              "ews": 1426,
              "obc": 3871,
              "sc": 2484,
              "st": 1259
            },
            "2021": {
              "general": 7896,
              "ews": 1396,
              "obc": 3791,
              "sc": 2432,
              "st": 1233
            },
            "2020": {
              "general": 7728,
              "ews": 1367,
              "obc": 3710,
              "sc": 2380,
              "st": 1207
            }
          }
        },
        "fees": 200000,
        "seats": 72
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5253,
              "ews": 936,
              "obc": 2581,
              "sc": 1375,
              "st": 811
            },
            "2023": {
              "general": 5147,
              "ews": 917,
              "obc": 2529,
              "sc": 1347,
              "st": 794
            },
            "2022": {
              "general": 5042,
              "ews": 898,
              "obc": 2477,
              "sc": 1320,
              "st": 778
            },
            "2021": {
              "general": 4937,
              "ews": 879,
              "obc": 2426,
              "sc": 1292,
              "st": 762
            },
            "2020": {
              "general": 4832,
              "ews": 861,
              "obc": 2374,
              "sc": 1265,
              "st": 746
            }
          }
        },
        "fees": 200000,
        "seats": 72
      },
      {
        "name": "Chemical Science and Technology",
        "code": "CST",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6549,
              "ews": 1198,
              "obc": 3307,
              "sc": 1868,
              "st": 993
            },
            "2023": {
              "general": 6418,
              "ews": 1174,
              "obc": 3240,
              "sc": 1830,
              "st": 973
            },
            "2022": {
              "general": 6287,
              "ews": 1150,
              "obc": 3174,
              "sc": 1793,
              "st": 953
            },
            "2021": {
              "general": 6156,
              "ews": 1126,
              "obc": 3108,
              "sc": 1755,
              "st": 933
            },
            "2020": {
              "general": 6025,
              "ews": 1102,
              "obc": 3042,
              "sc": 1718,
              "st": 913
            }
          }
        },
        "fees": 200000,
        "seats": 72
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 7142,
              "ews": 1245,
              "obc": 3249,
              "sc": 1681,
              "st": 608
            },
            "2023": {
              "general": 6999,
              "ews": 1220,
              "obc": 3184,
              "sc": 1647,
              "st": 595
            },
            "2022": {
              "general": 6856,
              "ews": 1195,
              "obc": 3119,
              "sc": 1613,
              "st": 583
            },
            "2021": {
              "general": 6713,
              "ews": 1170,
              "obc": 3054,
              "sc": 1580,
              "st": 571
            },
            "2020": {
              "general": 6570,
              "ews": 1145,
              "obc": 2989,
              "sc": 1546,
              "st": 559
            }
          }
        },
        "fees": 200000,
        "seats": 72
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 612,
              "ews": 115,
              "obc": 339,
              "sc": 181,
              "st": 100
            },
            "2023": {
              "general": 599,
              "ews": 112,
              "obc": 332,
              "sc": 177,
              "st": 98
            },
            "2022": {
              "general": 587,
              "ews": 110,
              "obc": 325,
              "sc": 173,
              "st": 96
            },
            "2021": {
              "general": 575,
              "ews": 108,
              "obc": 318,
              "sc": 170,
              "st": 94
            },
            "2020": {
              "general": 563,
              "ews": 105,
              "obc": 311,
              "sc": 166,
              "st": 92
            }
          }
        },
        "fees": 200000,
        "seats": 72
      },
      {
        "name": "Data Science and Artificial Intelligence",
        "code": "DSAI",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 981,
              "ews": 140,
              "obc": 479,
              "sc": 293,
              "st": 160
            },
            "2023": {
              "general": 961,
              "ews": 137,
              "obc": 469,
              "sc": 287,
              "st": 156
            },
            "2022": {
              "general": 941,
              "ews": 134,
              "obc": 459,
              "sc": 281,
              "st": 153
            },
            "2021": {
              "general": 922,
              "ews": 131,
              "obc": 450,
              "sc": 275,
              "st": 150
            },
            "2020": {
              "general": 902,
              "ews": 128,
              "obc": 440,
              "sc": 269,
              "st": 147
            }
          }
        },
        "fees": 200000,
        "seats": 72
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1615,
              "ews": 292,
              "obc": 855,
              "sc": 485,
              "st": 282
            },
            "2023": {
              "general": 1582,
              "ews": 286,
              "obc": 837,
              "sc": 475,
              "st": 276
            },
            "2022": {
              "general": 1550,
              "ews": 280,
              "obc": 820,
              "sc": 465,
              "st": 270
            },
            "2021": {
              "general": 1518,
              "ews": 274,
              "obc": 803,
              "sc": 455,
              "st": 265
            },
            "2020": {
              "general": 1485,
              "ews": 268,
              "obc": 786,
              "sc": 446,
              "st": 259
            }
          }
        },
        "fees": 200000,
        "seats": 72
      },
      {
        "name": "Electronics and Electrical Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2126,
              "ews": 375,
              "obc": 1020,
              "sc": 585,
              "st": 328
            },
            "2023": {
              "general": 2083,
              "ews": 367,
              "obc": 999,
              "sc": 573,
              "st": 321
            },
            "2022": {
              "general": 2040,
              "ews": 360,
              "obc": 979,
              "sc": 561,
              "st": 314
            },
            "2021": {
              "general": 1998,
              "ews": 352,
              "obc": 958,
              "sc": 549,
              "st": 308
            },
            "2020": {
              "general": 1955,
              "ews": 345,
              "obc": 938,
              "sc": 538,
              "st": 301
            }
          }
        },
        "fees": 200000,
        "seats": 72
      },
      {
        "name": "Energy Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5482,
              "ews": 1076,
              "obc": 2802,
              "sc": 1682,
              "st": 720
            },
            "2023": {
              "general": 5372,
              "ews": 1054,
              "obc": 2745,
              "sc": 1648,
              "st": 705
            },
            "2022": {
              "general": 5262,
              "ews": 1032,
              "obc": 2689,
              "sc": 1614,
              "st": 691
            },
            "2021": {
              "general": 5153,
              "ews": 1011,
              "obc": 2633,
              "sc": 1581,
              "st": 676
            },
            "2020": {
              "general": 5043,
              "ews": 989,
              "obc": 2577,
              "sc": 1547,
              "st": 662
            }
          }
        },
        "fees": 200000,
        "seats": 72
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5493,
              "ews": 1267,
              "obc": 2993,
              "sc": 1965,
              "st": 1165
            },
            "2023": {
              "general": 5383,
              "ews": 1241,
              "obc": 2933,
              "sc": 1925,
              "st": 1141
            },
            "2022": {
              "general": 5273,
              "ews": 1216,
              "obc": 2873,
              "sc": 1886,
              "st": 1118
            },
            "2021": {
              "general": 5163,
              "ews": 1190,
              "obc": 2813,
              "sc": 1847,
              "st": 1095
            },
            "2020": {
              "general": 5053,
              "ews": 1165,
              "obc": 2753,
              "sc": 1807,
              "st": 1071
            }
          }
        },
        "fees": 200000,
        "seats": 72
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1010,
              "ews": 176,
              "obc": 582,
              "sc": 393,
              "st": 227
            },
            "2023": {
              "general": 989,
              "ews": 172,
              "obc": 570,
              "sc": 385,
              "st": 222
            },
            "2022": {
              "general": 969,
              "ews": 168,
              "obc": 558,
              "sc": 377,
              "st": 217
            },
            "2021": {
              "general": 949,
              "ews": 165,
              "obc": 547,
              "sc": 369,
              "st": 213
            },
            "2020": {
              "general": 929,
              "ews": 161,
              "obc": 535,
              "sc": 361,
              "st": 208
            }
          }
        },
        "fees": 200000,
        "seats": 72
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4292,
              "ews": 768,
              "obc": 2128,
              "sc": 1094,
              "st": 579
            },
            "2023": {
              "general": 4206,
              "ews": 752,
              "obc": 2085,
              "sc": 1072,
              "st": 567
            },
            "2022": {
              "general": 4120,
              "ews": 737,
              "obc": 2042,
              "sc": 1050,
              "st": 555
            },
            "2021": {
              "general": 4034,
              "ews": 721,
              "obc": 2000,
              "sc": 1028,
              "st": 544
            },
            "2020": {
              "general": 3948,
              "ews": 706,
              "obc": 1957,
              "sc": 1006,
              "st": 532
            }
          }
        },
        "fees": 200000,
        "seats": 72
      }
    ]
  },
  {
    "id": 53,
    "name": "Indian Institute of Technology Hyderabad",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Artificial Intelligence",
        "code": "AI",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 864,
              "ews": 127,
              "obc": 399,
              "sc": 251,
              "st": 89
            },
            "2023": {
              "general": 846,
              "ews": 124,
              "obc": 391,
              "sc": 245,
              "st": 87
            },
            "2022": {
              "general": 829,
              "ews": 121,
              "obc": 383,
              "sc": 240,
              "st": 85
            },
            "2021": {
              "general": 812,
              "ews": 119,
              "obc": 375,
              "sc": 235,
              "st": 83
            },
            "2020": {
              "general": 794,
              "ews": 116,
              "obc": 367,
              "sc": 230,
              "st": 81
            }
          }
        },
        "fees": 200000,
        "seats": 73
      },
      {
        "name": "Biomedical Engineering",
        "code": "BE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 8172,
              "ews": 1636,
              "obc": 3929,
              "sc": 2244,
              "st": 1197
            },
            "2023": {
              "general": 8008,
              "ews": 1603,
              "obc": 3850,
              "sc": 2199,
              "st": 1173
            },
            "2022": {
              "general": 7845,
              "ews": 1570,
              "obc": 3771,
              "sc": 2154,
              "st": 1149
            },
            "2021": {
              "general": 7681,
              "ews": 1537,
              "obc": 3693,
              "sc": 2109,
              "st": 1125
            },
            "2020": {
              "general": 7518,
              "ews": 1505,
              "obc": 3614,
              "sc": 2064,
              "st": 1101
            }
          }
        },
        "fees": 200000,
        "seats": 73
      },
      {
        "name": "Biotechnology and Bioinformatics",
        "code": "BB",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 7972,
              "ews": 1522,
              "obc": 4011,
              "sc": 2324,
              "st": 1099
            },
            "2023": {
              "general": 7812,
              "ews": 1491,
              "obc": 3930,
              "sc": 2277,
              "st": 1077
            },
            "2022": {
              "general": 7653,
              "ews": 1461,
              "obc": 3850,
              "sc": 2231,
              "st": 1055
            },
            "2021": {
              "general": 7493,
              "ews": 1430,
              "obc": 3770,
              "sc": 2184,
              "st": 1033
            },
            "2020": {
              "general": 7334,
              "ews": 1400,
              "obc": 3690,
              "sc": 2138,
              "st": 1011
            }
          }
        },
        "fees": 200000,
        "seats": 73
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5558,
              "ews": 1014,
              "obc": 2614,
              "sc": 1548,
              "st": 783
            },
            "2023": {
              "general": 5446,
              "ews": 993,
              "obc": 2561,
              "sc": 1517,
              "st": 767
            },
            "2022": {
              "general": 5335,
              "ews": 973,
              "obc": 2509,
              "sc": 1486,
              "st": 751
            },
            "2021": {
              "general": 5224,
              "ews": 953,
              "obc": 2457,
              "sc": 1455,
              "st": 736
            },
            "2020": {
              "general": 5113,
              "ews": 932,
              "obc": 2404,
              "sc": 1424,
              "st": 720
            }
          }
        },
        "fees": 200000,
        "seats": 73
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 7463,
              "ews": 1249,
              "obc": 3314,
              "sc": 1747,
              "st": 665
            },
            "2023": {
              "general": 7313,
              "ews": 1224,
              "obc": 3247,
              "sc": 1712,
              "st": 651
            },
            "2022": {
              "general": 7164,
              "ews": 1199,
              "obc": 3181,
              "sc": 1677,
              "st": 638
            },
            "2021": {
              "general": 7015,
              "ews": 1174,
              "obc": 3115,
              "sc": 1642,
              "st": 625
            },
            "2020": {
              "general": 6865,
              "ews": 1149,
              "obc": 3048,
              "sc": 1607,
              "st": 611
            }
          }
        },
        "fees": 200000,
        "seats": 73
      },
      {
        "name": "Computational Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1771,
              "ews": 272,
              "obc": 991,
              "sc": 657,
              "st": 441
            },
            "2023": {
              "general": 1735,
              "ews": 266,
              "obc": 971,
              "sc": 643,
              "st": 432
            },
            "2022": {
              "general": 1700,
              "ews": 261,
              "obc": 951,
              "sc": 630,
              "st": 423
            },
            "2021": {
              "general": 1664,
              "ews": 255,
              "obc": 931,
              "sc": 617,
              "st": 414
            },
            "2020": {
              "general": 1629,
              "ews": 250,
              "obc": 911,
              "sc": 604,
              "st": 405
            }
          }
        },
        "fees": 200000,
        "seats": 73
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 652,
              "ews": 112,
              "obc": 285,
              "sc": 182,
              "st": 82
            },
            "2023": {
              "general": 638,
              "ews": 109,
              "obc": 279,
              "sc": 178,
              "st": 80
            },
            "2022": {
              "general": 625,
              "ews": 107,
              "obc": 273,
              "sc": 174,
              "st": 78
            },
            "2021": {
              "general": 612,
              "ews": 105,
              "obc": 267,
              "sc": 171,
              "st": 77
            },
            "2020": {
              "general": 599,
              "ews": 103,
              "obc": 262,
              "sc": 167,
              "st": 75
            }
          }
        },
        "fees": 200000,
        "seats": 73
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2105,
              "ews": 350,
              "obc": 920,
              "sc": 463,
              "st": 373
            },
            "2023": {
              "general": 2062,
              "ews": 343,
              "obc": 901,
              "sc": 453,
              "st": 365
            },
            "2022": {
              "general": 2020,
              "ews": 336,
              "obc": 883,
              "sc": 444,
              "st": 358
            },
            "2021": {
              "general": 1978,
              "ews": 329,
              "obc": 864,
              "sc": 435,
              "st": 350
            },
            "2020": {
              "general": 1936,
              "ews": 322,
              "obc": 846,
              "sc": 425,
              "st": 343
            }
          }
        },
        "fees": 200000,
        "seats": 73
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4678,
              "ews": 1180,
              "obc": 2841,
              "sc": 1818,
              "st": 1066
            },
            "2023": {
              "general": 4584,
              "ews": 1156,
              "obc": 2784,
              "sc": 1781,
              "st": 1044
            },
            "2022": {
              "general": 4490,
              "ews": 1132,
              "obc": 2727,
              "sc": 1745,
              "st": 1023
            },
            "2021": {
              "general": 4397,
              "ews": 1109,
              "obc": 2670,
              "sc": 1708,
              "st": 1002
            },
            "2020": {
              "general": 4303,
              "ews": 1085,
              "obc": 2613,
              "sc": 1672,
              "st": 980
            }
          }
        },
        "fees": 200000,
        "seats": 73
      },
      {
        "name": "Engineering Science",
        "code": "ES",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3326,
              "ews": 536,
              "obc": 1984,
              "sc": 1125,
              "st": 592
            },
            "2023": {
              "general": 3259,
              "ews": 525,
              "obc": 1944,
              "sc": 1102,
              "st": 580
            },
            "2022": {
              "general": 3192,
              "ews": 514,
              "obc": 1904,
              "sc": 1080,
              "st": 568
            },
            "2021": {
              "general": 3126,
              "ews": 503,
              "obc": 1864,
              "sc": 1057,
              "st": 556
            },
            "2020": {
              "general": 3059,
              "ews": 493,
              "obc": 1825,
              "sc": 1035,
              "st": 544
            }
          }
        },
        "fees": 200000,
        "seats": 73
      },
      {
        "name": "Industrial Chemistry",
        "code": "IC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 8802,
              "ews": 1656,
              "obc": 4089,
              "sc": 2370,
              "st": 1240
            },
            "2023": {
              "general": 8625,
              "ews": 1622,
              "obc": 4007,
              "sc": 2322,
              "st": 1215
            },
            "2022": {
              "general": 8449,
              "ews": 1589,
              "obc": 3925,
              "sc": 2275,
              "st": 1190
            },
            "2021": {
              "general": 8273,
              "ews": 1556,
              "obc": 3843,
              "sc": 2227,
              "st": 1165
            },
            "2020": {
              "general": 8097,
              "ews": 1523,
              "obc": 3761,
              "sc": 2180,
              "st": 1140
            }
          }
        },
        "fees": 200000,
        "seats": 73
      },
      {
        "name": "Materials Science and Metallurgical Engineering",
        "code": "MSME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 7864,
              "ews": 1422,
              "obc": 3481,
              "sc": 2156,
              "st": 945
            },
            "2023": {
              "general": 7706,
              "ews": 1393,
              "obc": 3411,
              "sc": 2112,
              "st": 926
            },
            "2022": {
              "general": 7549,
              "ews": 1365,
              "obc": 3341,
              "sc": 2069,
              "st": 907
            },
            "2021": {
              "general": 7392,
              "ews": 1336,
              "obc": 3272,
              "sc": 2026,
              "st": 888
            },
            "2020": {
              "general": 7234,
              "ews": 1308,
              "obc": 3202,
              "sc": 1983,
              "st": 869
            }
          }
        },
        "fees": 200000,
        "seats": 73
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 976,
              "ews": 147,
              "obc": 436,
              "sc": 301,
              "st": 178
            },
            "2023": {
              "general": 956,
              "ews": 144,
              "obc": 427,
              "sc": 294,
              "st": 174
            },
            "2022": {
              "general": 936,
              "ews": 141,
              "obc": 418,
              "sc": 288,
              "st": 170
            },
            "2021": {
              "general": 917,
              "ews": 138,
              "obc": 409,
              "sc": 282,
              "st": 167
            },
            "2020": {
              "general": 897,
              "ews": 135,
              "obc": 401,
              "sc": 276,
              "st": 163
            }
          }
        },
        "fees": 200000,
        "seats": 73
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4267,
              "ews": 739,
              "obc": 2121,
              "sc": 1116,
              "st": 570
            },
            "2023": {
              "general": 4181,
              "ews": 724,
              "obc": 2078,
              "sc": 1093,
              "st": 558
            },
            "2022": {
              "general": 4096,
              "ews": 709,
              "obc": 2036,
              "sc": 1071,
              "st": 547
            },
            "2021": {
              "general": 4010,
              "ews": 694,
              "obc": 1993,
              "sc": 1049,
              "st": 535
            },
            "2020": {
              "general": 3925,
              "ews": 679,
              "obc": 1951,
              "sc": 1026,
              "st": 524
            }
          }
        },
        "fees": 200000,
        "seats": 73
      }
    ]
  },
  {
    "id": 54,
    "name": "Indian Institute of Technology Indore",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 7555,
              "ews": 1321,
              "obc": 3468,
              "sc": 1871,
              "st": 922
            },
            "2023": {
              "general": 7403,
              "ews": 1294,
              "obc": 3398,
              "sc": 1833,
              "st": 903
            },
            "2022": {
              "general": 7252,
              "ews": 1268,
              "obc": 3329,
              "sc": 1796,
              "st": 885
            },
            "2021": {
              "general": 7101,
              "ews": 1241,
              "obc": 3259,
              "sc": 1758,
              "st": 866
            },
            "2020": {
              "general": 6950,
              "ews": 1215,
              "obc": 3190,
              "sc": 1721,
              "st": 848
            }
          }
        },
        "fees": 200000,
        "seats": 74
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 9410,
              "ews": 1458,
              "obc": 3965,
              "sc": 1866,
              "st": 631
            },
            "2023": {
              "general": 9221,
              "ews": 1428,
              "obc": 3885,
              "sc": 1828,
              "st": 618
            },
            "2022": {
              "general": 9033,
              "ews": 1399,
              "obc": 3806,
              "sc": 1791,
              "st": 605
            },
            "2021": {
              "general": 8845,
              "ews": 1370,
              "obc": 3727,
              "sc": 1754,
              "st": 593
            },
            "2020": {
              "general": 8657,
              "ews": 1341,
              "obc": 3647,
              "sc": 1716,
              "st": 580
            }
          }
        },
        "fees": 200000,
        "seats": 74
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1354,
              "ews": 212,
              "obc": 611,
              "sc": 329,
              "st": 168
            },
            "2023": {
              "general": 1326,
              "ews": 207,
              "obc": 598,
              "sc": 322,
              "st": 164
            },
            "2022": {
              "general": 1299,
              "ews": 203,
              "obc": 586,
              "sc": 315,
              "st": 161
            },
            "2021": {
              "general": 1272,
              "ews": 199,
              "obc": 574,
              "sc": 309,
              "st": 157
            },
            "2020": {
              "general": 1245,
              "ews": 195,
              "obc": 562,
              "sc": 302,
              "st": 154
            }
          }
        },
        "fees": 200000,
        "seats": 74
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3642,
              "ews": 619,
              "obc": 1637,
              "sc": 997,
              "st": 467
            },
            "2023": {
              "general": 3569,
              "ews": 606,
              "obc": 1604,
              "sc": 977,
              "st": 457
            },
            "2022": {
              "general": 3496,
              "ews": 594,
              "obc": 1571,
              "sc": 957,
              "st": 448
            },
            "2021": {
              "general": 3423,
              "ews": 581,
              "obc": 1538,
              "sc": 937,
              "st": 438
            },
            "2020": {
              "general": 3350,
              "ews": 569,
              "obc": 1506,
              "sc": 917,
              "st": 429
            }
          }
        },
        "fees": 200000,
        "seats": 74
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6913,
              "ews": 1402,
              "obc": 3618,
              "sc": 2070,
              "st": 1173
            },
            "2023": {
              "general": 6774,
              "ews": 1373,
              "obc": 3545,
              "sc": 2028,
              "st": 1149
            },
            "2022": {
              "general": 6636,
              "ews": 1345,
              "obc": 3473,
              "sc": 1987,
              "st": 1126
            },
            "2021": {
              "general": 6498,
              "ews": 1317,
              "obc": 3400,
              "sc": 1945,
              "st": 1102
            },
            "2020": {
              "general": 6359,
              "ews": 1289,
              "obc": 3328,
              "sc": 1904,
              "st": 1079
            }
          }
        },
        "fees": 200000,
        "seats": 74
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2074,
              "ews": 261,
              "obc": 1032,
              "sc": 719,
              "st": 287
            },
            "2023": {
              "general": 2032,
              "ews": 255,
              "obc": 1011,
              "sc": 704,
              "st": 281
            },
            "2022": {
              "general": 1991,
              "ews": 250,
              "obc": 990,
              "sc": 690,
              "st": 275
            },
            "2021": {
              "general": 1949,
              "ews": 245,
              "obc": 970,
              "sc": 675,
              "st": 269
            },
            "2020": {
              "general": 1908,
              "ews": 240,
              "obc": 949,
              "sc": 661,
              "st": 264
            }
          }
        },
        "fees": 200000,
        "seats": 74
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6275,
              "ews": 1132,
              "obc": 2882,
              "sc": 1701,
              "st": 747
            },
            "2023": {
              "general": 6149,
              "ews": 1109,
              "obc": 2824,
              "sc": 1666,
              "st": 732
            },
            "2022": {
              "general": 6024,
              "ews": 1086,
              "obc": 2766,
              "sc": 1632,
              "st": 717
            },
            "2021": {
              "general": 5898,
              "ews": 1064,
              "obc": 2709,
              "sc": 1598,
              "st": 702
            },
            "2020": {
              "general": 5773,
              "ews": 1041,
              "obc": 2651,
              "sc": 1564,
              "st": 687
            }
          }
        },
        "fees": 200000,
        "seats": 74
      },
      {
        "name": "Metallurgical Engineering and Materials Science",
        "code": "MEMS",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 10162,
              "ews": 1749,
              "obc": 4524,
              "sc": 2583,
              "st": 1225
            },
            "2023": {
              "general": 9958,
              "ews": 1714,
              "obc": 4433,
              "sc": 2531,
              "st": 1200
            },
            "2022": {
              "general": 9755,
              "ews": 1679,
              "obc": 4343,
              "sc": 2479,
              "st": 1176
            },
            "2021": {
              "general": 9552,
              "ews": 1644,
              "obc": 4252,
              "sc": 2428,
              "st": 1151
            },
            "2020": {
              "general": 9349,
              "ews": 1609,
              "obc": 4162,
              "sc": 2376,
              "st": 1127
            }
          }
        },
        "fees": 200000,
        "seats": 74
      },
      {
        "name": "Space Sciences and Engineering",
        "code": "SSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6362,
              "ews": 1307,
              "obc": 3159,
              "sc": 1425,
              "st": 719
            },
            "2023": {
              "general": 6234,
              "ews": 1280,
              "obc": 3095,
              "sc": 1396,
              "st": 704
            },
            "2022": {
              "general": 6107,
              "ews": 1254,
              "obc": 3032,
              "sc": 1368,
              "st": 690
            },
            "2021": {
              "general": 5980,
              "ews": 1228,
              "obc": 2969,
              "sc": 1339,
              "st": 675
            },
            "2020": {
              "general": 5853,
              "ews": 1202,
              "obc": 2906,
              "sc": 1311,
              "st": 661
            }
          }
        },
        "fees": 200000,
        "seats": 74
      }
    ]
  },
  {
    "id": 55,
    "name": "Indian Institute of Technology Jammu",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 14113,
              "ews": 2104,
              "obc": 5613,
              "sc": 2974,
              "st": 1291
            },
            "2023": {
              "general": 13830,
              "ews": 2061,
              "obc": 5500,
              "sc": 2914,
              "st": 1265
            },
            "2022": {
              "general": 13548,
              "ews": 2019,
              "obc": 5388,
              "sc": 2855,
              "st": 1239
            },
            "2021": {
              "general": 13266,
              "ews": 1977,
              "obc": 5276,
              "sc": 2795,
              "st": 1213
            },
            "2020": {
              "general": 12983,
              "ews": 1935,
              "obc": 5163,
              "sc": 2736,
              "st": 1187
            }
          }
        },
        "fees": 200000,
        "seats": 75
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 14906,
              "ews": 2295,
              "obc": 5640,
              "sc": 2962,
              "st": 1073
            },
            "2023": {
              "general": 14607,
              "ews": 2249,
              "obc": 5527,
              "sc": 2902,
              "st": 1051
            },
            "2022": {
              "general": 14309,
              "ews": 2203,
              "obc": 5414,
              "sc": 2843,
              "st": 1030
            },
            "2021": {
              "general": 14011,
              "ews": 2157,
              "obc": 5301,
              "sc": 2784,
              "st": 1008
            },
            "2020": {
              "general": 13713,
              "ews": 2111,
              "obc": 5188,
              "sc": 2725,
              "st": 987
            }
          }
        },
        "fees": 200000,
        "seats": 75
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5735,
              "ews": 862,
              "obc": 2341,
              "sc": 1093,
              "st": 635
            },
            "2023": {
              "general": 5620,
              "ews": 844,
              "obc": 2294,
              "sc": 1071,
              "st": 622
            },
            "2022": {
              "general": 5505,
              "ews": 827,
              "obc": 2247,
              "sc": 1049,
              "st": 609
            },
            "2021": {
              "general": 5390,
              "ews": 810,
              "obc": 2200,
              "sc": 1027,
              "st": 596
            },
            "2020": {
              "general": 5276,
              "ews": 793,
              "obc": 2153,
              "sc": 1005,
              "st": 584
            }
          }
        },
        "fees": 200000,
        "seats": 75
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 8789,
              "ews": 1467,
              "obc": 3972,
              "sc": 2111,
              "st": 1087
            },
            "2023": {
              "general": 8613,
              "ews": 1437,
              "obc": 3892,
              "sc": 2068,
              "st": 1065
            },
            "2022": {
              "general": 8437,
              "ews": 1408,
              "obc": 3813,
              "sc": 2026,
              "st": 1043
            },
            "2021": {
              "general": 8261,
              "ews": 1378,
              "obc": 3733,
              "sc": 1984,
              "st": 1021
            },
            "2020": {
              "general": 8085,
              "ews": 1349,
              "obc": 3654,
              "sc": 1942,
              "st": 1000
            }
          }
        },
        "fees": 200000,
        "seats": 75
      },
      {
        "name": "Materials Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 15280,
              "ews": 2391,
              "obc": 5921,
              "sc": 3136,
              "st": 1419
            },
            "2023": {
              "general": 14974,
              "ews": 2343,
              "obc": 5802,
              "sc": 3073,
              "st": 1390
            },
            "2022": {
              "general": 14668,
              "ews": 2295,
              "obc": 5684,
              "sc": 3010,
              "st": 1362
            },
            "2021": {
              "general": 14363,
              "ews": 2247,
              "obc": 5565,
              "sc": 2947,
              "st": 1333
            },
            "2020": {
              "general": 14057,
              "ews": 2199,
              "obc": 5447,
              "sc": 2885,
              "st": 1305
            }
          }
        },
        "fees": 200000,
        "seats": 75
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 7242,
              "ews": 1191,
              "obc": 3120,
              "sc": 1566,
              "st": 972
            },
            "2023": {
              "general": 7097,
              "ews": 1167,
              "obc": 3057,
              "sc": 1534,
              "st": 952
            },
            "2022": {
              "general": 6952,
              "ews": 1143,
              "obc": 2995,
              "sc": 1503,
              "st": 933
            },
            "2021": {
              "general": 6807,
              "ews": 1119,
              "obc": 2932,
              "sc": 1472,
              "st": 913
            },
            "2020": {
              "general": 6662,
              "ews": 1095,
              "obc": 2870,
              "sc": 1440,
              "st": 894
            }
          }
        },
        "fees": 200000,
        "seats": 75
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 12026,
              "ews": 1925,
              "obc": 4862,
              "sc": 2649,
              "st": 1208
            },
            "2023": {
              "general": 11785,
              "ews": 1886,
              "obc": 4764,
              "sc": 2596,
              "st": 1183
            },
            "2022": {
              "general": 11544,
              "ews": 1848,
              "obc": 4667,
              "sc": 2543,
              "st": 1159
            },
            "2021": {
              "general": 11304,
              "ews": 1809,
              "obc": 4570,
              "sc": 2490,
              "st": 1135
            },
            "2020": {
              "general": 11063,
              "ews": 1771,
              "obc": 4473,
              "sc": 2437,
              "st": 1111
            }
          }
        },
        "fees": 200000,
        "seats": 75
      }
    ]
  },
  {
    "id": 56,
    "name": "Indian Institute of Technology Jodhpur",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Artificial Intelligence and Data Science",
        "code": "AIDS",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3790,
              "ews": 555,
              "obc": 1704,
              "sc": 1078,
              "st": 589
            },
            "2023": {
              "general": 3714,
              "ews": 543,
              "obc": 1669,
              "sc": 1056,
              "st": 577
            },
            "2022": {
              "general": 3638,
              "ews": 532,
              "obc": 1635,
              "sc": 1034,
              "st": 565
            },
            "2021": {
              "general": 3562,
              "ews": 521,
              "obc": 1601,
              "sc": 1013,
              "st": 553
            },
            "2020": {
              "general": 3486,
              "ews": 510,
              "obc": 1567,
              "sc": 991,
              "st": 541
            }
          }
        },
        "fees": 200000,
        "seats": 76
      },
      {
        "name": "Bio Engineering",
        "code": "BE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 13865,
              "ews": 2211,
              "obc": 5618,
              "sc": 3133,
              "st": 1393
            },
            "2023": {
              "general": 13587,
              "ews": 2166,
              "obc": 5505,
              "sc": 3070,
              "st": 1365
            },
            "2022": {
              "general": 13310,
              "ews": 2122,
              "obc": 5393,
              "sc": 3007,
              "st": 1337
            },
            "2021": {
              "general": 13033,
              "ews": 2078,
              "obc": 5280,
              "sc": 2945,
              "st": 1309
            },
            "2020": {
              "general": 12755,
              "ews": 2034,
              "obc": 5168,
              "sc": 2882,
              "st": 1281
            }
          }
        },
        "fees": 200000,
        "seats": 76
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 10209,
              "ews": 1625,
              "obc": 4513,
              "sc": 2597,
              "st": 1120
            },
            "2023": {
              "general": 10004,
              "ews": 1592,
              "obc": 4422,
              "sc": 2545,
              "st": 1097
            },
            "2022": {
              "general": 9800,
              "ews": 1560,
              "obc": 4332,
              "sc": 2493,
              "st": 1075
            },
            "2021": {
              "general": 9596,
              "ews": 1527,
              "obc": 4242,
              "sc": 2441,
              "st": 1052
            },
            "2020": {
              "general": 9392,
              "ews": 1495,
              "obc": 4151,
              "sc": 2389,
              "st": 1030
            }
          }
        },
        "fees": 200000,
        "seats": 76
      },
      {
        "name": "Chemistry with Specialization",
        "code": "CS",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 15366,
              "ews": 2434,
              "obc": 5842,
              "sc": 3190,
              "st": 1512
            },
            "2023": {
              "general": 15058,
              "ews": 2385,
              "obc": 5725,
              "sc": 3126,
              "st": 1481
            },
            "2022": {
              "general": 14751,
              "ews": 2336,
              "obc": 5608,
              "sc": 3062,
              "st": 1451
            },
            "2021": {
              "general": 14444,
              "ews": 2287,
              "obc": 5491,
              "sc": 2998,
              "st": 1421
            },
            "2020": {
              "general": 14136,
              "ews": 2239,
              "obc": 5374,
              "sc": 2934,
              "st": 1391
            }
          }
        },
        "fees": 200000,
        "seats": 76
      },
      {
        "name": "Civil and Infrastructure Engineering",
        "code": "CIE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 12182,
              "ews": 1974,
              "obc": 4864,
              "sc": 2585,
              "st": 980
            },
            "2023": {
              "general": 11938,
              "ews": 1934,
              "obc": 4766,
              "sc": 2533,
              "st": 960
            },
            "2022": {
              "general": 11694,
              "ews": 1895,
              "obc": 4669,
              "sc": 2481,
              "st": 940
            },
            "2021": {
              "general": 11451,
              "ews": 1855,
              "obc": 4572,
              "sc": 2429,
              "st": 921
            },
            "2020": {
              "general": 11207,
              "ews": 1816,
              "obc": 4474,
              "sc": 2378,
              "st": 901
            }
          }
        },
        "fees": 200000,
        "seats": 76
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2859,
              "ews": 416,
              "obc": 1334,
              "sc": 789,
              "st": 396
            },
            "2023": {
              "general": 2801,
              "ews": 407,
              "obc": 1307,
              "sc": 773,
              "st": 388
            },
            "2022": {
              "general": 2744,
              "ews": 399,
              "obc": 1280,
              "sc": 757,
              "st": 380
            },
            "2021": {
              "general": 2687,
              "ews": 391,
              "obc": 1253,
              "sc": 741,
              "st": 372
            },
            "2020": {
              "general": 2630,
              "ews": 382,
              "obc": 1227,
              "sc": 725,
              "st": 364
            }
          }
        },
        "fees": 200000,
        "seats": 76
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5952,
              "ews": 1123,
              "obc": 2940,
              "sc": 1782,
              "st": 875
            },
            "2023": {
              "general": 5832,
              "ews": 1100,
              "obc": 2881,
              "sc": 1746,
              "st": 857
            },
            "2022": {
              "general": 5713,
              "ews": 1078,
              "obc": 2822,
              "sc": 1710,
              "st": 840
            },
            "2021": {
              "general": 5594,
              "ews": 1055,
              "obc": 2763,
              "sc": 1675,
              "st": 822
            },
            "2020": {
              "general": 5475,
              "ews": 1033,
              "obc": 2704,
              "sc": 1639,
              "st": 805
            }
          }
        },
        "fees": 200000,
        "seats": 76
      },
      {
        "name": "Materials Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 12543,
              "ews": 2139,
              "obc": 5540,
              "sc": 2950,
              "st": 1366
            },
            "2023": {
              "general": 12292,
              "ews": 2096,
              "obc": 5429,
              "sc": 2891,
              "st": 1338
            },
            "2022": {
              "general": 12041,
              "ews": 2053,
              "obc": 5318,
              "sc": 2832,
              "st": 1311
            },
            "2021": {
              "general": 11790,
              "ews": 2010,
              "obc": 5207,
              "sc": 2773,
              "st": 1284
            },
            "2020": {
              "general": 11539,
              "ews": 1967,
              "obc": 5096,
              "sc": 2714,
              "st": 1256
            }
          }
        },
        "fees": 200000,
        "seats": 76
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 8932,
              "ews": 1533,
              "obc": 4001,
              "sc": 2275,
              "st": 1052
            },
            "2023": {
              "general": 8753,
              "ews": 1502,
              "obc": 3920,
              "sc": 2229,
              "st": 1030
            },
            "2022": {
              "general": 8574,
              "ews": 1471,
              "obc": 3840,
              "sc": 2184,
              "st": 1009
            },
            "2021": {
              "general": 8396,
              "ews": 1441,
              "obc": 3760,
              "sc": 2138,
              "st": 988
            },
            "2020": {
              "general": 8217,
              "ews": 1410,
              "obc": 3680,
              "sc": 2093,
              "st": 967
            }
          }
        },
        "fees": 200000,
        "seats": 76
      },
      {
        "name": "Physics with Specialization",
        "code": "PS",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 12393,
              "ews": 2372,
              "obc": 5752,
              "sc": 2967,
              "st": 1510
            },
            "2023": {
              "general": 12145,
              "ews": 2324,
              "obc": 5636,
              "sc": 2907,
              "st": 1479
            },
            "2022": {
              "general": 11897,
              "ews": 2277,
              "obc": 5521,
              "sc": 2848,
              "st": 1449
            },
            "2021": {
              "general": 11649,
              "ews": 2229,
              "obc": 5406,
              "sc": 2788,
              "st": 1419
            },
            "2020": {
              "general": 11401,
              "ews": 2182,
              "obc": 5291,
              "sc": 2729,
              "st": 1389
            }
          }
        },
        "fees": 200000,
        "seats": 76
      }
    ]
  },
  {
    "id": 57,
    "name": "Indian Institute of Technology Kanpur",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Aerospace Engineering",
        "code": "AE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3582,
              "ews": 837,
              "obc": 1965,
              "sc": 986,
              "st": 681
            },
            "2023": {
              "general": 3510,
              "ews": 820,
              "obc": 1925,
              "sc": 966,
              "st": 667
            },
            "2022": {
              "general": 3438,
              "ews": 803,
              "obc": 1886,
              "sc": 946,
              "st": 653
            },
            "2021": {
              "general": 3367,
              "ews": 786,
              "obc": 1847,
              "sc": 926,
              "st": 640
            },
            "2020": {
              "general": 3295,
              "ews": 770,
              "obc": 1807,
              "sc": 907,
              "st": 626
            }
          }
        },
        "fees": 200000,
        "seats": 77
      },
      {
        "name": "Biological Sciences and Bioengineering",
        "code": "BSB",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6791,
              "ews": 1341,
              "obc": 3472,
              "sc": 2071,
              "st": 1168
            },
            "2023": {
              "general": 6655,
              "ews": 1314,
              "obc": 3402,
              "sc": 2029,
              "st": 1144
            },
            "2022": {
              "general": 6519,
              "ews": 1287,
              "obc": 3333,
              "sc": 1988,
              "st": 1121
            },
            "2021": {
              "general": 6383,
              "ews": 1260,
              "obc": 3263,
              "sc": 1946,
              "st": 1097
            },
            "2020": {
              "general": 6247,
              "ews": 1233,
              "obc": 3194,
              "sc": 1905,
              "st": 1074
            }
          }
        },
        "fees": 200000,
        "seats": 77
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3911,
              "ews": 675,
              "obc": 2017,
              "sc": 1165,
              "st": 684
            },
            "2023": {
              "general": 3832,
              "ews": 661,
              "obc": 1976,
              "sc": 1141,
              "st": 670
            },
            "2022": {
              "general": 3754,
              "ews": 648,
              "obc": 1936,
              "sc": 1118,
              "st": 656
            },
            "2021": {
              "general": 3676,
              "ews": 634,
              "obc": 1895,
              "sc": 1095,
              "st": 642
            },
            "2020": {
              "general": 3598,
              "ews": 621,
              "obc": 1855,
              "sc": 1071,
              "st": 629
            }
          }
        },
        "fees": 200000,
        "seats": 77
      },
      {
        "name": "Chemistry",
        "code": "C",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 10117,
              "ews": 1618,
              "obc": 4647,
              "sc": 2667,
              "st": 1434
            },
            "2023": {
              "general": 9914,
              "ews": 1585,
              "obc": 4554,
              "sc": 2613,
              "st": 1405
            },
            "2022": {
              "general": 9712,
              "ews": 1553,
              "obc": 4461,
              "sc": 2560,
              "st": 1376
            },
            "2021": {
              "general": 9509,
              "ews": 1520,
              "obc": 4368,
              "sc": 2506,
              "st": 1347
            },
            "2020": {
              "general": 9307,
              "ews": 1488,
              "obc": 4275,
              "sc": 2453,
              "st": 1319
            }
          }
        },
        "fees": 200000,
        "seats": 77
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5702,
              "ews": 987,
              "obc": 2678,
              "sc": 1489,
              "st": 482
            },
            "2023": {
              "general": 5587,
              "ews": 967,
              "obc": 2624,
              "sc": 1459,
              "st": 472
            },
            "2022": {
              "general": 5473,
              "ews": 947,
              "obc": 2570,
              "sc": 1429,
              "st": 462
            },
            "2021": {
              "general": 5359,
              "ews": 927,
              "obc": 2517,
              "sc": 1399,
              "st": 453
            },
            "2020": {
              "general": 5245,
              "ews": 908,
              "obc": 2463,
              "sc": 1369,
              "st": 443
            }
          }
        },
        "fees": 200000,
        "seats": 77
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 250,
              "ews": 51,
              "obc": 132,
              "sc": 96,
              "st": 54
            },
            "2023": {
              "general": 245,
              "ews": 49,
              "obc": 129,
              "sc": 94,
              "st": 52
            },
            "2022": {
              "general": 240,
              "ews": 48,
              "obc": 126,
              "sc": 92,
              "st": 51
            },
            "2021": {
              "general": 235,
              "ews": 47,
              "obc": 124,
              "sc": 90,
              "st": 50
            },
            "2020": {
              "general": 230,
              "ews": 46,
              "obc": 121,
              "sc": 88,
              "st": 49
            }
          }
        },
        "fees": 200000,
        "seats": 77
      },
      {
        "name": "Earth Sciences",
        "code": "ES",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 9550,
              "ews": 1627,
              "obc": 4562,
              "sc": 2567,
              "st": 1369
            },
            "2023": {
              "general": 9359,
              "ews": 1594,
              "obc": 4470,
              "sc": 2515,
              "st": 1341
            },
            "2022": {
              "general": 9168,
              "ews": 1561,
              "obc": 4379,
              "sc": 2464,
              "st": 1314
            },
            "2021": {
              "general": 8977,
              "ews": 1529,
              "obc": 4288,
              "sc": 2412,
              "st": 1286
            },
            "2020": {
              "general": 8786,
              "ews": 1496,
              "obc": 4197,
              "sc": 2361,
              "st": 1259
            }
          }
        },
        "fees": 200000,
        "seats": 77
      },
      {
        "name": "Economics",
        "code": "E",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2993,
              "ews": 690,
              "obc": 1604,
              "sc": 1426,
              "st": 725
            },
            "2023": {
              "general": 2933,
              "ews": 676,
              "obc": 1571,
              "sc": 1397,
              "st": 710
            },
            "2022": {
              "general": 2873,
              "ews": 662,
              "obc": 1539,
              "sc": 1368,
              "st": 696
            },
            "2021": {
              "general": 2813,
              "ews": 648,
              "obc": 1507,
              "sc": 1340,
              "st": 681
            },
            "2020": {
              "general": 2753,
              "ews": 634,
              "obc": 1475,
              "sc": 1311,
              "st": 667
            }
          }
        },
        "fees": 200000,
        "seats": 77
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1284,
              "ews": 259,
              "obc": 731,
              "sc": 452,
              "st": 203
            },
            "2023": {
              "general": 1258,
              "ews": 253,
              "obc": 716,
              "sc": 442,
              "st": 198
            },
            "2022": {
              "general": 1232,
              "ews": 248,
              "obc": 701,
              "sc": 433,
              "st": 194
            },
            "2021": {
              "general": 1206,
              "ews": 243,
              "obc": 687,
              "sc": 424,
              "st": 190
            },
            "2020": {
              "general": 1181,
              "ews": 238,
              "obc": 672,
              "sc": 415,
              "st": 186
            }
          }
        },
        "fees": 200000,
        "seats": 77
      },
      {
        "name": "Materials Science and Engineering",
        "code": "MSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5845,
              "ews": 1227,
              "obc": 3040,
              "sc": 1853,
              "st": 1080
            },
            "2023": {
              "general": 5728,
              "ews": 1202,
              "obc": 2979,
              "sc": 1815,
              "st": 1058
            },
            "2022": {
              "general": 5611,
              "ews": 1177,
              "obc": 2918,
              "sc": 1778,
              "st": 1036
            },
            "2021": {
              "general": 5494,
              "ews": 1153,
              "obc": 2857,
              "sc": 1741,
              "st": 1015
            },
            "2020": {
              "general": 5377,
              "ews": 1128,
              "obc": 2796,
              "sc": 1704,
              "st": 993
            }
          }
        },
        "fees": 200000,
        "seats": 77
      },
      {
        "name": "Mathematics and Scientific Computing",
        "code": "MSC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 989,
              "ews": 209,
              "obc": 631,
              "sc": 372,
              "st": 343
            },
            "2023": {
              "general": 969,
              "ews": 204,
              "obc": 618,
              "sc": 364,
              "st": 336
            },
            "2022": {
              "general": 949,
              "ews": 200,
              "obc": 605,
              "sc": 357,
              "st": 329
            },
            "2021": {
              "general": 929,
              "ews": 196,
              "obc": 593,
              "sc": 349,
              "st": 322
            },
            "2020": {
              "general": 909,
              "ews": 192,
              "obc": 580,
              "sc": 342,
              "st": 315
            }
          }
        },
        "fees": 200000,
        "seats": 77
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2740,
              "ews": 491,
              "obc": 1378,
              "sc": 815,
              "st": 509
            },
            "2023": {
              "general": 2685,
              "ews": 481,
              "obc": 1350,
              "sc": 798,
              "st": 498
            },
            "2022": {
              "general": 2630,
              "ews": 471,
              "obc": 1322,
              "sc": 782,
              "st": 488
            },
            "2021": {
              "general": 2575,
              "ews": 461,
              "obc": 1295,
              "sc": 766,
              "st": 478
            },
            "2020": {
              "general": 2520,
              "ews": 451,
              "obc": 1267,
              "sc": 749,
              "st": 468
            }
          }
        },
        "fees": 200000,
        "seats": 77
      },
      {
        "name": "Physics",
        "code": "P",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5268,
              "ews": 1368,
              "obc": 3503,
              "sc": 2352,
              "st": 1277
            },
            "2023": {
              "general": 5162,
              "ews": 1340,
              "obc": 3432,
              "sc": 2304,
              "st": 1251
            },
            "2022": {
              "general": 5057,
              "ews": 1313,
              "obc": 3362,
              "sc": 2257,
              "st": 1225
            },
            "2021": {
              "general": 4951,
              "ews": 1285,
              "obc": 3292,
              "sc": 2210,
              "st": 1200
            },
            "2020": {
              "general": 4846,
              "ews": 1258,
              "obc": 3222,
              "sc": 2163,
              "st": 1174
            }
          }
        },
        "fees": 200000,
        "seats": 77
      },
      {
        "name": "Statistics and Data Science",
        "code": "SDS",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1023,
              "ews": 207,
              "obc": 714,
              "sc": 458,
              "st": 224
            },
            "2023": {
              "general": 1002,
              "ews": 202,
              "obc": 699,
              "sc": 448,
              "st": 219
            },
            "2022": {
              "general": 982,
              "ews": 198,
              "obc": 685,
              "sc": 439,
              "st": 215
            },
            "2021": {
              "general": 961,
              "ews": 194,
              "obc": 671,
              "sc": 430,
              "st": 210
            },
            "2020": {
              "general": 941,
              "ews": 190,
              "obc": 656,
              "sc": 421,
              "st": 206
            }
          }
        },
        "fees": 200000,
        "seats": 77
      }
    ]
  },
  {
    "id": 58,
    "name": "Indian Institute of Technology Kharagpur",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Aerospace Engineering",
        "code": "AE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4565,
              "ews": 949,
              "obc": 2281,
              "sc": 1119,
              "st": 711
            },
            "2023": {
              "general": 4473,
              "ews": 930,
              "obc": 2235,
              "sc": 1096,
              "st": 696
            },
            "2022": {
              "general": 4382,
              "ews": 911,
              "obc": 2189,
              "sc": 1074,
              "st": 682
            },
            "2021": {
              "general": 4291,
              "ews": 892,
              "obc": 2144,
              "sc": 1051,
              "st": 668
            },
            "2020": {
              "general": 4199,
              "ews": 873,
              "obc": 2098,
              "sc": 1029,
              "st": 654
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Agricultural and Food Engineering",
        "code": "AFE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 10218,
              "ews": 1733,
              "obc": 4446,
              "sc": 2523,
              "st": 1129
            },
            "2023": {
              "general": 10013,
              "ews": 1698,
              "obc": 4357,
              "sc": 2472,
              "st": 1106
            },
            "2022": {
              "general": 9809,
              "ews": 1663,
              "obc": 4268,
              "sc": 2422,
              "st": 1083
            },
            "2021": {
              "general": 9604,
              "ews": 1629,
              "obc": 4179,
              "sc": 2371,
              "st": 1061
            },
            "2020": {
              "general": 9400,
              "ews": 1594,
              "obc": 4090,
              "sc": 2321,
              "st": 1038
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Applied Geology",
        "code": "AG",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 12262,
              "ews": 2049,
              "obc": 5375,
              "sc": 3045,
              "st": 1462
            },
            "2023": {
              "general": 12016,
              "ews": 2008,
              "obc": 5267,
              "sc": 2984,
              "st": 1432
            },
            "2022": {
              "general": 11771,
              "ews": 1967,
              "obc": 5160,
              "sc": 2923,
              "st": 1403
            },
            "2021": {
              "general": 11526,
              "ews": 1926,
              "obc": 5052,
              "sc": 2862,
              "st": 1374
            },
            "2020": {
              "general": 11281,
              "ews": 1885,
              "obc": 4945,
              "sc": 2801,
              "st": 1345
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 19348,
              "ews": 2967,
              "obc": 7624,
              "sc": 4204,
              "st": 1755
            },
            "2023": {
              "general": 18961,
              "ews": 2907,
              "obc": 7471,
              "sc": 4119,
              "st": 1719
            },
            "2022": {
              "general": 18574,
              "ews": 2848,
              "obc": 7319,
              "sc": 4035,
              "st": 1684
            },
            "2021": {
              "general": 18187,
              "ews": 2788,
              "obc": 7166,
              "sc": 3951,
              "st": 1649
            },
            "2020": {
              "general": 17800,
              "ews": 2729,
              "obc": 7014,
              "sc": 3867,
              "st": 1614
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Artificial Intelligence",
        "code": "AI",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 826,
              "ews": 138,
              "obc": 369,
              "sc": 243,
              "st": 135
            },
            "2023": {
              "general": 809,
              "ews": 135,
              "obc": 361,
              "sc": 238,
              "st": 132
            },
            "2022": {
              "general": 792,
              "ews": 132,
              "obc": 354,
              "sc": 233,
              "st": 129
            },
            "2021": {
              "general": 776,
              "ews": 129,
              "obc": 346,
              "sc": 228,
              "st": 126
            },
            "2020": {
              "general": 759,
              "ews": 126,
              "obc": 339,
              "sc": 223,
              "st": 124
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Biotechnology and Biochemical Engineering",
        "code": "BBE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 7543,
              "ews": 1386,
              "obc": 3759,
              "sc": 2294,
              "st": 1002
            },
            "2023": {
              "general": 7392,
              "ews": 1358,
              "obc": 3683,
              "sc": 2248,
              "st": 981
            },
            "2022": {
              "general": 7241,
              "ews": 1330,
              "obc": 3608,
              "sc": 2202,
              "st": 961
            },
            "2021": {
              "general": 7090,
              "ews": 1302,
              "obc": 3533,
              "sc": 2156,
              "st": 941
            },
            "2020": {
              "general": 6939,
              "ews": 1275,
              "obc": 3458,
              "sc": 2110,
              "st": 921
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4689,
              "ews": 856,
              "obc": 2299,
              "sc": 1249,
              "st": 740
            },
            "2023": {
              "general": 4595,
              "ews": 838,
              "obc": 2253,
              "sc": 1224,
              "st": 725
            },
            "2022": {
              "general": 4501,
              "ews": 821,
              "obc": 2207,
              "sc": 1199,
              "st": 710
            },
            "2021": {
              "general": 4407,
              "ews": 804,
              "obc": 2161,
              "sc": 1174,
              "st": 695
            },
            "2020": {
              "general": 4313,
              "ews": 787,
              "obc": 2115,
              "sc": 1149,
              "st": 680
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Chemistry",
        "code": "C",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 11968,
              "ews": 1893,
              "obc": 5219,
              "sc": 2868,
              "st": 1496
            },
            "2023": {
              "general": 11728,
              "ews": 1855,
              "obc": 5114,
              "sc": 2810,
              "st": 1466
            },
            "2022": {
              "general": 11489,
              "ews": 1817,
              "obc": 5010,
              "sc": 2753,
              "st": 1436
            },
            "2021": {
              "general": 11249,
              "ews": 1779,
              "obc": 4905,
              "sc": 2695,
              "st": 1406
            },
            "2020": {
              "general": 11010,
              "ews": 1741,
              "obc": 4801,
              "sc": 2638,
              "st": 1376
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6465,
              "ews": 1177,
              "obc": 2987,
              "sc": 1550,
              "st": 541
            },
            "2023": {
              "general": 6335,
              "ews": 1153,
              "obc": 2927,
              "sc": 1519,
              "st": 530
            },
            "2022": {
              "general": 6206,
              "ews": 1129,
              "obc": 2867,
              "sc": 1488,
              "st": 519
            },
            "2021": {
              "general": 6077,
              "ews": 1106,
              "obc": 2807,
              "sc": 1457,
              "st": 508
            },
            "2020": {
              "general": 5947,
              "ews": 1082,
              "obc": 2748,
              "sc": 1426,
              "st": 497
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 414,
              "ews": 67,
              "obc": 209,
              "sc": 137,
              "st": 67
            },
            "2023": {
              "general": 405,
              "ews": 65,
              "obc": 204,
              "sc": 134,
              "st": 65
            },
            "2022": {
              "general": 397,
              "ews": 64,
              "obc": 200,
              "sc": 131,
              "st": 64
            },
            "2021": {
              "general": 389,
              "ews": 62,
              "obc": 196,
              "sc": 128,
              "st": 62
            },
            "2020": {
              "general": 380,
              "ews": 61,
              "obc": 192,
              "sc": 126,
              "st": 61
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Economics",
        "code": "E",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5080,
              "ews": 986,
              "obc": 2606,
              "sc": 2027,
              "st": 818
            },
            "2023": {
              "general": 4978,
              "ews": 966,
              "obc": 2553,
              "sc": 1986,
              "st": 801
            },
            "2022": {
              "general": 4876,
              "ews": 946,
              "obc": 2501,
              "sc": 1945,
              "st": 785
            },
            "2021": {
              "general": 4775,
              "ews": 926,
              "obc": 2449,
              "sc": 1905,
              "st": 768
            },
            "2020": {
              "general": 4673,
              "ews": 907,
              "obc": 2397,
              "sc": 1864,
              "st": 752
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1893,
              "ews": 336,
              "obc": 903,
              "sc": 544,
              "st": 257
            },
            "2023": {
              "general": 1855,
              "ews": 329,
              "obc": 884,
              "sc": 533,
              "st": 251
            },
            "2022": {
              "general": 1817,
              "ews": 322,
              "obc": 866,
              "sc": 522,
              "st": 246
            },
            "2021": {
              "general": 1779,
              "ews": 315,
              "obc": 848,
              "sc": 511,
              "st": 241
            },
            "2020": {
              "general": 1741,
              "ews": 309,
              "obc": 830,
              "sc": 500,
              "st": 236
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Electronics and Electrical Communication Engineering",
        "code": "EECE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1446,
              "ews": 226,
              "obc": 660,
              "sc": 390,
              "st": 219
            },
            "2023": {
              "general": 1417,
              "ews": 221,
              "obc": 646,
              "sc": 382,
              "st": 214
            },
            "2022": {
              "general": 1388,
              "ews": 216,
              "obc": 633,
              "sc": 374,
              "st": 210
            },
            "2021": {
              "general": 1359,
              "ews": 212,
              "obc": 620,
              "sc": 366,
              "st": 205
            },
            "2020": {
              "general": 1330,
              "ews": 207,
              "obc": 607,
              "sc": 358,
              "st": 201
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Exploration Geophysics",
        "code": "EG",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 11575,
              "ews": 1955,
              "obc": 4857,
              "sc": 2874,
              "st": 1483
            },
            "2023": {
              "general": 11343,
              "ews": 1915,
              "obc": 4759,
              "sc": 2816,
              "st": 1453
            },
            "2022": {
              "general": 11112,
              "ews": 1876,
              "obc": 4662,
              "sc": 2759,
              "st": 1423
            },
            "2021": {
              "general": 10880,
              "ews": 1837,
              "obc": 4565,
              "sc": 2701,
              "st": 1394
            },
            "2020": {
              "general": 10649,
              "ews": 1798,
              "obc": 4468,
              "sc": 2644,
              "st": 1364
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Industrial and Systems Engineering",
        "code": "ISE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4099,
              "ews": 736,
              "obc": 2290,
              "sc": 1653,
              "st": 840
            },
            "2023": {
              "general": 4017,
              "ews": 721,
              "obc": 2244,
              "sc": 1619,
              "st": 823
            },
            "2022": {
              "general": 3935,
              "ews": 706,
              "obc": 2198,
              "sc": 1586,
              "st": 806
            },
            "2021": {
              "general": 3853,
              "ews": 691,
              "obc": 2152,
              "sc": 1553,
              "st": 789
            },
            "2020": {
              "general": 3771,
              "ews": 677,
              "obc": 2106,
              "sc": 1520,
              "st": 772
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Instrumentation Engineering",
        "code": "IE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2473,
              "ews": 466,
              "obc": 1296,
              "sc": 877,
              "st": 583
            },
            "2023": {
              "general": 2423,
              "ews": 456,
              "obc": 1270,
              "sc": 859,
              "st": 571
            },
            "2022": {
              "general": 2374,
              "ews": 447,
              "obc": 1244,
              "sc": 841,
              "st": 559
            },
            "2021": {
              "general": 2324,
              "ews": 438,
              "obc": 1218,
              "sc": 824,
              "st": 548
            },
            "2020": {
              "general": 2275,
              "ews": 428,
              "obc": 1192,
              "sc": 806,
              "st": 536
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Manufacturing Science and Engineering",
        "code": "MSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5964,
              "ews": 1251,
              "obc": 3276,
              "sc": 2076,
              "st": 1034
            },
            "2023": {
              "general": 5844,
              "ews": 1225,
              "obc": 3210,
              "sc": 2034,
              "st": 1013
            },
            "2022": {
              "general": 5725,
              "ews": 1200,
              "obc": 3144,
              "sc": 1992,
              "st": 992
            },
            "2021": {
              "general": 5606,
              "ews": 1175,
              "obc": 3079,
              "sc": 1951,
              "st": 971
            },
            "2020": {
              "general": 5486,
              "ews": 1150,
              "obc": 3013,
              "sc": 1909,
              "st": 951
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1290,
              "ews": 239,
              "obc": 720,
              "sc": 509,
              "st": 267
            },
            "2023": {
              "general": 1264,
              "ews": 234,
              "obc": 705,
              "sc": 498,
              "st": 261
            },
            "2022": {
              "general": 1238,
              "ews": 229,
              "obc": 691,
              "sc": 488,
              "st": 256
            },
            "2021": {
              "general": 1212,
              "ews": 224,
              "obc": 676,
              "sc": 478,
              "st": 250
            },
            "2020": {
              "general": 1186,
              "ews": 219,
              "obc": 662,
              "sc": 468,
              "st": 245
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3353,
              "ews": 656,
              "obc": 1686,
              "sc": 950,
              "st": 540
            },
            "2023": {
              "general": 3285,
              "ews": 642,
              "obc": 1652,
              "sc": 931,
              "st": 529
            },
            "2022": {
              "general": 3218,
              "ews": 629,
              "obc": 1618,
              "sc": 912,
              "st": 518
            },
            "2021": {
              "general": 3151,
              "ews": 616,
              "obc": 1584,
              "sc": 893,
              "st": 507
            },
            "2020": {
              "general": 3084,
              "ews": 603,
              "obc": 1551,
              "sc": 874,
              "st": 496
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6871,
              "ews": 1353,
              "obc": 3365,
              "sc": 2024,
              "st": 929
            },
            "2023": {
              "general": 6733,
              "ews": 1325,
              "obc": 3297,
              "sc": 1983,
              "st": 910
            },
            "2022": {
              "general": 6596,
              "ews": 1298,
              "obc": 3230,
              "sc": 1943,
              "st": 891
            },
            "2021": {
              "general": 6458,
              "ews": 1271,
              "obc": 3163,
              "sc": 1902,
              "st": 873
            },
            "2020": {
              "general": 6321,
              "ews": 1244,
              "obc": 3095,
              "sc": 1862,
              "st": 854
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Mining Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 9252,
              "ews": 1523,
              "obc": 4000,
              "sc": 2271,
              "st": 1085
            },
            "2023": {
              "general": 9066,
              "ews": 1492,
              "obc": 3920,
              "sc": 2225,
              "st": 1063
            },
            "2022": {
              "general": 8881,
              "ews": 1462,
              "obc": 3840,
              "sc": 2180,
              "st": 1041
            },
            "2021": {
              "general": 8696,
              "ews": 1431,
              "obc": 3760,
              "sc": 2134,
              "st": 1019
            },
            "2020": {
              "general": 8511,
              "ews": 1401,
              "obc": 3680,
              "sc": 2089,
              "st": 998
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Ocean Engineering and Naval Architecture",
        "code": "OENA",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 8707,
              "ews": 1650,
              "obc": 4097,
              "sc": 2357,
              "st": 1192
            },
            "2023": {
              "general": 8532,
              "ews": 1617,
              "obc": 4015,
              "sc": 2309,
              "st": 1168
            },
            "2022": {
              "general": 8358,
              "ews": 1584,
              "obc": 3933,
              "sc": 2262,
              "st": 1144
            },
            "2021": {
              "general": 8184,
              "ews": 1551,
              "obc": 3851,
              "sc": 2215,
              "st": 1120
            },
            "2020": {
              "general": 8010,
              "ews": 1518,
              "obc": 3769,
              "sc": 2168,
              "st": 1096
            }
          }
        },
        "fees": 200000,
        "seats": 78
      },
      {
        "name": "Physics",
        "code": "P",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 8465,
              "ews": 1701,
              "obc": 4401,
              "sc": 2664,
              "st": 1336
            },
            "2023": {
              "general": 8295,
              "ews": 1666,
              "obc": 4312,
              "sc": 2610,
              "st": 1309
            },
            "2022": {
              "general": 8126,
              "ews": 1632,
              "obc": 4224,
              "sc": 2557,
              "st": 1282
            },
            "2021": {
              "general": 7957,
              "ews": 1598,
              "obc": 4136,
              "sc": 2504,
              "st": 1255
            },
            "2020": {
              "general": 7787,
              "ews": 1564,
              "obc": 4048,
              "sc": 2450,
              "st": 1229
            }
          }
        },
        "fees": 200000,
        "seats": 78
      }
    ]
  },
  {
    "id": 59,
    "name": "Indian Institute of Technology Madras",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Aerospace Engineering",
        "code": "AE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2984,
              "ews": 883,
              "obc": 1455,
              "sc": 830,
              "st": 503
            },
            "2023": {
              "general": 2924,
              "ews": 865,
              "obc": 1425,
              "sc": 813,
              "st": 492
            },
            "2022": {
              "general": 2864,
              "ews": 847,
              "obc": 1396,
              "sc": 796,
              "st": 482
            },
            "2021": {
              "general": 2804,
              "ews": 830,
              "obc": 1367,
              "sc": 780,
              "st": 472
            },
            "2020": {
              "general": 2745,
              "ews": 812,
              "obc": 1338,
              "sc": 763,
              "st": 462
            }
          }
        },
        "fees": 200000,
        "seats": 79
      },
      {
        "name": "Artificial Intelligence and Data Analytics",
        "code": "AIDA",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 415,
              "ews": 104,
              "obc": 207,
              "sc": 188,
              "st": 83
            },
            "2023": {
              "general": 406,
              "ews": 101,
              "obc": 202,
              "sc": 184,
              "st": 81
            },
            "2022": {
              "general": 398,
              "ews": 99,
              "obc": 198,
              "sc": 180,
              "st": 79
            },
            "2021": {
              "general": 390,
              "ews": 97,
              "obc": 194,
              "sc": 176,
              "st": 78
            },
            "2020": {
              "general": 381,
              "ews": 95,
              "obc": 190,
              "sc": 172,
              "st": 76
            }
          }
        },
        "fees": 200000,
        "seats": 79
      },
      {
        "name": "Biological Engineering",
        "code": "BE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5491,
              "ews": 1384,
              "obc": 3364,
              "sc": 2266,
              "st": 1090
            },
            "2023": {
              "general": 5381,
              "ews": 1356,
              "obc": 3296,
              "sc": 2220,
              "st": 1068
            },
            "2022": {
              "general": 5271,
              "ews": 1328,
              "obc": 3229,
              "sc": 2175,
              "st": 1046
            },
            "2021": {
              "general": 5161,
              "ews": 1300,
              "obc": 3162,
              "sc": 2130,
              "st": 1024
            },
            "2020": {
              "general": 5051,
              "ews": 1273,
              "obc": 3094,
              "sc": 2084,
              "st": 1002
            }
          }
        },
        "fees": 200000,
        "seats": 79
      },
      {
        "name": "Biological Science",
        "code": "BS",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 10129,
              "ews": 1743,
              "obc": 4504,
              "sc": 2757,
              "st": 1359
            },
            "2023": {
              "general": 9926,
              "ews": 1708,
              "obc": 4413,
              "sc": 2701,
              "st": 1331
            },
            "2022": {
              "general": 9723,
              "ews": 1673,
              "obc": 4323,
              "sc": 2646,
              "st": 1304
            },
            "2021": {
              "general": 9521,
              "ews": 1638,
              "obc": 4233,
              "sc": 2591,
              "st": 1277
            },
            "2020": {
              "general": 9318,
              "ews": 1603,
              "obc": 4143,
              "sc": 2536,
              "st": 1250
            }
          }
        },
        "fees": 200000,
        "seats": 79
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3927,
              "ews": 766,
              "obc": 1957,
              "sc": 1225,
              "st": 617
            },
            "2023": {
              "general": 3848,
              "ews": 750,
              "obc": 1917,
              "sc": 1200,
              "st": 604
            },
            "2022": {
              "general": 3769,
              "ews": 735,
              "obc": 1878,
              "sc": 1176,
              "st": 592
            },
            "2021": {
              "general": 3691,
              "ews": 720,
              "obc": 1839,
              "sc": 1151,
              "st": 579
            },
            "2020": {
              "general": 3612,
              "ews": 704,
              "obc": 1800,
              "sc": 1127,
              "st": 567
            }
          }
        },
        "fees": 200000,
        "seats": 79
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5525,
              "ews": 1089,
              "obc": 2500,
              "sc": 1324,
              "st": 522
            },
            "2023": {
              "general": 5414,
              "ews": 1067,
              "obc": 2450,
              "sc": 1297,
              "st": 511
            },
            "2022": {
              "general": 5304,
              "ews": 1045,
              "obc": 2400,
              "sc": 1271,
              "st": 501
            },
            "2021": {
              "general": 5193,
              "ews": 1023,
              "obc": 2350,
              "sc": 1244,
              "st": 490
            },
            "2020": {
              "general": 5083,
              "ews": 1001,
              "obc": 2300,
              "sc": 1218,
              "st": 480
            }
          }
        },
        "fees": 200000,
        "seats": 79
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 159,
              "ews": 42,
              "obc": 82,
              "sc": 72,
              "st": 29
            },
            "2023": {
              "general": 155,
              "ews": 41,
              "obc": 80,
              "sc": 70,
              "st": 28
            },
            "2022": {
              "general": 152,
              "ews": 40,
              "obc": 78,
              "sc": 69,
              "st": 27
            },
            "2021": {
              "general": 149,
              "ews": 39,
              "obc": 77,
              "sc": 67,
              "st": 27
            },
            "2020": {
              "general": 146,
              "ews": 38,
              "obc": 75,
              "sc": 66,
              "st": 26
            }
          }
        },
        "fees": 200000,
        "seats": 79
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 835,
              "ews": 178,
              "obc": 407,
              "sc": 378,
              "st": 149
            },
            "2023": {
              "general": 818,
              "ews": 174,
              "obc": 398,
              "sc": 370,
              "st": 146
            },
            "2022": {
              "general": 801,
              "ews": 170,
              "obc": 390,
              "sc": 362,
              "st": 143
            },
            "2021": {
              "general": 784,
              "ews": 167,
              "obc": 382,
              "sc": 355,
              "st": 140
            },
            "2020": {
              "general": 768,
              "ews": 163,
              "obc": 374,
              "sc": 347,
              "st": 137
            }
          }
        },
        "fees": 200000,
        "seats": 79
      },
      {
        "name": "Engineering Design",
        "code": "ED",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3656,
              "ews": 1235,
              "obc": 1772,
              "sc": 1549,
              "st": 1133
            },
            "2023": {
              "general": 3582,
              "ews": 1210,
              "obc": 1736,
              "sc": 1518,
              "st": 1110
            },
            "2022": {
              "general": 3509,
              "ews": 1185,
              "obc": 1701,
              "sc": 1487,
              "st": 1087
            },
            "2021": {
              "general": 3436,
              "ews": 1160,
              "obc": 1665,
              "sc": 1456,
              "st": 1065
            },
            "2020": {
              "general": 3363,
              "ews": 1136,
              "obc": 1630,
              "sc": 1425,
              "st": 1042
            }
          }
        },
        "fees": 200000,
        "seats": 79
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1783,
              "ews": 803,
              "obc": 1192,
              "sc": 1053,
              "st": 1022
            },
            "2023": {
              "general": 1747,
              "ews": 786,
              "obc": 1168,
              "sc": 1031,
              "st": 1001
            },
            "2022": {
              "general": 1711,
              "ews": 770,
              "obc": 1144,
              "sc": 1010,
              "st": 981
            },
            "2021": {
              "general": 1676,
              "ews": 754,
              "obc": 1120,
              "sc": 989,
              "st": 960
            },
            "2020": {
              "general": 1640,
              "ews": 738,
              "obc": 1096,
              "sc": 968,
              "st": 940
            }
          }
        },
        "fees": 200000,
        "seats": 79
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2302,
              "ews": 547,
              "obc": 1133,
              "sc": 750,
              "st": 369
            },
            "2023": {
              "general": 2255,
              "ews": 536,
              "obc": 1110,
              "sc": 735,
              "st": 361
            },
            "2022": {
              "general": 2209,
              "ews": 525,
              "obc": 1087,
              "sc": 720,
              "st": 354
            },
            "2021": {
              "general": 2163,
              "ews": 514,
              "obc": 1065,
              "sc": 705,
              "st": 346
            },
            "2020": {
              "general": 2117,
              "ews": 503,
              "obc": 1042,
              "sc": 690,
              "st": 339
            }
          }
        },
        "fees": 200000,
        "seats": 79
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4683,
              "ews": 1263,
              "obc": 2463,
              "sc": 1679,
              "st": 784
            },
            "2023": {
              "general": 4589,
              "ews": 1237,
              "obc": 2413,
              "sc": 1645,
              "st": 768
            },
            "2022": {
              "general": 4495,
              "ews": 1212,
              "obc": 2364,
              "sc": 1611,
              "st": 752
            },
            "2021": {
              "general": 4402,
              "ews": 1187,
              "obc": 2315,
              "sc": 1578,
              "st": 736
            },
            "2020": {
              "general": 4308,
              "ews": 1161,
              "obc": 2265,
              "sc": 1544,
              "st": 721
            }
          }
        },
        "fees": 200000,
        "seats": 79
      },
      {
        "name": "Naval Architecture and Ocean Engineering",
        "code": "NAOE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 7187,
              "ews": 1550,
              "obc": 3199,
              "sc": 2224,
              "st": 1056
            },
            "2023": {
              "general": 7043,
              "ews": 1519,
              "obc": 3135,
              "sc": 2179,
              "st": 1034
            },
            "2022": {
              "general": 6899,
              "ews": 1488,
              "obc": 3071,
              "sc": 2135,
              "st": 1013
            },
            "2021": {
              "general": 6755,
              "ews": 1457,
              "obc": 3007,
              "sc": 2090,
              "st": 992
            },
            "2020": {
              "general": 6612,
              "ews": 1426,
              "obc": 2943,
              "sc": 2046,
              "st": 971
            }
          }
        },
        "fees": 200000,
        "seats": 79
      },
      {
        "name": "Physics",
        "code": "P",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1331,
              "ews": 942,
              "obc": 2296,
              "sc": 1784,
              "st": 1149
            },
            "2023": {
              "general": 1304,
              "ews": 923,
              "obc": 2250,
              "sc": 1748,
              "st": 1126
            },
            "2022": {
              "general": 1277,
              "ews": 904,
              "obc": 2204,
              "sc": 1712,
              "st": 1103
            },
            "2021": {
              "general": 1251,
              "ews": 885,
              "obc": 2158,
              "sc": 1676,
              "st": 1080
            },
            "2020": {
              "general": 1224,
              "ews": 866,
              "obc": 2112,
              "sc": 1641,
              "st": 1057
            }
          }
        },
        "fees": 200000,
        "seats": 79
      }
    ]
  },
  {
    "id": 60,
    "name": "Indian Institute of Technology Mandi",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "B.Tech in General Engineering",
        "code": "BGE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 10181,
              "ews": 1590,
              "obc": 4664,
              "sc": 2555,
              "st": 1400
            },
            "2023": {
              "general": 9977,
              "ews": 1558,
              "obc": 4570,
              "sc": 2503,
              "st": 1372
            },
            "2022": {
              "general": 9773,
              "ews": 1526,
              "obc": 4477,
              "sc": 2452,
              "st": 1344
            },
            "2021": {
              "general": 9570,
              "ews": 1494,
              "obc": 4384,
              "sc": 2401,
              "st": 1316
            },
            "2020": {
              "general": 9366,
              "ews": 1462,
              "obc": 4290,
              "sc": 2350,
              "st": 1288
            }
          }
        },
        "fees": 200000,
        "seats": 80
      },
      {
        "name": "B.Tech in Materials Science and Engineering",
        "code": "BMSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 13000,
              "ews": 2143,
              "obc": 5464,
              "sc": 2787,
              "st": 1453
            },
            "2023": {
              "general": 12740,
              "ews": 2100,
              "obc": 5354,
              "sc": 2731,
              "st": 1423
            },
            "2022": {
              "general": 12480,
              "ews": 2057,
              "obc": 5245,
              "sc": 2675,
              "st": 1394
            },
            "2021": {
              "general": 12220,
              "ews": 2014,
              "obc": 5136,
              "sc": 2619,
              "st": 1365
            },
            "2020": {
              "general": 11960,
              "ews": 1971,
              "obc": 5026,
              "sc": 2564,
              "st": 1336
            }
          }
        },
        "fees": 200000,
        "seats": 80
      },
      {
        "name": "B.Tech in Mathematics and Computing",
        "code": "BMC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3980,
              "ews": 671,
              "obc": 1767,
              "sc": 1086,
              "st": 678
            },
            "2023": {
              "general": 3900,
              "ews": 657,
              "obc": 1731,
              "sc": 1064,
              "st": 664
            },
            "2022": {
              "general": 3820,
              "ews": 644,
              "obc": 1696,
              "sc": 1042,
              "st": 650
            },
            "2021": {
              "general": 3741,
              "ews": 630,
              "obc": 1660,
              "sc": 1020,
              "st": 637
            },
            "2020": {
              "general": 3661,
              "ews": 617,
              "obc": 1625,
              "sc": 999,
              "st": 623
            }
          }
        },
        "fees": 200000,
        "seats": 80
      },
      {
        "name": "B.Tech in Microelectronics & VLSI",
        "code": "BMV",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5522,
              "ews": 969,
              "obc": 2914,
              "sc": 1751,
              "st": 1096
            },
            "2023": {
              "general": 5411,
              "ews": 949,
              "obc": 2855,
              "sc": 1715,
              "st": 1074
            },
            "2022": {
              "general": 5301,
              "ews": 930,
              "obc": 2797,
              "sc": 1680,
              "st": 1052
            },
            "2021": {
              "general": 5190,
              "ews": 910,
              "obc": 2739,
              "sc": 1645,
              "st": 1030
            },
            "2020": {
              "general": 5080,
              "ews": 891,
              "obc": 2680,
              "sc": 1610,
              "st": 1008
            }
          }
        },
        "fees": 200000,
        "seats": 80
      },
      {
        "name": "Bio Engineering",
        "code": "BE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 13153,
              "ews": 2215,
              "obc": 5494,
              "sc": 3050,
              "st": 1502
            },
            "2023": {
              "general": 12889,
              "ews": 2170,
              "obc": 5384,
              "sc": 2989,
              "st": 1471
            },
            "2022": {
              "general": 12626,
              "ews": 2126,
              "obc": 5274,
              "sc": 2928,
              "st": 1441
            },
            "2021": {
              "general": 12363,
              "ews": 2082,
              "obc": 5164,
              "sc": 2867,
              "st": 1411
            },
            "2020": {
              "general": 12100,
              "ews": 2037,
              "obc": 5054,
              "sc": 2806,
              "st": 1381
            }
          }
        },
        "fees": 200000,
        "seats": 80
      },
      {
        "name": "BS in Chemical Sciences",
        "code": "BCS",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 15365,
              "ews": 2353,
              "obc": 5884,
              "sc": 3161,
              "st": 1493
            },
            "2023": {
              "general": 15057,
              "ews": 2305,
              "obc": 5766,
              "sc": 3097,
              "st": 1463
            },
            "2022": {
              "general": 14750,
              "ews": 2258,
              "obc": 5648,
              "sc": 3034,
              "st": 1433
            },
            "2021": {
              "general": 14443,
              "ews": 2211,
              "obc": 5530,
              "sc": 2971,
              "st": 1403
            },
            "2020": {
              "general": 14135,
              "ews": 2164,
              "obc": 5413,
              "sc": 2908,
              "st": 1373
            }
          }
        },
        "fees": 200000,
        "seats": 80
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 11505,
              "ews": 1947,
              "obc": 4705,
              "sc": 2525,
              "st": 795
            },
            "2023": {
              "general": 11274,
              "ews": 1908,
              "obc": 4610,
              "sc": 2474,
              "st": 779
            },
            "2022": {
              "general": 11044,
              "ews": 1869,
              "obc": 4516,
              "sc": 2424,
              "st": 763
            },
            "2021": {
              "general": 10814,
              "ews": 1830,
              "obc": 4422,
              "sc": 2373,
              "st": 747
            },
            "2020": {
              "general": 10584,
              "ews": 1791,
              "obc": 4328,
              "sc": 2323,
              "st": 731
            }
          }
        },
        "fees": 200000,
        "seats": 80
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2909,
              "ews": 454,
              "obc": 1269,
              "sc": 737,
              "st": 371
            },
            "2023": {
              "general": 2850,
              "ews": 444,
              "obc": 1243,
              "sc": 722,
              "st": 363
            },
            "2022": {
              "general": 2792,
              "ews": 435,
              "obc": 1218,
              "sc": 707,
              "st": 356
            },
            "2021": {
              "general": 2734,
              "ews": 426,
              "obc": 1192,
              "sc": 692,
              "st": 348
            },
            "2020": {
              "general": 2676,
              "ews": 417,
              "obc": 1167,
              "sc": 678,
              "st": 341
            }
          }
        },
        "fees": 200000,
        "seats": 80
      },
      {
        "name": "Data Science and Engineering",
        "code": "DSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3867,
              "ews": 595,
              "obc": 1679,
              "sc": 943,
              "st": 615
            },
            "2023": {
              "general": 3789,
              "ews": 583,
              "obc": 1645,
              "sc": 924,
              "st": 602
            },
            "2022": {
              "general": 3712,
              "ews": 571,
              "obc": 1611,
              "sc": 905,
              "st": 590
            },
            "2021": {
              "general": 3634,
              "ews": 559,
              "obc": 1578,
              "sc": 886,
              "st": 578
            },
            "2020": {
              "general": 3557,
              "ews": 547,
              "obc": 1544,
              "sc": 867,
              "st": 565
            }
          }
        },
        "fees": 200000,
        "seats": 80
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6428,
              "ews": 1071,
              "obc": 2930,
              "sc": 1650,
              "st": 833
            },
            "2023": {
              "general": 6299,
              "ews": 1049,
              "obc": 2871,
              "sc": 1617,
              "st": 816
            },
            "2022": {
              "general": 6170,
              "ews": 1028,
              "obc": 2812,
              "sc": 1584,
              "st": 799
            },
            "2021": {
              "general": 6042,
              "ews": 1006,
              "obc": 2754,
              "sc": 1551,
              "st": 783
            },
            "2020": {
              "general": 5913,
              "ews": 985,
              "obc": 2695,
              "sc": 1518,
              "st": 766
            }
          }
        },
        "fees": 200000,
        "seats": 80
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 9750,
              "ews": 1924,
              "obc": 4809,
              "sc": 2631,
              "st": 1342
            },
            "2023": {
              "general": 9555,
              "ews": 1885,
              "obc": 4712,
              "sc": 2578,
              "st": 1315
            },
            "2022": {
              "general": 9360,
              "ews": 1847,
              "obc": 4616,
              "sc": 2525,
              "st": 1288
            },
            "2021": {
              "general": 9165,
              "ews": 1808,
              "obc": 4520,
              "sc": 2473,
              "st": 1261
            },
            "2020": {
              "general": 8970,
              "ews": 1770,
              "obc": 4424,
              "sc": 2420,
              "st": 1234
            }
          }
        },
        "fees": 200000,
        "seats": 80
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 8962,
              "ews": 1496,
              "obc": 4027,
              "sc": 2084,
              "st": 974
            },
            "2023": {
              "general": 8782,
              "ews": 1466,
              "obc": 3946,
              "sc": 2042,
              "st": 954
            },
            "2022": {
              "general": 8603,
              "ews": 1436,
              "obc": 3865,
              "sc": 2000,
              "st": 935
            },
            "2021": {
              "general": 8424,
              "ews": 1406,
              "obc": 3785,
              "sc": 1958,
              "st": 915
            },
            "2020": {
              "general": 8245,
              "ews": 1376,
              "obc": 3704,
              "sc": 1917,
              "st": 896
            }
          }
        },
        "fees": 200000,
        "seats": 80
      }
    ]
  },
  {
    "id": 61,
    "name": "Indian Institute of Technology Palakkad",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 14327,
              "ews": 2311,
              "obc": 5355,
              "sc": 2825,
              "st": 1153
            },
            "2023": {
              "general": 14040,
              "ews": 2264,
              "obc": 5247,
              "sc": 2768,
              "st": 1129
            },
            "2022": {
              "general": 13753,
              "ews": 2218,
              "obc": 5140,
              "sc": 2712,
              "st": 1106
            },
            "2021": {
              "general": 13467,
              "ews": 2172,
              "obc": 5033,
              "sc": 2655,
              "st": 1083
            },
            "2020": {
              "general": 13180,
              "ews": 2126,
              "obc": 4926,
              "sc": 2599,
              "st": 1060
            }
          }
        },
        "fees": 200000,
        "seats": 81
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5556,
              "ews": 801,
              "obc": 2038,
              "sc": 1097,
              "st": 564
            },
            "2023": {
              "general": 5444,
              "ews": 784,
              "obc": 1997,
              "sc": 1075,
              "st": 552
            },
            "2022": {
              "general": 5333,
              "ews": 768,
              "obc": 1956,
              "sc": 1053,
              "st": 541
            },
            "2021": {
              "general": 5222,
              "ews": 752,
              "obc": 1915,
              "sc": 1031,
              "st": 530
            },
            "2020": {
              "general": 5111,
              "ews": 736,
              "obc": 1874,
              "sc": 1009,
              "st": 518
            }
          }
        },
        "fees": 200000,
        "seats": 81
      },
      {
        "name": "Data Science and Engineering",
        "code": "DSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6965,
              "ews": 1148,
              "obc": 2788,
              "sc": 1602,
              "st": 722
            },
            "2023": {
              "general": 6825,
              "ews": 1125,
              "obc": 2732,
              "sc": 1569,
              "st": 707
            },
            "2022": {
              "general": 6686,
              "ews": 1102,
              "obc": 2676,
              "sc": 1537,
              "st": 693
            },
            "2021": {
              "general": 6547,
              "ews": 1079,
              "obc": 2620,
              "sc": 1505,
              "st": 678
            },
            "2020": {
              "general": 6407,
              "ews": 1056,
              "obc": 2564,
              "sc": 1473,
              "st": 664
            }
          }
        },
        "fees": 200000,
        "seats": 81
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 9234,
              "ews": 1268,
              "obc": 3608,
              "sc": 2040,
              "st": 965
            },
            "2023": {
              "general": 9049,
              "ews": 1242,
              "obc": 3535,
              "sc": 1999,
              "st": 945
            },
            "2022": {
              "general": 8864,
              "ews": 1217,
              "obc": 3463,
              "sc": 1958,
              "st": 926
            },
            "2021": {
              "general": 8679,
              "ews": 1191,
              "obc": 3391,
              "sc": 1917,
              "st": 907
            },
            "2020": {
              "general": 8495,
              "ews": 1166,
              "obc": 3319,
              "sc": 1876,
              "st": 887
            }
          }
        },
        "fees": 200000,
        "seats": 81
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 11302,
              "ews": 1710,
              "obc": 4545,
              "sc": 2396,
              "st": 1187
            },
            "2023": {
              "general": 11075,
              "ews": 1675,
              "obc": 4454,
              "sc": 2348,
              "st": 1163
            },
            "2022": {
              "general": 10849,
              "ews": 1641,
              "obc": 4363,
              "sc": 2300,
              "st": 1139
            },
            "2021": {
              "general": 10623,
              "ews": 1607,
              "obc": 4272,
              "sc": 2252,
              "st": 1115
            },
            "2020": {
              "general": 10397,
              "ews": 1573,
              "obc": 4181,
              "sc": 2204,
              "st": 1092
            }
          }
        },
        "fees": 200000,
        "seats": 81
      }
    ]
  },
  {
    "id": 62,
    "name": "Indian Institute of Technology Patna",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Artificial Intelligence and Data Science",
        "code": "AIDS",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4034,
              "ews": 579,
              "obc": 1661,
              "sc": 1012,
              "st": 575
            },
            "2023": {
              "general": 3953,
              "ews": 567,
              "obc": 1627,
              "sc": 991,
              "st": 563
            },
            "2022": {
              "general": 3872,
              "ews": 555,
              "obc": 1594,
              "sc": 971,
              "st": 552
            },
            "2021": {
              "general": 3791,
              "ews": 544,
              "obc": 1561,
              "sc": 951,
              "st": 540
            },
            "2020": {
              "general": 3711,
              "ews": 532,
              "obc": 1528,
              "sc": 931,
              "st": 529
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "B. Tech in CE. - M. Tech. in Geotechnical Engineering",
        "code": "BTCMT",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 14566,
              "ews": 2292,
              "obc": 5517,
              "sc": 2753,
              "st": 1188
            },
            "2023": {
              "general": 14274,
              "ews": 2246,
              "obc": 5406,
              "sc": 2697,
              "st": 1164
            },
            "2022": {
              "general": 13983,
              "ews": 2200,
              "obc": 5296,
              "sc": 2642,
              "st": 1140
            },
            "2021": {
              "general": 13692,
              "ews": 2154,
              "obc": 5185,
              "sc": 2587,
              "st": 1116
            },
            "2020": {
              "general": 13400,
              "ews": 2108,
              "obc": 5075,
              "sc": 2532,
              "st": 1092
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "B. Tech in CE. - M. Tech. in Structural Engineering",
        "code": "BTCMT",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 13789,
              "ews": 2290,
              "obc": 5199,
              "sc": 2613
            },
            "2023": {
              "general": 13513,
              "ews": 2244,
              "obc": 5095,
              "sc": 2560
            },
            "2022": {
              "general": 13237,
              "ews": 2198,
              "obc": 4991,
              "sc": 2508
            },
            "2021": {
              "general": 12961,
              "ews": 2152,
              "obc": 4887,
              "sc": 2456
            },
            "2020": {
              "general": 12685,
              "ews": 2106,
              "obc": 4783,
              "sc": 2403
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "B. Tech.",
        "code": "BT",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 8327,
              "ews": 1326,
              "obc": 3885,
              "sc": 2303,
              "st": 1244
            },
            "2023": {
              "general": 8160,
              "ews": 1299,
              "obc": 3807,
              "sc": 2256,
              "st": 1219
            },
            "2022": {
              "general": 7993,
              "ews": 1272,
              "obc": 3729,
              "sc": 2210,
              "st": 1194
            },
            "2021": {
              "general": 7827,
              "ews": 1246,
              "obc": 3651,
              "sc": 2164,
              "st": 1169
            },
            "2020": {
              "general": 7660,
              "ews": 1219,
              "obc": 3574,
              "sc": 2118,
              "st": 1144
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "B.Tech",
        "code": "B",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 14530,
              "obc": 4728,
              "sc": 2341,
              "ews": 1703,
              "st": 1273
            },
            "2023": {
              "general": 14239,
              "obc": 4633,
              "sc": 2294,
              "ews": 1668,
              "st": 1247
            },
            "2022": {
              "general": 13948,
              "obc": 4538,
              "sc": 2247,
              "ews": 1634,
              "st": 1222
            },
            "2021": {
              "general": 13658,
              "obc": 4444,
              "sc": 2200,
              "ews": 1600,
              "st": 1196
            },
            "2020": {
              "general": 13367,
              "obc": 4349,
              "sc": 2153,
              "ews": 1566,
              "st": 1171
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "B.Tech. in Electronics and Communication Engineering and M.Tech. in Communication Systems",
        "code": "BECEM",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6188,
              "ews": 926,
              "obc": 2383,
              "sc": 1663,
              "st": 882
            },
            "2023": {
              "general": 6064,
              "ews": 907,
              "obc": 2335,
              "sc": 1629,
              "st": 864
            },
            "2022": {
              "general": 5940,
              "ews": 888,
              "obc": 2287,
              "sc": 1596,
              "st": 846
            },
            "2021": {
              "general": 5816,
              "ews": 870,
              "obc": 2240,
              "sc": 1563,
              "st": 829
            },
            "2020": {
              "general": 5692,
              "ews": 851,
              "obc": 2192,
              "sc": 1529,
              "st": 811
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "BS in Economics with MBA",
        "code": "BEM",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 9961,
              "obc": 3890,
              "sc": 2678,
              "st": 1329
            },
            "2023": {
              "general": 9761,
              "obc": 3812,
              "sc": 2624,
              "st": 1302
            },
            "2022": {
              "general": 9562,
              "obc": 3734,
              "sc": 2570,
              "st": 1275
            },
            "2021": {
              "general": 9363,
              "obc": 3656,
              "sc": 2517,
              "st": 1249
            },
            "2020": {
              "general": 9164,
              "obc": 3578,
              "sc": 2463,
              "st": 1222
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 11588,
              "ews": 1726,
              "obc": 4679,
              "sc": 2592,
              "st": 1236
            },
            "2023": {
              "general": 11356,
              "ews": 1691,
              "obc": 4585,
              "sc": 2540,
              "st": 1211
            },
            "2022": {
              "general": 11124,
              "ews": 1656,
              "obc": 4491,
              "sc": 2488,
              "st": 1186
            },
            "2021": {
              "general": 10892,
              "ews": 1622,
              "obc": 4398,
              "sc": 2436,
              "st": 1161
            },
            "2020": {
              "general": 10660,
              "ews": 1587,
              "obc": 4304,
              "sc": 2384,
              "st": 1137
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "Chemical Science and Technology",
        "code": "CST",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 13172,
              "ews": 1940,
              "obc": 5214,
              "sc": 2977,
              "st": 1252
            },
            "2023": {
              "general": 12908,
              "ews": 1901,
              "obc": 5109,
              "sc": 2917,
              "st": 1226
            },
            "2022": {
              "general": 12645,
              "ews": 1862,
              "obc": 5005,
              "sc": 2857,
              "st": 1201
            },
            "2021": {
              "general": 12381,
              "ews": 1823,
              "obc": 4901,
              "sc": 2798,
              "st": 1176
            },
            "2020": {
              "general": 12118,
              "ews": 1784,
              "obc": 4796,
              "sc": 2738,
              "st": 1151
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 13404,
              "ews": 2075,
              "obc": 5052,
              "sc": 2587,
              "st": 1105
            },
            "2023": {
              "general": 13135,
              "ews": 2033,
              "obc": 4950,
              "sc": 2535,
              "st": 1082
            },
            "2022": {
              "general": 12867,
              "ews": 1992,
              "obc": 4849,
              "sc": 2483,
              "st": 1060
            },
            "2021": {
              "general": 12599,
              "ews": 1950,
              "obc": 4748,
              "sc": 2431,
              "st": 1038
            },
            "2020": {
              "general": 12331,
              "ews": 1909,
              "obc": 4647,
              "sc": 2380,
              "st": 1016
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3074,
              "ews": 425,
              "obc": 1117,
              "sc": 681,
              "st": 404
            },
            "2023": {
              "general": 3012,
              "ews": 416,
              "obc": 1094,
              "sc": 667,
              "st": 395
            },
            "2022": {
              "general": 2951,
              "ews": 408,
              "obc": 1072,
              "sc": 653,
              "st": 387
            },
            "2021": {
              "general": 2889,
              "ews": 399,
              "obc": 1049,
              "sc": 640,
              "st": 379
            },
            "2020": {
              "general": 2828,
              "ews": 391,
              "obc": 1027,
              "sc": 626,
              "st": 371
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "Economics",
        "code": "E",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 10343,
              "ews": 1679,
              "obc": 4834,
              "sc": 2770,
              "st": 1489
            },
            "2023": {
              "general": 10136,
              "ews": 1645,
              "obc": 4737,
              "sc": 2714,
              "st": 1459
            },
            "2022": {
              "general": 9929,
              "ews": 1611,
              "obc": 4640,
              "sc": 2659,
              "st": 1429
            },
            "2021": {
              "general": 9722,
              "ews": 1578,
              "obc": 4543,
              "sc": 2603,
              "st": 1399
            },
            "2020": {
              "general": 9515,
              "ews": 1544,
              "obc": 4447,
              "sc": 2548,
              "st": 1369
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6191,
              "ews": 998,
              "obc": 2695,
              "sc": 1595,
              "st": 876
            },
            "2023": {
              "general": 6067,
              "ews": 978,
              "obc": 2641,
              "sc": 1563,
              "st": 858
            },
            "2022": {
              "general": 5943,
              "ews": 958,
              "obc": 2587,
              "sc": 1531,
              "st": 840
            },
            "2021": {
              "general": 5819,
              "ews": 938,
              "obc": 2533,
              "sc": 1499,
              "st": 823
            },
            "2020": {
              "general": 5695,
              "ews": 918,
              "obc": 2479,
              "sc": 1467,
              "st": 805
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5196,
              "ews": 833,
              "obc": 2142,
              "sc": 1299,
              "st": 799
            },
            "2023": {
              "general": 5092,
              "ews": 816,
              "obc": 2099,
              "sc": 1273,
              "st": 783
            },
            "2022": {
              "general": 4988,
              "ews": 799,
              "obc": 2056,
              "sc": 1247,
              "st": 767
            },
            "2021": {
              "general": 4884,
              "ews": 783,
              "obc": 2013,
              "sc": 1221,
              "st": 751
            },
            "2020": {
              "general": 4780,
              "ews": 766,
              "obc": 1970,
              "sc": 1195,
              "st": 735
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 11144,
              "ews": 1958,
              "obc": 5127,
              "sc": 2806,
              "st": 1376
            },
            "2023": {
              "general": 10921,
              "ews": 1918,
              "obc": 5024,
              "sc": 2749,
              "st": 1348
            },
            "2022": {
              "general": 10698,
              "ews": 1879,
              "obc": 4921,
              "sc": 2693,
              "st": 1320
            },
            "2021": {
              "general": 10475,
              "ews": 1840,
              "obc": 4819,
              "sc": 2637,
              "st": 1293
            },
            "2020": {
              "general": 10252,
              "ews": 1801,
              "obc": 4716,
              "sc": 2581,
              "st": 1265
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4575,
              "ews": 679,
              "obc": 1939,
              "sc": 1187,
              "st": 841
            },
            "2023": {
              "general": 4483,
              "ews": 665,
              "obc": 1900,
              "sc": 1163,
              "st": 824
            },
            "2022": {
              "general": 4392,
              "ews": 651,
              "obc": 1861,
              "sc": 1139,
              "st": 807
            },
            "2021": {
              "general": 4300,
              "ews": 638,
              "obc": 1822,
              "sc": 1115,
              "st": 790
            },
            "2020": {
              "general": 4209,
              "ews": 624,
              "obc": 1783,
              "sc": 1092,
              "st": 773
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 10000,
              "ews": 1620,
              "obc": 3999,
              "sc": 2320,
              "st": 1088
            },
            "2023": {
              "general": 9800,
              "ews": 1587,
              "obc": 3919,
              "sc": 2273,
              "st": 1066
            },
            "2022": {
              "general": 9600,
              "ews": 1555,
              "obc": 3839,
              "sc": 2227,
              "st": 1044
            },
            "2021": {
              "general": 9400,
              "ews": 1522,
              "obc": 3759,
              "sc": 2180,
              "st": 1022
            },
            "2020": {
              "general": 9200,
              "ews": 1490,
              "obc": 3679,
              "sc": 2134,
              "st": 1000
            }
          }
        },
        "fees": 200000,
        "seats": 82
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 14020,
              "ews": 2208,
              "obc": 5632,
              "sc": 3031,
              "st": 1324
            },
            "2023": {
              "general": 13739,
              "ews": 2163,
              "obc": 5519,
              "sc": 2970,
              "st": 1297
            },
            "2022": {
              "general": 13459,
              "ews": 2119,
              "obc": 5406,
              "sc": 2909,
              "st": 1271
            },
            "2021": {
              "general": 13178,
              "ews": 2075,
              "obc": 5294,
              "sc": 2849,
              "st": 1244
            },
            "2020": {
              "general": 12898,
              "ews": 2031,
              "obc": 5181,
              "sc": 2788,
              "st": 1218
            }
          }
        },
        "fees": 200000,
        "seats": 82
      }
    ]
  },
  {
    "id": 63,
    "name": "Indian Institute of Technology Roorkee",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 16381,
              "ews": 2926,
              "obc": 6968,
              "sc": 3792
            },
            "2023": {
              "general": 16053,
              "ews": 2867,
              "obc": 6828,
              "sc": 3716
            },
            "2022": {
              "general": 15725,
              "ews": 2808,
              "obc": 6689,
              "sc": 3640
            },
            "2021": {
              "general": 15398,
              "ews": 2750,
              "obc": 6549,
              "sc": 3564
            },
            "2020": {
              "general": 15070,
              "ews": 2691,
              "obc": 6410,
              "sc": 3488
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Biosciences and Bioengineering",
        "code": "BB",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 7253,
              "ews": 1398,
              "obc": 3541,
              "sc": 2148,
              "st": 1229
            },
            "2023": {
              "general": 7107,
              "ews": 1370,
              "obc": 3470,
              "sc": 2105,
              "st": 1204
            },
            "2022": {
              "general": 6962,
              "ews": 1342,
              "obc": 3399,
              "sc": 2062,
              "st": 1179
            },
            "2021": {
              "general": 6817,
              "ews": 1314,
              "obc": 3328,
              "sc": 2019,
              "st": 1155
            },
            "2020": {
              "general": 6672,
              "ews": 1286,
              "obc": 3257,
              "sc": 1976,
              "st": 1130
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4545,
              "ews": 805,
              "obc": 2361,
              "sc": 1261,
              "st": 748
            },
            "2023": {
              "general": 4454,
              "ews": 788,
              "obc": 2313,
              "sc": 1235,
              "st": 733
            },
            "2022": {
              "general": 4363,
              "ews": 772,
              "obc": 2266,
              "sc": 1210,
              "st": 718
            },
            "2021": {
              "general": 4272,
              "ews": 756,
              "obc": 2219,
              "sc": 1185,
              "st": 703
            },
            "2020": {
              "general": 4181,
              "ews": 740,
              "obc": 2172,
              "sc": 1160,
              "st": 688
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Chemical Sciences",
        "code": "CS",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 10427,
              "ews": 1817,
              "obc": 4745,
              "sc": 2535,
              "st": 1137
            },
            "2023": {
              "general": 10218,
              "ews": 1780,
              "obc": 4650,
              "sc": 2484,
              "st": 1114
            },
            "2022": {
              "general": 10009,
              "ews": 1744,
              "obc": 4555,
              "sc": 2433,
              "st": 1091
            },
            "2021": {
              "general": 9801,
              "ews": 1707,
              "obc": 4460,
              "sc": 2382,
              "st": 1068
            },
            "2020": {
              "general": 9592,
              "ews": 1671,
              "obc": 4365,
              "sc": 2332,
              "st": 1046
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6148,
              "ews": 1109,
              "obc": 2884,
              "sc": 1475,
              "st": 457
            },
            "2023": {
              "general": 6025,
              "ews": 1086,
              "obc": 2826,
              "sc": 1445,
              "st": 447
            },
            "2022": {
              "general": 5902,
              "ews": 1064,
              "obc": 2768,
              "sc": 1416,
              "st": 438
            },
            "2021": {
              "general": 5779,
              "ews": 1042,
              "obc": 2710,
              "sc": 1386,
              "st": 429
            },
            "2020": {
              "general": 5656,
              "ews": 1020,
              "obc": 2653,
              "sc": 1357,
              "st": 420
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 481,
              "ews": 90,
              "obc": 236,
              "sc": 144,
              "st": 75
            },
            "2023": {
              "general": 471,
              "ews": 88,
              "obc": 231,
              "sc": 141,
              "st": 73
            },
            "2022": {
              "general": 461,
              "ews": 86,
              "obc": 226,
              "sc": 138,
              "st": 72
            },
            "2021": {
              "general": 452,
              "ews": 84,
              "obc": 221,
              "sc": 135,
              "st": 70
            },
            "2020": {
              "general": 442,
              "ews": 82,
              "obc": 217,
              "sc": 132,
              "st": 69
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Data Science and Artificial Intelligence",
        "code": "DSAI",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 678,
              "ews": 132,
              "obc": 402,
              "sc": 226,
              "st": 103
            },
            "2023": {
              "general": 664,
              "ews": 129,
              "obc": 393,
              "sc": 221,
              "st": 100
            },
            "2022": {
              "general": 650,
              "ews": 126,
              "obc": 385,
              "sc": 216,
              "st": 98
            },
            "2021": {
              "general": 637,
              "ews": 124,
              "obc": 377,
              "sc": 212,
              "st": 96
            },
            "2020": {
              "general": 623,
              "ews": 121,
              "obc": 369,
              "sc": 207,
              "st": 94
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Economics",
        "code": "E",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5224,
              "ews": 931,
              "obc": 2552,
              "sc": 1879,
              "st": 1009
            },
            "2023": {
              "general": 5119,
              "ews": 912,
              "obc": 2500,
              "sc": 1841,
              "st": 988
            },
            "2022": {
              "general": 5015,
              "ews": 893,
              "obc": 2449,
              "sc": 1803,
              "st": 968
            },
            "2021": {
              "general": 4910,
              "ews": 875,
              "obc": 2398,
              "sc": 1766,
              "st": 948
            },
            "2020": {
              "general": 4806,
              "ews": 856,
              "obc": 2347,
              "sc": 1728,
              "st": 928
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1992,
              "ews": 370,
              "obc": 989,
              "sc": 560,
              "st": 298
            },
            "2023": {
              "general": 1952,
              "ews": 362,
              "obc": 969,
              "sc": 548,
              "st": 292
            },
            "2022": {
              "general": 1912,
              "ews": 355,
              "obc": 949,
              "sc": 537,
              "st": 286
            },
            "2021": {
              "general": 1872,
              "ews": 347,
              "obc": 929,
              "sc": 526,
              "st": 280
            },
            "2020": {
              "general": 1832,
              "ews": 340,
              "obc": 909,
              "sc": 515,
              "st": 274
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1424,
              "ews": 242,
              "obc": 725,
              "sc": 398,
              "st": 217
            },
            "2023": {
              "general": 1395,
              "ews": 237,
              "obc": 710,
              "sc": 390,
              "st": 212
            },
            "2022": {
              "general": 1367,
              "ews": 232,
              "obc": 696,
              "sc": 382,
              "st": 208
            },
            "2021": {
              "general": 1338,
              "ews": 227,
              "obc": 681,
              "sc": 374,
              "st": 203
            },
            "2020": {
              "general": 1310,
              "ews": 222,
              "obc": 667,
              "sc": 366,
              "st": 199
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Energy Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4637,
              "ews": 1061,
              "obc": 2521,
              "sc": 1416,
              "st": 835
            },
            "2023": {
              "general": 4544,
              "ews": 1039,
              "obc": 2470,
              "sc": 1387,
              "st": 818
            },
            "2022": {
              "general": 4451,
              "ews": 1018,
              "obc": 2420,
              "sc": 1359,
              "st": 801
            },
            "2021": {
              "general": 4358,
              "ews": 997,
              "obc": 2369,
              "sc": 1331,
              "st": 784
            },
            "2020": {
              "general": 4266,
              "ews": 976,
              "obc": 2319,
              "sc": 1302,
              "st": 768
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3809,
              "ews": 1093,
              "obc": 2607,
              "sc": 1590,
              "st": 1118
            },
            "2023": {
              "general": 3732,
              "ews": 1071,
              "obc": 2554,
              "sc": 1558,
              "st": 1095
            },
            "2022": {
              "general": 3656,
              "ews": 1049,
              "obc": 2502,
              "sc": 1526,
              "st": 1073
            },
            "2021": {
              "general": 3580,
              "ews": 1027,
              "obc": 2450,
              "sc": 1494,
              "st": 1050
            },
            "2020": {
              "general": 3504,
              "ews": 1005,
              "obc": 2398,
              "sc": 1462,
              "st": 1028
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Geological Technology",
        "code": "GT",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 9620,
              "ews": 1530,
              "obc": 4209,
              "sc": 2491,
              "st": 1332
            },
            "2023": {
              "general": 9427,
              "ews": 1499,
              "obc": 4124,
              "sc": 2441,
              "st": 1305
            },
            "2022": {
              "general": 9235,
              "ews": 1468,
              "obc": 4040,
              "sc": 2391,
              "st": 1278
            },
            "2021": {
              "general": 9042,
              "ews": 1438,
              "obc": 3956,
              "sc": 2341,
              "st": 1252
            },
            "2020": {
              "general": 8850,
              "ews": 1407,
              "obc": 3872,
              "sc": 2291,
              "st": 1225
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Geophysical Technology",
        "code": "GT",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 9064,
              "ews": 1475,
              "obc": 3834,
              "sc": 2363,
              "st": 1371
            },
            "2023": {
              "general": 8882,
              "ews": 1445,
              "obc": 3757,
              "sc": 2315,
              "st": 1343
            },
            "2022": {
              "general": 8701,
              "ews": 1416,
              "obc": 3680,
              "sc": 2268,
              "st": 1316
            },
            "2021": {
              "general": 8520,
              "ews": 1386,
              "obc": 3603,
              "sc": 2221,
              "st": 1288
            },
            "2020": {
              "general": 8338,
              "ews": 1357,
              "obc": 3527,
              "sc": 2173,
              "st": 1261
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Mathematics & Computing",
        "code": "MC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 1501,
              "ews": 266,
              "obc": 810,
              "sc": 592,
              "st": 338
            },
            "2023": {
              "general": 1470,
              "ews": 260,
              "obc": 793,
              "sc": 580,
              "st": 331
            },
            "2022": {
              "general": 1440,
              "ews": 255,
              "obc": 777,
              "sc": 568,
              "st": 324
            },
            "2021": {
              "general": 1410,
              "ews": 250,
              "obc": 761,
              "sc": 556,
              "st": 317
            },
            "2020": {
              "general": 1380,
              "ews": 244,
              "obc": 745,
              "sc": 544,
              "st": 310
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3504,
              "ews": 634,
              "obc": 1763,
              "sc": 992,
              "st": 515
            },
            "2023": {
              "general": 3433,
              "ews": 621,
              "obc": 1727,
              "sc": 972,
              "st": 504
            },
            "2022": {
              "general": 3363,
              "ews": 608,
              "obc": 1692,
              "sc": 952,
              "st": 494
            },
            "2021": {
              "general": 3293,
              "ews": 595,
              "obc": 1657,
              "sc": 932,
              "st": 484
            },
            "2020": {
              "general": 3223,
              "ews": 583,
              "obc": 1621,
              "sc": 912,
              "st": 473
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 6815,
              "ews": 1290,
              "obc": 3301,
              "sc": 2001,
              "st": 958
            },
            "2023": {
              "general": 6678,
              "ews": 1264,
              "obc": 3234,
              "sc": 1960,
              "st": 938
            },
            "2022": {
              "general": 6542,
              "ews": 1238,
              "obc": 3168,
              "sc": 1920,
              "st": 919
            },
            "2021": {
              "general": 6406,
              "ews": 1212,
              "obc": 3102,
              "sc": 1880,
              "st": 900
            },
            "2020": {
              "general": 6269,
              "ews": 1186,
              "obc": 3036,
              "sc": 1840,
              "st": 881
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Physics",
        "code": "P",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 8245,
              "ews": 1619,
              "obc": 3831,
              "sc": 2217,
              "st": 1426
            },
            "2023": {
              "general": 8080,
              "ews": 1586,
              "obc": 3754,
              "sc": 2172,
              "st": 1397
            },
            "2022": {
              "general": 7915,
              "ews": 1554,
              "obc": 3677,
              "sc": 2128,
              "st": 1368
            },
            "2021": {
              "general": 7750,
              "ews": 1521,
              "obc": 3601,
              "sc": 2083,
              "st": 1340
            },
            "2020": {
              "general": 7585,
              "ews": 1489,
              "obc": 3524,
              "sc": 2039,
              "st": 1311
            }
          }
        },
        "fees": 200000,
        "seats": 83
      },
      {
        "name": "Production and Industrial Engineering",
        "code": "PIE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5166,
              "ews": 1048,
              "obc": 2867,
              "sc": 1728,
              "st": 904
            },
            "2023": {
              "general": 5062,
              "ews": 1027,
              "obc": 2809,
              "sc": 1693,
              "st": 885
            },
            "2022": {
              "general": 4959,
              "ews": 1006,
              "obc": 2752,
              "sc": 1658,
              "st": 867
            },
            "2021": {
              "general": 4856,
              "ews": 985,
              "obc": 2694,
              "sc": 1624,
              "st": 849
            },
            "2020": {
              "general": 4752,
              "ews": 964,
              "obc": 2637,
              "sc": 1589,
              "st": 831
            }
          }
        },
        "fees": 200000,
        "seats": 83
      }
    ]
  },
  {
    "id": 64,
    "name": "Indian Institute of Technology Ropar",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Artificial Intelligence and Data Engineering",
        "code": "AIDE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2576,
              "ews": 528,
              "obc": 1237,
              "sc": 781,
              "st": 449
            },
            "2023": {
              "general": 2524,
              "ews": 517,
              "obc": 1212,
              "sc": 765,
              "st": 440
            },
            "2022": {
              "general": 2472,
              "ews": 506,
              "obc": 1187,
              "sc": 749,
              "st": 431
            },
            "2021": {
              "general": 2421,
              "ews": 496,
              "obc": 1162,
              "sc": 734,
              "st": 422
            },
            "2020": {
              "general": 2369,
              "ews": 485,
              "obc": 1138,
              "sc": 718,
              "st": 413
            }
          }
        },
        "fees": 200000,
        "seats": 84
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 9615,
              "ews": 1631,
              "obc": 3952,
              "sc": 2227,
              "st": 1146
            },
            "2023": {
              "general": 9422,
              "ews": 1598,
              "obc": 3872,
              "sc": 2182,
              "st": 1123
            },
            "2022": {
              "general": 9230,
              "ews": 1565,
              "obc": 3793,
              "sc": 2137,
              "st": 1100
            },
            "2021": {
              "general": 9038,
              "ews": 1533,
              "obc": 3714,
              "sc": 2093,
              "st": 1077
            },
            "2020": {
              "general": 8845,
              "ews": 1500,
              "obc": 3635,
              "sc": 2048,
              "st": 1054
            }
          }
        },
        "fees": 200000,
        "seats": 84
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 10771,
              "ews": 1902,
              "obc": 4369,
              "sc": 2368,
              "st": 744
            },
            "2023": {
              "general": 10555,
              "ews": 1863,
              "obc": 4281,
              "sc": 2320,
              "st": 729
            },
            "2022": {
              "general": 10340,
              "ews": 1825,
              "obc": 4194,
              "sc": 2273,
              "st": 714
            },
            "2021": {
              "general": 10124,
              "ews": 1787,
              "obc": 4106,
              "sc": 2225,
              "st": 699
            },
            "2020": {
              "general": 9909,
              "ews": 1749,
              "obc": 4019,
              "sc": 2178,
              "st": 684
            }
          }
        },
        "fees": 200000,
        "seats": 84
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 2262,
              "ews": 285,
              "obc": 1061,
              "sc": 548,
              "st": 419
            },
            "2023": {
              "general": 2216,
              "ews": 279,
              "obc": 1039,
              "sc": 537,
              "st": 410
            },
            "2022": {
              "general": 2171,
              "ews": 273,
              "obc": 1018,
              "sc": 526,
              "st": 402
            },
            "2021": {
              "general": 2126,
              "ews": 267,
              "obc": 997,
              "sc": 515,
              "st": 393
            },
            "2020": {
              "general": 2081,
              "ews": 262,
              "obc": 976,
              "sc": 504,
              "st": 385
            }
          }
        },
        "fees": 200000,
        "seats": 84
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 5249,
              "ews": 860,
              "obc": 2590,
              "sc": 1593,
              "st": 764
            },
            "2023": {
              "general": 5144,
              "ews": 842,
              "obc": 2538,
              "sc": 1561,
              "st": 748
            },
            "2022": {
              "general": 5039,
              "ews": 825,
              "obc": 2486,
              "sc": 1529,
              "st": 733
            },
            "2021": {
              "general": 4934,
              "ews": 808,
              "obc": 2434,
              "sc": 1497,
              "st": 718
            },
            "2020": {
              "general": 4829,
              "ews": 791,
              "obc": 2382,
              "sc": 1465,
              "st": 702
            }
          }
        },
        "fees": 200000,
        "seats": 84
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 8826,
              "ews": 1790,
              "obc": 4156,
              "sc": 2573,
              "st": 1391
            },
            "2023": {
              "general": 8649,
              "ews": 1754,
              "obc": 4072,
              "sc": 2521,
              "st": 1363
            },
            "2022": {
              "general": 8472,
              "ews": 1718,
              "obc": 3989,
              "sc": 2470,
              "st": 1335
            },
            "2021": {
              "general": 8296,
              "ews": 1682,
              "obc": 3906,
              "sc": 2418,
              "st": 1307
            },
            "2020": {
              "general": 8119,
              "ews": 1646,
              "obc": 3823,
              "sc": 2367,
              "st": 1279
            }
          }
        },
        "fees": 200000,
        "seats": 84
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 3378,
              "ews": 552,
              "obc": 1674,
              "sc": 930,
              "st": 620
            },
            "2023": {
              "general": 3310,
              "ews": 540,
              "obc": 1640,
              "sc": 911,
              "st": 607
            },
            "2022": {
              "general": 3242,
              "ews": 529,
              "obc": 1607,
              "sc": 892,
              "st": 595
            },
            "2021": {
              "general": 3175,
              "ews": 518,
              "obc": 1573,
              "sc": 874,
              "st": 582
            },
            "2020": {
              "general": 3107,
              "ews": 507,
              "obc": 1540,
              "sc": 855,
              "st": 570
            }
          }
        },
        "fees": 200000,
        "seats": 84
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 8005,
              "ews": 1426,
              "obc": 3734,
              "sc": 2125,
              "st": 889
            },
            "2023": {
              "general": 7844,
              "ews": 1397,
              "obc": 3659,
              "sc": 2082,
              "st": 871
            },
            "2022": {
              "general": 7684,
              "ews": 1368,
              "obc": 3584,
              "sc": 2040,
              "st": 853
            },
            "2021": {
              "general": 7524,
              "ews": 1340,
              "obc": 3509,
              "sc": 1997,
              "st": 835
            },
            "2020": {
              "general": 7364,
              "ews": 1311,
              "obc": 3435,
              "sc": 1955,
              "st": 817
            }
          }
        },
        "fees": 200000,
        "seats": 84
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 11377,
              "ews": 2191,
              "obc": 4968,
              "sc": 2662,
              "st": 1300
            },
            "2023": {
              "general": 11149,
              "ews": 2147,
              "obc": 4868,
              "sc": 2608,
              "st": 1274
            },
            "2022": {
              "general": 10921,
              "ews": 2103,
              "obc": 4769,
              "sc": 2555,
              "st": 1248
            },
            "2021": {
              "general": 10694,
              "ews": 2059,
              "obc": 4669,
              "sc": 2502,
              "st": 1222
            },
            "2020": {
              "general": 10466,
              "ews": 2015,
              "obc": 4570,
              "sc": 2449,
              "st": 1196
            }
          }
        },
        "fees": 200000,
        "seats": 84
      }
    ]
  },
  {
    "id": 65,
    "name": "Indian Institute of Technology Tirupati",
    "type": "IIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 12791,
              "ews": 1953,
              "obc": 5177,
              "sc": 2694,
              "st": 1263
            },
            "2023": {
              "general": 12535,
              "ews": 1913,
              "obc": 5073,
              "sc": 2640,
              "st": 1237
            },
            "2022": {
              "general": 12279,
              "ews": 1874,
              "obc": 4969,
              "sc": 2586,
              "st": 1212
            },
            "2021": {
              "general": 12023,
              "ews": 1835,
              "obc": 4866,
              "sc": 2532,
              "st": 1187
            },
            "2020": {
              "general": 11767,
              "ews": 1796,
              "obc": 4762,
              "sc": 2478,
              "st": 1161
            }
          }
        },
        "fees": 200000,
        "seats": 85
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 14312,
              "ews": 2201,
              "obc": 5303,
              "sc": 2620,
              "st": 994
            },
            "2023": {
              "general": 14025,
              "ews": 2156,
              "obc": 5196,
              "sc": 2567,
              "st": 974
            },
            "2022": {
              "general": 13739,
              "ews": 2112,
              "obc": 5090,
              "sc": 2515,
              "st": 954
            },
            "2021": {
              "general": 13453,
              "ews": 2068,
              "obc": 4984,
              "sc": 2462,
              "st": 934
            },
            "2020": {
              "general": 13167,
              "ews": 2024,
              "obc": 4878,
              "sc": 2410,
              "st": 914
            }
          }
        },
        "fees": 200000,
        "seats": 85
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 4522,
              "ews": 672,
              "obc": 1644,
              "sc": 1057,
              "st": 492
            },
            "2023": {
              "general": 4431,
              "ews": 658,
              "obc": 1611,
              "sc": 1035,
              "st": 482
            },
            "2022": {
              "general": 4341,
              "ews": 645,
              "obc": 1578,
              "sc": 1014,
              "st": 472
            },
            "2021": {
              "general": 4250,
              "ews": 631,
              "obc": 1545,
              "sc": 993,
              "st": 462
            },
            "2020": {
              "general": 4160,
              "ews": 618,
              "obc": 1512,
              "sc": 972,
              "st": 452
            }
          }
        },
        "fees": 200000,
        "seats": 85
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 7787,
              "ews": 1291,
              "obc": 3389,
              "sc": 1848,
              "st": 951
            },
            "2023": {
              "general": 7631,
              "ews": 1265,
              "obc": 3321,
              "sc": 1811,
              "st": 931
            },
            "2022": {
              "general": 7475,
              "ews": 1239,
              "obc": 3253,
              "sc": 1774,
              "st": 912
            },
            "2021": {
              "general": 7319,
              "ews": 1213,
              "obc": 3185,
              "sc": 1737,
              "st": 893
            },
            "2020": {
              "general": 7164,
              "ews": 1187,
              "obc": 3117,
              "sc": 1700,
              "st": 874
            }
          }
        },
        "fees": 200000,
        "seats": 85
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 11453,
              "ews": 1978,
              "obc": 4808,
              "sc": 3026,
              "st": 1190
            },
            "2023": {
              "general": 11223,
              "ews": 1938,
              "obc": 4711,
              "sc": 2965,
              "st": 1166
            },
            "2022": {
              "general": 10994,
              "ews": 1898,
              "obc": 4615,
              "sc": 2904,
              "st": 1142
            },
            "2021": {
              "general": 10765,
              "ews": 1859,
              "obc": 4519,
              "sc": 2844,
              "st": 1118
            },
            "2020": {
              "general": 10536,
              "ews": 1819,
              "obc": 4423,
              "sc": 2783,
              "st": 1094
            }
          }
        },
        "fees": 200000,
        "seats": 85
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeAdvanced": {
            "2024": {
              "general": 10530,
              "ews": 1677,
              "obc": 4232,
              "sc": 2543,
              "st": 1117
            },
            "2023": {
              "general": 10319,
              "ews": 1643,
              "obc": 4147,
              "sc": 2492,
              "st": 1094
            },
            "2022": {
              "general": 10108,
              "ews": 1609,
              "obc": 4062,
              "sc": 2441,
              "st": 1072
            },
            "2021": {
              "general": 9898,
              "ews": 1576,
              "obc": 3978,
              "sc": 2390,
              "st": 1049
            },
            "2020": {
              "general": 9687,
              "ews": 1542,
              "obc": 3893,
              "sc": 2339,
              "st": 1027
            }
          }
        },
        "fees": 200000,
        "seats": 85
      }
    ]
  },
  {
    "id": 66,
    "name": "Indian institute of information technology, Raichur, Karnataka",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Artificial Intelligence and Data Science",
        "code": "AIDS",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 35446,
              "ews": 6439,
              "obc": 15093,
              "sc": 9254,
              "st": 3896
            },
            "2023": {
              "general": 34737,
              "ews": 6310,
              "obc": 14791,
              "sc": 9068,
              "st": 3818
            },
            "2022": {
              "general": 34028,
              "ews": 6181,
              "obc": 14489,
              "sc": 8883,
              "st": 3740
            },
            "2021": {
              "general": 33319,
              "ews": 6052,
              "obc": 14187,
              "sc": 8698,
              "st": 3662
            },
            "2020": {
              "general": 32610,
              "ews": 5923,
              "obc": 13885,
              "sc": 8513,
              "st": 3584
            }
          }
        },
        "fees": 150000,
        "seats": 86
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 32785,
              "ews": 5474,
              "obc": 13784,
              "sc": 8933,
              "st": 3655
            },
            "2023": {
              "general": 32129,
              "ews": 5364,
              "obc": 13508,
              "sc": 8754,
              "st": 3581
            },
            "2022": {
              "general": 31473,
              "ews": 5255,
              "obc": 13232,
              "sc": 8575,
              "st": 3508
            },
            "2021": {
              "general": 30817,
              "ews": 5145,
              "obc": 12956,
              "sc": 8397,
              "st": 3435
            },
            "2020": {
              "general": 30162,
              "ews": 5036,
              "obc": 12681,
              "sc": 8218,
              "st": 3362
            }
          }
        },
        "fees": 150000,
        "seats": 86
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 37248,
              "ews": 6747,
              "obc": 15834,
              "sc": 10055,
              "st": 3904
            },
            "2023": {
              "general": 36503,
              "ews": 6612,
              "obc": 15517,
              "sc": 9853,
              "st": 3825
            },
            "2022": {
              "general": 35758,
              "ews": 6477,
              "obc": 15200,
              "sc": 9652,
              "st": 3747
            },
            "2021": {
              "general": 35013,
              "ews": 6342,
              "obc": 14883,
              "sc": 9451,
              "st": 3669
            },
            "2020": {
              "general": 34268,
              "ews": 6207,
              "obc": 14567,
              "sc": 9250,
              "st": 3591
            }
          }
        },
        "fees": 150000,
        "seats": 86
      }
    ]
  },
  {
    "id": 67,
    "name": "Institute of Chemical Technology, Mumbai: Indian Oil Odisha Campus, Bhubaneswar",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 73668,
              "ews": 20688,
              "obc": 37676,
              "sc": 16608,
              "st": 9482
            },
            "2023": {
              "general": 72194,
              "ews": 20274,
              "obc": 36922,
              "sc": 16275,
              "st": 9292
            },
            "2022": {
              "general": 70721,
              "ews": 19860,
              "obc": 36168,
              "sc": 15943,
              "st": 9102
            },
            "2021": {
              "general": 69247,
              "ews": 19446,
              "obc": 35415,
              "sc": 15611,
              "st": 8913
            },
            "2020": {
              "general": 67774,
              "ews": 19032,
              "obc": 34661,
              "sc": 15279,
              "st": 8723
            }
          }
        },
        "fees": 150000,
        "seats": 87
      }
    ]
  },
  {
    "id": 68,
    "name": "Institute of Engineering and Technology, Dr. H. S. Gour University. Sagar (A Central University)",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Aeronautical Engineering",
        "code": "AE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 72584,
              "ews": 13607,
              "obc": 27757,
              "sc": 9978,
              "st": 5909
            },
            "2023": {
              "general": 71132,
              "ews": 13334,
              "obc": 27201,
              "sc": 9778,
              "st": 5790
            },
            "2022": {
              "general": 69680,
              "ews": 13062,
              "obc": 26646,
              "sc": 9578,
              "st": 5672
            },
            "2021": {
              "general": 68228,
              "ews": 12790,
              "obc": 26091,
              "sc": 9379,
              "st": 5554
            },
            "2020": {
              "general": 66777,
              "ews": 12518,
              "obc": 25536,
              "sc": 9179,
              "st": 5436
            }
          }
        },
        "fees": 150000,
        "seats": 88
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 61897,
              "ews": 10932,
              "obc": 21271,
              "sc": 12076,
              "st": 6089
            },
            "2023": {
              "general": 60659,
              "ews": 10713,
              "obc": 20845,
              "sc": 11834,
              "st": 5967
            },
            "2022": {
              "general": 59421,
              "ews": 10494,
              "obc": 20420,
              "sc": 11592,
              "st": 5845
            },
            "2021": {
              "general": 58183,
              "ews": 10276,
              "obc": 19994,
              "sc": 11351,
              "st": 5723
            },
            "2020": {
              "general": 56945,
              "ews": 10057,
              "obc": 19569,
              "sc": 11109,
              "st": 5601
            }
          }
        },
        "fees": 150000,
        "seats": 88
      },
      {
        "name": "Dairy Engineering",
        "code": "DE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 105594,
              "ews": 17722,
              "obc": 36770,
              "sc": 16211,
              "st": 7901
            },
            "2023": {
              "general": 103482,
              "ews": 17367,
              "obc": 36034,
              "sc": 15886,
              "st": 7742
            },
            "2022": {
              "general": 101370,
              "ews": 17013,
              "obc": 35299,
              "sc": 15562,
              "st": 7584
            },
            "2021": {
              "general": 99258,
              "ews": 16658,
              "obc": 34563,
              "sc": 15238,
              "st": 7426
            },
            "2020": {
              "general": 97146,
              "ews": 16304,
              "obc": 33828,
              "sc": 14914,
              "st": 7268
            }
          }
        },
        "fees": 150000,
        "seats": 88
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 76758,
              "ews": 13620,
              "obc": 28255,
              "sc": 14277,
              "st": 7150
            },
            "2023": {
              "general": 75222,
              "ews": 13347,
              "obc": 27689,
              "sc": 13991,
              "st": 7007
            },
            "2022": {
              "general": 73687,
              "ews": 13075,
              "obc": 27124,
              "sc": 13705,
              "st": 6864
            },
            "2021": {
              "general": 72152,
              "ews": 12802,
              "obc": 26559,
              "sc": 13420,
              "st": 6721
            },
            "2020": {
              "general": 70617,
              "ews": 12530,
              "obc": 25994,
              "sc": 13134,
              "st": 6578
            }
          }
        },
        "fees": 150000,
        "seats": 88
      },
      {
        "name": "Fashion and Apparel Engineering",
        "code": "FAE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 102910,
              "ews": 17662,
              "obc": 36243,
              "sc": 16157,
              "st": 7781
            },
            "2023": {
              "general": 100851,
              "ews": 17308,
              "obc": 35518,
              "sc": 15833,
              "st": 7625
            },
            "2022": {
              "general": 98793,
              "ews": 16955,
              "obc": 34793,
              "sc": 15510,
              "st": 7469
            },
            "2021": {
              "general": 96735,
              "ews": 16602,
              "obc": 34068,
              "sc": 15187,
              "st": 7314
            },
            "2020": {
              "general": 94677,
              "ews": 16249,
              "obc": 33343,
              "sc": 14864,
              "st": 7158
            }
          }
        },
        "fees": 150000,
        "seats": 88
      },
      {
        "name": "Food Engineering and Technology",
        "code": "FET",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 106182,
              "ews": 17891,
              "obc": 37278,
              "sc": 16490,
              "st": 8029
            },
            "2023": {
              "general": 104058,
              "ews": 17533,
              "obc": 36532,
              "sc": 16160,
              "st": 7868
            },
            "2022": {
              "general": 101934,
              "ews": 17175,
              "obc": 35786,
              "sc": 15830,
              "st": 7707
            },
            "2021": {
              "general": 99811,
              "ews": 16817,
              "obc": 35041,
              "sc": 15500,
              "st": 7547
            },
            "2020": {
              "general": 97687,
              "ews": 16459,
              "obc": 34295,
              "sc": 15170,
              "st": 7386
            }
          }
        },
        "fees": 150000,
        "seats": 88
      }
    ]
  },
  {
    "id": 69,
    "name": "Institute of Infrastructure, Technology, Research and Management-Ahmedabad",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 68404,
              "ews": 11435,
              "obc": 23283,
              "sc": 12628,
              "st": 4607
            },
            "2023": {
              "general": 67035,
              "ews": 11206,
              "obc": 22817,
              "sc": 12375,
              "st": 4514
            },
            "2022": {
              "general": 65667,
              "ews": 10977,
              "obc": 22351,
              "sc": 12122,
              "st": 4422
            },
            "2021": {
              "general": 64299,
              "ews": 10748,
              "obc": 21886,
              "sc": 11870,
              "st": 4330
            },
            "2020": {
              "general": 62931,
              "ews": 10520,
              "obc": 21420,
              "sc": 11617,
              "st": 4238
            }
          }
        },
        "fees": 150000,
        "seats": 89
      },
      {
        "name": "Computer Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 37263,
              "ews": 7067,
              "obc": 17649,
              "sc": 9797,
              "st": 4045
            },
            "2023": {
              "general": 36517,
              "ews": 6925,
              "obc": 17296,
              "sc": 9601,
              "st": 3964
            },
            "2022": {
              "general": 35772,
              "ews": 6784,
              "obc": 16943,
              "sc": 9405,
              "st": 3883
            },
            "2021": {
              "general": 35027,
              "ews": 6642,
              "obc": 16590,
              "sc": 9209,
              "st": 3802
            },
            "2020": {
              "general": 34281,
              "ews": 6501,
              "obc": 16237,
              "sc": 9013,
              "st": 3721
            }
          }
        },
        "fees": 150000,
        "seats": 89
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 52227,
              "ews": 9168,
              "obc": 20916,
              "sc": 11513,
              "st": 5672
            },
            "2023": {
              "general": 51182,
              "ews": 8984,
              "obc": 20497,
              "sc": 11282,
              "st": 5558
            },
            "2022": {
              "general": 50137,
              "ews": 8801,
              "obc": 20079,
              "sc": 11052,
              "st": 5445
            },
            "2021": {
              "general": 49093,
              "ews": 8617,
              "obc": 19661,
              "sc": 10822,
              "st": 5331
            },
            "2020": {
              "general": 48048,
              "ews": 8434,
              "obc": 19242,
              "sc": 10591,
              "st": 5218
            }
          }
        },
        "fees": 150000,
        "seats": 89
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 59138,
              "ews": 10547,
              "obc": 22293,
              "sc": 11948,
              "st": 5847
            },
            "2023": {
              "general": 57955,
              "ews": 10336,
              "obc": 21847,
              "sc": 11709,
              "st": 5730
            },
            "2022": {
              "general": 56772,
              "ews": 10125,
              "obc": 21401,
              "sc": 11470,
              "st": 5613
            },
            "2021": {
              "general": 55589,
              "ews": 9914,
              "obc": 20955,
              "sc": 11231,
              "st": 5496
            },
            "2020": {
              "general": 54406,
              "ews": 9703,
              "obc": 20509,
              "sc": 10992,
              "st": 5379
            }
          }
        },
        "fees": 150000,
        "seats": 89
      }
    ]
  },
  {
    "id": 70,
    "name": "International Institute of Information Technology, Bhubaneswar",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 32284,
              "ews": 5672,
              "obc": 14805,
              "sc": 8843,
              "st": 3820
            },
            "2023": {
              "general": 31638,
              "ews": 5558,
              "obc": 14508,
              "sc": 8666,
              "st": 3743
            },
            "2022": {
              "general": 30992,
              "ews": 5445,
              "obc": 14212,
              "sc": 8489,
              "st": 3667
            },
            "2021": {
              "general": 30346,
              "ews": 5331,
              "obc": 13916,
              "sc": 8312,
              "st": 3590
            },
            "2020": {
              "general": 29701,
              "ews": 5218,
              "obc": 13620,
              "sc": 8135,
              "st": 3514
            }
          }
        },
        "fees": 150000,
        "seats": 90
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 28720,
              "ews": 5226,
              "obc": 13051,
              "sc": 7615,
              "st": 3504
            },
            "2023": {
              "general": 28145,
              "ews": 5121,
              "obc": 12789,
              "sc": 7462,
              "st": 3433
            },
            "2022": {
              "general": 27571,
              "ews": 5016,
              "obc": 12528,
              "sc": 7310,
              "st": 3363
            },
            "2021": {
              "general": 26996,
              "ews": 4912,
              "obc": 12267,
              "sc": 7158,
              "st": 3293
            },
            "2020": {
              "general": 26422,
              "ews": 4807,
              "obc": 12006,
              "sc": 7005,
              "st": 3223
            }
          }
        },
        "fees": 150000,
        "seats": 90
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 39592,
              "ews": 6861,
              "obc": 16710,
              "sc": 9998,
              "st": 4791
            },
            "2023": {
              "general": 38800,
              "ews": 6723,
              "obc": 16375,
              "sc": 9798,
              "st": 4695
            },
            "2022": {
              "general": 38008,
              "ews": 6586,
              "obc": 16041,
              "sc": 9598,
              "st": 4599
            },
            "2021": {
              "general": 37216,
              "ews": 6449,
              "obc": 15707,
              "sc": 9398,
              "st": 4503
            },
            "2020": {
              "general": 36424,
              "ews": 6312,
              "obc": 15373,
              "sc": 9198,
              "st": 4407
            }
          }
        },
        "fees": 150000,
        "seats": 90
      },
      {
        "name": "Electronics and Telecommunication Engineering",
        "code": "ETE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 38048,
              "ews": 6772,
              "obc": 16085,
              "sc": 9255,
              "st": 4587
            },
            "2023": {
              "general": 37287,
              "ews": 6636,
              "obc": 15763,
              "sc": 9069,
              "st": 4495
            },
            "2022": {
              "general": 36526,
              "ews": 6501,
              "obc": 15441,
              "sc": 8884,
              "st": 4403
            },
            "2021": {
              "general": 35765,
              "ews": 6365,
              "obc": 15119,
              "sc": 8699,
              "st": 4311
            },
            "2020": {
              "general": 35004,
              "ews": 6230,
              "obc": 14798,
              "sc": 8514,
              "st": 4220
            }
          }
        },
        "fees": 150000,
        "seats": 90
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 32651,
              "ews": 5783,
              "obc": 14473,
              "sc": 8719,
              "st": 4399
            },
            "2023": {
              "general": 31997,
              "ews": 5667,
              "obc": 14183,
              "sc": 8544,
              "st": 4311
            },
            "2022": {
              "general": 31344,
              "ews": 5551,
              "obc": 13894,
              "sc": 8370,
              "st": 4223
            },
            "2021": {
              "general": 30691,
              "ews": 5436,
              "obc": 13604,
              "sc": 8195,
              "st": 4135
            },
            "2020": {
              "general": 30038,
              "ews": 5320,
              "obc": 13315,
              "sc": 8021,
              "st": 4047
            }
          }
        },
        "fees": 150000,
        "seats": 90
      }
    ]
  },
  {
    "id": 71,
    "name": "International Institute of Information Technology, Naya Raipur",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 17755,
              "ews": 3394,
              "obc": 8125,
              "sc": 5728,
              "st": 2821
            },
            "2023": {
              "general": 17399,
              "ews": 3326,
              "obc": 7962,
              "sc": 5613,
              "st": 2764
            },
            "2022": {
              "general": 17044,
              "ews": 3258,
              "obc": 7800,
              "sc": 5498,
              "st": 2708
            },
            "2021": {
              "general": 16689,
              "ews": 3190,
              "obc": 7637,
              "sc": 5384,
              "st": 2651
            },
            "2020": {
              "general": 16334,
              "ews": 3122,
              "obc": 7475,
              "sc": 5269,
              "st": 2595
            }
          }
        },
        "fees": 150000,
        "seats": 91
      },
      {
        "name": "Data Science and Artificial Intelligence",
        "code": "DSAI",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 21044,
              "ews": 3700,
              "obc": 9569,
              "sc": 6158,
              "st": 3578
            },
            "2023": {
              "general": 20623,
              "ews": 3626,
              "obc": 9377,
              "sc": 6034,
              "st": 3506
            },
            "2022": {
              "general": 20202,
              "ews": 3552,
              "obc": 9186,
              "sc": 5911,
              "st": 3434
            },
            "2021": {
              "general": 19781,
              "ews": 3478,
              "obc": 8994,
              "sc": 5788,
              "st": 3363
            },
            "2020": {
              "general": 19360,
              "ews": 3404,
              "obc": 8803,
              "sc": 5665,
              "st": 3291
            }
          }
        },
        "fees": 150000,
        "seats": 91
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 30426,
              "ews": 5621,
              "obc": 12608,
              "sc": 9266,
              "st": 4239
            },
            "2023": {
              "general": 29817,
              "ews": 5508,
              "obc": 12355,
              "sc": 9080,
              "st": 4154
            },
            "2022": {
              "general": 29208,
              "ews": 5396,
              "obc": 12103,
              "sc": 8895,
              "st": 4069
            },
            "2021": {
              "general": 28600,
              "ews": 5283,
              "obc": 11851,
              "sc": 8710,
              "st": 3984
            },
            "2020": {
              "general": 27991,
              "ews": 5171,
              "obc": 11599,
              "sc": 8524,
              "st": 3899
            }
          }
        },
        "fees": 150000,
        "seats": 91
      }
    ]
  },
  {
    "id": 72,
    "name": "J.K. Institute of Applied Physics & Technology, Department of Electronics & Communication, University of Allahabad- Allahabad",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering with Major in Artificial Intelligence",
        "code": "CSEMA",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 41723,
              "ews": 7660,
              "obc": 18052,
              "sc": 7699,
              "st": 5022
            },
            "2023": {
              "general": 40888,
              "ews": 7506,
              "obc": 17690,
              "sc": 7545,
              "st": 4921
            },
            "2022": {
              "general": 40054,
              "ews": 7353,
              "obc": 17329,
              "sc": 7391,
              "st": 4821
            },
            "2021": {
              "general": 39219,
              "ews": 7200,
              "obc": 16968,
              "sc": 7237,
              "st": 4720
            },
            "2020": {
              "general": 38385,
              "ews": 7047,
              "obc": 16607,
              "sc": 7083,
              "st": 4620
            }
          }
        },
        "fees": 150000,
        "seats": 92
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 54768,
              "ews": 9471,
              "obc": 21338,
              "sc": 10572,
              "st": 5357
            },
            "2023": {
              "general": 53672,
              "ews": 9281,
              "obc": 20911,
              "sc": 10360,
              "st": 5249
            },
            "2022": {
              "general": 52577,
              "ews": 9092,
              "obc": 20484,
              "sc": 10149,
              "st": 5142
            },
            "2021": {
              "general": 51481,
              "ews": 8902,
              "obc": 20057,
              "sc": 9937,
              "st": 5035
            },
            "2020": {
              "general": 50386,
              "ews": 8713,
              "obc": 19630,
              "sc": 9726,
              "st": 4928
            }
          }
        },
        "fees": 150000,
        "seats": 92
      }
    ]
  },
  {
    "id": 73,
    "name": "Jawaharlal Nehru University, Delhi",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 26174,
              "ews": 5377,
              "obc": 11131,
              "sc": 5053,
              "st": 2863
            },
            "2023": {
              "general": 25650,
              "ews": 5269,
              "obc": 10908,
              "sc": 4951,
              "st": 2805
            },
            "2022": {
              "general": 25127,
              "ews": 5161,
              "obc": 10685,
              "sc": 4850,
              "st": 2748
            },
            "2021": {
              "general": 24603,
              "ews": 5054,
              "obc": 10463,
              "sc": 4749,
              "st": 2691
            },
            "2020": {
              "general": 24080,
              "ews": 4946,
              "obc": 10240,
              "sc": 4648,
              "st": 2633
            }
          }
        },
        "fees": 150000,
        "seats": 93
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 34649,
              "ews": 6581,
              "obc": 14240,
              "sc": 7300,
              "st": 3349
            },
            "2023": {
              "general": 33956,
              "ews": 6449,
              "obc": 13955,
              "sc": 7154,
              "st": 3282
            },
            "2022": {
              "general": 33263,
              "ews": 6317,
              "obc": 13670,
              "sc": 7008,
              "st": 3215
            },
            "2021": {
              "general": 32570,
              "ews": 6186,
              "obc": 13385,
              "sc": 6862,
              "st": 3148
            },
            "2020": {
              "general": 31877,
              "ews": 6054,
              "obc": 13100,
              "sc": 6716,
              "st": 3081
            }
          }
        },
        "fees": 150000,
        "seats": 93
      }
    ]
  },
  {
    "id": 74,
    "name": "Malaviya National Institute of Technology Jaipur",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 886,
              "ews": 417,
              "obc": 651,
              "sc": 321,
              "st": 192
            },
            "2023": {
              "general": 868,
              "ews": 408,
              "obc": 637,
              "sc": 314,
              "st": 188
            },
            "2022": {
              "general": 850,
              "ews": 400,
              "obc": 624,
              "sc": 308,
              "st": 184
            },
            "2021": {
              "general": 832,
              "ews": 391,
              "obc": 611,
              "sc": 301,
              "st": 180
            },
            "2020": {
              "general": 815,
              "ews": 383,
              "obc": 598,
              "sc": 295,
              "st": 176
            }
          }
        },
        "fees": 150000,
        "seats": 94
      },
      {
        "name": "Artificial Intelligence and Data Engineering",
        "code": "AIDE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 5251,
              "ews": 937,
              "obc": 1951,
              "sc": 1349,
              "st": 521
            },
            "2023": {
              "general": 5145,
              "ews": 918,
              "obc": 1911,
              "sc": 1322,
              "st": 510
            },
            "2022": {
              "general": 5040,
              "ews": 899,
              "obc": 1872,
              "sc": 1295,
              "st": 500
            },
            "2021": {
              "general": 4935,
              "ews": 880,
              "obc": 1833,
              "sc": 1268,
              "st": 489
            },
            "2020": {
              "general": 4830,
              "ews": 862,
              "obc": 1794,
              "sc": 1241,
              "st": 479
            }
          }
        },
        "fees": 150000,
        "seats": 94
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 23541,
              "ews": 4256,
              "obc": 9083,
              "sc": 5176,
              "st": 2399
            },
            "2023": {
              "general": 23070,
              "ews": 4170,
              "obc": 8901,
              "sc": 5072,
              "st": 2351
            },
            "2022": {
              "general": 22599,
              "ews": 4085,
              "obc": 8719,
              "sc": 4968,
              "st": 2303
            },
            "2021": {
              "general": 22128,
              "ews": 4000,
              "obc": 8538,
              "sc": 4865,
              "st": 2255
            },
            "2020": {
              "general": 21657,
              "ews": 3915,
              "obc": 8356,
              "sc": 4761,
              "st": 2207
            }
          }
        },
        "fees": 150000,
        "seats": 94
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 30150,
              "ews": 5456,
              "obc": 11673,
              "sc": 5538,
              "st": 1480
            },
            "2023": {
              "general": 29547,
              "ews": 5346,
              "obc": 11439,
              "sc": 5427,
              "st": 1450
            },
            "2022": {
              "general": 28944,
              "ews": 5237,
              "obc": 11206,
              "sc": 5316,
              "st": 1420
            },
            "2021": {
              "general": 28341,
              "ews": 5128,
              "obc": 10972,
              "sc": 5205,
              "st": 1391
            },
            "2020": {
              "general": 27738,
              "ews": 5019,
              "obc": 10739,
              "sc": 5094,
              "st": 1361
            }
          }
        },
        "fees": 150000,
        "seats": 94
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 4535,
              "ews": 709,
              "obc": 1605,
              "sc": 1015,
              "st": 433
            },
            "2023": {
              "general": 4444,
              "ews": 694,
              "obc": 1572,
              "sc": 994,
              "st": 424
            },
            "2022": {
              "general": 4353,
              "ews": 680,
              "obc": 1540,
              "sc": 974,
              "st": 415
            },
            "2021": {
              "general": 4262,
              "ews": 666,
              "obc": 1508,
              "sc": 954,
              "st": 407
            },
            "2020": {
              "general": 4172,
              "ews": 652,
              "obc": 1476,
              "sc": 933,
              "st": 398
            }
          }
        },
        "fees": 150000,
        "seats": 94
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 12301,
              "ews": 2019,
              "obc": 5288,
              "sc": 2949,
              "st": 1125
            },
            "2023": {
              "general": 12054,
              "ews": 1978,
              "obc": 5182,
              "sc": 2890,
              "st": 1102
            },
            "2022": {
              "general": 11808,
              "ews": 1938,
              "obc": 5076,
              "sc": 2831,
              "st": 1080
            },
            "2021": {
              "general": 11562,
              "ews": 1897,
              "obc": 4970,
              "sc": 2772,
              "st": 1057
            },
            "2020": {
              "general": 11316,
              "ews": 1857,
              "obc": 4864,
              "sc": 2713,
              "st": 1035
            }
          }
        },
        "fees": 150000,
        "seats": 94
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 8340,
              "ews": 1514,
              "obc": 3710,
              "sc": 2297,
              "st": 925
            },
            "2023": {
              "general": 8173,
              "ews": 1483,
              "obc": 3635,
              "sc": 2251,
              "st": 906
            },
            "2022": {
              "general": 8006,
              "ews": 1453,
              "obc": 3561,
              "sc": 2205,
              "st": 888
            },
            "2021": {
              "general": 7839,
              "ews": 1423,
              "obc": 3487,
              "sc": 2159,
              "st": 869
            },
            "2020": {
              "general": 7672,
              "ews": 1392,
              "obc": 3413,
              "sc": 2113,
              "st": 851
            }
          }
        },
        "fees": 150000,
        "seats": 94
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 18486,
              "ews": 3248,
              "obc": 8001,
              "sc": 4726,
              "st": 1466
            },
            "2023": {
              "general": 18116,
              "ews": 3183,
              "obc": 7840,
              "sc": 4631,
              "st": 1436
            },
            "2022": {
              "general": 17746,
              "ews": 3118,
              "obc": 7680,
              "sc": 4536,
              "st": 1407
            },
            "2021": {
              "general": 17376,
              "ews": 3053,
              "obc": 7520,
              "sc": 4442,
              "st": 1378
            },
            "2020": {
              "general": 17007,
              "ews": 2988,
              "obc": 7360,
              "sc": 4347,
              "st": 1348
            }
          }
        },
        "fees": 150000,
        "seats": 94
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 35770,
              "ews": 6076,
              "obc": 13308,
              "sc": 6712,
              "st": 2607
            },
            "2023": {
              "general": 35054,
              "ews": 5954,
              "obc": 13041,
              "sc": 6577,
              "st": 2554
            },
            "2022": {
              "general": 34339,
              "ews": 5832,
              "obc": 12775,
              "sc": 6443,
              "st": 2502
            },
            "2021": {
              "general": 33623,
              "ews": 5711,
              "obc": 12509,
              "sc": 6309,
              "st": 2450
            },
            "2020": {
              "general": 32908,
              "ews": 5589,
              "obc": 12243,
              "sc": 6175,
              "st": 2398
            }
          }
        },
        "fees": 150000,
        "seats": 94
      }
    ]
  },
  {
    "id": 75,
    "name": "Maulana Azad National Institute of Technology Bhopal",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 1421,
              "ews": 616,
              "obc": 863,
              "sc": 414,
              "st": 208
            },
            "2023": {
              "general": 1392,
              "ews": 603,
              "obc": 845,
              "sc": 405,
              "st": 203
            },
            "2022": {
              "general": 1364,
              "ews": 591,
              "obc": 828,
              "sc": 397,
              "st": 199
            },
            "2021": {
              "general": 1335,
              "ews": 579,
              "obc": 811,
              "sc": 389,
              "st": 195
            },
            "2020": {
              "general": 1307,
              "ews": 566,
              "obc": 793,
              "sc": 380,
              "st": 191
            }
          }
        },
        "fees": 150000,
        "seats": 95
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 33024,
              "ews": 5432,
              "obc": 11773,
              "sc": 6564,
              "st": 2455
            },
            "2023": {
              "general": 32363,
              "ews": 5323,
              "obc": 11537,
              "sc": 6432,
              "st": 2405
            },
            "2022": {
              "general": 31703,
              "ews": 5214,
              "obc": 11302,
              "sc": 6301,
              "st": 2356
            },
            "2021": {
              "general": 31042,
              "ews": 5106,
              "obc": 11066,
              "sc": 6170,
              "st": 2307
            },
            "2020": {
              "general": 30382,
              "ews": 4997,
              "obc": 10831,
              "sc": 6038,
              "st": 2258
            }
          }
        },
        "fees": 150000,
        "seats": 95
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 37120,
              "ews": 6667,
              "obc": 13594,
              "sc": 6832,
              "st": 1693
            },
            "2023": {
              "general": 36377,
              "ews": 6533,
              "obc": 13322,
              "sc": 6695,
              "st": 1659
            },
            "2022": {
              "general": 35635,
              "ews": 6400,
              "obc": 13050,
              "sc": 6558,
              "st": 1625
            },
            "2021": {
              "general": 34892,
              "ews": 6266,
              "obc": 12778,
              "sc": 6422,
              "st": 1591
            },
            "2020": {
              "general": 34150,
              "ews": 6133,
              "obc": 12506,
              "sc": 6285,
              "st": 1557
            }
          }
        },
        "fees": 150000,
        "seats": 95
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 8372,
              "ews": 1310,
              "obc": 3320,
              "sc": 1993,
              "st": 738
            },
            "2023": {
              "general": 8204,
              "ews": 1283,
              "obc": 3253,
              "sc": 1953,
              "st": 723
            },
            "2022": {
              "general": 8037,
              "ews": 1257,
              "obc": 3187,
              "sc": 1913,
              "st": 708
            },
            "2021": {
              "general": 7869,
              "ews": 1231,
              "obc": 3120,
              "sc": 1873,
              "st": 693
            },
            "2020": {
              "general": 7702,
              "ews": 1205,
              "obc": 3054,
              "sc": 1833,
              "st": 678
            }
          }
        },
        "fees": 150000,
        "seats": 95
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 19104,
              "ews": 3286,
              "obc": 6823,
              "sc": 4425,
              "st": 1561
            },
            "2023": {
              "general": 18721,
              "ews": 3220,
              "obc": 6686,
              "sc": 4336,
              "st": 1529
            },
            "2022": {
              "general": 18339,
              "ews": 3154,
              "obc": 6550,
              "sc": 4248,
              "st": 1498
            },
            "2021": {
              "general": 17957,
              "ews": 3088,
              "obc": 6413,
              "sc": 4159,
              "st": 1467
            },
            "2020": {
              "general": 17575,
              "ews": 3023,
              "obc": 6277,
              "sc": 4071,
              "st": 1436
            }
          }
        },
        "fees": 150000,
        "seats": 95
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 14271,
              "ews": 2338,
              "obc": 5360,
              "sc": 3260,
              "st": 1293
            },
            "2023": {
              "general": 13985,
              "ews": 2291,
              "obc": 5252,
              "sc": 3194,
              "st": 1267
            },
            "2022": {
              "general": 13700,
              "ews": 2244,
              "obc": 5145,
              "sc": 3129,
              "st": 1241
            },
            "2021": {
              "general": 13414,
              "ews": 2197,
              "obc": 5038,
              "sc": 3064,
              "st": 1215
            },
            "2020": {
              "general": 13129,
              "ews": 2150,
              "obc": 4931,
              "sc": 2999,
              "st": 1189
            }
          }
        },
        "fees": 150000,
        "seats": 95
      },
      {
        "name": "Materials Science and Metallurgical Engineering",
        "code": "MSME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 42701,
              "ews": 7115,
              "obc": 14949,
              "sc": 7119,
              "st": 2966
            },
            "2023": {
              "general": 41846,
              "ews": 6972,
              "obc": 14650,
              "sc": 6976,
              "st": 2906
            },
            "2022": {
              "general": 40992,
              "ews": 6830,
              "obc": 14351,
              "sc": 6834,
              "st": 2847
            },
            "2021": {
              "general": 40138,
              "ews": 6688,
              "obc": 14052,
              "sc": 6691,
              "st": 2788
            },
            "2020": {
              "general": 39284,
              "ews": 6545,
              "obc": 13753,
              "sc": 6549,
              "st": 2728
            }
          }
        },
        "fees": 150000,
        "seats": 95
      },
      {
        "name": "Mathematics and Data Science",
        "code": "MDS",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 14070,
              "ews": 2268,
              "obc": 5314,
              "sc": 3655,
              "st": 1120
            },
            "2023": {
              "general": 13788,
              "ews": 2222,
              "obc": 5207,
              "sc": 3581,
              "st": 1097
            },
            "2022": {
              "general": 13507,
              "ews": 2177,
              "obc": 5101,
              "sc": 3508,
              "st": 1075
            },
            "2021": {
              "general": 13225,
              "ews": 2131,
              "obc": 4995,
              "sc": 3435,
              "st": 1052
            },
            "2020": {
              "general": 12944,
              "ews": 2086,
              "obc": 4888,
              "sc": 3362,
              "st": 1030
            }
          }
        },
        "fees": 150000,
        "seats": 95
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 27832,
              "ews": 4767,
              "obc": 10315,
              "sc": 5968,
              "st": 2147
            },
            "2023": {
              "general": 27275,
              "ews": 4671,
              "obc": 10108,
              "sc": 5848,
              "st": 2104
            },
            "2022": {
              "general": 26718,
              "ews": 4576,
              "obc": 9902,
              "sc": 5729,
              "st": 2061
            },
            "2021": {
              "general": 26162,
              "ews": 4480,
              "obc": 9696,
              "sc": 5609,
              "st": 2018
            },
            "2020": {
              "general": 25605,
              "ews": 4385,
              "obc": 9489,
              "sc": 5490,
              "st": 1975
            }
          }
        },
        "fees": 150000,
        "seats": 95
      },
      {
        "name": "Planning",
        "code": "P",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 763,
              "ews": 181,
              "obc": 378,
              "sc": 111,
              "st": 54
            },
            "2023": {
              "general": 747,
              "ews": 177,
              "obc": 370,
              "sc": 108,
              "st": 52
            },
            "2022": {
              "general": 732,
              "ews": 173,
              "obc": 362,
              "sc": 106,
              "st": 51
            },
            "2021": {
              "general": 717,
              "ews": 170,
              "obc": 355,
              "sc": 104,
              "st": 50
            },
            "2020": {
              "general": 701,
              "ews": 166,
              "obc": 347,
              "sc": 102,
              "st": 49
            }
          }
        },
        "fees": 150000,
        "seats": 95
      }
    ]
  },
  {
    "id": 76,
    "name": "Mizoram University, Aizawl",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 1858,
              "ews": 756,
              "sc": 453,
              "st": 241
            },
            "2023": {
              "general": 1820,
              "ews": 740,
              "sc": 443,
              "st": 236
            },
            "2022": {
              "general": 1783,
              "ews": 725,
              "sc": 434,
              "st": 231
            },
            "2021": {
              "general": 1746,
              "ews": 710,
              "sc": 425,
              "st": 226
            },
            "2020": {
              "general": 1709,
              "ews": 695,
              "sc": 416,
              "st": 221
            }
          }
        },
        "fees": 150000,
        "seats": 96
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 91633,
              "ews": 16056,
              "sc": 14742,
              "st": 6172
            },
            "2023": {
              "general": 89800,
              "ews": 15734,
              "sc": 14447,
              "st": 6048
            },
            "2022": {
              "general": 87967,
              "ews": 15413,
              "sc": 14152,
              "st": 5925
            },
            "2021": {
              "general": 86135,
              "ews": 15092,
              "sc": 13857,
              "st": 5801
            },
            "2020": {
              "general": 84302,
              "ews": 14771,
              "sc": 13562,
              "st": 5678
            }
          }
        },
        "fees": 150000,
        "seats": 96
      },
      {
        "name": "Computer Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 67924,
              "ews": 11627,
              "sc": 11551,
              "st": 6637
            },
            "2023": {
              "general": 66565,
              "ews": 11394,
              "sc": 11319,
              "st": 6504
            },
            "2022": {
              "general": 65207,
              "ews": 11161,
              "sc": 11088,
              "st": 6371
            },
            "2021": {
              "general": 63848,
              "ews": 10929,
              "sc": 10857,
              "st": 6238
            },
            "2020": {
              "general": 62490,
              "ews": 10696,
              "sc": 10626,
              "st": 6106
            }
          }
        },
        "fees": 150000,
        "seats": 96
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 82012,
              "ews": 14388,
              "sc": 13878,
              "st": 6633
            },
            "2023": {
              "general": 80371,
              "ews": 14100,
              "sc": 13600,
              "st": 6500
            },
            "2022": {
              "general": 78731,
              "ews": 13812,
              "sc": 13322,
              "st": 6367
            },
            "2021": {
              "general": 77091,
              "ews": 13524,
              "sc": 13045,
              "st": 6235
            },
            "2020": {
              "general": 75451,
              "ews": 13236,
              "sc": 12767,
              "st": 6102
            }
          }
        },
        "fees": 150000,
        "seats": 96
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 75755,
              "ews": 13331,
              "sc": 14012,
              "st": 6951
            },
            "2023": {
              "general": 74239,
              "ews": 13064,
              "sc": 13731,
              "st": 6811
            },
            "2022": {
              "general": 72724,
              "ews": 12797,
              "sc": 13451,
              "st": 6672
            },
            "2021": {
              "general": 71209,
              "ews": 12531,
              "sc": 13171,
              "st": 6533
            },
            "2020": {
              "general": 69694,
              "ews": 12264,
              "sc": 12891,
              "st": 6394
            }
          }
        },
        "fees": 150000,
        "seats": 96
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 67630,
              "ews": 12191,
              "sc": 12610,
              "st": 7234
            },
            "2023": {
              "general": 66277,
              "ews": 11947,
              "sc": 12357,
              "st": 7089
            },
            "2022": {
              "general": 64924,
              "ews": 11703,
              "sc": 12105,
              "st": 6944
            },
            "2021": {
              "general": 63572,
              "ews": 11459,
              "sc": 11853,
              "st": 6799
            },
            "2020": {
              "general": 62219,
              "ews": 11215,
              "sc": 11601,
              "st": 6655
            }
          }
        },
        "fees": 150000,
        "seats": 96
      }
    ]
  },
  {
    "id": 77,
    "name": "Motilal Nehru National Institute of Technology Allahabad",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Bio Technology",
        "code": "BT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 34536,
              "ews": 6178,
              "obc": 13589,
              "sc": 7201,
              "st": 2672
            },
            "2023": {
              "general": 33845,
              "ews": 6054,
              "obc": 13317,
              "sc": 7056,
              "st": 2618
            },
            "2022": {
              "general": 33154,
              "ews": 5930,
              "obc": 13045,
              "sc": 6912,
              "st": 2565
            },
            "2021": {
              "general": 32463,
              "ews": 5807,
              "obc": 12773,
              "sc": 6768,
              "st": 2511
            },
            "2020": {
              "general": 31773,
              "ews": 5683,
              "obc": 12501,
              "sc": 6624,
              "st": 2458
            }
          }
        },
        "fees": 150000,
        "seats": 97
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 20356,
              "ews": 3267,
              "obc": 8097,
              "sc": 4770,
              "st": 1839
            },
            "2023": {
              "general": 19948,
              "ews": 3201,
              "obc": 7935,
              "sc": 4674,
              "st": 1802
            },
            "2022": {
              "general": 19541,
              "ews": 3136,
              "obc": 7773,
              "sc": 4579,
              "st": 1765
            },
            "2021": {
              "general": 19134,
              "ews": 3070,
              "obc": 7611,
              "sc": 4483,
              "st": 1728
            },
            "2020": {
              "general": 18727,
              "ews": 3005,
              "obc": 7449,
              "sc": 4388,
              "st": 1691
            }
          }
        },
        "fees": 150000,
        "seats": 97
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 28054,
              "ews": 4858,
              "obc": 10011,
              "sc": 5314,
              "st": 1232
            },
            "2023": {
              "general": 27492,
              "ews": 4760,
              "obc": 9810,
              "sc": 5207,
              "st": 1207
            },
            "2022": {
              "general": 26931,
              "ews": 4663,
              "obc": 9610,
              "sc": 5101,
              "st": 1182
            },
            "2021": {
              "general": 26370,
              "ews": 4566,
              "obc": 9410,
              "sc": 4995,
              "st": 1158
            },
            "2020": {
              "general": 25809,
              "ews": 4469,
              "obc": 9210,
              "sc": 4888,
              "st": 1133
            }
          }
        },
        "fees": 150000,
        "seats": 97
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 4050,
              "ews": 674,
              "obc": 1568,
              "sc": 1072,
              "st": 418
            },
            "2023": {
              "general": 3969,
              "ews": 660,
              "obc": 1536,
              "sc": 1050,
              "st": 409
            },
            "2022": {
              "general": 3888,
              "ews": 647,
              "obc": 1505,
              "sc": 1029,
              "st": 401
            },
            "2021": {
              "general": 3807,
              "ews": 633,
              "obc": 1473,
              "sc": 1007,
              "st": 392
            },
            "2020": {
              "general": 3726,
              "ews": 620,
              "obc": 1442,
              "sc": 986,
              "st": 384
            }
          }
        },
        "fees": 150000,
        "seats": 97
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 10710,
              "ews": 1897,
              "obc": 4881,
              "sc": 2605,
              "st": 870
            },
            "2023": {
              "general": 10495,
              "ews": 1859,
              "obc": 4783,
              "sc": 2552,
              "st": 852
            },
            "2022": {
              "general": 10281,
              "ews": 1821,
              "obc": 4685,
              "sc": 2500,
              "st": 835
            },
            "2021": {
              "general": 10067,
              "ews": 1783,
              "obc": 4588,
              "sc": 2448,
              "st": 817
            },
            "2020": {
              "general": 9853,
              "ews": 1745,
              "obc": 4490,
              "sc": 2396,
              "st": 800
            }
          }
        },
        "fees": 150000,
        "seats": 97
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 7404,
              "ews": 1205,
              "obc": 2960,
              "sc": 2062,
              "st": 809
            },
            "2023": {
              "general": 7255,
              "ews": 1180,
              "obc": 2900,
              "sc": 2020,
              "st": 792
            },
            "2022": {
              "general": 7107,
              "ews": 1156,
              "obc": 2841,
              "sc": 1979,
              "st": 776
            },
            "2021": {
              "general": 6959,
              "ews": 1132,
              "obc": 2782,
              "sc": 1938,
              "st": 760
            },
            "2020": {
              "general": 6811,
              "ews": 1108,
              "obc": 2723,
              "sc": 1897,
              "st": 744
            }
          }
        },
        "fees": 150000,
        "seats": 97
      },
      {
        "name": "Engineering and Computational Mechanics",
        "code": "ECM",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 10545,
              "ews": 1774,
              "obc": 4975,
              "sc": 3141,
              "st": 1374
            },
            "2023": {
              "general": 10334,
              "ews": 1738,
              "obc": 4875,
              "sc": 3078,
              "st": 1346
            },
            "2022": {
              "general": 10123,
              "ews": 1703,
              "obc": 4776,
              "sc": 3015,
              "st": 1319
            },
            "2021": {
              "general": 9912,
              "ews": 1667,
              "obc": 4676,
              "sc": 2952,
              "st": 1291
            },
            "2020": {
              "general": 9701,
              "ews": 1632,
              "obc": 4577,
              "sc": 2889,
              "st": 1264
            }
          }
        },
        "fees": 150000,
        "seats": 97
      },
      {
        "name": "Materials Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 35953,
              "ews": 6475,
              "obc": 13282,
              "sc": 6525,
              "st": 2091
            },
            "2023": {
              "general": 35233,
              "ews": 6345,
              "obc": 13016,
              "sc": 6394,
              "st": 2049
            },
            "2022": {
              "general": 34514,
              "ews": 6216,
              "obc": 12750,
              "sc": 6264,
              "st": 2007
            },
            "2021": {
              "general": 33795,
              "ews": 6086,
              "obc": 12485,
              "sc": 6133,
              "st": 1965
            },
            "2020": {
              "general": 33076,
              "ews": 5957,
              "obc": 12219,
              "sc": 6003,
              "st": 1923
            }
          }
        },
        "fees": 150000,
        "seats": 97
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 18006,
              "ews": 3330,
              "obc": 7340,
              "sc": 4669,
              "st": 1643
            },
            "2023": {
              "general": 17645,
              "ews": 3263,
              "obc": 7193,
              "sc": 4575,
              "st": 1610
            },
            "2022": {
              "general": 17285,
              "ews": 3196,
              "obc": 7046,
              "sc": 4482,
              "st": 1577
            },
            "2021": {
              "general": 16925,
              "ews": 3130,
              "obc": 6899,
              "sc": 4388,
              "st": 1544
            },
            "2020": {
              "general": 16565,
              "ews": 3063,
              "obc": 6752,
              "sc": 4295,
              "st": 1511
            }
          }
        },
        "fees": 150000,
        "seats": 97
      },
      {
        "name": "Production and Industrial Engineering",
        "code": "PIE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 30238,
              "ews": 5478,
              "obc": 12811,
              "sc": 6398,
              "st": 2824
            },
            "2023": {
              "general": 29633,
              "ews": 5368,
              "obc": 12554,
              "sc": 6270,
              "st": 2767
            },
            "2022": {
              "general": 29028,
              "ews": 5258,
              "obc": 12298,
              "sc": 6142,
              "st": 2711
            },
            "2021": {
              "general": 28423,
              "ews": 5149,
              "obc": 12042,
              "sc": 6014,
              "st": 2654
            },
            "2020": {
              "general": 27818,
              "ews": 5039,
              "obc": 11786,
              "sc": 5886,
              "st": 2598
            }
          }
        },
        "fees": 150000,
        "seats": 97
      }
    ]
  },
  {
    "id": 78,
    "name": "National Institute of Advanced Manufacturing Technology, Ranchi",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 48597,
              "ews": 8634,
              "obc": 18936,
              "sc": 10794,
              "st": 4701
            },
            "2023": {
              "general": 47625,
              "ews": 8461,
              "obc": 18557,
              "sc": 10578,
              "st": 4606
            },
            "2022": {
              "general": 46653,
              "ews": 8288,
              "obc": 18178,
              "sc": 10362,
              "st": 4512
            },
            "2021": {
              "general": 45681,
              "ews": 8115,
              "obc": 17799,
              "sc": 10146,
              "st": 4418
            },
            "2020": {
              "general": 44709,
              "ews": 7943,
              "obc": 17421,
              "sc": 9930,
              "st": 4324
            }
          }
        },
        "fees": 150000,
        "seats": 98
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 62952,
              "ews": 11520,
              "obc": 21725,
              "sc": 13175,
              "st": 5363
            },
            "2023": {
              "general": 61692,
              "ews": 11289,
              "obc": 21290,
              "sc": 12911,
              "st": 5255
            },
            "2022": {
              "general": 60433,
              "ews": 11059,
              "obc": 20856,
              "sc": 12648,
              "st": 5148
            },
            "2021": {
              "general": 59174,
              "ews": 10828,
              "obc": 20421,
              "sc": 12384,
              "st": 5041
            },
            "2020": {
              "general": 57915,
              "ews": 10598,
              "obc": 19987,
              "sc": 12121,
              "st": 4933
            }
          }
        },
        "fees": 150000,
        "seats": 98
      },
      {
        "name": "Metallurgy and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 74737,
              "ews": 14064,
              "obc": 29665,
              "sc": 14283,
              "st": 6694
            },
            "2023": {
              "general": 73242,
              "ews": 13782,
              "obc": 29071,
              "sc": 13997,
              "st": 6560
            },
            "2022": {
              "general": 71747,
              "ews": 13501,
              "obc": 28478,
              "sc": 13711,
              "st": 6426
            },
            "2021": {
              "general": 70252,
              "ews": 13220,
              "obc": 27885,
              "sc": 13426,
              "st": 6292
            },
            "2020": {
              "general": 68758,
              "ews": 12938,
              "obc": 27291,
              "sc": 13140,
              "st": 6158
            }
          }
        },
        "fees": 150000,
        "seats": 98
      },
      {
        "name": "Production and Industrial Engineering",
        "code": "PIE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 75957,
              "ews": 14150,
              "obc": 30543,
              "sc": 14601,
              "st": 6146
            },
            "2023": {
              "general": 74437,
              "ews": 13867,
              "obc": 29932,
              "sc": 14308,
              "st": 6023
            },
            "2022": {
              "general": 72918,
              "ews": 13584,
              "obc": 29321,
              "sc": 14016,
              "st": 5900
            },
            "2021": {
              "general": 71399,
              "ews": 13301,
              "obc": 28710,
              "sc": 13724,
              "st": 5777
            },
            "2020": {
              "general": 69880,
              "ews": 13018,
              "obc": 28099,
              "sc": 13432,
              "st": 5654
            }
          }
        },
        "fees": 150000,
        "seats": 98
      }
    ]
  },
  {
    "id": 79,
    "name": "National Institute of Electronics and Information Technology, Aurangabad (Maharashtra)",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Electronic Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 54068,
              "ews": 9622,
              "obc": 20791,
              "sc": 10967,
              "st": 5426
            },
            "2023": {
              "general": 52986,
              "ews": 9429,
              "obc": 20375,
              "sc": 10747,
              "st": 5317
            },
            "2022": {
              "general": 51905,
              "ews": 9237,
              "obc": 19959,
              "sc": 10528,
              "st": 5208
            },
            "2021": {
              "general": 50823,
              "ews": 9044,
              "obc": 19543,
              "sc": 10308,
              "st": 5100
            },
            "2020": {
              "general": 49742,
              "ews": 8852,
              "obc": 19127,
              "sc": 10089,
              "st": 4991
            }
          }
        },
        "fees": 150000,
        "seats": 99
      }
    ]
  },
  {
    "id": 80,
    "name": "National Institute of Food Technology Entrepreneurship and Management, Kundli",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Food Technology and Management",
        "code": "FTM",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 100639,
              "ews": 17457,
              "obc": 35820,
              "sc": 15428,
              "st": 7592
            },
            "2023": {
              "general": 98626,
              "ews": 17107,
              "obc": 35103,
              "sc": 15119,
              "st": 7440
            },
            "2022": {
              "general": 96613,
              "ews": 16758,
              "obc": 34387,
              "sc": 14810,
              "st": 7288
            },
            "2021": {
              "general": 94600,
              "ews": 16409,
              "obc": 33670,
              "sc": 14502,
              "st": 7136
            },
            "2020": {
              "general": 92587,
              "ews": 16060,
              "obc": 32954,
              "sc": 14193,
              "st": 6984
            }
          }
        },
        "fees": 150000,
        "seats": 60
      }
    ]
  },
  {
    "id": 81,
    "name": "National Institute of Food Technology Entrepreneurship and Management, Thanjavur",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Food Technology",
        "code": "FT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 88267,
              "ews": 17134,
              "obc": 35033,
              "sc": 14585,
              "st": 7326
            },
            "2023": {
              "general": 86501,
              "ews": 16791,
              "obc": 34332,
              "sc": 14293,
              "st": 7179
            },
            "2022": {
              "general": 84736,
              "ews": 16448,
              "obc": 33631,
              "sc": 14001,
              "st": 7032
            },
            "2021": {
              "general": 82970,
              "ews": 16105,
              "obc": 32931,
              "sc": 13709,
              "st": 6886
            },
            "2020": {
              "general": 81205,
              "ews": 15763,
              "obc": 32230,
              "sc": 13418,
              "st": 6739
            }
          }
        },
        "fees": 150000,
        "seats": 61
      }
    ]
  },
  {
    "id": 82,
    "name": "National Institute of Technology Agartala",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Biotechnology and Biochemical Engineering",
        "code": "BBE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 54110,
              "sc": 8743,
              "st": 3665,
              "ews": 9099,
              "obc": 17959
            },
            "2023": {
              "general": 53027,
              "sc": 8568,
              "st": 3591,
              "ews": 8917,
              "obc": 17599
            },
            "2022": {
              "general": 51945,
              "sc": 8393,
              "st": 3518,
              "ews": 8735,
              "obc": 17240
            },
            "2021": {
              "general": 50863,
              "sc": 8218,
              "st": 3445,
              "ews": 8553,
              "obc": 16881
            },
            "2020": {
              "general": 49781,
              "sc": 8043,
              "st": 3371,
              "ews": 8371,
              "obc": 16522
            }
          }
        },
        "fees": 150000,
        "seats": 62
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 48612,
              "ews": 8122,
              "sc": 7798,
              "st": 3003,
              "obc": 15964
            },
            "2023": {
              "general": 47639,
              "ews": 7959,
              "sc": 7642,
              "st": 2942,
              "obc": 15644
            },
            "2022": {
              "general": 46667,
              "ews": 7797,
              "sc": 7486,
              "st": 2882,
              "obc": 15325
            },
            "2021": {
              "general": 45695,
              "ews": 7634,
              "sc": 7330,
              "st": 2822,
              "obc": 15006
            },
            "2020": {
              "general": 44723,
              "ews": 7472,
              "sc": 7174,
              "st": 2762,
              "obc": 14686
            }
          }
        },
        "fees": 150000,
        "seats": 62
      },
      {
        "name": "Chemistry",
        "code": "C",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 56937,
              "sc": 9573,
              "st": 3851,
              "ews": 9327,
              "obc": 18489
            },
            "2023": {
              "general": 55798,
              "sc": 9381,
              "st": 3773,
              "ews": 9140,
              "obc": 18119
            },
            "2022": {
              "general": 54659,
              "sc": 9190,
              "st": 3696,
              "ews": 8953,
              "obc": 17749
            },
            "2021": {
              "general": 53520,
              "sc": 8998,
              "st": 3619,
              "ews": 8767,
              "obc": 17379
            },
            "2020": {
              "general": 52382,
              "sc": 8807,
              "st": 3542,
              "ews": 8580,
              "obc": 17009
            }
          }
        },
        "fees": 150000,
        "seats": 62
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 50745,
              "sc": 7995,
              "st": 2579,
              "ews": 8369,
              "obc": 16985
            },
            "2023": {
              "general": 49730,
              "sc": 7835,
              "st": 2527,
              "ews": 8201,
              "obc": 16645
            },
            "2022": {
              "general": 48715,
              "sc": 7675,
              "st": 2475,
              "ews": 8034,
              "obc": 16305
            },
            "2021": {
              "general": 47700,
              "sc": 7515,
              "st": 2424,
              "ews": 7866,
              "obc": 15965
            },
            "2020": {
              "general": 46685,
              "sc": 7355,
              "st": 2372,
              "ews": 7699,
              "obc": 15626
            }
          }
        },
        "fees": 150000,
        "seats": 62
      },
      {
        "name": "Computational Mathematics",
        "code": "CM",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 30927,
              "sc": 6296,
              "ews": 5201,
              "obc": 13665,
              "st": 2162
            },
            "2023": {
              "general": 30308,
              "sc": 6170,
              "ews": 5096,
              "obc": 13391,
              "st": 2118
            },
            "2022": {
              "general": 29689,
              "sc": 6044,
              "ews": 4992,
              "obc": 13118,
              "st": 2075
            },
            "2021": {
              "general": 29071,
              "sc": 5918,
              "ews": 4888,
              "obc": 12845,
              "st": 2032
            },
            "2020": {
              "general": 28452,
              "sc": 5792,
              "ews": 4784,
              "obc": 12571,
              "st": 1989
            }
          }
        },
        "fees": 150000,
        "seats": 62
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 19544,
              "ews": 3133,
              "sc": 3682,
              "st": 1464,
              "obc": 6951
            },
            "2023": {
              "general": 19153,
              "ews": 3070,
              "sc": 3608,
              "st": 1434,
              "obc": 6811
            },
            "2022": {
              "general": 18762,
              "ews": 3007,
              "sc": 3534,
              "st": 1405,
              "obc": 6672
            },
            "2021": {
              "general": 18371,
              "ews": 2945,
              "sc": 3461,
              "st": 1376,
              "obc": 6533
            },
            "2020": {
              "general": 17980,
              "ews": 2882,
              "sc": 3387,
              "st": 1346,
              "obc": 6394
            }
          }
        },
        "fees": 150000,
        "seats": 62
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 36023,
              "ews": 6171,
              "sc": 5995,
              "st": 2487,
              "obc": 12403
            },
            "2023": {
              "general": 35302,
              "ews": 6047,
              "sc": 5875,
              "st": 2437,
              "obc": 12154
            },
            "2022": {
              "general": 34582,
              "ews": 5924,
              "sc": 5755,
              "st": 2387,
              "obc": 11906
            },
            "2021": {
              "general": 33861,
              "ews": 5800,
              "sc": 5635,
              "st": 2337,
              "obc": 11658
            },
            "2020": {
              "general": 33141,
              "ews": 5677,
              "sc": 5515,
              "st": 2288,
              "obc": 11410
            }
          }
        },
        "fees": 150000,
        "seats": 62
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 25977,
              "ews": 4337,
              "sc": 4937,
              "st": 1942,
              "obc": 8905
            },
            "2023": {
              "general": 25457,
              "ews": 4250,
              "sc": 4838,
              "st": 1903,
              "obc": 8726
            },
            "2022": {
              "general": 24937,
              "ews": 4163,
              "sc": 4739,
              "st": 1864,
              "obc": 8548
            },
            "2021": {
              "general": 24418,
              "ews": 4076,
              "sc": 4640,
              "st": 1825,
              "obc": 8370
            },
            "2020": {
              "general": 23898,
              "ews": 3990,
              "sc": 4542,
              "st": 1786,
              "obc": 8192
            }
          }
        },
        "fees": 150000,
        "seats": 62
      },
      {
        "name": "Electronics and Instrumentation Engineering",
        "code": "EIE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 33597,
              "ews": 5981,
              "sc": 6686,
              "obc": 13389,
              "st": 2716
            },
            "2023": {
              "general": 32925,
              "ews": 5861,
              "sc": 6552,
              "obc": 13121,
              "st": 2661
            },
            "2022": {
              "general": 32253,
              "ews": 5741,
              "sc": 6418,
              "obc": 12853,
              "st": 2607
            },
            "2021": {
              "general": 31581,
              "ews": 5622,
              "sc": 6284,
              "obc": 12585,
              "st": 2553
            },
            "2020": {
              "general": 30909,
              "ews": 5502,
              "sc": 6151,
              "obc": 12317,
              "st": 2498
            }
          }
        },
        "fees": 150000,
        "seats": 62
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 45025,
              "sc": 8006,
              "ews": 7624,
              "obc": 16398,
              "st": 3509
            },
            "2023": {
              "general": 44124,
              "sc": 7845,
              "ews": 7471,
              "obc": 16070,
              "st": 3438
            },
            "2022": {
              "general": 43224,
              "sc": 7685,
              "ews": 7319,
              "obc": 15742,
              "st": 3368
            },
            "2021": {
              "general": 42323,
              "sc": 7525,
              "ews": 7166,
              "obc": 15414,
              "st": 3298
            },
            "2020": {
              "general": 41423,
              "sc": 7365,
              "ews": 7014,
              "obc": 15086,
              "st": 3228
            }
          }
        },
        "fees": 150000,
        "seats": 62
      },
      {
        "name": "Mathematics & Computing",
        "code": "MC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 31639,
              "ews": 5223,
              "sc": 6702,
              "st": 2728,
              "obc": 13839
            },
            "2023": {
              "general": 31006,
              "ews": 5118,
              "sc": 6567,
              "st": 2673,
              "obc": 13562
            },
            "2022": {
              "general": 30373,
              "ews": 5014,
              "sc": 6433,
              "st": 2618,
              "obc": 13285
            },
            "2021": {
              "general": 29740,
              "ews": 4909,
              "sc": 6299,
              "st": 2564,
              "obc": 13008
            },
            "2020": {
              "general": 29107,
              "ews": 4805,
              "sc": 6165,
              "st": 2509,
              "obc": 12731
            }
          }
        },
        "fees": 150000,
        "seats": 62
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 44120,
              "ews": 7248,
              "sc": 7347,
              "st": 2779,
              "obc": 14571
            },
            "2023": {
              "general": 43237,
              "ews": 7103,
              "sc": 7200,
              "st": 2723,
              "obc": 14279
            },
            "2022": {
              "general": 42355,
              "ews": 6958,
              "sc": 7053,
              "st": 2667,
              "obc": 13988
            },
            "2021": {
              "general": 41472,
              "ews": 6813,
              "sc": 6906,
              "st": 2612,
              "obc": 13696
            },
            "2020": {
              "general": 40590,
              "ews": 6668,
              "sc": 6759,
              "st": 2556,
              "obc": 13405
            }
          }
        },
        "fees": 150000,
        "seats": 62
      },
      {
        "name": "Physics",
        "code": "P",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 47952,
              "sc": 8362,
              "st": 3126,
              "obc": 18252
            },
            "2023": {
              "general": 46992,
              "sc": 8194,
              "st": 3063,
              "obc": 17886
            },
            "2022": {
              "general": 46033,
              "sc": 8027,
              "st": 3000,
              "obc": 17521
            },
            "2021": {
              "general": 45074,
              "sc": 7860,
              "st": 2938,
              "obc": 17156
            },
            "2020": {
              "general": 44115,
              "sc": 7693,
              "st": 2875,
              "obc": 16791
            }
          }
        },
        "fees": 150000,
        "seats": 62
      },
      {
        "name": "Production Engineering",
        "code": "PE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 54098,
              "sc": 9276,
              "st": 3622,
              "ews": 9128,
              "obc": 18085
            },
            "2023": {
              "general": 53016,
              "sc": 9090,
              "st": 3549,
              "ews": 8945,
              "obc": 17723
            },
            "2022": {
              "general": 51934,
              "sc": 8904,
              "st": 3477,
              "ews": 8762,
              "obc": 17361
            },
            "2021": {
              "general": 50852,
              "sc": 8719,
              "st": 3404,
              "ews": 8580,
              "obc": 16999
            },
            "2020": {
              "general": 49770,
              "sc": 8533,
              "st": 3332,
              "ews": 8397,
              "obc": 16638
            }
          }
        },
        "fees": 150000,
        "seats": 62
      }
    ]
  },
  {
    "id": 83,
    "name": "National Institute of Technology Arunachal Pradesh",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 54246,
              "obc": 17743,
              "sc": 8598,
              "st": 2694,
              "ews": 8913
            },
            "2023": {
              "general": 53161,
              "obc": 17388,
              "sc": 8426,
              "st": 2640,
              "ews": 8734
            },
            "2022": {
              "general": 52076,
              "obc": 17033,
              "sc": 8254,
              "st": 2586,
              "ews": 8556
            },
            "2021": {
              "general": 50991,
              "obc": 16678,
              "sc": 8082,
              "st": 2532,
              "ews": 8378
            },
            "2020": {
              "general": 49906,
              "obc": 16323,
              "sc": 7910,
              "st": 2478,
              "ews": 8199
            }
          }
        },
        "fees": 150000,
        "seats": 63
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 27312,
              "ews": 4986,
              "obc": 10941,
              "st": 1794,
              "sc": 4295
            },
            "2023": {
              "general": 26765,
              "ews": 4886,
              "obc": 10722,
              "st": 1758,
              "sc": 4209
            },
            "2022": {
              "general": 26219,
              "ews": 4786,
              "obc": 10503,
              "st": 1722,
              "sc": 4123
            },
            "2021": {
              "general": 25673,
              "ews": 4686,
              "obc": 10284,
              "st": 1686,
              "sc": 4037
            },
            "2020": {
              "general": 25127,
              "ews": 4587,
              "obc": 10065,
              "st": 1650,
              "sc": 3951
            }
          }
        },
        "fees": 150000,
        "seats": 63
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 41942,
              "ews": 7145,
              "obc": 13812,
              "st": 2588,
              "sc": 7062
            },
            "2023": {
              "general": 41103,
              "ews": 7002,
              "obc": 13535,
              "st": 2536,
              "sc": 6920
            },
            "2022": {
              "general": 40264,
              "ews": 6859,
              "obc": 13259,
              "st": 2484,
              "sc": 6779
            },
            "2021": {
              "general": 39425,
              "ews": 6716,
              "obc": 12983,
              "st": 2432,
              "sc": 6638
            },
            "2020": {
              "general": 38586,
              "ews": 6573,
              "obc": 12707,
              "st": 2380,
              "sc": 6497
            }
          }
        },
        "fees": 150000,
        "seats": 63
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 38624,
              "ews": 6526,
              "obc": 12594,
              "sc": 5980,
              "st": 2196
            },
            "2023": {
              "general": 37851,
              "ews": 6395,
              "obc": 12342,
              "sc": 5860,
              "st": 2152
            },
            "2022": {
              "general": 37079,
              "ews": 6264,
              "obc": 12090,
              "sc": 5740,
              "st": 2108
            },
            "2021": {
              "general": 36306,
              "ews": 6134,
              "obc": 11838,
              "sc": 5621,
              "st": 2064
            },
            "2020": {
              "general": 35534,
              "ews": 6003,
              "obc": 11586,
              "sc": 5501,
              "st": 2020
            }
          }
        },
        "fees": 150000,
        "seats": 63
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 48541,
              "obc": 15967,
              "sc": 8019,
              "st": 21354,
              "ews": 8111
            },
            "2023": {
              "general": 47570,
              "obc": 15647,
              "sc": 7858,
              "st": 20926,
              "ews": 7948
            },
            "2022": {
              "general": 46599,
              "obc": 15328,
              "sc": 7698,
              "st": 20499,
              "ews": 7786
            },
            "2021": {
              "general": 45628,
              "obc": 15008,
              "sc": 7537,
              "st": 20072,
              "ews": 7624
            },
            "2020": {
              "general": 44657,
              "obc": 14689,
              "sc": 7377,
              "st": 19645,
              "ews": 7462
            }
          }
        },
        "fees": 150000,
        "seats": 63
      }
    ]
  },
  {
    "id": 84,
    "name": "National Institute of Technology Calicut",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 466,
              "ews": 136,
              "obc": 299,
              "sc": 104,
              "st": 50
            },
            "2023": {
              "general": 456,
              "ews": 133,
              "obc": 293,
              "sc": 101,
              "st": 49
            },
            "2022": {
              "general": 447,
              "ews": 130,
              "obc": 287,
              "sc": 99,
              "st": 48
            },
            "2021": {
              "general": 438,
              "ews": 127,
              "obc": 281,
              "sc": 97,
              "st": 47
            },
            "2020": {
              "general": 428,
              "ews": 125,
              "obc": 275,
              "sc": 95,
              "st": 46
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Bio Technology",
        "code": "BT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 34678,
              "ews": 6217,
              "obc": 11950,
              "sc": 5691,
              "st": 1867
            },
            "2023": {
              "general": 33984,
              "ews": 6092,
              "obc": 11711,
              "sc": 5577,
              "st": 1829
            },
            "2022": {
              "general": 33290,
              "ews": 5968,
              "obc": 11472,
              "sc": 5463,
              "st": 1792
            },
            "2021": {
              "general": 32597,
              "ews": 5843,
              "obc": 11233,
              "sc": 5349,
              "st": 1754
            },
            "2020": {
              "general": 31903,
              "ews": 5719,
              "obc": 10994,
              "sc": 5235,
              "st": 1717
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 24067,
              "ews": 4541,
              "obc": 8918,
              "sc": 4985,
              "st": 1689
            },
            "2023": {
              "general": 23585,
              "ews": 4450,
              "obc": 8739,
              "sc": 4885,
              "st": 1655
            },
            "2022": {
              "general": 23104,
              "ews": 4359,
              "obc": 8561,
              "sc": 4785,
              "st": 1621
            },
            "2021": {
              "general": 22622,
              "ews": 4268,
              "obc": 8382,
              "sc": 4685,
              "st": 1587
            },
            "2020": {
              "general": 22141,
              "ews": 4177,
              "obc": 8204,
              "sc": 4586,
              "st": 1553
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 31899,
              "ews": 5317,
              "obc": 10954,
              "sc": 5530,
              "st": 1515
            },
            "2023": {
              "general": 31261,
              "ews": 5210,
              "obc": 10734,
              "sc": 5419,
              "st": 1484
            },
            "2022": {
              "general": 30623,
              "ews": 5104,
              "obc": 10515,
              "sc": 5308,
              "st": 1454
            },
            "2021": {
              "general": 29985,
              "ews": 4997,
              "obc": 10296,
              "sc": 5198,
              "st": 1424
            },
            "2020": {
              "general": 29347,
              "ews": 4891,
              "obc": 10077,
              "sc": 5087,
              "st": 1393
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 4185,
              "ews": 643,
              "obc": 1442,
              "sc": 843,
              "st": 269
            },
            "2023": {
              "general": 4101,
              "ews": 630,
              "obc": 1413,
              "sc": 826,
              "st": 263
            },
            "2022": {
              "general": 4017,
              "ews": 617,
              "obc": 1384,
              "sc": 809,
              "st": 258
            },
            "2021": {
              "general": 3933,
              "ews": 604,
              "obc": 1355,
              "sc": 792,
              "st": 252
            },
            "2020": {
              "general": 3850,
              "ews": 591,
              "obc": 1326,
              "sc": 775,
              "st": 247
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 10496,
              "ews": 1862,
              "obc": 4118,
              "sc": 2680,
              "st": 869
            },
            "2023": {
              "general": 10286,
              "ews": 1824,
              "obc": 4035,
              "sc": 2626,
              "st": 851
            },
            "2022": {
              "general": 10076,
              "ews": 1787,
              "obc": 3953,
              "sc": 2572,
              "st": 834
            },
            "2021": {
              "general": 9866,
              "ews": 1750,
              "obc": 3870,
              "sc": 2519,
              "st": 816
            },
            "2020": {
              "general": 9656,
              "ews": 1713,
              "obc": 3788,
              "sc": 2465,
              "st": 799
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 7056,
              "ews": 1081,
              "obc": 2422,
              "sc": 1665,
              "st": 411
            },
            "2023": {
              "general": 6914,
              "ews": 1059,
              "obc": 2373,
              "sc": 1631,
              "st": 402
            },
            "2022": {
              "general": 6773,
              "ews": 1037,
              "obc": 2325,
              "sc": 1598,
              "st": 394
            },
            "2021": {
              "general": 6632,
              "ews": 1016,
              "obc": 2276,
              "sc": 1565,
              "st": 386
            },
            "2020": {
              "general": 6491,
              "ews": 994,
              "obc": 2228,
              "sc": 1531,
              "st": 378
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 13950,
              "ews": 3099,
              "obc": 6881,
              "sc": 4856,
              "st": 1258
            },
            "2023": {
              "general": 13671,
              "ews": 3037,
              "obc": 6743,
              "sc": 4758,
              "st": 1232
            },
            "2022": {
              "general": 13392,
              "ews": 2975,
              "obc": 6605,
              "sc": 4661,
              "st": 1207
            },
            "2021": {
              "general": 13113,
              "ews": 2913,
              "obc": 6468,
              "sc": 4564,
              "st": 1182
            },
            "2020": {
              "general": 12834,
              "ews": 2851,
              "obc": 6330,
              "sc": 4467,
              "st": 1157
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Materials Science and Engineering",
        "code": "MSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 30399,
              "ews": 6173,
              "obc": 12253,
              "sc": 6324,
              "st": 1940
            },
            "2023": {
              "general": 29791,
              "ews": 6049,
              "obc": 12007,
              "sc": 6197,
              "st": 1901
            },
            "2022": {
              "general": 29183,
              "ews": 5926,
              "obc": 11762,
              "sc": 6071,
              "st": 1862
            },
            "2021": {
              "general": 28575,
              "ews": 5802,
              "obc": 11517,
              "sc": 5944,
              "st": 1823
            },
            "2020": {
              "general": 27967,
              "ews": 5679,
              "obc": 11272,
              "sc": 5818,
              "st": 1784
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 18886,
              "ews": 3348,
              "obc": 6584,
              "sc": 4556,
              "st": 1457
            },
            "2023": {
              "general": 18508,
              "ews": 3281,
              "obc": 6452,
              "sc": 4464,
              "st": 1427
            },
            "2022": {
              "general": 18130,
              "ews": 3214,
              "obc": 6320,
              "sc": 4373,
              "st": 1398
            },
            "2021": {
              "general": 17752,
              "ews": 3147,
              "obc": 6188,
              "sc": 4282,
              "st": 1369
            },
            "2020": {
              "general": 17375,
              "ews": 3080,
              "obc": 6057,
              "sc": 4191,
              "st": 1340
            }
          }
        },
        "fees": 150000,
        "seats": 64
      },
      {
        "name": "Production Engineering",
        "code": "PE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 30932,
              "ews": 6176,
              "obc": 11455,
              "sc": 5806,
              "st": 1889
            },
            "2023": {
              "general": 30313,
              "ews": 6052,
              "obc": 11225,
              "sc": 5689,
              "st": 1851
            },
            "2022": {
              "general": 29694,
              "ews": 5928,
              "obc": 10996,
              "sc": 5573,
              "st": 1813
            },
            "2021": {
              "general": 29076,
              "ews": 5805,
              "obc": 10767,
              "sc": 5457,
              "st": 1775
            },
            "2020": {
              "general": 28457,
              "ews": 5681,
              "obc": 10538,
              "sc": 5341,
              "st": 1737
            }
          }
        },
        "fees": 150000,
        "seats": 64
      }
    ]
  },
  {
    "id": 85,
    "name": "National Institute of Technology Delhi",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Aerospace Engineering",
        "code": "AE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 13890,
              "obc": 4743,
              "sc": 1950,
              "st": 785
            },
            "2023": {
              "general": 13612,
              "obc": 4648,
              "sc": 1911,
              "st": 769
            },
            "2022": {
              "general": 13334,
              "obc": 4553,
              "sc": 1872,
              "st": 753
            },
            "2021": {
              "general": 13056,
              "obc": 4458,
              "sc": 1833,
              "st": 737
            },
            "2020": {
              "general": 12778,
              "obc": 4363,
              "sc": 1794,
              "st": 722
            }
          }
        },
        "fees": 150000,
        "seats": 65
      },
      {
        "name": "Artificial Intelligence and Data Science",
        "code": "AIDS",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 7717,
              "ews": 1318,
              "obc": 2105,
              "sc": 1621,
              "st": 2525
            },
            "2023": {
              "general": 7562,
              "ews": 1291,
              "obc": 2062,
              "sc": 1588,
              "st": 2474
            },
            "2022": {
              "general": 7408,
              "ews": 1265,
              "obc": 2020,
              "sc": 1556,
              "st": 2424
            },
            "2021": {
              "general": 7253,
              "ews": 1238,
              "obc": 1978,
              "sc": 1523,
              "st": 2373
            },
            "2020": {
              "general": 7099,
              "ews": 1212,
              "obc": 1936,
              "sc": 1491,
              "st": 2323
            }
          }
        },
        "fees": 150000,
        "seats": 65
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 26208,
              "ews": 6588,
              "obc": 9096,
              "sc": 3471,
              "st": 379
            },
            "2023": {
              "general": 25683,
              "ews": 6456,
              "obc": 8914,
              "sc": 3401,
              "st": 371
            },
            "2022": {
              "general": 25159,
              "ews": 6324,
              "obc": 8732,
              "sc": 3332,
              "st": 363
            },
            "2021": {
              "general": 24635,
              "ews": 6192,
              "obc": 8550,
              "sc": 3262,
              "st": 356
            },
            "2020": {
              "general": 24111,
              "ews": 6060,
              "obc": 8368,
              "sc": 3193,
              "st": 348
            }
          }
        },
        "fees": 150000,
        "seats": 65
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 7256,
              "ews": 1316,
              "obc": 3404,
              "sc": 1512,
              "st": 443
            },
            "2023": {
              "general": 7110,
              "ews": 1289,
              "obc": 3335,
              "sc": 1481,
              "st": 434
            },
            "2022": {
              "general": 6965,
              "ews": 1263,
              "obc": 3267,
              "sc": 1451,
              "st": 425
            },
            "2021": {
              "general": 6820,
              "ews": 1237,
              "obc": 3199,
              "sc": 1421,
              "st": 416
            },
            "2020": {
              "general": 6675,
              "ews": 1210,
              "obc": 3131,
              "sc": 1391,
              "st": 407
            }
          }
        },
        "fees": 150000,
        "seats": 65
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 16561,
              "ews": 2551,
              "obc": 5751,
              "sc": 2935,
              "st": 1448
            },
            "2023": {
              "general": 16229,
              "ews": 2499,
              "obc": 5635,
              "sc": 2876,
              "st": 1419
            },
            "2022": {
              "general": 15898,
              "ews": 2448,
              "obc": 5520,
              "sc": 2817,
              "st": 1390
            },
            "2021": {
              "general": 15567,
              "ews": 2397,
              "obc": 5405,
              "sc": 2758,
              "st": 1361
            },
            "2020": {
              "general": 15236,
              "ews": 2346,
              "obc": 5290,
              "sc": 2700,
              "st": 1332
            }
          }
        },
        "fees": 150000,
        "seats": 65
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 11595,
              "ews": 1912,
              "obc": 4507,
              "sc": 2536,
              "st": 991
            },
            "2023": {
              "general": 11363,
              "ews": 1873,
              "obc": 4416,
              "sc": 2485,
              "st": 971
            },
            "2022": {
              "general": 11131,
              "ews": 1835,
              "obc": 4326,
              "sc": 2434,
              "st": 951
            },
            "2021": {
              "general": 10899,
              "ews": 1797,
              "obc": 4236,
              "sc": 2383,
              "st": 931
            },
            "2020": {
              "general": 10667,
              "ews": 1759,
              "obc": 4146,
              "sc": 2333,
              "st": 911
            }
          }
        },
        "fees": 150000,
        "seats": 65
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 20286,
              "ews": 3563,
              "obc": 8571,
              "sc": 3934,
              "st": 1423
            },
            "2023": {
              "general": 19880,
              "ews": 3491,
              "obc": 8399,
              "sc": 3855,
              "st": 1394
            },
            "2022": {
              "general": 19474,
              "ews": 3420,
              "obc": 8228,
              "sc": 3776,
              "st": 1366
            },
            "2021": {
              "general": 19068,
              "ews": 3349,
              "obc": 8056,
              "sc": 3697,
              "st": 1337
            },
            "2020": {
              "general": 18663,
              "ews": 3277,
              "obc": 7885,
              "sc": 3619,
              "st": 1309
            }
          }
        },
        "fees": 150000,
        "seats": 65
      },
      {
        "name": "VLSI Design and Technology",
        "code": "VDT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 13596,
              "ews": 4774,
              "obc": 5708,
              "sc": 3930,
              "st": 1730
            },
            "2023": {
              "general": 13324,
              "ews": 4678,
              "obc": 5593,
              "sc": 3851,
              "st": 1695
            },
            "2022": {
              "general": 13052,
              "ews": 4583,
              "obc": 5479,
              "sc": 3772,
              "st": 1660
            },
            "2021": {
              "general": 12780,
              "ews": 4487,
              "obc": 5365,
              "sc": 3694,
              "st": 1626
            },
            "2020": {
              "general": 12508,
              "ews": 4392,
              "obc": 5251,
              "sc": 3615,
              "st": 1591
            }
          }
        },
        "fees": 150000,
        "seats": 65
      }
    ]
  },
  {
    "id": 86,
    "name": "National Institute of Technology Durgapur",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "B.Tech in Mathematics and Computing",
        "code": "BMC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 10824,
              "ews": 1665,
              "obc": 4183,
              "sc": 2746,
              "st": 847
            },
            "2023": {
              "general": 10607,
              "ews": 1631,
              "obc": 4099,
              "sc": 2691,
              "st": 830
            },
            "2022": {
              "general": 10391,
              "ews": 1598,
              "obc": 4015,
              "sc": 2636,
              "st": 813
            },
            "2021": {
              "general": 10174,
              "ews": 1565,
              "obc": 3932,
              "sc": 2581,
              "st": 796
            },
            "2020": {
              "general": 9958,
              "ews": 1531,
              "obc": 3848,
              "sc": 2526,
              "st": 779
            }
          }
        },
        "fees": 150000,
        "seats": 66
      },
      {
        "name": "Bio Technology",
        "code": "BT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 44598,
              "ews": 7684,
              "obc": 15030,
              "sc": 6367,
              "st": 2906
            },
            "2023": {
              "general": 43706,
              "ews": 7530,
              "obc": 14729,
              "sc": 6239,
              "st": 2847
            },
            "2022": {
              "general": 42814,
              "ews": 7376,
              "obc": 14428,
              "sc": 6112,
              "st": 2789
            },
            "2021": {
              "general": 41922,
              "ews": 7222,
              "obc": 14128,
              "sc": 5984,
              "st": 2731
            },
            "2020": {
              "general": 41030,
              "ews": 7069,
              "obc": 13827,
              "sc": 5857,
              "st": 2673
            }
          }
        },
        "fees": 150000,
        "seats": 66
      },
      {
        "name": "Biotechnology",
        "code": "B",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 42109,
              "obc": 17664,
              "sc": 9379,
              "st": 2920
            },
            "2023": {
              "general": 41266,
              "obc": 17310,
              "sc": 9191,
              "st": 2861
            },
            "2022": {
              "general": 40424,
              "obc": 16957,
              "sc": 9003,
              "st": 2803
            },
            "2021": {
              "general": 39582,
              "obc": 16604,
              "sc": 8816,
              "st": 2744
            },
            "2020": {
              "general": 38740,
              "obc": 16250,
              "sc": 8628,
              "st": 2686
            }
          }
        },
        "fees": 150000,
        "seats": 66
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 32174,
              "ews": 5460,
              "obc": 12168,
              "sc": 5803,
              "st": 2084
            },
            "2023": {
              "general": 31530,
              "ews": 5350,
              "obc": 11924,
              "sc": 5686,
              "st": 2042
            },
            "2022": {
              "general": 30887,
              "ews": 5241,
              "obc": 11681,
              "sc": 5570,
              "st": 2000
            },
            "2021": {
              "general": 30243,
              "ews": 5132,
              "obc": 11437,
              "sc": 5454,
              "st": 1958
            },
            "2020": {
              "general": 29600,
              "ews": 5023,
              "obc": 11194,
              "sc": 5338,
              "st": 1917
            }
          }
        },
        "fees": 150000,
        "seats": 66
      },
      {
        "name": "Chemistry",
        "code": "C",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 52552,
              "ews": 8656,
              "obc": 18001,
              "sc": 9454,
              "st": 3238
            },
            "2023": {
              "general": 51500,
              "ews": 8482,
              "obc": 17640,
              "sc": 9264,
              "st": 3173
            },
            "2022": {
              "general": 50449,
              "ews": 8309,
              "obc": 17280,
              "sc": 9075,
              "st": 3108
            },
            "2021": {
              "general": 49398,
              "ews": 8136,
              "obc": 16920,
              "sc": 8886,
              "st": 3043
            },
            "2020": {
              "general": 48347,
              "ews": 7963,
              "obc": 16560,
              "sc": 8697,
              "st": 2978
            }
          }
        },
        "fees": 150000,
        "seats": 66
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 38211,
              "ews": 6298,
              "obc": 12571,
              "sc": 5784,
              "st": 1585
            },
            "2023": {
              "general": 37446,
              "ews": 6172,
              "obc": 12319,
              "sc": 5668,
              "st": 1553
            },
            "2022": {
              "general": 36682,
              "ews": 6046,
              "obc": 12068,
              "sc": 5552,
              "st": 1521
            },
            "2021": {
              "general": 35918,
              "ews": 5920,
              "obc": 11816,
              "sc": 5436,
              "st": 1489
            },
            "2020": {
              "general": 35154,
              "ews": 5794,
              "obc": 11565,
              "sc": 5321,
              "st": 1458
            }
          }
        },
        "fees": 150000,
        "seats": 66
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 8331,
              "ews": 1224,
              "obc": 3043,
              "sc": 1934,
              "st": 458
            },
            "2023": {
              "general": 8164,
              "ews": 1199,
              "obc": 2982,
              "sc": 1895,
              "st": 448
            },
            "2022": {
              "general": 7997,
              "ews": 1175,
              "obc": 2921,
              "sc": 1856,
              "st": 439
            },
            "2021": {
              "general": 7831,
              "ews": 1150,
              "obc": 2860,
              "sc": 1817,
              "st": 430
            },
            "2020": {
              "general": 7664,
              "ews": 1126,
              "obc": 2799,
              "sc": 1779,
              "st": 421
            }
          }
        },
        "fees": 150000,
        "seats": 66
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 18198,
              "ews": 3043,
              "obc": 6151,
              "sc": 3788,
              "st": 1139
            },
            "2023": {
              "general": 17834,
              "ews": 2982,
              "obc": 6027,
              "sc": 3712,
              "st": 1116
            },
            "2022": {
              "general": 17470,
              "ews": 2921,
              "obc": 5904,
              "sc": 3636,
              "st": 1093
            },
            "2021": {
              "general": 17106,
              "ews": 2860,
              "obc": 5781,
              "sc": 3560,
              "st": 1070
            },
            "2020": {
              "general": 16742,
              "ews": 2799,
              "obc": 5658,
              "sc": 3484,
              "st": 1047
            }
          }
        },
        "fees": 150000,
        "seats": 66
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 12278,
              "ews": 1984,
              "obc": 4356,
              "sc": 2722,
              "st": 757
            },
            "2023": {
              "general": 12032,
              "ews": 1944,
              "obc": 4268,
              "sc": 2667,
              "st": 741
            },
            "2022": {
              "general": 11786,
              "ews": 1904,
              "obc": 4181,
              "sc": 2613,
              "st": 726
            },
            "2021": {
              "general": 11541,
              "ews": 1864,
              "obc": 4094,
              "sc": 2558,
              "st": 711
            },
            "2020": {
              "general": 11295,
              "ews": 1825,
              "obc": 4007,
              "sc": 2504,
              "st": 696
            }
          }
        },
        "fees": 150000,
        "seats": 66
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 26921,
              "ews": 4584,
              "obc": 9602,
              "sc": 5342,
              "st": 1915
            },
            "2023": {
              "general": 26382,
              "ews": 4492,
              "obc": 9409,
              "sc": 5235,
              "st": 1876
            },
            "2022": {
              "general": 25844,
              "ews": 4400,
              "obc": 9217,
              "sc": 5128,
              "st": 1838
            },
            "2021": {
              "general": 25305,
              "ews": 4308,
              "obc": 9025,
              "sc": 5021,
              "st": 1800
            },
            "2020": {
              "general": 24767,
              "ews": 4217,
              "obc": 8833,
              "sc": 4914,
              "st": 1761
            }
          }
        },
        "fees": 150000,
        "seats": 66
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 42932,
              "ews": 7166,
              "obc": 14907,
              "sc": 7790,
              "st": 2844
            },
            "2023": {
              "general": 42073,
              "ews": 7022,
              "obc": 14608,
              "sc": 7634,
              "st": 2787
            },
            "2022": {
              "general": 41214,
              "ews": 6879,
              "obc": 14310,
              "sc": 7478,
              "st": 2730
            },
            "2021": {
              "general": 40356,
              "ews": 6736,
              "obc": 14012,
              "sc": 7322,
              "st": 2673
            },
            "2020": {
              "general": 39497,
              "ews": 6592,
              "obc": 13714,
              "sc": 7166,
              "st": 2616
            }
          }
        },
        "fees": 150000,
        "seats": 66
      }
    ]
  },
  {
    "id": 87,
    "name": "National Institute of Technology Goa",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 41929,
              "obc": 13744,
              "sc": 3758,
              "st": 2138,
              "ews": 7142
            },
            "2023": {
              "general": 41090,
              "obc": 13469,
              "sc": 3682,
              "st": 2095,
              "ews": 6999
            },
            "2022": {
              "general": 40251,
              "obc": 13194,
              "sc": 3607,
              "st": 2052,
              "ews": 6856
            },
            "2021": {
              "general": 39413,
              "obc": 12919,
              "sc": 3532,
              "st": 2009,
              "ews": 6713
            },
            "2020": {
              "general": 38574,
              "obc": 12644,
              "sc": 3457,
              "st": 1966,
              "ews": 6570
            }
          }
        },
        "fees": 150000,
        "seats": 67
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 11384,
              "ews": 1845,
              "obc": 4746,
              "sc": 2445,
              "st": 626
            },
            "2023": {
              "general": 11156,
              "ews": 1808,
              "obc": 4651,
              "sc": 2396,
              "st": 613
            },
            "2022": {
              "general": 10928,
              "ews": 1771,
              "obc": 4556,
              "sc": 2347,
              "st": 600
            },
            "2021": {
              "general": 10700,
              "ews": 1734,
              "obc": 4461,
              "sc": 2298,
              "st": 588
            },
            "2020": {
              "general": 10473,
              "ews": 1697,
              "obc": 4366,
              "sc": 2249,
              "st": 575
            }
          }
        },
        "fees": 150000,
        "seats": 67
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 21466,
              "ews": 3465,
              "obc": 7888,
              "sc": 4601,
              "st": 3139
            },
            "2023": {
              "general": 21036,
              "ews": 3395,
              "obc": 7730,
              "sc": 4508,
              "st": 3076
            },
            "2022": {
              "general": 20607,
              "ews": 3326,
              "obc": 7572,
              "sc": 4416,
              "st": 3013
            },
            "2021": {
              "general": 20178,
              "ews": 3257,
              "obc": 7414,
              "sc": 4324,
              "st": 2950
            },
            "2020": {
              "general": 19748,
              "ews": 3187,
              "obc": 7256,
              "sc": 4232,
              "st": 2887
            }
          }
        },
        "fees": 150000,
        "seats": 67
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 16704,
              "ews": 2708,
              "obc": 6777,
              "sc": 4114,
              "st": 1474
            },
            "2023": {
              "general": 16369,
              "ews": 2653,
              "obc": 6641,
              "sc": 4031,
              "st": 1444
            },
            "2022": {
              "general": 16035,
              "ews": 2599,
              "obc": 6505,
              "sc": 3949,
              "st": 1415
            },
            "2021": {
              "general": 15701,
              "ews": 2545,
              "obc": 6370,
              "sc": 3867,
              "st": 1385
            },
            "2020": {
              "general": 15367,
              "ews": 2491,
              "obc": 6234,
              "sc": 3784,
              "st": 1356
            }
          }
        },
        "fees": 150000,
        "seats": 67
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 28004,
              "ews": 40543,
              "obc": 10772,
              "sc": 6034,
              "st": 2319
            },
            "2023": {
              "general": 27443,
              "ews": 39732,
              "obc": 10556,
              "sc": 5913,
              "st": 2272
            },
            "2022": {
              "general": 26883,
              "ews": 38921,
              "obc": 10341,
              "sc": 5792,
              "st": 2226
            },
            "2021": {
              "general": 26323,
              "ews": 38110,
              "obc": 10125,
              "sc": 5671,
              "st": 2179
            },
            "2020": {
              "general": 25763,
              "ews": 37299,
              "obc": 9910,
              "sc": 5551,
              "st": 2133
            }
          }
        },
        "fees": 150000,
        "seats": 67
      }
    ]
  },
  {
    "id": 88,
    "name": "National Institute of Technology Hamirpur",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 1532,
              "ews": 701,
              "obc": 964,
              "sc": 286,
              "st": 161
            },
            "2023": {
              "general": 1501,
              "ews": 686,
              "obc": 944,
              "sc": 280,
              "st": 157
            },
            "2022": {
              "general": 1470,
              "ews": 672,
              "obc": 925,
              "sc": 274,
              "st": 154
            },
            "2021": {
              "general": 1440,
              "ews": 658,
              "obc": 906,
              "sc": 268,
              "st": 151
            },
            "2020": {
              "general": 1409,
              "ews": 644,
              "obc": 886,
              "sc": 263,
              "st": 148
            }
          }
        },
        "fees": 150000,
        "seats": 68
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 36965,
              "ews": 6252,
              "obc": 12522,
              "sc": 6695,
              "st": 2886
            },
            "2023": {
              "general": 36225,
              "ews": 6126,
              "obc": 12271,
              "sc": 6561,
              "st": 2828
            },
            "2022": {
              "general": 35486,
              "ews": 6001,
              "obc": 12021,
              "sc": 6427,
              "st": 2770
            },
            "2021": {
              "general": 34747,
              "ews": 5876,
              "obc": 11770,
              "sc": 6293,
              "st": 2712
            },
            "2020": {
              "general": 34007,
              "ews": 5751,
              "obc": 11520,
              "sc": 6159,
              "st": 2655
            }
          }
        },
        "fees": 150000,
        "seats": 68
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 44170,
              "ews": 7278,
              "obc": 15114,
              "sc": 7306,
              "st": 1911
            },
            "2023": {
              "general": 43286,
              "ews": 7132,
              "obc": 14811,
              "sc": 7159,
              "st": 1872
            },
            "2022": {
              "general": 42403,
              "ews": 6986,
              "obc": 14509,
              "sc": 7013,
              "st": 1834
            },
            "2021": {
              "general": 41519,
              "ews": 6841,
              "obc": 14207,
              "sc": 6867,
              "st": 1796
            },
            "2020": {
              "general": 40636,
              "ews": 6695,
              "obc": 13904,
              "sc": 6721,
              "st": 1758
            }
          }
        },
        "fees": 150000,
        "seats": 68
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 13772,
              "ews": 2169,
              "obc": 4238,
              "sc": 3056,
              "st": 1227
            },
            "2023": {
              "general": 13496,
              "ews": 2125,
              "obc": 4153,
              "sc": 2994,
              "st": 1202
            },
            "2022": {
              "general": 13221,
              "ews": 2082,
              "obc": 4068,
              "sc": 2933,
              "st": 1177
            },
            "2021": {
              "general": 12945,
              "ews": 2038,
              "obc": 3983,
              "sc": 2872,
              "st": 1153
            },
            "2020": {
              "general": 12670,
              "ews": 1995,
              "obc": 3898,
              "sc": 2811,
              "st": 1128
            }
          }
        },
        "fees": 150000,
        "seats": 68
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 23545,
              "ews": 3926,
              "obc": 8500,
              "sc": 4960,
              "st": 2004
            },
            "2023": {
              "general": 23074,
              "ews": 3847,
              "obc": 8330,
              "sc": 4860,
              "st": 1963
            },
            "2022": {
              "general": 22603,
              "ews": 3768,
              "obc": 8160,
              "sc": 4761,
              "st": 1923
            },
            "2021": {
              "general": 22132,
              "ews": 3690,
              "obc": 7990,
              "sc": 4662,
              "st": 1883
            },
            "2020": {
              "general": 21661,
              "ews": 3611,
              "obc": 7820,
              "sc": 4563,
              "st": 1843
            }
          }
        },
        "fees": 150000,
        "seats": 68
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 19167,
              "ews": 3023,
              "obc": 6454,
              "sc": 4553,
              "st": 2164
            },
            "2023": {
              "general": 18783,
              "ews": 2962,
              "obc": 6324,
              "sc": 4461,
              "st": 2120
            },
            "2022": {
              "general": 18400,
              "ews": 2902,
              "obc": 6195,
              "sc": 4370,
              "st": 2077
            },
            "2021": {
              "general": 18016,
              "ews": 2841,
              "obc": 6066,
              "sc": 4279,
              "st": 2034
            },
            "2020": {
              "general": 17633,
              "ews": 2781,
              "obc": 5937,
              "sc": 4188,
              "st": 1990
            }
          }
        },
        "fees": 150000,
        "seats": 68
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 32781,
              "ews": 6012,
              "obc": 13008,
              "sc": 6164,
              "st": 3096
            },
            "2023": {
              "general": 32125,
              "ews": 5891,
              "obc": 12747,
              "sc": 6040,
              "st": 3034
            },
            "2022": {
              "general": 31469,
              "ews": 5771,
              "obc": 12487,
              "sc": 5917,
              "st": 2972
            },
            "2021": {
              "general": 30814,
              "ews": 5651,
              "obc": 12227,
              "sc": 5794,
              "st": 2910
            },
            "2020": {
              "general": 30158,
              "ews": 5531,
              "obc": 11967,
              "sc": 5670,
              "st": 2848
            }
          }
        },
        "fees": 150000,
        "seats": 68
      },
      {
        "name": "Materials Science and Engineering",
        "code": "MSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 45178,
              "ews": 7413,
              "obc": 15705,
              "sc": 7573,
              "st": 3191
            },
            "2023": {
              "general": 44274,
              "ews": 7264,
              "obc": 15390,
              "sc": 7421,
              "st": 3127
            },
            "2022": {
              "general": 43370,
              "ews": 7116,
              "obc": 15076,
              "sc": 7270,
              "st": 3063
            },
            "2021": {
              "general": 42467,
              "ews": 6968,
              "obc": 14762,
              "sc": 7118,
              "st": 2999
            },
            "2020": {
              "general": 41563,
              "ews": 6819,
              "obc": 14448,
              "sc": 6967,
              "st": 2935
            }
          }
        },
        "fees": 150000,
        "seats": 68
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 14542,
              "ews": 2365,
              "obc": 5629,
              "sc": 3642,
              "st": 1521
            },
            "2023": {
              "general": 14251,
              "ews": 2317,
              "obc": 5516,
              "sc": 3569,
              "st": 1490
            },
            "2022": {
              "general": 13960,
              "ews": 2270,
              "obc": 5403,
              "sc": 3496,
              "st": 1460
            },
            "2021": {
              "general": 13669,
              "ews": 2223,
              "obc": 5291,
              "sc": 3423,
              "st": 1429
            },
            "2020": {
              "general": 13378,
              "ews": 2175,
              "obc": 5178,
              "sc": 3350,
              "st": 1399
            }
          }
        },
        "fees": 150000,
        "seats": 68
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 32633,
              "ews": 5647,
              "obc": 11902,
              "sc": 6126,
              "st": 2365
            },
            "2023": {
              "general": 31980,
              "ews": 5534,
              "obc": 11663,
              "sc": 6003,
              "st": 2317
            },
            "2022": {
              "general": 31327,
              "ews": 5421,
              "obc": 11425,
              "sc": 5880,
              "st": 2270
            },
            "2021": {
              "general": 30675,
              "ews": 5308,
              "obc": 11187,
              "sc": 5758,
              "st": 2223
            },
            "2020": {
              "general": 30022,
              "ews": 5195,
              "obc": 10949,
              "sc": 5635,
              "st": 2175
            }
          }
        },
        "fees": 150000,
        "seats": 68
      }
    ]
  },
  {
    "id": 89,
    "name": "National Institute of Technology Karnataka, Surathkal",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Artificial Intelligence",
        "code": "AI",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 2486,
              "ews": 356,
              "obc": 740,
              "sc": 586,
              "st": 224
            },
            "2023": {
              "general": 2436,
              "ews": 348,
              "obc": 725,
              "sc": 574,
              "st": 219
            },
            "2022": {
              "general": 2386,
              "ews": 341,
              "obc": 710,
              "sc": 562,
              "st": 215
            },
            "2021": {
              "general": 2336,
              "ews": 334,
              "obc": 695,
              "sc": 550,
              "st": 210
            },
            "2020": {
              "general": 2287,
              "ews": 327,
              "obc": 680,
              "sc": 539,
              "st": 206
            }
          }
        },
        "fees": 150000,
        "seats": 69
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 14669,
              "ews": 2572,
              "obc": 5596,
              "sc": 3704,
              "st": 1229
            },
            "2023": {
              "general": 14375,
              "ews": 2520,
              "obc": 5484,
              "sc": 3629,
              "st": 1204
            },
            "2022": {
              "general": 14082,
              "ews": 2469,
              "obc": 5372,
              "sc": 3555,
              "st": 1179
            },
            "2021": {
              "general": 13788,
              "ews": 2417,
              "obc": 5260,
              "sc": 3481,
              "st": 1155
            },
            "2020": {
              "general": 13495,
              "ews": 2366,
              "obc": 5148,
              "sc": 3407,
              "st": 1130
            }
          }
        },
        "fees": 150000,
        "seats": 69
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 21379,
              "ews": 3453,
              "obc": 7544,
              "sc": 4134,
              "st": 1010
            },
            "2023": {
              "general": 20951,
              "ews": 3383,
              "obc": 7393,
              "sc": 4051,
              "st": 989
            },
            "2022": {
              "general": 20523,
              "ews": 3314,
              "obc": 7242,
              "sc": 3968,
              "st": 969
            },
            "2021": {
              "general": 20096,
              "ews": 3245,
              "obc": 7091,
              "sc": 3885,
              "st": 949
            },
            "2020": {
              "general": 19668,
              "ews": 3176,
              "obc": 6940,
              "sc": 3803,
              "st": 929
            }
          }
        },
        "fees": 150000,
        "seats": 69
      },
      {
        "name": "Computational and Data Science",
        "code": "CDS",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 2952,
              "ews": 416,
              "obc": 1101,
              "sc": 979,
              "st": 232
            },
            "2023": {
              "general": 2892,
              "ews": 407,
              "obc": 1078,
              "sc": 959,
              "st": 227
            },
            "2022": {
              "general": 2833,
              "ews": 399,
              "obc": 1056,
              "sc": 939,
              "st": 222
            },
            "2021": {
              "general": 2774,
              "ews": 391,
              "obc": 1034,
              "sc": 920,
              "st": 218
            },
            "2020": {
              "general": 2715,
              "ews": 382,
              "obc": 1012,
              "sc": 900,
              "st": 213
            }
          }
        },
        "fees": 150000,
        "seats": 69
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 1441,
              "ews": 309,
              "obc": 519,
              "sc": 324,
              "st": 153
            },
            "2023": {
              "general": 1412,
              "ews": 302,
              "obc": 508,
              "sc": 317,
              "st": 149
            },
            "2022": {
              "general": 1383,
              "ews": 296,
              "obc": 498,
              "sc": 311,
              "st": 146
            },
            "2021": {
              "general": 1354,
              "ews": 290,
              "obc": 487,
              "sc": 304,
              "st": 143
            },
            "2020": {
              "general": 1325,
              "ews": 284,
              "obc": 477,
              "sc": 298,
              "st": 140
            }
          }
        },
        "fees": 150000,
        "seats": 69
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 6490,
              "ews": 1155,
              "obc": 2378,
              "sc": 1710,
              "st": 366
            },
            "2023": {
              "general": 6360,
              "ews": 1131,
              "obc": 2330,
              "sc": 1675,
              "st": 358
            },
            "2022": {
              "general": 6230,
              "ews": 1108,
              "obc": 2282,
              "sc": 1641,
              "st": 351
            },
            "2021": {
              "general": 6100,
              "ews": 1085,
              "obc": 2235,
              "sc": 1607,
              "st": 344
            },
            "2020": {
              "general": 5970,
              "ews": 1062,
              "obc": 2187,
              "sc": 1573,
              "st": 336
            }
          }
        },
        "fees": 150000,
        "seats": 69
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 3871,
              "ews": 689,
              "obc": 1565,
              "sc": 986,
              "st": 309
            },
            "2023": {
              "general": 3793,
              "ews": 675,
              "obc": 1533,
              "sc": 966,
              "st": 302
            },
            "2022": {
              "general": 3716,
              "ews": 661,
              "obc": 1502,
              "sc": 946,
              "st": 296
            },
            "2021": {
              "general": 3638,
              "ews": 647,
              "obc": 1471,
              "sc": 926,
              "st": 290
            },
            "2020": {
              "general": 3561,
              "ews": 633,
              "obc": 1439,
              "sc": 907,
              "st": 284
            }
          }
        },
        "fees": 150000,
        "seats": 69
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 2842,
              "ews": 398,
              "obc": 1038,
              "sc": 852,
              "st": 158
            },
            "2023": {
              "general": 2785,
              "ews": 390,
              "obc": 1017,
              "sc": 834,
              "st": 154
            },
            "2022": {
              "general": 2728,
              "ews": 382,
              "obc": 996,
              "sc": 817,
              "st": 151
            },
            "2021": {
              "general": 2671,
              "ews": 374,
              "obc": 975,
              "sc": 800,
              "st": 148
            },
            "2020": {
              "general": 2614,
              "ews": 366,
              "obc": 954,
              "sc": 783,
              "st": 145
            }
          }
        },
        "fees": 150000,
        "seats": 69
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 10643,
              "ews": 1997,
              "obc": 4882,
              "sc": 2633,
              "st": 1134
            },
            "2023": {
              "general": 10430,
              "ews": 1957,
              "obc": 4784,
              "sc": 2580,
              "st": 1111
            },
            "2022": {
              "general": 10217,
              "ews": 1917,
              "obc": 4686,
              "sc": 2527,
              "st": 1088
            },
            "2021": {
              "general": 10004,
              "ews": 1877,
              "obc": 4589,
              "sc": 2475,
              "st": 1065
            },
            "2020": {
              "general": 9791,
              "ews": 1837,
              "obc": 4491,
              "sc": 2422,
              "st": 1043
            }
          }
        },
        "fees": 150000,
        "seats": 69
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 23075,
              "ews": 4294,
              "obc": 9034,
              "sc": 5257,
              "st": 2069
            },
            "2023": {
              "general": 22613,
              "ews": 4208,
              "obc": 8853,
              "sc": 5151,
              "st": 2027
            },
            "2022": {
              "general": 22152,
              "ews": 4122,
              "obc": 8672,
              "sc": 5046,
              "st": 1986
            },
            "2021": {
              "general": 21690,
              "ews": 4036,
              "obc": 8491,
              "sc": 4941,
              "st": 1944
            },
            "2020": {
              "general": 21229,
              "ews": 3950,
              "obc": 8311,
              "sc": 4836,
              "st": 1903
            }
          }
        },
        "fees": 150000,
        "seats": 69
      },
      {
        "name": "Mining Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 27493,
              "ews": 4482,
              "obc": 10458,
              "sc": 5712,
              "st": 1538
            },
            "2023": {
              "general": 26943,
              "ews": 4392,
              "obc": 10248,
              "sc": 5597,
              "st": 1507
            },
            "2022": {
              "general": 26393,
              "ews": 4302,
              "obc": 10039,
              "sc": 5483,
              "st": 1476
            },
            "2021": {
              "general": 25843,
              "ews": 4213,
              "obc": 9830,
              "sc": 5369,
              "st": 1445
            },
            "2020": {
              "general": 25293,
              "ews": 4123,
              "obc": 9621,
              "sc": 5255,
              "st": 1414
            }
          }
        },
        "fees": 150000,
        "seats": 69
      }
    ]
  },
  {
    "id": 90,
    "name": "National Institute of Technology Meghalaya",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 48731,
              "st": 2156,
              "ews": 7929,
              "obc": 17008,
              "sc": 7662
            },
            "2023": {
              "general": 47756,
              "st": 2112,
              "ews": 7770,
              "obc": 16667,
              "sc": 7508
            },
            "2022": {
              "general": 46781,
              "st": 2069,
              "ews": 7611,
              "obc": 16327,
              "sc": 7355
            },
            "2021": {
              "general": 45807,
              "st": 2026,
              "ews": 7453,
              "obc": 15987,
              "sc": 7202
            },
            "2020": {
              "general": 44832,
              "st": 1983,
              "ews": 7294,
              "obc": 15647,
              "sc": 7049
            }
          }
        },
        "fees": 150000,
        "seats": 70
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 20013,
              "ews": 3117,
              "sc": 3059,
              "st": 1031,
              "obc": 6373
            },
            "2023": {
              "general": 19612,
              "ews": 3054,
              "sc": 2997,
              "st": 1010,
              "obc": 6245
            },
            "2022": {
              "general": 19212,
              "ews": 2992,
              "sc": 2936,
              "st": 989,
              "obc": 6118
            },
            "2021": {
              "general": 18812,
              "ews": 2929,
              "sc": 2875,
              "st": 969,
              "obc": 5990
            },
            "2020": {
              "general": 18411,
              "ews": 2867,
              "sc": 2814,
              "st": 948,
              "obc": 5863
            }
          }
        },
        "fees": 150000,
        "seats": 70
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 34741,
              "ews": 6309,
              "sc": 7193,
              "st": 18350,
              "obc": 12614
            },
            "2023": {
              "general": 34046,
              "ews": 6182,
              "sc": 7049,
              "st": 17983,
              "obc": 12361
            },
            "2022": {
              "general": 33351,
              "ews": 6056,
              "sc": 6905,
              "st": 17616,
              "obc": 12109
            },
            "2021": {
              "general": 32656,
              "ews": 5930,
              "sc": 6761,
              "st": 17249,
              "obc": 11857
            },
            "2020": {
              "general": 31961,
              "ews": 5804,
              "sc": 6617,
              "st": 16882,
              "obc": 11604
            }
          }
        },
        "fees": 150000,
        "seats": 70
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 28402,
              "st": 1463,
              "ews": 4534,
              "obc": 9463,
              "sc": 4878
            },
            "2023": {
              "general": 27833,
              "st": 1433,
              "ews": 4443,
              "obc": 9273,
              "sc": 4780
            },
            "2022": {
              "general": 27265,
              "st": 1404,
              "ews": 4352,
              "obc": 9084,
              "sc": 4682
            },
            "2021": {
              "general": 26697,
              "st": 1375,
              "ews": 4261,
              "obc": 8895,
              "sc": 4585
            },
            "2020": {
              "general": 26129,
              "st": 1345,
              "ews": 4171,
              "obc": 8705,
              "sc": 4487
            }
          }
        },
        "fees": 150000,
        "seats": 70
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 46582,
              "sc": 7521,
              "st": 2952,
              "ews": 7661,
              "obc": 14581
            },
            "2023": {
              "general": 45650,
              "sc": 7370,
              "st": 2892,
              "ews": 7507,
              "obc": 14289
            },
            "2022": {
              "general": 44718,
              "sc": 7220,
              "st": 2833,
              "ews": 7354,
              "obc": 13997
            },
            "2021": {
              "general": 43787,
              "sc": 7069,
              "st": 2774,
              "ews": 7201,
              "obc": 13706
            },
            "2020": {
              "general": 42855,
              "sc": 6919,
              "st": 2715,
              "ews": 7048,
              "obc": 13414
            }
          }
        },
        "fees": 150000,
        "seats": 70
      }
    ]
  },
  {
    "id": 91,
    "name": "National Institute of Technology Nagaland",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "st": 11973,
              "general": 54994,
              "ews": 9364,
              "obc": 17686,
              "sc": 8804
            },
            "2023": {
              "st": 11733,
              "general": 53894,
              "ews": 9176,
              "obc": 17332,
              "sc": 8627
            },
            "2022": {
              "st": 11494,
              "general": 52794,
              "ews": 8989,
              "obc": 16978,
              "sc": 8451
            },
            "2021": {
              "st": 11254,
              "general": 51694,
              "ews": 8802,
              "obc": 16624,
              "sc": 8275
            },
            "2020": {
              "st": 11015,
              "general": 50594,
              "ews": 8614,
              "obc": 16271,
              "sc": 8099
            }
          }
        },
        "fees": 150000,
        "seats": 71
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "st": 10791,
              "general": 31298,
              "ews": 5233,
              "obc": 10561,
              "sc": 4460
            },
            "2023": {
              "st": 10575,
              "general": 30672,
              "ews": 5128,
              "obc": 10349,
              "sc": 4370
            },
            "2022": {
              "st": 10359,
              "general": 30046,
              "ews": 5023,
              "obc": 10138,
              "sc": 4281
            },
            "2021": {
              "st": 10143,
              "general": 29420,
              "ews": 4919,
              "obc": 9927,
              "sc": 4192
            },
            "2020": {
              "st": 9927,
              "general": 28794,
              "ews": 4814,
              "obc": 9716,
              "sc": 4103
            }
          }
        },
        "fees": 150000,
        "seats": 71
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "st": 20854,
              "general": 45326,
              "ews": 7920,
              "obc": 15216,
              "sc": 6738
            },
            "2023": {
              "st": 20436,
              "general": 44419,
              "ews": 7761,
              "obc": 14911,
              "sc": 6603
            },
            "2022": {
              "st": 20019,
              "general": 43512,
              "ews": 7603,
              "obc": 14607,
              "sc": 6468
            },
            "2021": {
              "st": 19602,
              "general": 42606,
              "ews": 7444,
              "obc": 14303,
              "sc": 6333
            },
            "2020": {
              "st": 19185,
              "general": 41699,
              "ews": 7286,
              "obc": 13998,
              "sc": 6198
            }
          }
        },
        "fees": 150000,
        "seats": 71
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "st": 29330,
              "general": 40015,
              "ews": 6950,
              "obc": 13249,
              "sc": 6439
            },
            "2023": {
              "st": 28743,
              "general": 39214,
              "ews": 6811,
              "obc": 12984,
              "sc": 6310
            },
            "2022": {
              "st": 28156,
              "general": 38414,
              "ews": 6672,
              "obc": 12719,
              "sc": 6181
            },
            "2021": {
              "st": 27570,
              "general": 37614,
              "ews": 6533,
              "obc": 12454,
              "sc": 6052
            },
            "2020": {
              "st": 26983,
              "general": 36813,
              "ews": 6394,
              "obc": 12189,
              "sc": 5923
            }
          }
        },
        "fees": 150000,
        "seats": 71
      },
      {
        "name": "Electronics and Instrumentation Engineering",
        "code": "EIE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "st": 32284,
              "general": 47219,
              "ews": 8221,
              "obc": 15835,
              "sc": 8353
            },
            "2023": {
              "st": 31638,
              "general": 46274,
              "ews": 8056,
              "obc": 15518,
              "sc": 8185
            },
            "2022": {
              "st": 30992,
              "general": 45330,
              "ews": 7892,
              "obc": 15201,
              "sc": 8018
            },
            "2021": {
              "st": 30346,
              "general": 44385,
              "ews": 7727,
              "obc": 14884,
              "sc": 7851
            },
            "2020": {
              "st": 29701,
              "general": 43441,
              "ews": 7563,
              "obc": 14568,
              "sc": 7684
            }
          }
        },
        "fees": 150000,
        "seats": 71
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "st": 19275,
              "general": 50535,
              "ews": 8644,
              "obc": 17245,
              "sc": 7715
            },
            "2023": {
              "st": 18889,
              "general": 49524,
              "ews": 8471,
              "obc": 16900,
              "sc": 7560
            },
            "2022": {
              "st": 18504,
              "general": 48513,
              "ews": 8298,
              "obc": 16555,
              "sc": 7406
            },
            "2021": {
              "st": 18118,
              "general": 47502,
              "ews": 8125,
              "obc": 16210,
              "sc": 7252
            },
            "2020": {
              "st": 17733,
              "general": 46492,
              "ews": 7952,
              "obc": 15865,
              "sc": 7097
            }
          }
        },
        "fees": 150000,
        "seats": 71
      }
    ]
  },
  {
    "id": 92,
    "name": "National Institute of Technology Patna",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 1540,
              "ews": 723,
              "obc": 907,
              "sc": 203,
              "st": 167
            },
            "2023": {
              "general": 1509,
              "ews": 708,
              "obc": 888,
              "sc": 198,
              "st": 163
            },
            "2022": {
              "general": 1478,
              "ews": 694,
              "obc": 870,
              "sc": 194,
              "st": 160
            },
            "2021": {
              "general": 1447,
              "ews": 679,
              "obc": 852,
              "sc": 190,
              "st": 156
            },
            "2020": {
              "general": 1416,
              "ews": 665,
              "obc": 834,
              "sc": 186,
              "st": 153
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Chemical Technology",
        "code": "CT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 36034,
              "ews": 8134,
              "obc": 15803,
              "sc": 9246
            },
            "2023": {
              "general": 35313,
              "ews": 7971,
              "obc": 15486,
              "sc": 9061
            },
            "2022": {
              "general": 34592,
              "ews": 7808,
              "obc": 15170,
              "sc": 8876
            },
            "2021": {
              "general": 33871,
              "ews": 7645,
              "obc": 14854,
              "sc": 8691
            },
            "2020": {
              "general": 33151,
              "ews": 7483,
              "obc": 14538,
              "sc": 8506
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 43739,
              "ews": 7174,
              "obc": 15153,
              "sc": 7211,
              "st": 2105
            },
            "2023": {
              "general": 42864,
              "ews": 7030,
              "obc": 14849,
              "sc": 7066,
              "st": 2062
            },
            "2022": {
              "general": 41989,
              "ews": 6887,
              "obc": 14546,
              "sc": 6922,
              "st": 2020
            },
            "2021": {
              "general": 41114,
              "ews": 6743,
              "obc": 14243,
              "sc": 6778,
              "st": 1978
            },
            "2020": {
              "general": 40239,
              "ews": 6600,
              "obc": 13940,
              "sc": 6634,
              "st": 1936
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Civil Engineering with Specialization in Construction Technology and Management",
        "code": "CESCT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 42411,
              "obc": 15361,
              "sc": 7321
            },
            "2023": {
              "general": 41562,
              "obc": 15053,
              "sc": 7174
            },
            "2022": {
              "general": 40714,
              "obc": 14746,
              "sc": 7028
            },
            "2021": {
              "general": 39866,
              "obc": 14439,
              "sc": 6881
            },
            "2020": {
              "general": 39018,
              "obc": 14132,
              "sc": 6735
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 12992,
              "ews": 2201,
              "obc": 4742,
              "sc": 2894,
              "st": 963
            },
            "2023": {
              "general": 12732,
              "ews": 2156,
              "obc": 4647,
              "sc": 2836,
              "st": 943
            },
            "2022": {
              "general": 12472,
              "ews": 2112,
              "obc": 4552,
              "sc": 2778,
              "st": 924
            },
            "2021": {
              "general": 12212,
              "ews": 2068,
              "obc": 4457,
              "sc": 2720,
              "st": 905
            },
            "2020": {
              "general": 11952,
              "ews": 2024,
              "obc": 4362,
              "sc": 2662,
              "st": 885
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Computer Science and Engineering with Specialization in Cyber Security",
        "code": "CSESC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 15093,
              "ews": 2363,
              "obc": 5641,
              "sc": 2577,
              "st": 1436
            },
            "2023": {
              "general": 14791,
              "ews": 2315,
              "obc": 5528,
              "sc": 2525,
              "st": 1407
            },
            "2022": {
              "general": 14489,
              "ews": 2268,
              "obc": 5415,
              "sc": 2473,
              "st": 1378
            },
            "2021": {
              "general": 14187,
              "ews": 2221,
              "obc": 5302,
              "sc": 2422,
              "st": 1349
            },
            "2020": {
              "general": 13885,
              "ews": 2173,
              "obc": 5189,
              "sc": 2370,
              "st": 1321
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Computer Science and Engineering with Specialization in Data Science",
        "code": "CSESD",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 13497,
              "ews": 2254,
              "obc": 5654,
              "sc": 2766,
              "st": 1461
            },
            "2023": {
              "general": 13227,
              "ews": 2208,
              "obc": 5540,
              "sc": 2710,
              "st": 1431
            },
            "2022": {
              "general": 12957,
              "ews": 2163,
              "obc": 5427,
              "sc": 2655,
              "st": 1402
            },
            "2021": {
              "general": 12687,
              "ews": 2118,
              "obc": 5314,
              "sc": 2600,
              "st": 1373
            },
            "2020": {
              "general": 12417,
              "ews": 2073,
              "obc": 5201,
              "sc": 2544,
              "st": 1344
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 24282,
              "ews": 4149,
              "obc": 8259,
              "sc": 5351,
              "st": 2117
            },
            "2023": {
              "general": 23796,
              "ews": 4066,
              "obc": 8093,
              "sc": 5243,
              "st": 2074
            },
            "2022": {
              "general": 23310,
              "ews": 3983,
              "obc": 7928,
              "sc": 5136,
              "st": 2032
            },
            "2021": {
              "general": 22825,
              "ews": 3900,
              "obc": 7763,
              "sc": 5029,
              "st": 1989
            },
            "2020": {
              "general": 22339,
              "ews": 3817,
              "obc": 7598,
              "sc": 4922,
              "st": 1947
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Electrical Engineering with Specialization In Power System Engineering",
        "code": "EESIP",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 25245,
              "ews": 4289,
              "obc": 9100,
              "sc": 5378,
              "st": 2218
            },
            "2023": {
              "general": 24740,
              "ews": 4203,
              "obc": 8918,
              "sc": 5270,
              "st": 2173
            },
            "2022": {
              "general": 24235,
              "ews": 4117,
              "obc": 8736,
              "sc": 5162,
              "st": 2129
            },
            "2021": {
              "general": 23730,
              "ews": 4031,
              "obc": 8554,
              "sc": 5055,
              "st": 2084
            },
            "2020": {
              "general": 23225,
              "ews": 3945,
              "obc": 8372,
              "sc": 4947,
              "st": 2040
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 18743,
              "ews": 3046,
              "obc": 6680,
              "sc": 4139,
              "st": 1540
            },
            "2023": {
              "general": 18368,
              "ews": 2985,
              "obc": 6546,
              "sc": 4056,
              "st": 1509
            },
            "2022": {
              "general": 17993,
              "ews": 2924,
              "obc": 6412,
              "sc": 3973,
              "st": 1478
            },
            "2021": {
              "general": 17618,
              "ews": 2863,
              "obc": 6279,
              "sc": 3890,
              "st": 1447
            },
            "2020": {
              "general": 17243,
              "ews": 2802,
              "obc": 6145,
              "sc": 3807,
              "st": 1416
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Electronics and Communication Engineering with Specialization in Microelectronics and VLSI System Design",
        "code": "ECESM",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 20768,
              "ews": 3523,
              "obc": 6172,
              "sc": 3928,
              "st": 1553
            },
            "2023": {
              "general": 20352,
              "ews": 3452,
              "obc": 6048,
              "sc": 3849,
              "st": 1521
            },
            "2022": {
              "general": 19937,
              "ews": 3382,
              "obc": 5925,
              "sc": 3770,
              "st": 1490
            },
            "2021": {
              "general": 19521,
              "ews": 3311,
              "obc": 5801,
              "sc": 3692,
              "st": 1459
            },
            "2020": {
              "general": 19106,
              "ews": 3241,
              "obc": 5678,
              "sc": 3613,
              "st": 1428
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Material Science and Engineering",
        "code": "MSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 18938,
              "ews": 6442,
              "obc": 13860,
              "sc": 9597
            },
            "2023": {
              "general": 18559,
              "ews": 6313,
              "obc": 13582,
              "sc": 9405
            },
            "2022": {
              "general": 18180,
              "ews": 6184,
              "obc": 13305,
              "sc": 9213
            },
            "2021": {
              "general": 17801,
              "ews": 6055,
              "obc": 13028,
              "sc": 9021
            },
            "2020": {
              "general": 17422,
              "ews": 5926,
              "obc": 12751,
              "sc": 8829
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Mathematics and Computing Technology",
        "code": "MCT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 15362,
              "obc": 5804,
              "sc": 4836
            },
            "2023": {
              "general": 15054,
              "obc": 5687,
              "sc": 4739
            },
            "2022": {
              "general": 14747,
              "obc": 5571,
              "sc": 4642
            },
            "2021": {
              "general": 14440,
              "obc": 5455,
              "sc": 4545
            },
            "2020": {
              "general": 14133,
              "obc": 5339,
              "sc": 4449
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 34544,
              "ews": 5869,
              "obc": 11809,
              "sc": 6213,
              "st": 2334
            },
            "2023": {
              "general": 33853,
              "ews": 5751,
              "obc": 11572,
              "sc": 6088,
              "st": 2287
            },
            "2022": {
              "general": 33162,
              "ews": 5634,
              "obc": 11336,
              "sc": 5964,
              "st": 2240
            },
            "2021": {
              "general": 32471,
              "ews": 5516,
              "obc": 11100,
              "sc": 5840,
              "st": 2193
            },
            "2020": {
              "general": 31780,
              "ews": 5399,
              "obc": 10864,
              "sc": 5715,
              "st": 2147
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Mechanical Engineering with Specialization in Manufacturing and Industrial Engineering",
        "code": "MESMI",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 37408,
              "ews": 6094,
              "obc": 11327,
              "sc": 6664,
              "st": 2620
            },
            "2023": {
              "general": 36659,
              "ews": 5972,
              "obc": 11100,
              "sc": 6530,
              "st": 2567
            },
            "2022": {
              "general": 35911,
              "ews": 5850,
              "obc": 10873,
              "sc": 6397,
              "st": 2515
            },
            "2021": {
              "general": 35163,
              "ews": 5728,
              "obc": 10647,
              "sc": 6264,
              "st": 2462
            },
            "2020": {
              "general": 34415,
              "ews": 5606,
              "obc": 10420,
              "sc": 6130,
              "st": 2410
            }
          }
        },
        "fees": 150000,
        "seats": 72
      },
      {
        "name": "Mechatronics and Automation Engineering",
        "code": "MAE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 24053,
              "ews": 4391,
              "obc": 8711,
              "sc": 5641,
              "st": 4513
            },
            "2023": {
              "general": 23571,
              "ews": 4303,
              "obc": 8536,
              "sc": 5528,
              "st": 4422
            },
            "2022": {
              "general": 23090,
              "ews": 4215,
              "obc": 8362,
              "sc": 5415,
              "st": 4332
            },
            "2021": {
              "general": 22609,
              "ews": 4127,
              "obc": 8188,
              "sc": 5302,
              "st": 4242
            },
            "2020": {
              "general": 22128,
              "ews": 4039,
              "obc": 8014,
              "sc": 5189,
              "st": 4151
            }
          }
        },
        "fees": 150000,
        "seats": 72
      }
    ]
  },
  {
    "id": 93,
    "name": "National Institute of Technology Puducherry",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 46496,
              "obc": 15543,
              "sc": 7386,
              "ews": 7990,
              "st": 2265
            },
            "2023": {
              "general": 45566,
              "obc": 15232,
              "sc": 7238,
              "ews": 7830,
              "st": 2219
            },
            "2022": {
              "general": 44636,
              "obc": 14921,
              "sc": 7090,
              "ews": 7670,
              "st": 2174
            },
            "2021": {
              "general": 43706,
              "obc": 14610,
              "sc": 6942,
              "ews": 7510,
              "st": 2129
            },
            "2020": {
              "general": 42776,
              "obc": 14299,
              "sc": 6795,
              "ews": 7350,
              "st": 2083
            }
          }
        },
        "fees": 150000,
        "seats": 73
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 16917,
              "ews": 2844,
              "obc": 6354,
              "sc": 3160,
              "st": 792
            },
            "2023": {
              "general": 16578,
              "ews": 2787,
              "obc": 6226,
              "sc": 3096,
              "st": 776
            },
            "2022": {
              "general": 16240,
              "ews": 2730,
              "obc": 6099,
              "sc": 3033,
              "st": 760
            },
            "2021": {
              "general": 15901,
              "ews": 2673,
              "obc": 5972,
              "sc": 2970,
              "st": 744
            },
            "2020": {
              "general": 15563,
              "ews": 2616,
              "obc": 5845,
              "sc": 2907,
              "st": 728
            }
          }
        },
        "fees": 150000,
        "seats": 73
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 28670,
              "obc": 11164,
              "sc": 5533,
              "ews": 5184,
              "st": 1858
            },
            "2023": {
              "general": 28096,
              "obc": 10940,
              "sc": 5422,
              "ews": 5080,
              "st": 1820
            },
            "2022": {
              "general": 27523,
              "obc": 10717,
              "sc": 5311,
              "ews": 4976,
              "st": 1783
            },
            "2021": {
              "general": 26949,
              "obc": 10494,
              "sc": 5201,
              "ews": 4872,
              "st": 1746
            },
            "2020": {
              "general": 26376,
              "obc": 10270,
              "sc": 5090,
              "ews": 4769,
              "st": 1709
            }
          }
        },
        "fees": 150000,
        "seats": 73
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 23799,
              "ews": 3933,
              "obc": 8478,
              "sc": 4866,
              "st": 1296
            },
            "2023": {
              "general": 23323,
              "ews": 3854,
              "obc": 8308,
              "sc": 4768,
              "st": 1270
            },
            "2022": {
              "general": 22847,
              "ews": 3775,
              "obc": 8138,
              "sc": 4671,
              "st": 1244
            },
            "2021": {
              "general": 22371,
              "ews": 3697,
              "obc": 7969,
              "sc": 4574,
              "st": 1218
            },
            "2020": {
              "general": 21895,
              "ews": 3618,
              "obc": 7799,
              "sc": 4476,
              "st": 1192
            }
          }
        },
        "fees": 150000,
        "seats": 73
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 39217,
              "obc": 13200,
              "sc": 6958,
              "ews": 6452
            },
            "2023": {
              "general": 38432,
              "obc": 12936,
              "sc": 6818,
              "ews": 6322
            },
            "2022": {
              "general": 37648,
              "obc": 12672,
              "sc": 6679,
              "ews": 6193
            },
            "2021": {
              "general": 36863,
              "obc": 12408,
              "sc": 6540,
              "ews": 6064
            },
            "2020": {
              "general": 36079,
              "obc": 12144,
              "sc": 6401,
              "ews": 5935
            }
          }
        },
        "fees": 150000,
        "seats": 73
      }
    ]
  },
  {
    "id": 94,
    "name": "National Institute of Technology Raipur",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 1422,
              "ews": 712,
              "obc": 836,
              "sc": 369,
              "st": 201
            },
            "2023": {
              "general": 1393,
              "ews": 697,
              "obc": 819,
              "sc": 361,
              "st": 196
            },
            "2022": {
              "general": 1365,
              "ews": 683,
              "obc": 802,
              "sc": 354,
              "st": 192
            },
            "2021": {
              "general": 1336,
              "ews": 669,
              "obc": 785,
              "sc": 346,
              "st": 188
            },
            "2020": {
              "general": 1308,
              "ews": 655,
              "obc": 769,
              "sc": 339,
              "st": 184
            }
          }
        },
        "fees": 150000,
        "seats": 74
      },
      {
        "name": "Bio Medical Engineering",
        "code": "BME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 52108,
              "ews": 8679,
              "obc": 17406,
              "sc": 8114,
              "st": 3472
            },
            "2023": {
              "general": 51065,
              "ews": 8505,
              "obc": 17057,
              "sc": 7951,
              "st": 3402
            },
            "2022": {
              "general": 50023,
              "ews": 8331,
              "obc": 16709,
              "sc": 7789,
              "st": 3333
            },
            "2021": {
              "general": 48981,
              "ews": 8158,
              "obc": 16361,
              "sc": 7627,
              "st": 3263
            },
            "2020": {
              "general": 47939,
              "ews": 7984,
              "obc": 16013,
              "sc": 7464,
              "st": 3194
            }
          }
        },
        "fees": 150000,
        "seats": 74
      },
      {
        "name": "Bio Technology",
        "code": "BT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 50528,
              "ews": 8407,
              "obc": 16882,
              "sc": 8050,
              "st": 3250
            },
            "2023": {
              "general": 49517,
              "ews": 8238,
              "obc": 16544,
              "sc": 7889,
              "st": 3185
            },
            "2022": {
              "general": 48506,
              "ews": 8070,
              "obc": 16206,
              "sc": 7728,
              "st": 3120
            },
            "2021": {
              "general": 47496,
              "ews": 7902,
              "obc": 15869,
              "sc": 7567,
              "st": 3055
            },
            "2020": {
              "general": 46485,
              "ews": 7734,
              "obc": 15531,
              "sc": 7406,
              "st": 2990
            }
          }
        },
        "fees": 150000,
        "seats": 74
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 37761,
              "ews": 6331,
              "obc": 13150,
              "sc": 7064,
              "st": 2543
            },
            "2023": {
              "general": 37005,
              "ews": 6204,
              "obc": 12887,
              "sc": 6922,
              "st": 2492
            },
            "2022": {
              "general": 36250,
              "ews": 6077,
              "obc": 12624,
              "sc": 6781,
              "st": 2441
            },
            "2021": {
              "general": 35495,
              "ews": 5951,
              "obc": 12361,
              "sc": 6640,
              "st": 2390
            },
            "2020": {
              "general": 34740,
              "ews": 5824,
              "obc": 12098,
              "sc": 6498,
              "st": 2339
            }
          }
        },
        "fees": 150000,
        "seats": 74
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 42884,
              "ews": 7009,
              "obc": 15040,
              "sc": 7286,
              "st": 2133
            },
            "2023": {
              "general": 42026,
              "ews": 6868,
              "obc": 14739,
              "sc": 7140,
              "st": 2090
            },
            "2022": {
              "general": 41168,
              "ews": 6728,
              "obc": 14438,
              "sc": 6994,
              "st": 2047
            },
            "2021": {
              "general": 40310,
              "ews": 6588,
              "obc": 14137,
              "sc": 6848,
              "st": 2005
            },
            "2020": {
              "general": 39453,
              "ews": 6448,
              "obc": 13836,
              "sc": 6703,
              "st": 1962
            }
          }
        },
        "fees": 150000,
        "seats": 74
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 11549,
              "ews": 1778,
              "obc": 4208,
              "sc": 2860,
              "st": 974
            },
            "2023": {
              "general": 11318,
              "ews": 1742,
              "obc": 4123,
              "sc": 2802,
              "st": 954
            },
            "2022": {
              "general": 11087,
              "ews": 1706,
              "obc": 4039,
              "sc": 2745,
              "st": 935
            },
            "2021": {
              "general": 10856,
              "ews": 1671,
              "obc": 3955,
              "sc": 2688,
              "st": 915
            },
            "2020": {
              "general": 10625,
              "ews": 1635,
              "obc": 3871,
              "sc": 2631,
              "st": 896
            }
          }
        },
        "fees": 150000,
        "seats": 74
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 24608,
              "ews": 4211,
              "obc": 8405,
              "sc": 5118,
              "st": 1937
            },
            "2023": {
              "general": 24115,
              "ews": 4126,
              "obc": 8236,
              "sc": 5015,
              "st": 1898
            },
            "2022": {
              "general": 23623,
              "ews": 4042,
              "obc": 8068,
              "sc": 4913,
              "st": 1859
            },
            "2021": {
              "general": 23131,
              "ews": 3958,
              "obc": 7900,
              "sc": 4810,
              "st": 1820
            },
            "2020": {
              "general": 22639,
              "ews": 3874,
              "obc": 7732,
              "sc": 4708,
              "st": 1782
            }
          }
        },
        "fees": 150000,
        "seats": 74
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 17673,
              "ews": 2883,
              "obc": 6295,
              "sc": 4340,
              "st": 1520
            },
            "2023": {
              "general": 17319,
              "ews": 2825,
              "obc": 6169,
              "sc": 4253,
              "st": 1489
            },
            "2022": {
              "general": 16966,
              "ews": 2767,
              "obc": 6043,
              "sc": 4166,
              "st": 1459
            },
            "2021": {
              "general": 16612,
              "ews": 2710,
              "obc": 5917,
              "sc": 4079,
              "st": 1428
            },
            "2020": {
              "general": 16259,
              "ews": 2652,
              "obc": 5791,
              "sc": 3992,
              "st": 1398
            }
          }
        },
        "fees": 150000,
        "seats": 74
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 14359,
              "ews": 2228,
              "obc": 5334,
              "sc": 3529,
              "st": 1357
            },
            "2023": {
              "general": 14071,
              "ews": 2183,
              "obc": 5227,
              "sc": 3458,
              "st": 1329
            },
            "2022": {
              "general": 13784,
              "ews": 2138,
              "obc": 5120,
              "sc": 3387,
              "st": 1302
            },
            "2021": {
              "general": 13497,
              "ews": 2094,
              "obc": 5013,
              "sc": 3317,
              "st": 1275
            },
            "2020": {
              "general": 13210,
              "ews": 2049,
              "obc": 4907,
              "sc": 3246,
              "st": 1248
            }
          }
        },
        "fees": 150000,
        "seats": 74
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 33119,
              "ews": 5733,
              "obc": 11528,
              "sc": 6498,
              "st": 2353
            },
            "2023": {
              "general": 32456,
              "ews": 5618,
              "obc": 11297,
              "sc": 6368,
              "st": 2305
            },
            "2022": {
              "general": 31794,
              "ews": 5503,
              "obc": 11066,
              "sc": 6238,
              "st": 2258
            },
            "2021": {
              "general": 31131,
              "ews": 5389,
              "obc": 10836,
              "sc": 6108,
              "st": 2211
            },
            "2020": {
              "general": 30469,
              "ews": 5274,
              "obc": 10605,
              "sc": 5978,
              "st": 2164
            }
          }
        },
        "fees": 150000,
        "seats": 74
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 46799,
              "ews": 8262,
              "obc": 16745,
              "sc": 7989,
              "st": 3070
            },
            "2023": {
              "general": 45863,
              "ews": 8096,
              "obc": 16410,
              "sc": 7829,
              "st": 3008
            },
            "2022": {
              "general": 44927,
              "ews": 7931,
              "obc": 16075,
              "sc": 7669,
              "st": 2947
            },
            "2021": {
              "general": 43991,
              "ews": 7766,
              "obc": 15740,
              "sc": 7509,
              "st": 2885
            },
            "2020": {
              "general": 43055,
              "ews": 7601,
              "obc": 15405,
              "sc": 7349,
              "st": 2824
            }
          }
        },
        "fees": 150000,
        "seats": 74
      },
      {
        "name": "Mining Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 48383,
              "ews": 8214,
              "obc": 16637,
              "sc": 8305,
              "st": 3101
            },
            "2023": {
              "general": 47415,
              "ews": 8049,
              "obc": 16304,
              "sc": 8138,
              "st": 3038
            },
            "2022": {
              "general": 46447,
              "ews": 7885,
              "obc": 15971,
              "sc": 7972,
              "st": 2976
            },
            "2021": {
              "general": 45480,
              "ews": 7721,
              "obc": 15638,
              "sc": 7806,
              "st": 2914
            },
            "2020": {
              "general": 44512,
              "ews": 7556,
              "obc": 15306,
              "sc": 7640,
              "st": 2852
            }
          }
        },
        "fees": 150000,
        "seats": 74
      }
    ]
  },
  {
    "id": 95,
    "name": "National Institute of Technology Sikkim",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Artificial Intelligence and Machine Learning",
        "code": "AIML",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 31461,
              "obc": 10412,
              "st": 1424,
              "sc": 2843
            },
            "2023": {
              "general": 30831,
              "obc": 10203,
              "st": 1395,
              "sc": 2786
            },
            "2022": {
              "general": 30202,
              "obc": 9995,
              "st": 1367,
              "sc": 2729
            },
            "2021": {
              "general": 29573,
              "obc": 9787,
              "st": 1338,
              "sc": 2672
            },
            "2020": {
              "general": 28944,
              "obc": 9579,
              "st": 1310,
              "sc": 2615
            }
          }
        },
        "fees": 150000,
        "seats": 75
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 53675,
              "obc": 17116,
              "sc": 8222
            },
            "2023": {
              "general": 52601,
              "obc": 16773,
              "sc": 8057
            },
            "2022": {
              "general": 51528,
              "obc": 16431,
              "sc": 7893
            },
            "2021": {
              "general": 50454,
              "obc": 16089,
              "sc": 7728
            },
            "2020": {
              "general": 49381,
              "obc": 15746,
              "sc": 7564
            }
          }
        },
        "fees": 150000,
        "seats": 75
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 26007,
              "obc": 9886,
              "sc": 3803,
              "st": 1764
            },
            "2023": {
              "general": 25486,
              "obc": 9688,
              "sc": 3726,
              "st": 1728
            },
            "2022": {
              "general": 24966,
              "obc": 9490,
              "sc": 3650,
              "st": 1693
            },
            "2021": {
              "general": 24446,
              "obc": 9292,
              "sc": 3574,
              "st": 1658
            },
            "2020": {
              "general": 23926,
              "obc": 9095,
              "sc": 3498,
              "st": 1622
            }
          }
        },
        "fees": 150000,
        "seats": 75
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 40177,
              "obc": 12906,
              "sc": 5979,
              "st": 2325
            },
            "2023": {
              "general": 39373,
              "obc": 12647,
              "sc": 5859,
              "st": 2278
            },
            "2022": {
              "general": 38569,
              "obc": 12389,
              "sc": 5739,
              "st": 2232
            },
            "2021": {
              "general": 37766,
              "obc": 12131,
              "sc": 5620,
              "st": 2185
            },
            "2020": {
              "general": 36962,
              "obc": 11873,
              "sc": 5500,
              "st": 2139
            }
          }
        },
        "fees": 150000,
        "seats": 75
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 36690,
              "obc": 12628,
              "sc": 5549,
              "st": 2000
            },
            "2023": {
              "general": 35956,
              "obc": 12375,
              "sc": 5438,
              "st": 1960
            },
            "2022": {
              "general": 35222,
              "obc": 12122,
              "sc": 5327,
              "st": 1920
            },
            "2021": {
              "general": 34488,
              "obc": 11870,
              "sc": 5216,
              "st": 1880
            },
            "2020": {
              "general": 33754,
              "obc": 11617,
              "sc": 5105,
              "st": 1840
            }
          }
        },
        "fees": 150000,
        "seats": 75
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 44288,
              "st": 2798,
              "obc": 14510,
              "sc": 6443
            },
            "2023": {
              "general": 43402,
              "st": 2742,
              "obc": 14219,
              "sc": 6314
            },
            "2022": {
              "general": 42516,
              "st": 2686,
              "obc": 13929,
              "sc": 6185
            },
            "2021": {
              "general": 41630,
              "st": 2630,
              "obc": 13639,
              "sc": 6056
            },
            "2020": {
              "general": 40744,
              "st": 2574,
              "obc": 13349,
              "sc": 5927
            }
          }
        },
        "fees": 150000,
        "seats": 75
      }
    ]
  },
  {
    "id": 96,
    "name": "National Institute of Technology, Andhra Pradesh",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Bio Technology",
        "code": "BT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 49218,
              "ews": 8526,
              "obc": 17137,
              "sc": 8947,
              "st": 3660
            },
            "2023": {
              "general": 48233,
              "ews": 8355,
              "obc": 16794,
              "sc": 8768,
              "st": 3586
            },
            "2022": {
              "general": 47249,
              "ews": 8184,
              "obc": 16451,
              "sc": 8589,
              "st": 3513
            },
            "2021": {
              "general": 46264,
              "ews": 8014,
              "obc": 16108,
              "sc": 8410,
              "st": 3440
            },
            "2020": {
              "general": 45280,
              "ews": 7843,
              "obc": 15766,
              "sc": 8231,
              "st": 3367
            }
          }
        },
        "fees": 150000,
        "seats": 76
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 41377,
              "ews": 6899,
              "obc": 15242,
              "sc": 7567,
              "st": 2808
            },
            "2023": {
              "general": 40549,
              "ews": 6761,
              "obc": 14937,
              "sc": 7415,
              "st": 2751
            },
            "2022": {
              "general": 39721,
              "ews": 6623,
              "obc": 14632,
              "sc": 7264,
              "st": 2695
            },
            "2021": {
              "general": 38894,
              "ews": 6485,
              "obc": 14327,
              "sc": 7112,
              "st": 2639
            },
            "2020": {
              "general": 38066,
              "ews": 6347,
              "obc": 14022,
              "sc": 6961,
              "st": 2583
            }
          }
        },
        "fees": 150000,
        "seats": 76
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 47757,
              "ews": 8081,
              "obc": 16129,
              "sc": 7566,
              "st": 2471
            },
            "2023": {
              "general": 46801,
              "ews": 7919,
              "obc": 15806,
              "sc": 7414,
              "st": 2421
            },
            "2022": {
              "general": 45846,
              "ews": 7757,
              "obc": 15483,
              "sc": 7263,
              "st": 2372
            },
            "2021": {
              "general": 44891,
              "ews": 7596,
              "obc": 15161,
              "sc": 7112,
              "st": 2322
            },
            "2020": {
              "general": 43936,
              "ews": 7434,
              "obc": 14838,
              "sc": 6960,
              "st": 2273
            }
          }
        },
        "fees": 150000,
        "seats": 76
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 17508,
              "ews": 2942,
              "obc": 6215,
              "sc": 3468,
              "st": 940
            },
            "2023": {
              "general": 17157,
              "ews": 2883,
              "obc": 6090,
              "sc": 3398,
              "st": 921
            },
            "2022": {
              "general": 16807,
              "ews": 2824,
              "obc": 5966,
              "sc": 3329,
              "st": 902
            },
            "2021": {
              "general": 16457,
              "ews": 2765,
              "obc": 5842,
              "sc": 3259,
              "st": 883
            },
            "2020": {
              "general": 16107,
              "ews": 2706,
              "obc": 5717,
              "sc": 3190,
              "st": 864
            }
          }
        },
        "fees": 150000,
        "seats": 76
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 33269,
              "ews": 6321,
              "obc": 12053,
              "sc": 6010,
              "st": 1953
            },
            "2023": {
              "general": 32603,
              "ews": 6194,
              "obc": 11811,
              "sc": 5889,
              "st": 1913
            },
            "2022": {
              "general": 31938,
              "ews": 6068,
              "obc": 11570,
              "sc": 5769,
              "st": 1874
            },
            "2021": {
              "general": 31272,
              "ews": 5941,
              "obc": 11329,
              "sc": 5649,
              "st": 1835
            },
            "2020": {
              "general": 30607,
              "ews": 5815,
              "obc": 11088,
              "sc": 5529,
              "st": 1796
            }
          }
        },
        "fees": 150000,
        "seats": 76
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 23370,
              "ews": 4208,
              "obc": 8653,
              "sc": 4867,
              "st": 1865
            },
            "2023": {
              "general": 22902,
              "ews": 4123,
              "obc": 8479,
              "sc": 4769,
              "st": 1827
            },
            "2022": {
              "general": 22435,
              "ews": 4039,
              "obc": 8306,
              "sc": 4672,
              "st": 1790
            },
            "2021": {
              "general": 21967,
              "ews": 3955,
              "obc": 8133,
              "sc": 4574,
              "st": 1753
            },
            "2020": {
              "general": 21500,
              "ews": 3871,
              "obc": 7960,
              "sc": 4477,
              "st": 1715
            }
          }
        },
        "fees": 150000,
        "seats": 76
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 38439,
              "ews": 6594,
              "obc": 13445,
              "sc": 7318,
              "st": 2130
            },
            "2023": {
              "general": 37670,
              "ews": 6462,
              "obc": 13176,
              "sc": 7171,
              "st": 2087
            },
            "2022": {
              "general": 36901,
              "ews": 6330,
              "obc": 12907,
              "sc": 7025,
              "st": 2044
            },
            "2021": {
              "general": 36132,
              "ews": 6198,
              "obc": 12638,
              "sc": 6878,
              "st": 2002
            },
            "2020": {
              "general": 35363,
              "ews": 6066,
              "obc": 12369,
              "sc": 6732,
              "st": 1959
            }
          }
        },
        "fees": 150000,
        "seats": 76
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 49444,
              "ews": 8287,
              "obc": 17128,
              "sc": 8341,
              "st": 3162
            },
            "2023": {
              "general": 48455,
              "ews": 8121,
              "obc": 16785,
              "sc": 8174,
              "st": 3098
            },
            "2022": {
              "general": 47466,
              "ews": 7955,
              "obc": 16442,
              "sc": 8007,
              "st": 3035
            },
            "2021": {
              "general": 46477,
              "ews": 7789,
              "obc": 16100,
              "sc": 7840,
              "st": 2972
            },
            "2020": {
              "general": 45488,
              "ews": 7624,
              "obc": 15757,
              "sc": 7673,
              "st": 2909
            }
          }
        },
        "fees": 150000,
        "seats": 76
      }
    ]
  },
  {
    "id": 97,
    "name": "National Institute of Technology, Jamshedpur",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 38534,
              "ews": 6739,
              "obc": 13266,
              "sc": 6193,
              "st": 2060
            },
            "2023": {
              "general": 37763,
              "ews": 6604,
              "obc": 13000,
              "sc": 6069,
              "st": 2018
            },
            "2022": {
              "general": 36992,
              "ews": 6469,
              "obc": 12735,
              "sc": 5945,
              "st": 1977
            },
            "2021": {
              "general": 36221,
              "ews": 6334,
              "obc": 12470,
              "sc": 5821,
              "st": 1936
            },
            "2020": {
              "general": 35451,
              "ews": 6199,
              "obc": 12204,
              "sc": 5697,
              "st": 1895
            }
          }
        },
        "fees": 150000,
        "seats": 77
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 7519,
              "ews": 1143,
              "obc": 2729,
              "sc": 1784,
              "st": 748
            },
            "2023": {
              "general": 7368,
              "ews": 1120,
              "obc": 2674,
              "sc": 1748,
              "st": 733
            },
            "2022": {
              "general": 7218,
              "ews": 1097,
              "obc": 2619,
              "sc": 1712,
              "st": 718
            },
            "2021": {
              "general": 7067,
              "ews": 1074,
              "obc": 2565,
              "sc": 1676,
              "st": 703
            },
            "2020": {
              "general": 6917,
              "ews": 1051,
              "obc": 2510,
              "sc": 1641,
              "st": 688
            }
          }
        },
        "fees": 150000,
        "seats": 77
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 16994,
              "ews": 2687,
              "obc": 6423,
              "sc": 3793,
              "st": 1763
            },
            "2023": {
              "general": 16654,
              "ews": 2633,
              "obc": 6294,
              "sc": 3717,
              "st": 1727
            },
            "2022": {
              "general": 16314,
              "ews": 2579,
              "obc": 6166,
              "sc": 3641,
              "st": 1692
            },
            "2021": {
              "general": 15974,
              "ews": 2525,
              "obc": 6037,
              "sc": 3565,
              "st": 1657
            },
            "2020": {
              "general": 15634,
              "ews": 2472,
              "obc": 5909,
              "sc": 3489,
              "st": 1621
            }
          }
        },
        "fees": 150000,
        "seats": 77
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 11799,
              "ews": 1956,
              "obc": 4456,
              "sc": 2955,
              "st": 970
            },
            "2023": {
              "general": 11563,
              "ews": 1916,
              "obc": 4366,
              "sc": 2895,
              "st": 950
            },
            "2022": {
              "general": 11327,
              "ews": 1877,
              "obc": 4277,
              "sc": 2836,
              "st": 931
            },
            "2021": {
              "general": 11091,
              "ews": 1838,
              "obc": 4188,
              "sc": 2777,
              "st": 911
            },
            "2020": {
              "general": 10855,
              "ews": 1799,
              "obc": 4099,
              "sc": 2718,
              "st": 892
            }
          }
        },
        "fees": 150000,
        "seats": 77
      },
      {
        "name": "Engineering and Computational Mechanics",
        "code": "ECM",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 18419,
              "ews": 2969,
              "obc": 5242,
              "sc": 4580,
              "st": 2173
            },
            "2023": {
              "general": 18050,
              "ews": 2909,
              "obc": 5137,
              "sc": 4488,
              "st": 2129
            },
            "2022": {
              "general": 17682,
              "ews": 2850,
              "obc": 5032,
              "sc": 4396,
              "st": 2086
            },
            "2021": {
              "general": 17313,
              "ews": 2790,
              "obc": 4927,
              "sc": 4305,
              "st": 2042
            },
            "2020": {
              "general": 16945,
              "ews": 2731,
              "obc": 4822,
              "sc": 4213,
              "st": 1999
            }
          }
        },
        "fees": 150000,
        "seats": 77
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 27524,
              "ews": 4456,
              "obc": 8873,
              "sc": 5718,
              "st": 2251
            },
            "2023": {
              "general": 26973,
              "ews": 4366,
              "obc": 8695,
              "sc": 5603,
              "st": 2205
            },
            "2022": {
              "general": 26423,
              "ews": 4277,
              "obc": 8518,
              "sc": 5489,
              "st": 2160
            },
            "2021": {
              "general": 25872,
              "ews": 4188,
              "obc": 8340,
              "sc": 5374,
              "st": 2115
            },
            "2020": {
              "general": 25322,
              "ews": 4099,
              "obc": 8163,
              "sc": 5260,
              "st": 2070
            }
          }
        },
        "fees": 150000,
        "seats": 77
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 43227,
              "ews": 7338,
              "obc": 14905,
              "sc": 7490,
              "st": 3215
            },
            "2023": {
              "general": 42362,
              "ews": 7191,
              "obc": 14606,
              "sc": 7340,
              "st": 3150
            },
            "2022": {
              "general": 41497,
              "ews": 7044,
              "obc": 14308,
              "sc": 7190,
              "st": 3086
            },
            "2021": {
              "general": 40633,
              "ews": 6897,
              "obc": 14010,
              "sc": 7040,
              "st": 3022
            },
            "2020": {
              "general": 39768,
              "ews": 6750,
              "obc": 13712,
              "sc": 6890,
              "st": 2957
            }
          }
        },
        "fees": 150000,
        "seats": 77
      },
      {
        "name": "Production and Industrial Engineering",
        "code": "PIE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 38944,
              "ews": 6508,
              "obc": 14458,
              "sc": 7146,
              "st": 3073
            },
            "2023": {
              "general": 38165,
              "ews": 6377,
              "obc": 14168,
              "sc": 7003,
              "st": 3011
            },
            "2022": {
              "general": 37386,
              "ews": 6247,
              "obc": 13879,
              "sc": 6860,
              "st": 2950
            },
            "2021": {
              "general": 36607,
              "ews": 6117,
              "obc": 13590,
              "sc": 6717,
              "st": 2888
            },
            "2020": {
              "general": 35828,
              "ews": 5987,
              "obc": 13301,
              "sc": 6574,
              "st": 2827
            }
          }
        },
        "fees": 150000,
        "seats": 77
      }
    ]
  },
  {
    "id": 98,
    "name": "National Institute of Technology, Kurukshetra",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture and Planning",
        "code": "AP",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 1542,
              "ews": 450,
              "obc": 918,
              "sc": 363,
              "st": 195
            },
            "2023": {
              "general": 1511,
              "ews": 441,
              "obc": 899,
              "sc": 355,
              "st": 191
            },
            "2022": {
              "general": 1480,
              "ews": 432,
              "obc": 881,
              "sc": 348,
              "st": 187
            },
            "2021": {
              "general": 1449,
              "ews": 423,
              "obc": 862,
              "sc": 341,
              "st": 183
            },
            "2020": {
              "general": 1418,
              "ews": 414,
              "obc": 844,
              "sc": 333,
              "st": 179
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Artificial Intelligence and Data Science",
        "code": "AIDS",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 7077,
              "ews": 1164,
              "obc": 3010,
              "sc": 1762,
              "st": 588
            },
            "2023": {
              "general": 6935,
              "ews": 1140,
              "obc": 2949,
              "sc": 1726,
              "st": 576
            },
            "2022": {
              "general": 6793,
              "ews": 1117,
              "obc": 2889,
              "sc": 1691,
              "st": 564
            },
            "2021": {
              "general": 6652,
              "ews": 1094,
              "obc": 2829,
              "sc": 1656,
              "st": 552
            },
            "2020": {
              "general": 6510,
              "ews": 1070,
              "obc": 2769,
              "sc": 1621,
              "st": 540
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Artificial Intelligence and Machine Learning",
        "code": "AIML",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 7695,
              "ews": 1172,
              "obc": 3212,
              "sc": 1676,
              "st": 519
            },
            "2023": {
              "general": 7541,
              "ews": 1148,
              "obc": 3147,
              "sc": 1642,
              "st": 508
            },
            "2022": {
              "general": 7387,
              "ews": 1125,
              "obc": 3083,
              "sc": 1608,
              "st": 498
            },
            "2021": {
              "general": 7233,
              "ews": 1101,
              "obc": 3019,
              "sc": 1575,
              "st": 487
            },
            "2020": {
              "general": 7079,
              "ews": 1078,
              "obc": 2955,
              "sc": 1541,
              "st": 477
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 34173,
              "ews": 6556,
              "obc": 13373,
              "sc": 6042,
              "st": 1146
            },
            "2023": {
              "general": 33489,
              "ews": 6424,
              "obc": 13105,
              "sc": 5921,
              "st": 1123
            },
            "2022": {
              "general": 32806,
              "ews": 6293,
              "obc": 12838,
              "sc": 5800,
              "st": 1100
            },
            "2021": {
              "general": 32122,
              "ews": 6162,
              "obc": 12570,
              "sc": 5679,
              "st": 1077
            },
            "2020": {
              "general": 31439,
              "ews": 6031,
              "obc": 12303,
              "sc": 5558,
              "st": 1054
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 6827,
              "ews": 1515,
              "obc": 2635,
              "sc": 2129,
              "st": 12079
            },
            "2023": {
              "general": 6690,
              "ews": 1484,
              "obc": 2582,
              "sc": 2086,
              "st": 11837
            },
            "2022": {
              "general": 6553,
              "ews": 1454,
              "obc": 2529,
              "sc": 2043,
              "st": 11595
            },
            "2021": {
              "general": 6417,
              "ews": 1424,
              "obc": 2476,
              "sc": 2001,
              "st": 11354
            },
            "2020": {
              "general": 6280,
              "ews": 1393,
              "obc": 2424,
              "sc": 1958,
              "st": 11112
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 14047,
              "ews": 2692,
              "obc": 6472,
              "sc": 2990,
              "st": 1282
            },
            "2023": {
              "general": 13766,
              "ews": 2638,
              "obc": 6342,
              "sc": 2930,
              "st": 1256
            },
            "2022": {
              "general": 13485,
              "ews": 2584,
              "obc": 6213,
              "sc": 2870,
              "st": 1230
            },
            "2021": {
              "general": 13204,
              "ews": 2530,
              "obc": 6083,
              "sc": 2810,
              "st": 1205
            },
            "2020": {
              "general": 12923,
              "ews": 2476,
              "obc": 5954,
              "sc": 2750,
              "st": 1179
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 12066,
              "ews": 2327,
              "obc": 5026,
              "sc": 3146,
              "st": 959
            },
            "2023": {
              "general": 11824,
              "ews": 2280,
              "obc": 4925,
              "sc": 3083,
              "st": 939
            },
            "2022": {
              "general": 11583,
              "ews": 2233,
              "obc": 4824,
              "sc": 3020,
              "st": 920
            },
            "2021": {
              "general": 11342,
              "ews": 2187,
              "obc": 4724,
              "sc": 2957,
              "st": 901
            },
            "2020": {
              "general": 11100,
              "ews": 2140,
              "obc": 4623,
              "sc": 2894,
              "st": 882
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Industrial Internet of Things",
        "code": "IIT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 16007,
              "ews": 2534,
              "obc": 6715,
              "sc": 4124,
              "st": 1611
            },
            "2023": {
              "general": 15686,
              "ews": 2483,
              "obc": 6580,
              "sc": 4041,
              "st": 1578
            },
            "2022": {
              "general": 15366,
              "ews": 2432,
              "obc": 6446,
              "sc": 3959,
              "st": 1546
            },
            "2021": {
              "general": 15046,
              "ews": 2381,
              "obc": 6312,
              "sc": 3876,
              "st": 1514
            },
            "2020": {
              "general": 14726,
              "ews": 2331,
              "obc": 6177,
              "sc": 3794,
              "st": 1482
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 6734,
              "ews": 1098,
              "obc": 3007,
              "sc": 1598,
              "st": 786
            },
            "2023": {
              "general": 6599,
              "ews": 1076,
              "obc": 2946,
              "sc": 1566,
              "st": 770
            },
            "2022": {
              "general": 6464,
              "ews": 1054,
              "obc": 2886,
              "sc": 1534,
              "st": 754
            },
            "2021": {
              "general": 6329,
              "ews": 1032,
              "obc": 2826,
              "sc": 1502,
              "st": 738
            },
            "2020": {
              "general": 6195,
              "ews": 1010,
              "obc": 2766,
              "sc": 1470,
              "st": 723
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 8953,
              "ews": 1497,
              "obc": 3778,
              "sc": 1893,
              "st": 872
            },
            "2023": {
              "general": 8773,
              "ews": 1467,
              "obc": 3702,
              "sc": 1855,
              "st": 854
            },
            "2022": {
              "general": 8594,
              "ews": 1437,
              "obc": 3626,
              "sc": 1817,
              "st": 837
            },
            "2021": {
              "general": 8415,
              "ews": 1407,
              "obc": 3551,
              "sc": 1779,
              "st": 819
            },
            "2020": {
              "general": 8236,
              "ews": 1377,
              "obc": 3475,
              "sc": 1741,
              "st": 802
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 18205,
              "ews": 3688,
              "obc": 9210,
              "sc": 4874,
              "st": 1891
            },
            "2023": {
              "general": 17840,
              "ews": 3614,
              "obc": 9025,
              "sc": 4776,
              "st": 1853
            },
            "2022": {
              "general": 17476,
              "ews": 3540,
              "obc": 8841,
              "sc": 4679,
              "st": 1815
            },
            "2021": {
              "general": 17112,
              "ews": 3466,
              "obc": 8657,
              "sc": 4581,
              "st": 1777
            },
            "2020": {
              "general": 16748,
              "ews": 3392,
              "obc": 8473,
              "sc": 4484,
              "st": 1739
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Microelectronics & VLSI Engineering",
        "code": "MVE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 13402,
              "ews": 2178,
              "obc": 5868,
              "sc": 3947,
              "st": 1410
            },
            "2023": {
              "general": 13133,
              "ews": 2134,
              "obc": 5750,
              "sc": 3868,
              "st": 1381
            },
            "2022": {
              "general": 12865,
              "ews": 2090,
              "obc": 5633,
              "sc": 3789,
              "st": 1353
            },
            "2021": {
              "general": 12597,
              "ews": 2047,
              "obc": 5515,
              "sc": 3710,
              "st": 1325
            },
            "2020": {
              "general": 12329,
              "ews": 2003,
              "obc": 5398,
              "sc": 3631,
              "st": 1297
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "Production and Industrial Engineering",
        "code": "PIE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 34891,
              "ews": 5873,
              "obc": 12544,
              "sc": 6730,
              "st": 2885
            },
            "2023": {
              "general": 34193,
              "ews": 5755,
              "obc": 12293,
              "sc": 6595,
              "st": 2827
            },
            "2022": {
              "general": 33495,
              "ews": 5638,
              "obc": 12042,
              "sc": 6460,
              "st": 2769
            },
            "2021": {
              "general": 32797,
              "ews": 5520,
              "obc": 11791,
              "sc": 6326,
              "st": 2711
            },
            "2020": {
              "general": 32099,
              "ews": 5403,
              "obc": 11540,
              "sc": 6191,
              "st": 2654
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "ROBOTICS & AUTOMATION",
        "code": "RA",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 11046,
              "ews": 1843,
              "obc": 4840,
              "sc": 2089,
              "st": 1468
            },
            "2023": {
              "general": 10825,
              "ews": 1806,
              "obc": 4743,
              "sc": 2047,
              "st": 1438
            },
            "2022": {
              "general": 10604,
              "ews": 1769,
              "obc": 4646,
              "sc": 2005,
              "st": 1409
            },
            "2021": {
              "general": 10383,
              "ews": 1732,
              "obc": 4549,
              "sc": 1963,
              "st": 1379
            },
            "2020": {
              "general": 10162,
              "ews": 1695,
              "obc": 4452,
              "sc": 1921,
              "st": 1350
            }
          }
        },
        "fees": 150000,
        "seats": 78
      },
      {
        "name": "SUSTAINABLE ENERGY TECHNOLOGIES",
        "code": "SET",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 30113,
              "ews": 5018,
              "obc": 13327,
              "sc": 6718,
              "st": 3224
            },
            "2023": {
              "general": 29510,
              "ews": 4917,
              "obc": 13060,
              "sc": 6583,
              "st": 3159
            },
            "2022": {
              "general": 28908,
              "ews": 4817,
              "obc": 12793,
              "sc": 6449,
              "st": 3095
            },
            "2021": {
              "general": 28306,
              "ews": 4716,
              "obc": 12527,
              "sc": 6314,
              "st": 3030
            },
            "2020": {
              "general": 27703,
              "ews": 4616,
              "obc": 12260,
              "sc": 6180,
              "st": 2966
            }
          }
        },
        "fees": 150000,
        "seats": 78
      }
    ]
  },
  {
    "id": 99,
    "name": "National Institute of Technology, Manipur",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 55319,
              "obc": 17798,
              "sc": 8678,
              "st": 4464,
              "ews": 9136
            },
            "2023": {
              "general": 54212,
              "obc": 17442,
              "sc": 8504,
              "st": 4374,
              "ews": 8953
            },
            "2022": {
              "general": 53106,
              "obc": 17086,
              "sc": 8330,
              "st": 4285,
              "ews": 8770
            },
            "2021": {
              "general": 51999,
              "obc": 16730,
              "sc": 8157,
              "st": 4196,
              "ews": 8587
            },
            "2020": {
              "general": 50893,
              "obc": 16374,
              "sc": 7983,
              "st": 4106,
              "ews": 8405
            }
          }
        },
        "fees": 150000,
        "seats": 79
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 29637,
              "obc": 11064,
              "sc": 4720,
              "st": 1922,
              "ews": 5178
            },
            "2023": {
              "general": 29044,
              "obc": 10842,
              "sc": 4625,
              "st": 1883,
              "ews": 5074
            },
            "2022": {
              "general": 28451,
              "obc": 10621,
              "sc": 4531,
              "st": 1845,
              "ews": 4970
            },
            "2021": {
              "general": 27858,
              "obc": 10400,
              "sc": 4436,
              "st": 1806,
              "ews": 4867
            },
            "2020": {
              "general": 27266,
              "obc": 10178,
              "sc": 4342,
              "st": 1768,
              "ews": 4763
            }
          }
        },
        "fees": 150000,
        "seats": 79
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 45343,
              "obc": 15386,
              "sc": 7497,
              "st": 2546,
              "ews": 7841
            },
            "2023": {
              "general": 44436,
              "obc": 15078,
              "sc": 7347,
              "st": 2495,
              "ews": 7684
            },
            "2022": {
              "general": 43529,
              "obc": 14770,
              "sc": 7197,
              "st": 2444,
              "ews": 7527
            },
            "2021": {
              "general": 42622,
              "obc": 14462,
              "sc": 7047,
              "st": 2393,
              "ews": 7370
            },
            "2020": {
              "general": 41715,
              "obc": 14155,
              "sc": 6897,
              "st": 2342,
              "ews": 7213
            }
          }
        },
        "fees": 150000,
        "seats": 79
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 36368,
              "obc": 12299,
              "sc": 7352,
              "st": 2521,
              "ews": 5858
            },
            "2023": {
              "general": 35640,
              "obc": 12053,
              "sc": 7204,
              "st": 2470,
              "ews": 5740
            },
            "2022": {
              "general": 34913,
              "obc": 11807,
              "sc": 7057,
              "st": 2420,
              "ews": 5623
            },
            "2021": {
              "general": 34185,
              "obc": 11561,
              "sc": 6910,
              "st": 2369,
              "ews": 5506
            },
            "2020": {
              "general": 33458,
              "obc": 11315,
              "sc": 6763,
              "st": 2319,
              "ews": 5389
            }
          }
        },
        "fees": 150000,
        "seats": 79
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 48442,
              "obc": 16235,
              "sc": 8264,
              "st": 3076,
              "ews": 7986
            },
            "2023": {
              "general": 47473,
              "obc": 15910,
              "sc": 8098,
              "st": 3014,
              "ews": 7826
            },
            "2022": {
              "general": 46504,
              "obc": 15585,
              "sc": 7933,
              "st": 2952,
              "ews": 7666
            },
            "2021": {
              "general": 45535,
              "obc": 15260,
              "sc": 7768,
              "st": 2891,
              "ews": 7506
            },
            "2020": {
              "general": 44566,
              "obc": 14936,
              "sc": 7602,
              "st": 2829,
              "ews": 7347
            }
          }
        },
        "fees": 150000,
        "seats": 79
      }
    ]
  },
  {
    "id": 100,
    "name": "National Institute of Technology, Mizoram",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 55346,
              "st": 2710,
              "ews": 9157,
              "obc": 18237,
              "sc": 8515
            },
            "2023": {
              "general": 54239,
              "st": 2655,
              "ews": 8973,
              "obc": 17872,
              "sc": 8344
            },
            "2022": {
              "general": 53132,
              "st": 2601,
              "ews": 8790,
              "obc": 17507,
              "sc": 8174
            },
            "2021": {
              "general": 52025,
              "st": 2547,
              "ews": 8607,
              "obc": 17142,
              "sc": 8004
            },
            "2020": {
              "general": 50918,
              "st": 2493,
              "ews": 8424,
              "obc": 16778,
              "sc": 7833
            }
          }
        },
        "fees": 150000,
        "seats": 80
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 30186,
              "sc": 3963,
              "st": 1943,
              "ews": 5219,
              "obc": 11236
            },
            "2023": {
              "general": 29582,
              "sc": 3883,
              "st": 1904,
              "ews": 5114,
              "obc": 11011
            },
            "2022": {
              "general": 28978,
              "sc": 3804,
              "st": 1865,
              "ews": 5010,
              "obc": 10786
            },
            "2021": {
              "general": 28374,
              "sc": 3725,
              "st": 1826,
              "ews": 4905,
              "obc": 10561
            },
            "2020": {
              "general": 27771,
              "sc": 3645,
              "st": 1787,
              "ews": 4801,
              "obc": 10337
            }
          }
        },
        "fees": 150000,
        "seats": 80
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 46125,
              "ews": 7822,
              "obc": 15861,
              "sc": 7814,
              "st": 2801
            },
            "2023": {
              "general": 45202,
              "ews": 7665,
              "obc": 15543,
              "sc": 7657,
              "st": 2744
            },
            "2022": {
              "general": 44280,
              "ews": 7509,
              "obc": 15226,
              "sc": 7501,
              "st": 2688
            },
            "2021": {
              "general": 43357,
              "ews": 7352,
              "obc": 14909,
              "sc": 7345,
              "st": 2632
            },
            "2020": {
              "general": 42435,
              "ews": 7196,
              "obc": 14592,
              "sc": 7188,
              "st": 2576
            }
          }
        },
        "fees": 150000,
        "seats": 80
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 40816,
              "ews": 6741,
              "obc": 13193,
              "sc": 6735,
              "st": 2166
            },
            "2023": {
              "general": 39999,
              "ews": 6606,
              "obc": 12929,
              "sc": 6600,
              "st": 2122
            },
            "2022": {
              "general": 39183,
              "ews": 6471,
              "obc": 12665,
              "sc": 6465,
              "st": 2079
            },
            "2021": {
              "general": 38367,
              "ews": 6336,
              "obc": 12401,
              "sc": 6330,
              "st": 2036
            },
            "2020": {
              "general": 37550,
              "ews": 6201,
              "obc": 12137,
              "sc": 6196,
              "st": 1992
            }
          }
        },
        "fees": 150000,
        "seats": 80
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 34795,
              "ews": 6120,
              "obc": 12648
            },
            "2023": {
              "general": 34099,
              "ews": 5997,
              "obc": 12395
            },
            "2022": {
              "general": 33403,
              "ews": 5875,
              "obc": 12142
            },
            "2021": {
              "general": 32707,
              "ews": 5752,
              "obc": 11889
            },
            "2020": {
              "general": 32011,
              "ews": 5630,
              "obc": 11636
            }
          }
        },
        "fees": 150000,
        "seats": 80
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 50712,
              "st": 3078,
              "ews": 8375,
              "obc": 17633,
              "sc": 8299
            },
            "2023": {
              "general": 49697,
              "st": 3016,
              "ews": 8207,
              "obc": 17280,
              "sc": 8133
            },
            "2022": {
              "general": 48683,
              "st": 2954,
              "ews": 8040,
              "obc": 16927,
              "sc": 7967
            },
            "2021": {
              "general": 47669,
              "st": 2893,
              "ews": 7872,
              "obc": 16575,
              "sc": 7801
            },
            "2020": {
              "general": 46655,
              "st": 2831,
              "ews": 7705,
              "obc": 16222,
              "sc": 7635
            }
          }
        },
        "fees": 150000,
        "seats": 80
      }
    ]
  },
  {
    "id": 101,
    "name": "National Institute of Technology, Rourkela",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 716,
              "ews": 147,
              "obc": 290,
              "sc": 91,
              "st": 56
            },
            "2023": {
              "general": 701,
              "ews": 144,
              "obc": 284,
              "sc": 89,
              "st": 54
            },
            "2022": {
              "general": 687,
              "ews": 141,
              "obc": 278,
              "sc": 87,
              "st": 53
            },
            "2021": {
              "general": 673,
              "ews": 138,
              "obc": 272,
              "sc": 85,
              "st": 52
            },
            "2020": {
              "general": 658,
              "ews": 135,
              "obc": 266,
              "sc": 83,
              "st": 51
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Artificial Intelligence",
        "code": "AI",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 3880,
              "ews": 547,
              "obc": 1258,
              "sc": 821,
              "st": 315
            },
            "2023": {
              "general": 3802,
              "ews": 536,
              "obc": 1232,
              "sc": 804,
              "st": 308
            },
            "2022": {
              "general": 3724,
              "ews": 525,
              "obc": 1207,
              "sc": 788,
              "st": 302
            },
            "2021": {
              "general": 3647,
              "ews": 514,
              "obc": 1182,
              "sc": 771,
              "st": 296
            },
            "2020": {
              "general": 3569,
              "ews": 503,
              "obc": 1157,
              "sc": 755,
              "st": 289
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Bio Medical Engineering",
        "code": "BME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 31418,
              "ews": 6659,
              "obc": 12375,
              "sc": 6559,
              "st": 2534
            },
            "2023": {
              "general": 30789,
              "ews": 6525,
              "obc": 12127,
              "sc": 6427,
              "st": 2483
            },
            "2022": {
              "general": 30161,
              "ews": 6392,
              "obc": 11880,
              "sc": 6296,
              "st": 2432
            },
            "2021": {
              "general": 29532,
              "ews": 6259,
              "obc": 11632,
              "sc": 6165,
              "st": 2381
            },
            "2020": {
              "general": 28904,
              "ews": 6126,
              "obc": 11385,
              "sc": 6034,
              "st": 2331
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Bio Technology",
        "code": "BT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 29422,
              "ews": 4683,
              "obc": 11791,
              "sc": 4251,
              "st": 2276
            },
            "2023": {
              "general": 28833,
              "ews": 4589,
              "obc": 11555,
              "sc": 4165,
              "st": 2230
            },
            "2022": {
              "general": 28245,
              "ews": 4495,
              "obc": 11319,
              "sc": 4080,
              "st": 2184
            },
            "2021": {
              "general": 27656,
              "ews": 4402,
              "obc": 11083,
              "sc": 3995,
              "st": 2139
            },
            "2020": {
              "general": 27068,
              "ews": 4308,
              "obc": 10847,
              "sc": 3910,
              "st": 2093
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Ceramic Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 34919,
              "ews": 5780,
              "obc": 12506,
              "sc": 6396,
              "st": 1860
            },
            "2023": {
              "general": 34220,
              "ews": 5664,
              "obc": 12255,
              "sc": 6268,
              "st": 1822
            },
            "2022": {
              "general": 33522,
              "ews": 5548,
              "obc": 12005,
              "sc": 6140,
              "st": 1785
            },
            "2021": {
              "general": 32823,
              "ews": 5433,
              "obc": 11755,
              "sc": 6012,
              "st": 1748
            },
            "2020": {
              "general": 32125,
              "ews": 5317,
              "obc": 11505,
              "sc": 5884,
              "st": 1711
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Ceramic Engineering and M.Tech Industrial Ceramic",
        "code": "CEMIC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 39253,
              "obc": 14845,
              "sc": 6666
            },
            "2023": {
              "general": 38467,
              "obc": 14548,
              "sc": 6532
            },
            "2022": {
              "general": 37682,
              "obc": 14251,
              "sc": 6399
            },
            "2021": {
              "general": 36897,
              "obc": 13954,
              "sc": 6266
            },
            "2020": {
              "general": 36112,
              "obc": 13657,
              "sc": 6132
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 21024,
              "ews": 4431,
              "obc": 6797,
              "sc": 4787,
              "st": 1252
            },
            "2023": {
              "general": 20603,
              "ews": 4342,
              "obc": 6661,
              "sc": 4691,
              "st": 1226
            },
            "2022": {
              "general": 20183,
              "ews": 4253,
              "obc": 6525,
              "sc": 4595,
              "st": 1201
            },
            "2021": {
              "general": 19762,
              "ews": 4165,
              "obc": 6389,
              "sc": 4499,
              "st": 1176
            },
            "2020": {
              "general": 19342,
              "ews": 4076,
              "obc": 6253,
              "sc": 4404,
              "st": 1151
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Chemistry",
        "code": "C",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 41605,
              "ews": 7756,
              "obc": 15838,
              "sc": 8428,
              "st": 2819
            },
            "2023": {
              "general": 40772,
              "ews": 7600,
              "obc": 15521,
              "sc": 8259,
              "st": 2762
            },
            "2022": {
              "general": 39940,
              "ews": 7445,
              "obc": 15204,
              "sc": 8090,
              "st": 2706
            },
            "2021": {
              "general": 39108,
              "ews": 7290,
              "obc": 14887,
              "sc": 7922,
              "st": 2649
            },
            "2020": {
              "general": 38276,
              "ews": 7135,
              "obc": 14570,
              "sc": 7753,
              "st": 2593
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 24286,
              "ews": 4223,
              "obc": 8179,
              "sc": 4447,
              "st": 1129
            },
            "2023": {
              "general": 23800,
              "ews": 4138,
              "obc": 8015,
              "sc": 4358,
              "st": 1106
            },
            "2022": {
              "general": 23314,
              "ews": 4054,
              "obc": 7851,
              "sc": 4269,
              "st": 1083
            },
            "2021": {
              "general": 22828,
              "ews": 3969,
              "obc": 7688,
              "sc": 4180,
              "st": 1061
            },
            "2020": {
              "general": 22343,
              "ews": 3885,
              "obc": 7524,
              "sc": 4091,
              "st": 1038
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 2824,
              "ews": 414,
              "obc": 1022,
              "sc": 523,
              "st": 202
            },
            "2023": {
              "general": 2767,
              "ews": 405,
              "obc": 1001,
              "sc": 512,
              "st": 197
            },
            "2022": {
              "general": 2711,
              "ews": 397,
              "obc": 981,
              "sc": 502,
              "st": 193
            },
            "2021": {
              "general": 2654,
              "ews": 389,
              "obc": 960,
              "sc": 491,
              "st": 189
            },
            "2020": {
              "general": 2598,
              "ews": 380,
              "obc": 940,
              "sc": 481,
              "st": 185
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 8940,
              "ews": 1566,
              "obc": 3807,
              "sc": 2112,
              "st": 414
            },
            "2023": {
              "general": 8761,
              "ews": 1534,
              "obc": 3730,
              "sc": 2069,
              "st": 405
            },
            "2022": {
              "general": 8582,
              "ews": 1503,
              "obc": 3654,
              "sc": 2027,
              "st": 397
            },
            "2021": {
              "general": 8403,
              "ews": 1472,
              "obc": 3578,
              "sc": 1985,
              "st": 389
            },
            "2020": {
              "general": 8224,
              "ews": 1440,
              "obc": 3502,
              "sc": 1943,
              "st": 380
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 5245,
              "ews": 751,
              "obc": 1774,
              "sc": 706,
              "st": 356
            },
            "2023": {
              "general": 5140,
              "ews": 735,
              "obc": 1738,
              "sc": 691,
              "st": 348
            },
            "2022": {
              "general": 5035,
              "ews": 720,
              "obc": 1703,
              "sc": 677,
              "st": 341
            },
            "2021": {
              "general": 4930,
              "ews": 705,
              "obc": 1667,
              "sc": 663,
              "st": 334
            },
            "2020": {
              "general": 4825,
              "ews": 690,
              "obc": 1632,
              "sc": 649,
              "st": 327
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Electronics and Instrumentation Engineering",
        "code": "EIE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 9315,
              "ews": 1659,
              "obc": 4328,
              "sc": 2055,
              "st": 735
            },
            "2023": {
              "general": 9128,
              "ews": 1625,
              "obc": 4241,
              "sc": 2013,
              "st": 720
            },
            "2022": {
              "general": 8942,
              "ews": 1592,
              "obc": 4154,
              "sc": 1972,
              "st": 705
            },
            "2021": {
              "general": 8756,
              "ews": 1559,
              "obc": 4068,
              "sc": 1931,
              "st": 690
            },
            "2020": {
              "general": 8569,
              "ews": 1526,
              "obc": 3981,
              "sc": 1890,
              "st": 676
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Food Process Engineering",
        "code": "FPE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 39483,
              "ews": 6874,
              "obc": 13501,
              "sc": 6331,
              "st": 2123
            },
            "2023": {
              "general": 38693,
              "ews": 6736,
              "obc": 13230,
              "sc": 6204,
              "st": 2080
            },
            "2022": {
              "general": 37903,
              "ews": 6599,
              "obc": 12960,
              "sc": 6077,
              "st": 2038
            },
            "2021": {
              "general": 37114,
              "ews": 6461,
              "obc": 12690,
              "sc": 5951,
              "st": 1995
            },
            "2020": {
              "general": 36324,
              "ews": 6324,
              "obc": 12420,
              "sc": 5824,
              "st": 1953
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Industrial Design",
        "code": "ID",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 29447,
              "ews": 4981,
              "obc": 10482,
              "sc": 5357,
              "st": 2397
            },
            "2023": {
              "general": 28858,
              "ews": 4881,
              "obc": 10272,
              "sc": 5249,
              "st": 2349
            },
            "2022": {
              "general": 28269,
              "ews": 4781,
              "obc": 10062,
              "sc": 5142,
              "st": 2301
            },
            "2021": {
              "general": 27680,
              "ews": 4682,
              "obc": 9853,
              "sc": 5035,
              "st": 2253
            },
            "2020": {
              "general": 27091,
              "ews": 4582,
              "obc": 9643,
              "sc": 4928,
              "st": 2205
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Life Science",
        "code": "LS",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 43373,
              "ews": 7534,
              "obc": 15138,
              "sc": 6210,
              "st": 2820
            },
            "2023": {
              "general": 42505,
              "ews": 7383,
              "obc": 14835,
              "sc": 6085,
              "st": 2763
            },
            "2022": {
              "general": 41638,
              "ews": 7232,
              "obc": 14532,
              "sc": 5961,
              "st": 2707
            },
            "2021": {
              "general": 40770,
              "ews": 7081,
              "obc": 14229,
              "sc": 5837,
              "st": 2650
            },
            "2020": {
              "general": 39903,
              "ews": 6931,
              "obc": 13926,
              "sc": 5713,
              "st": 2594
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Mathematics",
        "code": "M",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 25359,
              "ews": 5486,
              "obc": 13096,
              "sc": 6775,
              "st": 2717
            },
            "2023": {
              "general": 24851,
              "ews": 5376,
              "obc": 12834,
              "sc": 6639,
              "st": 2662
            },
            "2022": {
              "general": 24344,
              "ews": 5266,
              "obc": 12572,
              "sc": 6504,
              "st": 2608
            },
            "2021": {
              "general": 23837,
              "ews": 5156,
              "obc": 12310,
              "sc": 6368,
              "st": 2553
            },
            "2020": {
              "general": 23330,
              "ews": 5047,
              "obc": 12048,
              "sc": 6233,
              "st": 2499
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 14207,
              "ews": 2323,
              "obc": 5534,
              "sc": 3355,
              "st": 1314
            },
            "2023": {
              "general": 13922,
              "ews": 2276,
              "obc": 5423,
              "sc": 3287,
              "st": 1287
            },
            "2022": {
              "general": 13638,
              "ews": 2230,
              "obc": 5312,
              "sc": 3220,
              "st": 1261
            },
            "2021": {
              "general": 13354,
              "ews": 2183,
              "obc": 5201,
              "sc": 3153,
              "st": 1235
            },
            "2020": {
              "general": 13070,
              "ews": 2137,
              "obc": 5091,
              "sc": 3086,
              "st": 1208
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 33993,
              "ews": 5202,
              "obc": 12323,
              "sc": 6294,
              "st": 2275
            },
            "2023": {
              "general": 33313,
              "ews": 5097,
              "obc": 12076,
              "sc": 6168,
              "st": 2229
            },
            "2022": {
              "general": 32633,
              "ews": 4993,
              "obc": 11830,
              "sc": 6042,
              "st": 2184
            },
            "2021": {
              "general": 31953,
              "ews": 4889,
              "obc": 11583,
              "sc": 5916,
              "st": 2138
            },
            "2020": {
              "general": 31273,
              "ews": 4785,
              "obc": 11337,
              "sc": 5790,
              "st": 2093
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Mining Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 32461,
              "ews": 6521,
              "obc": 19581,
              "sc": 5775,
              "st": 2462
            },
            "2023": {
              "general": 31811,
              "ews": 6390,
              "obc": 19189,
              "sc": 5659,
              "st": 2412
            },
            "2022": {
              "general": 31162,
              "ews": 6260,
              "obc": 18797,
              "sc": 5544,
              "st": 2363
            },
            "2021": {
              "general": 30513,
              "ews": 6129,
              "obc": 18406,
              "sc": 5428,
              "st": 2314
            },
            "2020": {
              "general": 29864,
              "ews": 5999,
              "obc": 18014,
              "sc": 5313,
              "st": 2265
            }
          }
        },
        "fees": 150000,
        "seats": 81
      },
      {
        "name": "Physics",
        "code": "P",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 22008,
              "ews": 5838,
              "obc": 9176,
              "sc": 1771,
              "st": 1869
            },
            "2023": {
              "general": 21567,
              "ews": 5721,
              "obc": 8992,
              "sc": 1735,
              "st": 1831
            },
            "2022": {
              "general": 21127,
              "ews": 5604,
              "obc": 8808,
              "sc": 1700,
              "st": 1794
            },
            "2021": {
              "general": 20687,
              "ews": 5487,
              "obc": 8625,
              "sc": 1664,
              "st": 1756
            },
            "2020": {
              "general": 20247,
              "ews": 5370,
              "obc": 8441,
              "sc": 1629,
              "st": 1719
            }
          }
        },
        "fees": 150000,
        "seats": 81
      }
    ]
  },
  {
    "id": 102,
    "name": "National Institute of Technology, Silchar",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 42862,
              "ews": 7150,
              "obc": 14305,
              "sc": 7130,
              "st": 2038
            },
            "2023": {
              "general": 42004,
              "ews": 7007,
              "obc": 14018,
              "sc": 6987,
              "st": 1997
            },
            "2022": {
              "general": 41147,
              "ews": 6864,
              "obc": 13732,
              "sc": 6844,
              "st": 1956
            },
            "2021": {
              "general": 40290,
              "ews": 6721,
              "obc": 13446,
              "sc": 6702,
              "st": 1915
            },
            "2020": {
              "general": 39433,
              "ews": 6578,
              "obc": 13160,
              "sc": 6559,
              "st": 1874
            }
          }
        },
        "fees": 150000,
        "seats": 82
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 11104,
              "ews": 1709,
              "obc": 3782,
              "sc": 2425,
              "st": 806
            },
            "2023": {
              "general": 10881,
              "ews": 1674,
              "obc": 3706,
              "sc": 2376,
              "st": 789
            },
            "2022": {
              "general": 10659,
              "ews": 1640,
              "obc": 3630,
              "sc": 2328,
              "st": 773
            },
            "2021": {
              "general": 10437,
              "ews": 1606,
              "obc": 3555,
              "sc": 2279,
              "st": 757
            },
            "2020": {
              "general": 10215,
              "ews": 1572,
              "obc": 3479,
              "sc": 2231,
              "st": 741
            }
          }
        },
        "fees": 150000,
        "seats": 82
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 22590,
              "ews": 3668,
              "obc": 8133,
              "sc": 5298,
              "st": 1805
            },
            "2023": {
              "general": 22138,
              "ews": 3594,
              "obc": 7970,
              "sc": 5192,
              "st": 1768
            },
            "2022": {
              "general": 21686,
              "ews": 3521,
              "obc": 7807,
              "sc": 5086,
              "st": 1732
            },
            "2021": {
              "general": 21234,
              "ews": 3447,
              "obc": 7645,
              "sc": 4980,
              "st": 1696
            },
            "2020": {
              "general": 20782,
              "ews": 3374,
              "obc": 7482,
              "sc": 4874,
              "st": 1660
            }
          }
        },
        "fees": 150000,
        "seats": 82
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 16051,
              "ews": 2510,
              "obc": 5920,
              "sc": 3931,
              "st": 1404
            },
            "2023": {
              "general": 15729,
              "ews": 2459,
              "obc": 5801,
              "sc": 3852,
              "st": 1375
            },
            "2022": {
              "general": 15408,
              "ews": 2409,
              "obc": 5683,
              "sc": 3773,
              "st": 1347
            },
            "2021": {
              "general": 15087,
              "ews": 2359,
              "obc": 5564,
              "sc": 3695,
              "st": 1319
            },
            "2020": {
              "general": 14766,
              "ews": 2309,
              "obc": 5446,
              "sc": 3616,
              "st": 1291
            }
          }
        },
        "fees": 150000,
        "seats": 82
      },
      {
        "name": "Electronics and Instrumentation Engineering",
        "code": "EIE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 21019,
              "ews": 3386,
              "obc": 7744,
              "sc": 4635,
              "st": 2118
            },
            "2023": {
              "general": 20598,
              "ews": 3318,
              "obc": 7589,
              "sc": 4542,
              "st": 2075
            },
            "2022": {
              "general": 20178,
              "ews": 3250,
              "obc": 7434,
              "sc": 4449,
              "st": 2033
            },
            "2021": {
              "general": 19757,
              "ews": 3182,
              "obc": 7279,
              "sc": 4356,
              "st": 1990
            },
            "2020": {
              "general": 19337,
              "ews": 3115,
              "obc": 7124,
              "sc": 4264,
              "st": 1948
            }
          }
        },
        "fees": 150000,
        "seats": 82
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 29898,
              "ews": 5457,
              "obc": 10540,
              "sc": 5993,
              "st": 2232
            },
            "2023": {
              "general": 29300,
              "ews": 5347,
              "obc": 10329,
              "sc": 5873,
              "st": 2187
            },
            "2022": {
              "general": 28702,
              "ews": 5238,
              "obc": 10118,
              "sc": 5753,
              "st": 2142
            },
            "2021": {
              "general": 28104,
              "ews": 5129,
              "obc": 9907,
              "sc": 5633,
              "st": 2098
            },
            "2020": {
              "general": 27506,
              "ews": 5020,
              "obc": 9696,
              "sc": 5513,
              "st": 2053
            }
          }
        },
        "fees": 150000,
        "seats": 82
      }
    ]
  },
  {
    "id": 103,
    "name": "National Institute of Technology, Srinagar",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 50334,
              "sc": 8253,
              "st": 3088,
              "ews": 8429,
              "obc": 17144
            },
            "2023": {
              "general": 49327,
              "sc": 8087,
              "st": 3026,
              "ews": 8260,
              "obc": 16801
            },
            "2022": {
              "general": 48320,
              "sc": 7922,
              "st": 2964,
              "ews": 8091,
              "obc": 16458
            },
            "2021": {
              "general": 47313,
              "sc": 7757,
              "st": 2902,
              "ews": 7923,
              "obc": 16115
            },
            "2020": {
              "general": 46307,
              "sc": 7592,
              "st": 2840,
              "ews": 7754,
              "obc": 15772
            }
          }
        },
        "fees": 150000,
        "seats": 83
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 53262,
              "ews": 8777,
              "obc": 17818,
              "sc": 8100,
              "st": 2648
            },
            "2023": {
              "general": 52196,
              "ews": 8601,
              "obc": 17461,
              "sc": 7938,
              "st": 2595
            },
            "2022": {
              "general": 51131,
              "ews": 8425,
              "obc": 17105,
              "sc": 7776,
              "st": 2542
            },
            "2021": {
              "general": 50066,
              "ews": 8250,
              "obc": 16748,
              "sc": 7614,
              "st": 2489
            },
            "2020": {
              "general": 49001,
              "ews": 8074,
              "obc": 16392,
              "sc": 7452,
              "st": 2436
            }
          }
        },
        "fees": 150000,
        "seats": 83
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 21355,
              "ews": 3485,
              "obc": 7130,
              "sc": 3702,
              "st": 1630
            },
            "2023": {
              "general": 20927,
              "ews": 3415,
              "obc": 6987,
              "sc": 3627,
              "st": 1597
            },
            "2022": {
              "general": 20500,
              "ews": 3345,
              "obc": 6844,
              "sc": 3553,
              "st": 1564
            },
            "2021": {
              "general": 20073,
              "ews": 3275,
              "obc": 6702,
              "sc": 3479,
              "st": 1532
            },
            "2020": {
              "general": 19646,
              "ews": 3206,
              "obc": 6559,
              "sc": 3405,
              "st": 1499
            }
          }
        },
        "fees": 150000,
        "seats": 83
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 39615,
              "ews": 6576,
              "sc": 6221,
              "st": 2473,
              "obc": 13414
            },
            "2023": {
              "general": 38822,
              "ews": 6444,
              "sc": 6096,
              "st": 2423,
              "obc": 13145
            },
            "2022": {
              "general": 38030,
              "ews": 6312,
              "sc": 5972,
              "st": 2374,
              "obc": 12877
            },
            "2021": {
              "general": 37238,
              "ews": 6181,
              "sc": 5847,
              "st": 2324,
              "obc": 12609
            },
            "2020": {
              "general": 36445,
              "ews": 6049,
              "sc": 5723,
              "st": 2275,
              "obc": 12340
            }
          }
        },
        "fees": 150000,
        "seats": 83
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 31981,
              "ews": 5355,
              "obc": 11331,
              "sc": 5436,
              "st": 2322
            },
            "2023": {
              "general": 31341,
              "ews": 5247,
              "obc": 11104,
              "sc": 5327,
              "st": 2275
            },
            "2022": {
              "general": 30701,
              "ews": 5140,
              "obc": 10877,
              "sc": 5218,
              "st": 2229
            },
            "2021": {
              "general": 30062,
              "ews": 5033,
              "obc": 10651,
              "sc": 5109,
              "st": 2182
            },
            "2020": {
              "general": 29422,
              "ews": 4926,
              "obc": 10424,
              "sc": 5001,
              "st": 2136
            }
          }
        },
        "fees": 150000,
        "seats": 83
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 25684,
              "ews": 4222,
              "obc": 9167,
              "sc": 4843,
              "st": 2261
            },
            "2023": {
              "general": 25170,
              "ews": 4137,
              "obc": 8983,
              "sc": 4746,
              "st": 2215
            },
            "2022": {
              "general": 24656,
              "ews": 4053,
              "obc": 8800,
              "sc": 4649,
              "st": 2170
            },
            "2021": {
              "general": 24142,
              "ews": 3968,
              "obc": 8616,
              "sc": 4552,
              "st": 2125
            },
            "2020": {
              "general": 23629,
              "ews": 3884,
              "obc": 8433,
              "sc": 4455,
              "st": 2080
            }
          }
        },
        "fees": 150000,
        "seats": 83
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 45149,
              "ews": 7821,
              "obc": 15162,
              "sc": 7579,
              "st": 2707
            },
            "2023": {
              "general": 44246,
              "ews": 7664,
              "obc": 14858,
              "sc": 7427,
              "st": 2652
            },
            "2022": {
              "general": 43343,
              "ews": 7508,
              "obc": 14555,
              "sc": 7275,
              "st": 2598
            },
            "2021": {
              "general": 42440,
              "ews": 7351,
              "obc": 14252,
              "sc": 7124,
              "st": 2544
            },
            "2020": {
              "general": 41537,
              "ews": 7195,
              "obc": 13949,
              "sc": 6972,
              "st": 2490
            }
          }
        },
        "fees": 150000,
        "seats": 83
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 54425,
              "sc": 9124,
              "st": 3556,
              "ews": 9105,
              "obc": 18138
            },
            "2023": {
              "general": 53336,
              "sc": 8941,
              "st": 3484,
              "ews": 8922,
              "obc": 17775
            },
            "2022": {
              "general": 52248,
              "sc": 8759,
              "st": 3413,
              "ews": 8740,
              "obc": 17412
            },
            "2021": {
              "general": 51159,
              "sc": 8576,
              "st": 3342,
              "ews": 8558,
              "obc": 17049
            },
            "2020": {
              "general": 50071,
              "sc": 8394,
              "st": 3271,
              "ews": 8376,
              "obc": 16686
            }
          }
        },
        "fees": 150000,
        "seats": 83
      }
    ]
  },
  {
    "id": 104,
    "name": "National Institute of Technology, Tiruchirappalli",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 404,
              "ews": 102,
              "obc": 168,
              "sc": 50,
              "st": 41
            },
            "2023": {
              "general": 395,
              "ews": 99,
              "obc": 164,
              "sc": 49,
              "st": 40
            },
            "2022": {
              "general": 387,
              "ews": 97,
              "obc": 161,
              "sc": 48,
              "st": 39
            },
            "2021": {
              "general": 379,
              "ews": 95,
              "obc": 157,
              "sc": 47,
              "st": 38
            },
            "2020": {
              "general": 371,
              "ews": 93,
              "obc": 154,
              "sc": 46,
              "st": 37
            }
          }
        },
        "fees": 150000,
        "seats": 84
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 12844,
              "ews": 2493,
              "obc": 5446,
              "sc": 3666,
              "st": 1001
            },
            "2023": {
              "general": 12587,
              "ews": 2443,
              "obc": 5337,
              "sc": 3592,
              "st": 980
            },
            "2022": {
              "general": 12330,
              "ews": 2393,
              "obc": 5228,
              "sc": 3519,
              "st": 960
            },
            "2021": {
              "general": 12073,
              "ews": 2343,
              "obc": 5119,
              "sc": 3446,
              "st": 940
            },
            "2020": {
              "general": 11816,
              "ews": 2293,
              "obc": 5010,
              "sc": 3372,
              "st": 920
            }
          }
        },
        "fees": 150000,
        "seats": 84
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 16190,
              "ews": 3096,
              "obc": 6620,
              "sc": 2819,
              "st": 712
            },
            "2023": {
              "general": 15866,
              "ews": 3034,
              "obc": 6487,
              "sc": 2762,
              "st": 697
            },
            "2022": {
              "general": 15542,
              "ews": 2972,
              "obc": 6355,
              "sc": 2706,
              "st": 683
            },
            "2021": {
              "general": 15218,
              "ews": 2910,
              "obc": 6222,
              "sc": 2649,
              "st": 669
            },
            "2020": {
              "general": 14894,
              "ews": 2848,
              "obc": 6090,
              "sc": 2593,
              "st": 655
            }
          }
        },
        "fees": 150000,
        "seats": 84
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 1190,
              "ews": 190,
              "obc": 369,
              "sc": 204,
              "st": 123
            },
            "2023": {
              "general": 1166,
              "ews": 186,
              "obc": 361,
              "sc": 199,
              "st": 120
            },
            "2022": {
              "general": 1142,
              "ews": 182,
              "obc": 354,
              "sc": 195,
              "st": 118
            },
            "2021": {
              "general": 1118,
              "ews": 178,
              "obc": 346,
              "sc": 191,
              "st": 115
            },
            "2020": {
              "general": 1094,
              "ews": 174,
              "obc": 339,
              "sc": 187,
              "st": 113
            }
          }
        },
        "fees": 150000,
        "seats": 84
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 5285,
              "ews": 1071,
              "obc": 2013,
              "sc": 1242,
              "st": 329
            },
            "2023": {
              "general": 5179,
              "ews": 1049,
              "obc": 1972,
              "sc": 1217,
              "st": 322
            },
            "2022": {
              "general": 5073,
              "ews": 1028,
              "obc": 1932,
              "sc": 1192,
              "st": 315
            },
            "2021": {
              "general": 4967,
              "ews": 1006,
              "obc": 1892,
              "sc": 1167,
              "st": 309
            },
            "2020": {
              "general": 4862,
              "ews": 985,
              "obc": 1851,
              "sc": 1142,
              "st": 302
            }
          }
        },
        "fees": 150000,
        "seats": 84
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 3280,
              "ews": 471,
              "obc": 1294,
              "sc": 633,
              "st": 223
            },
            "2023": {
              "general": 3214,
              "ews": 461,
              "obc": 1268,
              "sc": 620,
              "st": 218
            },
            "2022": {
              "general": 3148,
              "ews": 452,
              "obc": 1242,
              "sc": 607,
              "st": 214
            },
            "2021": {
              "general": 3083,
              "ews": 442,
              "obc": 1216,
              "sc": 595,
              "st": 209
            },
            "2020": {
              "general": 3017,
              "ews": 433,
              "obc": 1190,
              "sc": 582,
              "st": 205
            }
          }
        },
        "fees": 150000,
        "seats": 84
      },
      {
        "name": "Instrumentation and Control Engineering",
        "code": "ICE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 10864,
              "ews": 1851,
              "obc": 4275,
              "sc": 2646,
              "st": 1166
            },
            "2023": {
              "general": 10646,
              "ews": 1813,
              "obc": 4189,
              "sc": 2593,
              "st": 1142
            },
            "2022": {
              "general": 10429,
              "ews": 1776,
              "obc": 4104,
              "sc": 2540,
              "st": 1119
            },
            "2021": {
              "general": 10212,
              "ews": 1739,
              "obc": 4018,
              "sc": 2487,
              "st": 1096
            },
            "2020": {
              "general": 9994,
              "ews": 1702,
              "obc": 3933,
              "sc": 2434,
              "st": 1072
            }
          }
        },
        "fees": 150000,
        "seats": 84
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 8625,
              "ews": 1726,
              "obc": 3737,
              "sc": 2390,
              "st": 818
            },
            "2023": {
              "general": 8452,
              "ews": 1691,
              "obc": 3662,
              "sc": 2342,
              "st": 801
            },
            "2022": {
              "general": 8280,
              "ews": 1656,
              "obc": 3587,
              "sc": 2294,
              "st": 785
            },
            "2021": {
              "general": 8107,
              "ews": 1622,
              "obc": 3512,
              "sc": 2246,
              "st": 768
            },
            "2020": {
              "general": 7935,
              "ews": 1587,
              "obc": 3438,
              "sc": 2198,
              "st": 752
            }
          }
        },
        "fees": 150000,
        "seats": 84
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 20754,
              "ews": 3645,
              "obc": 8529,
              "sc": 4931,
              "st": 1607
            },
            "2023": {
              "general": 20338,
              "ews": 3572,
              "obc": 8358,
              "sc": 4832,
              "st": 1574
            },
            "2022": {
              "general": 19923,
              "ews": 3499,
              "obc": 8187,
              "sc": 4733,
              "st": 1542
            },
            "2021": {
              "general": 19508,
              "ews": 3426,
              "obc": 8017,
              "sc": 4635,
              "st": 1510
            },
            "2020": {
              "general": 19093,
              "ews": 3353,
              "obc": 7846,
              "sc": 4536,
              "st": 1478
            }
          }
        },
        "fees": 150000,
        "seats": 84
      },
      {
        "name": "Production Engineering",
        "code": "PE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 21431,
              "ews": 4154,
              "obc": 8902,
              "sc": 5179,
              "st": 1681
            },
            "2023": {
              "general": 21002,
              "ews": 4070,
              "obc": 8723,
              "sc": 5075,
              "st": 1647
            },
            "2022": {
              "general": 20573,
              "ews": 3987,
              "obc": 8545,
              "sc": 4971,
              "st": 1613
            },
            "2021": {
              "general": 20145,
              "ews": 3904,
              "obc": 8367,
              "sc": 4868,
              "st": 1580
            },
            "2020": {
              "general": 19716,
              "ews": 3821,
              "obc": 8189,
              "sc": 4764,
              "st": 1546
            }
          }
        },
        "fees": 150000,
        "seats": 84
      }
    ]
  },
  {
    "id": 105,
    "name": "National Institute of Technology, Uttarakhand",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 45643,
              "ews": 7429,
              "obc": 15750,
              "sc": 7295,
              "st": 2029
            },
            "2023": {
              "general": 44730,
              "ews": 7280,
              "obc": 15435,
              "sc": 7149,
              "st": 1988
            },
            "2022": {
              "general": 43817,
              "ews": 7131,
              "obc": 15120,
              "sc": 7003,
              "st": 1947
            },
            "2021": {
              "general": 42904,
              "ews": 6983,
              "obc": 14805,
              "sc": 6857,
              "st": 1907
            },
            "2020": {
              "general": 41991,
              "ews": 6834,
              "obc": 14490,
              "sc": 6711,
              "st": 1866
            }
          }
        },
        "fees": 150000,
        "seats": 85
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 16840,
              "ews": 2606,
              "obc": 6517,
              "sc": 3720,
              "st": 1516
            },
            "2023": {
              "general": 16503,
              "ews": 2553,
              "obc": 6386,
              "sc": 3645,
              "st": 1485
            },
            "2022": {
              "general": 16166,
              "ews": 2501,
              "obc": 6256,
              "sc": 3571,
              "st": 1455
            },
            "2021": {
              "general": 15829,
              "ews": 2449,
              "obc": 6125,
              "sc": 3496,
              "st": 1425
            },
            "2020": {
              "general": 15492,
              "ews": 2397,
              "obc": 5995,
              "sc": 3422,
              "st": 1394
            }
          }
        },
        "fees": 150000,
        "seats": 85
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 30995,
              "ews": 5154,
              "obc": 10001,
              "sc": 5873,
              "st": 1857
            },
            "2023": {
              "general": 30375,
              "ews": 5050,
              "obc": 9800,
              "sc": 5755,
              "st": 1819
            },
            "2022": {
              "general": 29755,
              "ews": 4947,
              "obc": 9600,
              "sc": 5638,
              "st": 1782
            },
            "2021": {
              "general": 29135,
              "ews": 4844,
              "obc": 9400,
              "sc": 5520,
              "st": 1745
            },
            "2020": {
              "general": 28515,
              "ews": 4741,
              "obc": 9200,
              "sc": 5403,
              "st": 1708
            }
          }
        },
        "fees": 150000,
        "seats": 85
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 24552,
              "ews": 4006,
              "obc": 8377,
              "sc": 4727,
              "st": 1844
            },
            "2023": {
              "general": 24060,
              "ews": 3925,
              "obc": 8209,
              "sc": 4632,
              "st": 1807
            },
            "2022": {
              "general": 23569,
              "ews": 3845,
              "obc": 8041,
              "sc": 4537,
              "st": 1770
            },
            "2021": {
              "general": 23078,
              "ews": 3765,
              "obc": 7874,
              "sc": 4443,
              "st": 1733
            },
            "2020": {
              "general": 22587,
              "ews": 3685,
              "obc": 7706,
              "sc": 4348,
              "st": 1696
            }
          }
        },
        "fees": 150000,
        "seats": 85
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 39010,
              "ews": 6312,
              "obc": 13176,
              "sc": 6631,
              "st": 2297
            },
            "2023": {
              "general": 38229,
              "ews": 6185,
              "obc": 12912,
              "sc": 6498,
              "st": 2251
            },
            "2022": {
              "general": 37449,
              "ews": 6059,
              "obc": 12648,
              "sc": 6365,
              "st": 2205
            },
            "2021": {
              "general": 36669,
              "ews": 5933,
              "obc": 12385,
              "sc": 6233,
              "st": 2159
            },
            "2020": {
              "general": 35889,
              "ews": 5807,
              "obc": 12121,
              "sc": 6100,
              "st": 2113
            }
          }
        },
        "fees": 150000,
        "seats": 85
      }
    ]
  },
  {
    "id": 106,
    "name": "National Institute of Technology, Warangal",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Bio Technology",
        "code": "BT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 28482,
              "ews": 5053,
              "obc": 11333,
              "sc": 6168,
              "st": 2432
            },
            "2023": {
              "general": 27912,
              "ews": 4951,
              "obc": 11106,
              "sc": 6044,
              "st": 2383
            },
            "2022": {
              "general": 27342,
              "ews": 4850,
              "obc": 10879,
              "sc": 5921,
              "st": 2334
            },
            "2021": {
              "general": 26773,
              "ews": 4749,
              "obc": 10653,
              "sc": 5797,
              "st": 2286
            },
            "2020": {
              "general": 26203,
              "ews": 4648,
              "obc": 10426,
              "sc": 5674,
              "st": 2237
            }
          }
        },
        "fees": 150000,
        "seats": 86
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 17797,
              "ews": 3000,
              "obc": 6573,
              "sc": 4222,
              "st": 1498
            },
            "2023": {
              "general": 17441,
              "ews": 2940,
              "obc": 6441,
              "sc": 4137,
              "st": 1468
            },
            "2022": {
              "general": 17085,
              "ews": 2880,
              "obc": 6310,
              "sc": 4053,
              "st": 1438
            },
            "2021": {
              "general": 16729,
              "ews": 2820,
              "obc": 6178,
              "sc": 3968,
              "st": 1408
            },
            "2020": {
              "general": 16373,
              "ews": 2760,
              "obc": 6047,
              "sc": 3884,
              "st": 1378
            }
          }
        },
        "fees": 150000,
        "seats": 86
      },
      {
        "name": "Chemistry",
        "code": "C",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 31513,
              "ews": 7340,
              "obc": 13490,
              "sc": 7127,
              "st": 1862
            },
            "2023": {
              "general": 30882,
              "ews": 7193,
              "obc": 13220,
              "sc": 6984,
              "st": 1824
            },
            "2022": {
              "general": 30252,
              "ews": 7046,
              "obc": 12950,
              "sc": 6841,
              "st": 1787
            },
            "2021": {
              "general": 29622,
              "ews": 6899,
              "obc": 12680,
              "sc": 6699,
              "st": 1750
            },
            "2020": {
              "general": 28991,
              "ews": 6752,
              "obc": 12410,
              "sc": 6556,
              "st": 1713
            }
          }
        },
        "fees": 150000,
        "seats": 86
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 23087,
              "ews": 3810,
              "obc": 8555,
              "sc": 4617,
              "st": 1014
            },
            "2023": {
              "general": 22625,
              "ews": 3733,
              "obc": 8383,
              "sc": 4524,
              "st": 993
            },
            "2022": {
              "general": 22163,
              "ews": 3657,
              "obc": 8212,
              "sc": 4432,
              "st": 973
            },
            "2021": {
              "general": 21701,
              "ews": 3581,
              "obc": 8041,
              "sc": 4339,
              "st": 953
            },
            "2020": {
              "general": 21240,
              "ews": 3505,
              "obc": 7870,
              "sc": 4247,
              "st": 932
            }
          }
        },
        "fees": 150000,
        "seats": 86
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 2030,
              "ews": 321,
              "obc": 629,
              "sc": 409,
              "st": 201
            },
            "2023": {
              "general": 1989,
              "ews": 314,
              "obc": 616,
              "sc": 400,
              "st": 196
            },
            "2022": {
              "general": 1948,
              "ews": 308,
              "obc": 603,
              "sc": 392,
              "st": 192
            },
            "2021": {
              "general": 1908,
              "ews": 301,
              "obc": 591,
              "sc": 384,
              "st": 188
            },
            "2020": {
              "general": 1867,
              "ews": 295,
              "obc": 578,
              "sc": 376,
              "st": 184
            }
          }
        },
        "fees": 150000,
        "seats": 86
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 7396,
              "ews": 1302,
              "obc": 2763,
              "sc": 1835,
              "st": 660
            },
            "2023": {
              "general": 7248,
              "ews": 1275,
              "obc": 2707,
              "sc": 1798,
              "st": 646
            },
            "2022": {
              "general": 7100,
              "ews": 1249,
              "obc": 2652,
              "sc": 1761,
              "st": 633
            },
            "2021": {
              "general": 6952,
              "ews": 1223,
              "obc": 2597,
              "sc": 1724,
              "st": 620
            },
            "2020": {
              "general": 6804,
              "ews": 1197,
              "obc": 2541,
              "sc": 1688,
              "st": 607
            }
          }
        },
        "fees": 150000,
        "seats": 86
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 5214,
              "ews": 727,
              "obc": 1843,
              "sc": 1250,
              "st": 486
            },
            "2023": {
              "general": 5109,
              "ews": 712,
              "obc": 1806,
              "sc": 1225,
              "st": 476
            },
            "2022": {
              "general": 5005,
              "ews": 697,
              "obc": 1769,
              "sc": 1200,
              "st": 466
            },
            "2021": {
              "general": 4901,
              "ews": 683,
              "obc": 1732,
              "sc": 1175,
              "st": 456
            },
            "2020": {
              "general": 4796,
              "ews": 668,
              "obc": 1695,
              "sc": 1150,
              "st": 447
            }
          }
        },
        "fees": 150000,
        "seats": 86
      },
      {
        "name": "Mathematics",
        "code": "M",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 21556,
              "ews": 4367,
              "obc": 7230,
              "sc": 6132,
              "st": 2415
            },
            "2023": {
              "general": 21124,
              "ews": 4279,
              "obc": 7085,
              "sc": 6009,
              "st": 2366
            },
            "2022": {
              "general": 20693,
              "ews": 4192,
              "obc": 6940,
              "sc": 5886,
              "st": 2318
            },
            "2021": {
              "general": 20262,
              "ews": 4104,
              "obc": 6796,
              "sc": 5764,
              "st": 2270
            },
            "2020": {
              "general": 19831,
              "ews": 4017,
              "obc": 6651,
              "sc": 5641,
              "st": 2221
            }
          }
        },
        "fees": 150000,
        "seats": 86
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 3053,
              "ews": 427,
              "obc": 936,
              "sc": 862,
              "st": 375
            },
            "2023": {
              "general": 2991,
              "ews": 418,
              "obc": 917,
              "sc": 844,
              "st": 367
            },
            "2022": {
              "general": 2930,
              "ews": 409,
              "obc": 898,
              "sc": 827,
              "st": 360
            },
            "2021": {
              "general": 2869,
              "ews": 401,
              "obc": 879,
              "sc": 810,
              "st": 352
            },
            "2020": {
              "general": 2808,
              "ews": 392,
              "obc": 861,
              "sc": 793,
              "st": 345
            }
          }
        },
        "fees": 150000,
        "seats": 86
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 12779,
              "ews": 2061,
              "obc": 5087,
              "sc": 2818,
              "st": 1393
            },
            "2023": {
              "general": 12523,
              "ews": 2019,
              "obc": 4985,
              "sc": 2761,
              "st": 1365
            },
            "2022": {
              "general": 12267,
              "ews": 1978,
              "obc": 4883,
              "sc": 2705,
              "st": 1337
            },
            "2021": {
              "general": 12012,
              "ews": 1937,
              "obc": 4781,
              "sc": 2648,
              "st": 1309
            },
            "2020": {
              "general": 11756,
              "ews": 1896,
              "obc": 4680,
              "sc": 2592,
              "st": 1281
            }
          }
        },
        "fees": 150000,
        "seats": 86
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 26475,
              "ews": 4479,
              "obc": 10309,
              "sc": 5736,
              "st": 2157
            },
            "2023": {
              "general": 25945,
              "ews": 4389,
              "obc": 10102,
              "sc": 5621,
              "st": 2113
            },
            "2022": {
              "general": 25416,
              "ews": 4299,
              "obc": 9896,
              "sc": 5506,
              "st": 2070
            },
            "2021": {
              "general": 24886,
              "ews": 4210,
              "obc": 9690,
              "sc": 5391,
              "st": 2027
            },
            "2020": {
              "general": 24357,
              "ews": 4120,
              "obc": 9484,
              "sc": 5277,
              "st": 1984
            }
          }
        },
        "fees": 150000,
        "seats": 86
      },
      {
        "name": "Physics",
        "code": "P",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 12918,
              "ews": 5716,
              "obc": 9459,
              "sc": 4609,
              "st": 1658
            },
            "2023": {
              "general": 12659,
              "ews": 5601,
              "obc": 9269,
              "sc": 4516,
              "st": 1624
            },
            "2022": {
              "general": 12401,
              "ews": 5487,
              "obc": 9080,
              "sc": 4424,
              "st": 1591
            },
            "2021": {
              "general": 12142,
              "ews": 5373,
              "obc": 8891,
              "sc": 4332,
              "st": 1558
            },
            "2020": {
              "general": 11884,
              "ews": 5258,
              "obc": 8702,
              "sc": 4240,
              "st": 1525
            }
          }
        },
        "fees": 150000,
        "seats": 86
      }
    ]
  },
  {
    "id": 107,
    "name": "North Eastern Regional Institute of Science and Technology, Nirjuli-791109 (Itanagar),Arunachal Pradesh",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Agricultural Engineering",
        "code": "AE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "ews": 12242,
              "obc": 27958
            },
            "2023": {
              "ews": 11997,
              "obc": 27398
            },
            "2022": {
              "ews": 11752,
              "obc": 26839
            },
            "2021": {
              "ews": 11507,
              "obc": 26280
            },
            "2020": {
              "ews": 11262,
              "obc": 25721
            }
          }
        },
        "fees": 150000,
        "seats": 87
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "ews": 12430,
              "obc": 25403
            },
            "2023": {
              "ews": 12181,
              "obc": 24894
            },
            "2022": {
              "ews": 11932,
              "obc": 24386
            },
            "2021": {
              "ews": 11684,
              "obc": 23878
            },
            "2020": {
              "ews": 11435,
              "obc": 23370
            }
          }
        },
        "fees": 150000,
        "seats": 87
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 52952,
              "ews": 10115
            },
            "2023": {
              "general": 51892,
              "ews": 9912
            },
            "2022": {
              "general": 50833,
              "ews": 9710
            },
            "2021": {
              "general": 49774,
              "ews": 9508
            },
            "2020": {
              "general": 48715,
              "ews": 9305
            }
          }
        },
        "fees": 150000,
        "seats": 87
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "ews": 9790,
              "st": 5570
            },
            "2023": {
              "ews": 9594,
              "st": 5458
            },
            "2022": {
              "ews": 9398,
              "st": 5347
            },
            "2021": {
              "ews": 9202,
              "st": 5235
            },
            "2020": {
              "ews": 9006,
              "st": 5124
            }
          }
        },
        "fees": 150000,
        "seats": 87
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "ews": 9457,
              "sc": 10860
            },
            "2023": {
              "ews": 9267,
              "sc": 10642
            },
            "2022": {
              "ews": 9078,
              "sc": 10425
            },
            "2021": {
              "ews": 8889,
              "sc": 10208
            },
            "2020": {
              "ews": 8700,
              "sc": 9991
            }
          }
        },
        "fees": 150000,
        "seats": 87
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 63321,
              "ews": 11082
            },
            "2023": {
              "general": 62054,
              "ews": 10860
            },
            "2022": {
              "general": 60788,
              "ews": 10638
            },
            "2021": {
              "general": 59521,
              "ews": 10417
            },
            "2020": {
              "general": 58255,
              "ews": 10195
            }
          }
        },
        "fees": 150000,
        "seats": 87
      }
    ]
  },
  {
    "id": 108,
    "name": "North-Eastern Hill University, Shillong",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Biomedical Engineering",
        "code": "BE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 90611,
              "ews": 16913,
              "obc": 34140,
              "sc": 15342,
              "st": 6583
            },
            "2023": {
              "general": 88798,
              "ews": 16574,
              "obc": 33457,
              "sc": 15035,
              "st": 6451
            },
            "2022": {
              "general": 86986,
              "ews": 16236,
              "obc": 32774,
              "sc": 14728,
              "st": 6319
            },
            "2021": {
              "general": 85174,
              "ews": 15898,
              "obc": 32091,
              "sc": 14421,
              "st": 6188
            },
            "2020": {
              "general": 83362,
              "ews": 15559,
              "obc": 31408,
              "sc": 14114,
              "st": 6056
            }
          }
        },
        "fees": 150000,
        "seats": 88
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 76959,
              "ews": 13206,
              "obc": 27714,
              "sc": 12505,
              "st": 5666
            },
            "2023": {
              "general": 75419,
              "ews": 12941,
              "obc": 27159,
              "sc": 12254,
              "st": 5552
            },
            "2022": {
              "general": 73880,
              "ews": 12677,
              "obc": 26605,
              "sc": 12004,
              "st": 5439
            },
            "2021": {
              "general": 72341,
              "ews": 12413,
              "obc": 26051,
              "sc": 11754,
              "st": 5326
            },
            "2020": {
              "general": 70802,
              "ews": 12149,
              "obc": 25496,
              "sc": 11504,
              "st": 5212
            }
          }
        },
        "fees": 150000,
        "seats": 88
      },
      {
        "name": "Energy Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 85436,
              "ews": 14382,
              "obc": 31506,
              "sc": 13707,
              "st": 5831
            },
            "2023": {
              "general": 83727,
              "ews": 14094,
              "obc": 30875,
              "sc": 13432,
              "st": 5714
            },
            "2022": {
              "general": 82018,
              "ews": 13806,
              "obc": 30245,
              "sc": 13158,
              "st": 5597
            },
            "2021": {
              "general": 80309,
              "ews": 13519,
              "obc": 29615,
              "sc": 12884,
              "st": 5481
            },
            "2020": {
              "general": 78601,
              "ews": 13231,
              "obc": 28985,
              "sc": 12610,
              "st": 5364
            }
          }
        },
        "fees": 150000,
        "seats": 88
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 63722,
              "ews": 12773,
              "obc": 25462,
              "sc": 12454,
              "st": 5296
            },
            "2023": {
              "general": 62447,
              "ews": 12517,
              "obc": 24952,
              "sc": 12204,
              "st": 5190
            },
            "2022": {
              "general": 61173,
              "ews": 12262,
              "obc": 24443,
              "sc": 11955,
              "st": 5084
            },
            "2021": {
              "general": 59898,
              "ews": 12006,
              "obc": 23934,
              "sc": 11706,
              "st": 4978
            },
            "2020": {
              "general": 58624,
              "ews": 11751,
              "obc": 23425,
              "sc": 11457,
              "st": 4872
            }
          }
        },
        "fees": 150000,
        "seats": 88
      }
    ]
  },
  {
    "id": 109,
    "name": "Pt. Dwarka Prasad Mishra Indian Institute of Information Technology, Design & Manufacture Jabalpur",
    "type": "IIIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 14280,
              "ews": 2364,
              "obc": 5741,
              "sc": 3871,
              "st": 1935
            },
            "2023": {
              "general": 13994,
              "ews": 2316,
              "obc": 5626,
              "sc": 3793,
              "st": 1896
            },
            "2022": {
              "general": 13708,
              "ews": 2269,
              "obc": 5511,
              "sc": 3716,
              "st": 1857
            },
            "2021": {
              "general": 13423,
              "ews": 2222,
              "obc": 5396,
              "sc": 3638,
              "st": 1818
            },
            "2020": {
              "general": 13137,
              "ews": 2174,
              "obc": 5281,
              "sc": 3561,
              "st": 1780
            }
          }
        },
        "fees": 150000,
        "seats": 89
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 17869,
              "ews": 3050,
              "obc": 7433,
              "sc": 4800,
              "st": 2464
            },
            "2023": {
              "general": 17511,
              "ews": 2989,
              "obc": 7284,
              "sc": 4704,
              "st": 2414
            },
            "2022": {
              "general": 17154,
              "ews": 2928,
              "obc": 7135,
              "sc": 4608,
              "st": 2365
            },
            "2021": {
              "general": 16796,
              "ews": 2867,
              "obc": 6987,
              "sc": 4512,
              "st": 2316
            },
            "2020": {
              "general": 16439,
              "ews": 2806,
              "obc": 6838,
              "sc": 4416,
              "st": 2266
            }
          }
        },
        "fees": 150000,
        "seats": 89
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 38454,
              "ews": 7070,
              "obc": 15640,
              "sc": 7331,
              "st": 2964
            },
            "2023": {
              "general": 37684,
              "ews": 6928,
              "obc": 15327,
              "sc": 7184,
              "st": 2904
            },
            "2022": {
              "general": 36915,
              "ews": 6787,
              "obc": 15014,
              "sc": 7037,
              "st": 2845
            },
            "2021": {
              "general": 36146,
              "ews": 6645,
              "obc": 14701,
              "sc": 6891,
              "st": 2786
            },
            "2020": {
              "general": 35377,
              "ews": 6504,
              "obc": 14388,
              "sc": 6744,
              "st": 2726
            }
          }
        },
        "fees": 150000,
        "seats": 89
      },
      {
        "name": "Smart Manufacturing",
        "code": "SM",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 46514,
              "ews": 8152,
              "obc": 17705,
              "sc": 9013,
              "st": 3552
            },
            "2023": {
              "general": 45583,
              "ews": 7988,
              "obc": 17350,
              "sc": 8832,
              "st": 3480
            },
            "2022": {
              "general": 44653,
              "ews": 7825,
              "obc": 16996,
              "sc": 8652,
              "st": 3409
            },
            "2021": {
              "general": 43723,
              "ews": 7662,
              "obc": 16642,
              "sc": 8472,
              "st": 3338
            },
            "2020": {
              "general": 42792,
              "ews": 7499,
              "obc": 16288,
              "sc": 8291,
              "st": 3267
            }
          }
        },
        "fees": 150000,
        "seats": 89
      }
    ]
  },
  {
    "id": 110,
    "name": "Puducherry Technological University, Puducherry",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 57233,
              "ews": 11282,
              "obc": 20050,
              "sc": 11303
            },
            "2023": {
              "general": 56088,
              "ews": 11056,
              "obc": 19649,
              "sc": 11076
            },
            "2022": {
              "general": 54943,
              "ews": 10830,
              "obc": 19248,
              "sc": 10850
            },
            "2021": {
              "general": 53799,
              "ews": 10605,
              "obc": 18847,
              "sc": 10624
            },
            "2020": {
              "general": 52654,
              "ews": 10379,
              "obc": 18446,
              "sc": 10398
            }
          }
        },
        "fees": 150000,
        "seats": 90
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 469371,
              "ews": 14362,
              "obc": 224696,
              "sc": 66199,
              "st": 5462
            },
            "2023": {
              "general": 459983,
              "ews": 14074,
              "obc": 220202,
              "sc": 64875,
              "st": 5352
            },
            "2022": {
              "general": 450596,
              "ews": 13787,
              "obc": 215708,
              "sc": 63551,
              "st": 5243
            },
            "2021": {
              "general": 441208,
              "ews": 13500,
              "obc": 211214,
              "sc": 62227,
              "st": 5134
            },
            "2020": {
              "general": 431821,
              "ews": 13213,
              "obc": 206720,
              "sc": 60903,
              "st": 5025
            }
          }
        },
        "fees": 150000,
        "seats": 90
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 168596,
              "ews": 7927,
              "obc": 72069,
              "sc": 40774,
              "st": 5212
            },
            "2023": {
              "general": 165224,
              "ews": 7768,
              "obc": 70627,
              "sc": 39958,
              "st": 5107
            },
            "2022": {
              "general": 161852,
              "ews": 7609,
              "obc": 69186,
              "sc": 39143,
              "st": 5003
            },
            "2021": {
              "general": 158480,
              "ews": 7451,
              "obc": 67744,
              "sc": 38327,
              "st": 4899
            },
            "2020": {
              "general": 155108,
              "ews": 7292,
              "obc": 66303,
              "sc": 37512,
              "st": 4795
            }
          }
        },
        "fees": 150000,
        "seats": 90
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 53504,
              "ews": 9407,
              "obc": 18997,
              "sc": 9832
            },
            "2023": {
              "general": 52433,
              "ews": 9218,
              "obc": 18617,
              "sc": 9635
            },
            "2022": {
              "general": 51363,
              "ews": 9030,
              "obc": 18237,
              "sc": 9438
            },
            "2021": {
              "general": 50293,
              "ews": 8842,
              "obc": 17857,
              "sc": 9242
            },
            "2020": {
              "general": 49223,
              "ews": 8654,
              "obc": 17477,
              "sc": 9045
            }
          }
        },
        "fees": 150000,
        "seats": 90
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 227780,
              "ews": 9543,
              "obc": 89111,
              "sc": 32378,
              "st": 5271
            },
            "2023": {
              "general": 223224,
              "ews": 9352,
              "obc": 87328,
              "sc": 31730,
              "st": 5165
            },
            "2022": {
              "general": 218668,
              "ews": 9161,
              "obc": 85546,
              "sc": 31082,
              "st": 5060
            },
            "2021": {
              "general": 214113,
              "ews": 8970,
              "obc": 83764,
              "sc": 30435,
              "st": 4954
            },
            "2020": {
              "general": 209557,
              "ews": 8779,
              "obc": 81982,
              "sc": 29787,
              "st": 4849
            }
          }
        },
        "fees": 150000,
        "seats": 90
      },
      {
        "name": "Electronics and Instrumentation Engineering",
        "code": "EIE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 49013,
              "obc": 16394,
              "sc": 11035,
              "st": 4424
            },
            "2023": {
              "general": 48032,
              "obc": 16066,
              "sc": 10814,
              "st": 4335
            },
            "2022": {
              "general": 47052,
              "obc": 15738,
              "sc": 10593,
              "st": 4247
            },
            "2021": {
              "general": 46072,
              "obc": 15410,
              "sc": 10372,
              "st": 4158
            },
            "2020": {
              "general": 45091,
              "obc": 15082,
              "sc": 10152,
              "st": 4070
            }
          }
        },
        "fees": 150000,
        "seats": 90
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 44373,
              "obc": 18862,
              "sc": 9091
            },
            "2023": {
              "general": 43485,
              "obc": 18484,
              "sc": 8909
            },
            "2022": {
              "general": 42598,
              "obc": 18107,
              "sc": 8727
            },
            "2021": {
              "general": 41710,
              "obc": 17730,
              "sc": 8545
            },
            "2020": {
              "general": 40823,
              "obc": 17353,
              "sc": 8363
            }
          }
        },
        "fees": 150000,
        "seats": 90
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 365394,
              "ews": 12122,
              "obc": 149326,
              "sc": 58123,
              "st": 5827
            },
            "2023": {
              "general": 358086,
              "ews": 11879,
              "obc": 146339,
              "sc": 56960,
              "st": 5710
            },
            "2022": {
              "general": 350778,
              "ews": 11637,
              "obc": 143352,
              "sc": 55798,
              "st": 5593
            },
            "2021": {
              "general": 343470,
              "ews": 11394,
              "obc": 140366,
              "sc": 54635,
              "st": 5477
            },
            "2020": {
              "general": 336162,
              "ews": 11152,
              "obc": 137379,
              "sc": 53473,
              "st": 5360
            }
          }
        },
        "fees": 150000,
        "seats": 90
      },
      {
        "name": "Mechatronics Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 298097,
              "ews": 9897,
              "obc": 116897,
              "sc": 32756,
              "st": 5828
            },
            "2023": {
              "general": 292135,
              "ews": 9699,
              "obc": 114559,
              "sc": 32100,
              "st": 5711
            },
            "2022": {
              "general": 286173,
              "ews": 9501,
              "obc": 112221,
              "sc": 31445,
              "st": 5594
            },
            "2021": {
              "general": 280211,
              "ews": 9303,
              "obc": 109883,
              "sc": 30790,
              "st": 5478
            },
            "2020": {
              "general": 274249,
              "ews": 9105,
              "obc": 107545,
              "sc": 30135,
              "st": 5361
            }
          }
        },
        "fees": 150000,
        "seats": 90
      }
    ]
  },
  {
    "id": 111,
    "name": "Punjab Engineering College, Chandigarh",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Aerospace Engineering",
        "code": "AE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 30665,
              "ews": 6643,
              "sc": 4771,
              "st": 3072
            },
            "2023": {
              "general": 30051,
              "ews": 6510,
              "sc": 4675,
              "st": 3010
            },
            "2022": {
              "general": 29438,
              "ews": 6377,
              "sc": 4580,
              "st": 2949
            },
            "2021": {
              "general": 28825,
              "ews": 6244,
              "sc": 4484,
              "st": 2887
            },
            "2020": {
              "general": 28211,
              "ews": 6111,
              "sc": 4389,
              "st": 2826
            }
          }
        },
        "fees": 150000,
        "seats": 91
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 49990,
              "ews": 8691,
              "sc": 10036,
              "st": 3040
            },
            "2023": {
              "general": 48990,
              "ews": 8517,
              "sc": 9835,
              "st": 2979
            },
            "2022": {
              "general": 47990,
              "ews": 8343,
              "sc": 9634,
              "st": 2918
            },
            "2021": {
              "general": 46990,
              "ews": 8169,
              "sc": 9433,
              "st": 2857
            },
            "2020": {
              "general": 45990,
              "ews": 7995,
              "sc": 9233,
              "st": 2796
            }
          }
        },
        "fees": 150000,
        "seats": 91
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 10291,
              "ews": 2267,
              "sc": 3754,
              "st": 1189
            },
            "2023": {
              "general": 10085,
              "ews": 2221,
              "sc": 3678,
              "st": 1165
            },
            "2022": {
              "general": 9879,
              "ews": 2176,
              "sc": 3603,
              "st": 1141
            },
            "2021": {
              "general": 9673,
              "ews": 2130,
              "sc": 3528,
              "st": 1117
            },
            "2020": {
              "general": 9467,
              "ews": 2085,
              "sc": 3453,
              "st": 1093
            }
          }
        },
        "fees": 150000,
        "seats": 91
      },
      {
        "name": "Computer Science Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 13235,
              "ews": 2482,
              "sc": 3789,
              "st": 2270
            },
            "2023": {
              "general": 12970,
              "ews": 2432,
              "sc": 3713,
              "st": 2224
            },
            "2022": {
              "general": 12705,
              "ews": 2382,
              "sc": 3637,
              "st": 2179
            },
            "2021": {
              "general": 12440,
              "ews": 2333,
              "sc": 3561,
              "st": 2133
            },
            "2020": {
              "general": 12176,
              "ews": 2283,
              "sc": 3485,
              "st": 2088
            }
          }
        },
        "fees": 150000,
        "seats": 91
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 26838,
              "ews": 4848,
              "sc": 6097,
              "st": 3621
            },
            "2023": {
              "general": 26301,
              "ews": 4751,
              "sc": 5975,
              "st": 3548
            },
            "2022": {
              "general": 25764,
              "ews": 4654,
              "sc": 5853,
              "st": 3476
            },
            "2021": {
              "general": 25227,
              "ews": 4557,
              "sc": 5731,
              "st": 3403
            },
            "2020": {
              "general": 24690,
              "ews": 4460,
              "sc": 5609,
              "st": 3331
            }
          }
        },
        "fees": 150000,
        "seats": 91
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 19289,
              "ews": 3467,
              "sc": 4981,
              "st": 3038
            },
            "2023": {
              "general": 18903,
              "ews": 3397,
              "sc": 4881,
              "st": 2977
            },
            "2022": {
              "general": 18517,
              "ews": 3328,
              "sc": 4781,
              "st": 2916
            },
            "2021": {
              "general": 18131,
              "ews": 3258,
              "sc": 4682,
              "st": 2855
            },
            "2020": {
              "general": 17745,
              "ews": 3189,
              "sc": 4582,
              "st": 2794
            }
          }
        },
        "fees": 150000,
        "seats": 91
      },
      {
        "name": "Electronics Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 20279,
              "ews": 3598,
              "sc": 5346,
              "st": 3170
            },
            "2023": {
              "general": 19873,
              "ews": 3526,
              "sc": 5239,
              "st": 3106
            },
            "2022": {
              "general": 19467,
              "ews": 3454,
              "sc": 5132,
              "st": 3043
            },
            "2021": {
              "general": 19062,
              "ews": 3382,
              "sc": 5025,
              "st": 2979
            },
            "2020": {
              "general": 18656,
              "ews": 3310,
              "sc": 4918,
              "st": 2916
            }
          }
        },
        "fees": 150000,
        "seats": 91
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 15326,
              "ews": 2514,
              "sc": 5548,
              "st": 2478
            },
            "2023": {
              "general": 15019,
              "ews": 2463,
              "sc": 5437,
              "st": 2428
            },
            "2022": {
              "general": 14712,
              "ews": 2413,
              "sc": 5326,
              "st": 2378
            },
            "2021": {
              "general": 14406,
              "ews": 2363,
              "sc": 5215,
              "st": 2329
            },
            "2020": {
              "general": 14099,
              "ews": 2312,
              "sc": 5104,
              "st": 2279
            }
          }
        },
        "fees": 150000,
        "seats": 91
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 38891,
              "ews": 7193,
              "sc": 9547,
              "st": 4054
            },
            "2023": {
              "general": 38113,
              "ews": 7049,
              "sc": 9356,
              "st": 3972
            },
            "2022": {
              "general": 37335,
              "ews": 6905,
              "sc": 9165,
              "st": 3891
            },
            "2021": {
              "general": 36557,
              "ews": 6761,
              "sc": 8974,
              "st": 3810
            },
            "2020": {
              "general": 35779,
              "ews": 6617,
              "sc": 8783,
              "st": 3729
            }
          }
        },
        "fees": 150000,
        "seats": 91
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 51699,
              "sc": 11438,
              "ews": 8910,
              "st": 4852
            },
            "2023": {
              "general": 50665,
              "sc": 11209,
              "ews": 8731,
              "st": 4754
            },
            "2022": {
              "general": 49631,
              "sc": 10980,
              "ews": 8553,
              "st": 4657
            },
            "2021": {
              "general": 48597,
              "sc": 10751,
              "ews": 8375,
              "st": 4560
            },
            "2020": {
              "general": 47563,
              "sc": 10522,
              "ews": 8197,
              "st": 4463
            }
          }
        },
        "fees": 150000,
        "seats": 91
      },
      {
        "name": "Production and Industrial Engineering",
        "code": "PIE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 46447,
              "sc": 10728,
              "ews": 7872,
              "st": 4700
            },
            "2023": {
              "general": 45518,
              "sc": 10513,
              "ews": 7714,
              "st": 4606
            },
            "2022": {
              "general": 44589,
              "sc": 10298,
              "ews": 7557,
              "st": 4512
            },
            "2021": {
              "general": 43660,
              "sc": 10084,
              "ews": 7399,
              "st": 4418
            },
            "2020": {
              "general": 42731,
              "sc": 9869,
              "ews": 7242,
              "st": 4324
            }
          }
        },
        "fees": 150000,
        "seats": 91
      }
    ]
  },
  {
    "id": 112,
    "name": "Sant Longowal Institute of Engineering and Technology",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 90407,
              "ews": 16000,
              "obc": 32651,
              "sc": 15762,
              "st": 7594
            },
            "2023": {
              "general": 88598,
              "ews": 15680,
              "obc": 31997,
              "sc": 15446,
              "st": 7442
            },
            "2022": {
              "general": 86790,
              "ews": 15360,
              "obc": 31344,
              "sc": 15131,
              "st": 7290
            },
            "2021": {
              "general": 84982,
              "ews": 15040,
              "obc": 30691,
              "sc": 14816,
              "st": 7138
            },
            "2020": {
              "general": 83174,
              "ews": 14720,
              "obc": 30038,
              "sc": 14501,
              "st": 6986
            }
          }
        },
        "fees": 150000,
        "seats": 92
      },
      {
        "name": "Chemistry",
        "code": "C",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 96375,
              "ews": 16194,
              "obc": 34335,
              "sc": 14977,
              "st": 7434
            },
            "2023": {
              "general": 94447,
              "ews": 15870,
              "obc": 33648,
              "sc": 14677,
              "st": 7285
            },
            "2022": {
              "general": 92520,
              "ews": 15546,
              "obc": 32961,
              "sc": 14377,
              "st": 7136
            },
            "2021": {
              "general": 90592,
              "ews": 15222,
              "obc": 32274,
              "sc": 14078,
              "st": 6987
            },
            "2020": {
              "general": 88665,
              "ews": 14898,
              "obc": 31588,
              "sc": 13778,
              "st": 6839
            }
          }
        },
        "fees": 150000,
        "seats": 92
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 81419,
              "ews": 13807,
              "obc": 28332,
              "sc": 13129,
              "st": 4336
            },
            "2023": {
              "general": 79790,
              "ews": 13530,
              "obc": 27765,
              "sc": 12866,
              "st": 4249
            },
            "2022": {
              "general": 78162,
              "ews": 13254,
              "obc": 27198,
              "sc": 12603,
              "st": 4162
            },
            "2021": {
              "general": 76533,
              "ews": 12978,
              "obc": 26632,
              "sc": 12341,
              "st": 4075
            },
            "2020": {
              "general": 74905,
              "ews": 12702,
              "obc": 26065,
              "sc": 12078,
              "st": 3989
            }
          }
        },
        "fees": 150000,
        "seats": 92
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 57008,
              "ews": 9981,
              "obc": 20283,
              "sc": 11311,
              "st": 5930
            },
            "2023": {
              "general": 55867,
              "ews": 9781,
              "obc": 19877,
              "sc": 11084,
              "st": 5811
            },
            "2022": {
              "general": 54727,
              "ews": 9581,
              "obc": 19471,
              "sc": 10858,
              "st": 5692
            },
            "2021": {
              "general": 53587,
              "ews": 9382,
              "obc": 19066,
              "sc": 10632,
              "st": 5574
            },
            "2020": {
              "general": 52447,
              "ews": 9182,
              "obc": 18660,
              "sc": 10406,
              "st": 5455
            }
          }
        },
        "fees": 150000,
        "seats": 92
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 75482,
              "ews": 13150,
              "obc": 26499,
              "sc": 12813,
              "st": 6087
            },
            "2023": {
              "general": 73972,
              "ews": 12887,
              "obc": 25969,
              "sc": 12556,
              "st": 5965
            },
            "2022": {
              "general": 72462,
              "ews": 12624,
              "obc": 25439,
              "sc": 12300,
              "st": 5843
            },
            "2021": {
              "general": 70953,
              "ews": 12361,
              "obc": 24909,
              "sc": 12044,
              "st": 5721
            },
            "2020": {
              "general": 69443,
              "ews": 12098,
              "obc": 24379,
              "sc": 11787,
              "st": 5600
            }
          }
        },
        "fees": 150000,
        "seats": 92
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 59270,
              "ews": 11337,
              "obc": 23170,
              "sc": 12398,
              "st": 5200
            },
            "2023": {
              "general": 58084,
              "ews": 11110,
              "obc": 22706,
              "sc": 12150,
              "st": 5096
            },
            "2022": {
              "general": 56899,
              "ews": 10883,
              "obc": 22243,
              "sc": 11902,
              "st": 4992
            },
            "2021": {
              "general": 55713,
              "ews": 10656,
              "obc": 21779,
              "sc": 11654,
              "st": 4888
            },
            "2020": {
              "general": 54528,
              "ews": 10430,
              "obc": 21316,
              "sc": 11406,
              "st": 4784
            }
          }
        },
        "fees": 150000,
        "seats": 92
      },
      {
        "name": "Food Technology",
        "code": "FT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 103042,
              "ews": 17726,
              "obc": 36664,
              "sc": 16259,
              "st": 7983
            },
            "2023": {
              "general": 100981,
              "ews": 17371,
              "obc": 35930,
              "sc": 15933,
              "st": 7823
            },
            "2022": {
              "general": 98920,
              "ews": 17016,
              "obc": 35197,
              "sc": 15608,
              "st": 7663
            },
            "2021": {
              "general": 96859,
              "ews": 16662,
              "obc": 34464,
              "sc": 15283,
              "st": 7504
            },
            "2020": {
              "general": 94798,
              "ews": 16307,
              "obc": 33730,
              "sc": 14958,
              "st": 7344
            }
          }
        },
        "fees": 150000,
        "seats": 92
      },
      {
        "name": "Instrumentation and Control Engineering",
        "code": "ICE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 87289,
              "ews": 16252,
              "obc": 32958,
              "sc": 15829,
              "st": 7942
            },
            "2023": {
              "general": 85543,
              "ews": 15926,
              "obc": 32298,
              "sc": 15512,
              "st": 7783
            },
            "2022": {
              "general": 83797,
              "ews": 15601,
              "obc": 31639,
              "sc": 15195,
              "st": 7624
            },
            "2021": {
              "general": 82051,
              "ews": 15276,
              "obc": 30980,
              "sc": 14879,
              "st": 7465
            },
            "2020": {
              "general": 80305,
              "ews": 14951,
              "obc": 30321,
              "sc": 14562,
              "st": 7306
            }
          }
        },
        "fees": 150000,
        "seats": 92
      },
      {
        "name": "Mathematics",
        "code": "M",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 87677,
              "ews": 15321,
              "obc": 34135,
              "sc": 15839,
              "st": 7819
            },
            "2023": {
              "general": 85923,
              "ews": 15014,
              "obc": 33452,
              "sc": 15522,
              "st": 7662
            },
            "2022": {
              "general": 84169,
              "ews": 14708,
              "obc": 32769,
              "sc": 15205,
              "st": 7506
            },
            "2021": {
              "general": 82416,
              "ews": 14401,
              "obc": 32086,
              "sc": 14888,
              "st": 7349
            },
            "2020": {
              "general": 80662,
              "ews": 14095,
              "obc": 31404,
              "sc": 14571,
              "st": 7193
            }
          }
        },
        "fees": 150000,
        "seats": 92
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 89957,
              "ews": 15776,
              "obc": 32815,
              "sc": 15008,
              "st": 7282
            },
            "2023": {
              "general": 88157,
              "ews": 15460,
              "obc": 32158,
              "sc": 14707,
              "st": 7136
            },
            "2022": {
              "general": 86358,
              "ews": 15144,
              "obc": 31502,
              "sc": 14407,
              "st": 6990
            },
            "2021": {
              "general": 84559,
              "ews": 14829,
              "obc": 30846,
              "sc": 14107,
              "st": 6845
            },
            "2020": {
              "general": 82760,
              "ews": 14513,
              "obc": 30189,
              "sc": 13807,
              "st": 6699
            }
          }
        },
        "fees": 150000,
        "seats": 92
      },
      {
        "name": "Physics",
        "code": "P",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 81745,
              "ews": 15367,
              "obc": 32041,
              "sc": 15373,
              "st": 7403
            },
            "2023": {
              "general": 80110,
              "ews": 15059,
              "obc": 31400,
              "sc": 15065,
              "st": 7254
            },
            "2022": {
              "general": 78475,
              "ews": 14752,
              "obc": 30759,
              "sc": 14758,
              "st": 7106
            },
            "2021": {
              "general": 76840,
              "ews": 14444,
              "obc": 30118,
              "sc": 14450,
              "st": 6958
            },
            "2020": {
              "general": 75205,
              "ews": 14137,
              "obc": 29477,
              "sc": 14143,
              "st": 6810
            }
          }
        },
        "fees": 150000,
        "seats": 92
      }
    ]
  },
  {
    "id": 113,
    "name": "Sardar Vallabhbhai National Institute of Technology, Surat",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Artificial Intelligence",
        "code": "AI",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 12156,
              "ews": 1821,
              "obc": 4411,
              "sc": 2758,
              "st": 1200
            },
            "2023": {
              "general": 11912,
              "ews": 1784,
              "obc": 4322,
              "sc": 2702,
              "st": 1176
            },
            "2022": {
              "general": 11669,
              "ews": 1748,
              "obc": 4234,
              "sc": 2647,
              "st": 1152
            },
            "2021": {
              "general": 11426,
              "ews": 1711,
              "obc": 4146,
              "sc": 2592,
              "st": 1128
            },
            "2020": {
              "general": 11183,
              "ews": 1675,
              "obc": 4058,
              "sc": 2537,
              "st": 1104
            }
          }
        },
        "fees": 150000,
        "seats": 93
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 31864,
              "ews": 5538,
              "obc": 11850,
              "sc": 6768,
              "st": 2416
            },
            "2023": {
              "general": 31226,
              "ews": 5427,
              "obc": 11613,
              "sc": 6632,
              "st": 2367
            },
            "2022": {
              "general": 30589,
              "ews": 5316,
              "obc": 11376,
              "sc": 6497,
              "st": 2319
            },
            "2021": {
              "general": 29952,
              "ews": 5205,
              "obc": 11139,
              "sc": 6361,
              "st": 2271
            },
            "2020": {
              "general": 29314,
              "ews": 5094,
              "obc": 10902,
              "sc": 6226,
              "st": 2222
            }
          }
        },
        "fees": 150000,
        "seats": 93
      },
      {
        "name": "Chemistry",
        "code": "C",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 52472,
              "ews": 9078,
              "obc": 18359,
              "sc": 9456,
              "st": 3572
            },
            "2023": {
              "general": 51422,
              "ews": 8896,
              "obc": 17991,
              "sc": 9266,
              "st": 3500
            },
            "2022": {
              "general": 50373,
              "ews": 8714,
              "obc": 17624,
              "sc": 9077,
              "st": 3429
            },
            "2021": {
              "general": 49323,
              "ews": 8533,
              "obc": 17257,
              "sc": 8888,
              "st": 3357
            },
            "2020": {
              "general": 48274,
              "ews": 8351,
              "obc": 16890,
              "sc": 8699,
              "st": 3286
            }
          }
        },
        "fees": 150000,
        "seats": 93
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 40394,
              "ews": 6680,
              "obc": 13374,
              "sc": 6684,
              "st": 1674
            },
            "2023": {
              "general": 39586,
              "ews": 6546,
              "obc": 13106,
              "sc": 6550,
              "st": 1640
            },
            "2022": {
              "general": 38778,
              "ews": 6412,
              "obc": 12839,
              "sc": 6416,
              "st": 1607
            },
            "2021": {
              "general": 37970,
              "ews": 6279,
              "obc": 12571,
              "sc": 6282,
              "st": 1573
            },
            "2020": {
              "general": 37162,
              "ews": 6145,
              "obc": 12304,
              "sc": 6149,
              "st": 1540
            }
          }
        },
        "fees": 150000,
        "seats": 93
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 6745,
              "ews": 1043,
              "obc": 2708,
              "sc": 1926,
              "st": 568
            },
            "2023": {
              "general": 6610,
              "ews": 1022,
              "obc": 2653,
              "sc": 1887,
              "st": 556
            },
            "2022": {
              "general": 6475,
              "ews": 1001,
              "obc": 2599,
              "sc": 1848,
              "st": 545
            },
            "2021": {
              "general": 6340,
              "ews": 980,
              "obc": 2545,
              "sc": 1810,
              "st": 533
            },
            "2020": {
              "general": 6205,
              "ews": 959,
              "obc": 2491,
              "sc": 1771,
              "st": 522
            }
          }
        },
        "fees": 150000,
        "seats": 93
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 18159,
              "ews": 2976,
              "obc": 6768,
              "sc": 3920,
              "st": 1708
            },
            "2023": {
              "general": 17795,
              "ews": 2916,
              "obc": 6632,
              "sc": 3841,
              "st": 1673
            },
            "2022": {
              "general": 17432,
              "ews": 2856,
              "obc": 6497,
              "sc": 3763,
              "st": 1639
            },
            "2021": {
              "general": 17069,
              "ews": 2797,
              "obc": 6361,
              "sc": 3684,
              "st": 1605
            },
            "2020": {
              "general": 16706,
              "ews": 2737,
              "obc": 6226,
              "sc": 3606,
              "st": 1571
            }
          }
        },
        "fees": 150000,
        "seats": 93
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 12926,
              "ews": 2155,
              "obc": 5074,
              "sc": 3210,
              "st": 1159
            },
            "2023": {
              "general": 12667,
              "ews": 2111,
              "obc": 4972,
              "sc": 3145,
              "st": 1135
            },
            "2022": {
              "general": 12408,
              "ews": 2068,
              "obc": 4871,
              "sc": 3081,
              "st": 1112
            },
            "2021": {
              "general": 12150,
              "ews": 2025,
              "obc": 4769,
              "sc": 3017,
              "st": 1089
            },
            "2020": {
              "general": 11891,
              "ews": 1982,
              "obc": 4668,
              "sc": 2953,
              "st": 1066
            }
          }
        },
        "fees": 150000,
        "seats": 93
      },
      {
        "name": "Electronics and VLSI Engineering",
        "code": "EVE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 14753,
              "ews": 2442,
              "obc": 6113,
              "sc": 3596,
              "st": 1460
            },
            "2023": {
              "general": 14457,
              "ews": 2393,
              "obc": 5990,
              "sc": 3524,
              "st": 1430
            },
            "2022": {
              "general": 14162,
              "ews": 2344,
              "obc": 5868,
              "sc": 3452,
              "st": 1401
            },
            "2021": {
              "general": 13867,
              "ews": 2295,
              "obc": 5746,
              "sc": 3380,
              "st": 1372
            },
            "2020": {
              "general": 13572,
              "ews": 2246,
              "obc": 5623,
              "sc": 3308,
              "st": 1343
            }
          }
        },
        "fees": 150000,
        "seats": 93
      },
      {
        "name": "Engineering Physics",
        "code": "EP",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 21517,
              "ews": 3829,
              "obc": 11388,
              "sc": 6222,
              "st": 2956
            },
            "2023": {
              "general": 21086,
              "ews": 3752,
              "obc": 11160,
              "sc": 6097,
              "st": 2896
            },
            "2022": {
              "general": 20656,
              "ews": 3675,
              "obc": 10932,
              "sc": 5973,
              "st": 2837
            },
            "2021": {
              "general": 20225,
              "ews": 3599,
              "obc": 10704,
              "sc": 5848,
              "st": 2778
            },
            "2020": {
              "general": 19795,
              "ews": 3522,
              "obc": 10476,
              "sc": 5724,
              "st": 2719
            }
          }
        },
        "fees": 150000,
        "seats": 93
      },
      {
        "name": "Industrial Chemistry",
        "code": "IC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 45163,
              "ews": 7761,
              "obc": 14821,
              "sc": 6971,
              "st": 3234
            },
            "2023": {
              "general": 44259,
              "ews": 7605,
              "obc": 14524,
              "sc": 6831,
              "st": 3169
            },
            "2022": {
              "general": 43356,
              "ews": 7450,
              "obc": 14228,
              "sc": 6692,
              "st": 3104
            },
            "2021": {
              "general": 42453,
              "ews": 7295,
              "obc": 13931,
              "sc": 6552,
              "st": 3039
            },
            "2020": {
              "general": 41549,
              "ews": 7140,
              "obc": 13635,
              "sc": 6413,
              "st": 2975
            }
          }
        },
        "fees": 150000,
        "seats": 93
      },
      {
        "name": "Mathematics",
        "code": "M",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 42519,
              "ews": 7963,
              "obc": 16851,
              "sc": 8841,
              "st": 3402
            },
            "2023": {
              "general": 41668,
              "ews": 7803,
              "obc": 16513,
              "sc": 8664,
              "st": 3333
            },
            "2022": {
              "general": 40818,
              "ews": 7644,
              "obc": 16176,
              "sc": 8487,
              "st": 3265
            },
            "2021": {
              "general": 39967,
              "ews": 7485,
              "obc": 15839,
              "sc": 8310,
              "st": 3197
            },
            "2020": {
              "general": 39117,
              "ews": 7325,
              "obc": 15502,
              "sc": 8133,
              "st": 3129
            }
          }
        },
        "fees": 150000,
        "seats": 93
      },
      {
        "name": "Mathematics and Computing",
        "code": "MC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 8915,
              "ews": 1419,
              "obc": 4012,
              "sc": 2471,
              "st": 904
            },
            "2023": {
              "general": 8736,
              "ews": 1390,
              "obc": 3931,
              "sc": 2421,
              "st": 885
            },
            "2022": {
              "general": 8558,
              "ews": 1362,
              "obc": 3851,
              "sc": 2372,
              "st": 867
            },
            "2021": {
              "general": 8380,
              "ews": 1333,
              "obc": 3771,
              "sc": 2322,
              "st": 849
            },
            "2020": {
              "general": 8201,
              "ews": 1305,
              "obc": 3691,
              "sc": 2273,
              "st": 831
            }
          }
        },
        "fees": 150000,
        "seats": 93
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 25237,
              "ews": 4443,
              "obc": 10166,
              "sc": 5846,
              "st": 2096
            },
            "2023": {
              "general": 24732,
              "ews": 4354,
              "obc": 9962,
              "sc": 5729,
              "st": 2054
            },
            "2022": {
              "general": 24227,
              "ews": 4265,
              "obc": 9759,
              "sc": 5612,
              "st": 2012
            },
            "2021": {
              "general": 23722,
              "ews": 4176,
              "obc": 9556,
              "sc": 5495,
              "st": 1970
            },
            "2020": {
              "general": 23218,
              "ews": 4087,
              "obc": 9352,
              "sc": 5378,
              "st": 1928
            }
          }
        },
        "fees": 150000,
        "seats": 93
      },
      {
        "name": "Physics",
        "code": "P",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 38394,
              "ews": 8014,
              "obc": 17040,
              "sc": 9139,
              "st": 3230
            },
            "2023": {
              "general": 37626,
              "ews": 7853,
              "obc": 16699,
              "sc": 8956,
              "st": 3165
            },
            "2022": {
              "general": 36858,
              "ews": 7693,
              "obc": 16358,
              "sc": 8773,
              "st": 3100
            },
            "2021": {
              "general": 36090,
              "ews": 7533,
              "obc": 16017,
              "sc": 8590,
              "st": 3036
            },
            "2020": {
              "general": 35322,
              "ews": 7372,
              "obc": 15676,
              "sc": 8407,
              "st": 2971
            }
          }
        },
        "fees": 150000,
        "seats": 93
      }
    ]
  },
  {
    "id": 114,
    "name": "School of Engineering, Tezpur University, Napaam, Tezpur",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Bachelor of Design",
        "code": "BD",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 90552,
              "obc": 33369,
              "sc": 14172
            },
            "2023": {
              "general": 88740,
              "obc": 32701,
              "sc": 13888
            },
            "2022": {
              "general": 86929,
              "obc": 32034,
              "sc": 13605
            },
            "2021": {
              "general": 85118,
              "obc": 31366,
              "sc": 13321
            },
            "2020": {
              "general": 83307,
              "obc": 30699,
              "sc": 13038
            }
          }
        },
        "fees": 150000,
        "seats": 94
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 90711,
              "ews": 16680,
              "obc": 33364,
              "sc": 13855,
              "st": 5299
            },
            "2023": {
              "general": 88896,
              "ews": 16346,
              "obc": 32696,
              "sc": 13577,
              "st": 5193
            },
            "2022": {
              "general": 87082,
              "ews": 16012,
              "obc": 32029,
              "sc": 13300,
              "st": 5087
            },
            "2021": {
              "general": 85268,
              "ews": 15679,
              "obc": 31362,
              "sc": 13023,
              "st": 4981
            },
            "2020": {
              "general": 83454,
              "ews": 15345,
              "obc": 30694,
              "sc": 12746,
              "st": 4875
            }
          }
        },
        "fees": 150000,
        "seats": 94
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 54847,
              "ews": 9983,
              "obc": 19317,
              "sc": 8680,
              "st": 3737
            },
            "2023": {
              "general": 53750,
              "ews": 9783,
              "obc": 18930,
              "sc": 8506,
              "st": 3662
            },
            "2022": {
              "general": 52653,
              "ews": 9583,
              "obc": 18544,
              "sc": 8332,
              "st": 3587
            },
            "2021": {
              "general": 51556,
              "ews": 9384,
              "obc": 18157,
              "sc": 8159,
              "st": 3512
            },
            "2020": {
              "general": 50459,
              "ews": 9184,
              "obc": 17771,
              "sc": 7985,
              "st": 3438
            }
          }
        },
        "fees": 150000,
        "seats": 94
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 72639,
              "ews": 13775,
              "obc": 24113,
              "sc": 10867,
              "st": 3818
            },
            "2023": {
              "general": 71186,
              "ews": 13499,
              "obc": 23630,
              "sc": 10649,
              "st": 3741
            },
            "2022": {
              "general": 69733,
              "ews": 13224,
              "obc": 23148,
              "sc": 10432,
              "st": 3665
            },
            "2021": {
              "general": 68280,
              "ews": 12948,
              "obc": 22666,
              "sc": 10214,
              "st": 3588
            },
            "2020": {
              "general": 66827,
              "ews": 12673,
              "obc": 22183,
              "sc": 9997,
              "st": 3512
            }
          }
        },
        "fees": 150000,
        "seats": 94
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 66962,
              "ews": 11913,
              "obc": 22971,
              "sc": 9926,
              "st": 5346
            },
            "2023": {
              "general": 65622,
              "ews": 11674,
              "obc": 22511,
              "sc": 9727,
              "st": 5239
            },
            "2022": {
              "general": 64283,
              "ews": 11436,
              "obc": 22052,
              "sc": 9528,
              "st": 5132
            },
            "2021": {
              "general": 62944,
              "ews": 11198,
              "obc": 21592,
              "sc": 9330,
              "st": 5025
            },
            "2020": {
              "general": 61605,
              "ews": 10959,
              "obc": 21133,
              "sc": 9131,
              "st": 4918
            }
          }
        },
        "fees": 150000,
        "seats": 94
      },
      {
        "name": "Food Engineering and Technology",
        "code": "FET",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 103301,
              "ews": 17837,
              "obc": 36969,
              "sc": 15702,
              "st": 6458
            },
            "2023": {
              "general": 101234,
              "ews": 17480,
              "obc": 36229,
              "sc": 15387,
              "st": 6328
            },
            "2022": {
              "general": 99168,
              "ews": 17123,
              "obc": 35490,
              "sc": 15073,
              "st": 6199
            },
            "2021": {
              "general": 97102,
              "ews": 16766,
              "obc": 34750,
              "sc": 14759,
              "st": 6070
            },
            "2020": {
              "general": 95036,
              "ews": 16410,
              "obc": 34011,
              "sc": 14445,
              "st": 5941
            }
          }
        },
        "fees": 150000,
        "seats": 94
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 78854,
              "ews": 14911,
              "obc": 27364,
              "sc": 12947,
              "st": 5688
            },
            "2023": {
              "general": 77276,
              "ews": 14612,
              "obc": 26816,
              "sc": 12688,
              "st": 5574
            },
            "2022": {
              "general": 75699,
              "ews": 14314,
              "obc": 26269,
              "sc": 12429,
              "st": 5460
            },
            "2021": {
              "general": 74122,
              "ews": 14016,
              "obc": 25722,
              "sc": 12170,
              "st": 5346
            },
            "2020": {
              "general": 72545,
              "ews": 13718,
              "obc": 25174,
              "sc": 11911,
              "st": 5232
            }
          }
        },
        "fees": 150000,
        "seats": 94
      }
    ]
  },
  {
    "id": 115,
    "name": "School of Planning & Architecture, Bhopal",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 682,
              "ews": 613,
              "obc": 687,
              "sc": 312,
              "st": 155
            },
            "2023": {
              "general": 668,
              "ews": 600,
              "obc": 673,
              "sc": 305,
              "st": 151
            },
            "2022": {
              "general": 654,
              "ews": 588,
              "obc": 659,
              "sc": 299,
              "st": 148
            },
            "2021": {
              "general": 641,
              "ews": 576,
              "obc": 645,
              "sc": 293,
              "st": 145
            },
            "2020": {
              "general": 627,
              "ews": 563,
              "obc": 632,
              "sc": 287,
              "st": 142
            }
          }
        },
        "fees": 150000,
        "seats": 95
      },
      {
        "name": "Planning",
        "code": "P",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 961,
              "ews": 261,
              "obc": 601,
              "sc": 357,
              "st": 189
            },
            "2023": {
              "general": 941,
              "ews": 255,
              "obc": 588,
              "sc": 349,
              "st": 185
            },
            "2022": {
              "general": 922,
              "ews": 250,
              "obc": 576,
              "sc": 342,
              "st": 181
            },
            "2021": {
              "general": 903,
              "ews": 245,
              "obc": 564,
              "sc": 335,
              "st": 177
            },
            "2020": {
              "general": 884,
              "ews": 240,
              "obc": 552,
              "sc": 328,
              "st": 173
            }
          }
        },
        "fees": 150000,
        "seats": 95
      }
    ]
  },
  {
    "id": 116,
    "name": "School of Planning & Architecture, New Delhi",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 238,
              "ews": 339,
              "obc": 380,
              "sc": 172,
              "st": 48
            },
            "2023": {
              "general": 233,
              "ews": 332,
              "obc": 372,
              "sc": 168,
              "st": 47
            },
            "2022": {
              "general": 228,
              "ews": 325,
              "obc": 364,
              "sc": 165,
              "st": 46
            },
            "2021": {
              "general": 223,
              "ews": 318,
              "obc": 357,
              "sc": 161,
              "st": 45
            },
            "2020": {
              "general": 218,
              "ews": 311,
              "obc": 349,
              "sc": 158,
              "st": 44
            }
          }
        },
        "fees": 150000,
        "seats": 96
      },
      {
        "name": "Planning",
        "code": "P",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 435,
              "ews": 217,
              "obc": 550,
              "sc": 153,
              "st": 120
            },
            "2023": {
              "general": 426,
              "ews": 212,
              "obc": 539,
              "sc": 149,
              "st": 117
            },
            "2022": {
              "general": 417,
              "ews": 208,
              "obc": 528,
              "sc": 146,
              "st": 115
            },
            "2021": {
              "general": 408,
              "ews": 203,
              "obc": 517,
              "sc": 143,
              "st": 112
            },
            "2020": {
              "general": 400,
              "ews": 199,
              "obc": 506,
              "sc": 140,
              "st": 110
            }
          }
        },
        "fees": 150000,
        "seats": 96
      }
    ]
  },
  {
    "id": 117,
    "name": "School of Planning & Architecture: Vijayawada",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 798,
              "ews": 626,
              "obc": 682,
              "sc": 375,
              "st": 188
            },
            "2023": {
              "general": 782,
              "ews": 613,
              "obc": 668,
              "sc": 367,
              "st": 184
            },
            "2022": {
              "general": 766,
              "ews": 600,
              "obc": 654,
              "sc": 360,
              "st": 180
            },
            "2021": {
              "general": 750,
              "ews": 588,
              "obc": 641,
              "sc": 352,
              "st": 176
            },
            "2020": {
              "general": 734,
              "ews": 575,
              "obc": 627,
              "sc": 345,
              "st": 172
            }
          }
        },
        "fees": 150000,
        "seats": 97
      },
      {
        "name": "Planning",
        "code": "P",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 971,
              "ews": 280,
              "obc": 650,
              "sc": 349,
              "st": 224
            },
            "2023": {
              "general": 951,
              "ews": 274,
              "obc": 637,
              "sc": 342,
              "st": 219
            },
            "2022": {
              "general": 932,
              "ews": 268,
              "obc": 624,
              "sc": 335,
              "st": 215
            },
            "2021": {
              "general": 912,
              "ews": 263,
              "obc": 611,
              "sc": 328,
              "st": 210
            },
            "2020": {
              "general": 893,
              "ews": 257,
              "obc": 598,
              "sc": 321,
              "st": 206
            }
          }
        },
        "fees": 150000,
        "seats": 97
      }
    ]
  },
  {
    "id": 118,
    "name": "School of Studies of Engineering and Technology, Guru Ghasidas Vishwavidyalaya, Bilaspur",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 94835,
              "ews": 16570,
              "obc": 34322,
              "sc": 15863,
              "st": 7674
            },
            "2023": {
              "general": 92938,
              "ews": 16238,
              "obc": 33635,
              "sc": 15545,
              "st": 7520
            },
            "2022": {
              "general": 91041,
              "ews": 15907,
              "obc": 32949,
              "sc": 15228,
              "st": 7367
            },
            "2021": {
              "general": 89144,
              "ews": 15575,
              "obc": 32262,
              "sc": 14911,
              "st": 7213
            },
            "2020": {
              "general": 87248,
              "ews": 15244,
              "obc": 31576,
              "sc": 14593,
              "st": 7060
            }
          }
        },
        "fees": 150000,
        "seats": 98
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 95286,
              "ews": 16598,
              "obc": 33910,
              "sc": 14441,
              "st": 6497
            },
            "2023": {
              "general": 93380,
              "ews": 16266,
              "obc": 33231,
              "sc": 14152,
              "st": 6367
            },
            "2022": {
              "general": 91474,
              "ews": 15934,
              "obc": 32553,
              "sc": 13863,
              "st": 6237
            },
            "2021": {
              "general": 89568,
              "ews": 15602,
              "obc": 31875,
              "sc": 13574,
              "st": 6107
            },
            "2020": {
              "general": 87663,
              "ews": 15270,
              "obc": 31197,
              "sc": 13285,
              "st": 5977
            }
          }
        },
        "fees": 150000,
        "seats": 98
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 63064,
              "ews": 11068,
              "obc": 22522,
              "sc": 11950,
              "st": 5891
            },
            "2023": {
              "general": 61802,
              "ews": 10846,
              "obc": 22071,
              "sc": 11711,
              "st": 5773
            },
            "2022": {
              "general": 60541,
              "ews": 10625,
              "obc": 21621,
              "sc": 11472,
              "st": 5655
            },
            "2021": {
              "general": 59280,
              "ews": 10403,
              "obc": 21170,
              "sc": 11233,
              "st": 5537
            },
            "2020": {
              "general": 58018,
              "ews": 10182,
              "obc": 20720,
              "sc": 10994,
              "st": 5419
            }
          }
        },
        "fees": 150000,
        "seats": 98
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 86163,
              "ews": 14566,
              "obc": 29922,
              "sc": 14682,
              "st": 7541
            },
            "2023": {
              "general": 84439,
              "ews": 14274,
              "obc": 29323,
              "sc": 14388,
              "st": 7390
            },
            "2022": {
              "general": 82716,
              "ews": 13983,
              "obc": 28725,
              "sc": 14094,
              "st": 7239
            },
            "2021": {
              "general": 80993,
              "ews": 13692,
              "obc": 28126,
              "sc": 13801,
              "st": 7088
            },
            "2020": {
              "general": 79269,
              "ews": 13400,
              "obc": 27528,
              "sc": 13507,
              "st": 6937
            }
          }
        },
        "fees": 150000,
        "seats": 98
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 76654,
              "ews": 13292,
              "obc": 27016,
              "sc": 13413,
              "st": 6213
            },
            "2023": {
              "general": 75120,
              "ews": 13026,
              "obc": 26475,
              "sc": 13144,
              "st": 6088
            },
            "2022": {
              "general": 73587,
              "ews": 12760,
              "obc": 25935,
              "sc": 12876,
              "st": 5964
            },
            "2021": {
              "general": 72054,
              "ews": 12494,
              "obc": 25395,
              "sc": 12608,
              "st": 5840
            },
            "2020": {
              "general": 70521,
              "ews": 12228,
              "obc": 24854,
              "sc": 12339,
              "st": 5715
            }
          }
        },
        "fees": 150000,
        "seats": 98
      },
      {
        "name": "Industrial and Production Engineering",
        "code": "IPE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 103490,
              "ews": 17498,
              "obc": 36623,
              "sc": 16271,
              "st": 7895
            },
            "2023": {
              "general": 101420,
              "ews": 17148,
              "obc": 35890,
              "sc": 15945,
              "st": 7737
            },
            "2022": {
              "general": 99350,
              "ews": 16798,
              "obc": 35158,
              "sc": 15620,
              "st": 7579
            },
            "2021": {
              "general": 97280,
              "ews": 16448,
              "obc": 34425,
              "sc": 15294,
              "st": 7421
            },
            "2020": {
              "general": 95210,
              "ews": 16098,
              "obc": 33693,
              "sc": 14969,
              "st": 7263
            }
          }
        },
        "fees": 150000,
        "seats": 98
      },
      {
        "name": "Information Technology",
        "code": "IT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 74981,
              "ews": 13030,
              "obc": 27614,
              "sc": 13448,
              "st": 6767
            },
            "2023": {
              "general": 73481,
              "ews": 12769,
              "obc": 27061,
              "sc": 13179,
              "st": 6631
            },
            "2022": {
              "general": 71981,
              "ews": 12508,
              "obc": 26509,
              "sc": 12910,
              "st": 6496
            },
            "2021": {
              "general": 70482,
              "ews": 12248,
              "obc": 25957,
              "sc": 12641,
              "st": 6360
            },
            "2020": {
              "general": 68982,
              "ews": 11987,
              "obc": 25404,
              "sc": 12372,
              "st": 6225
            }
          }
        },
        "fees": 150000,
        "seats": 98
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 91857,
              "ews": 15958,
              "obc": 32371,
              "sc": 15227,
              "st": 7387
            },
            "2023": {
              "general": 90019,
              "ews": 15638,
              "obc": 31723,
              "sc": 14922,
              "st": 7239
            },
            "2022": {
              "general": 88182,
              "ews": 15319,
              "obc": 31076,
              "sc": 14617,
              "st": 7091
            },
            "2021": {
              "general": 86345,
              "ews": 15000,
              "obc": 30428,
              "sc": 14313,
              "st": 6943
            },
            "2020": {
              "general": 84508,
              "ews": 14681,
              "obc": 29781,
              "sc": 14008,
              "st": 6796
            }
          }
        },
        "fees": 150000,
        "seats": 98
      }
    ]
  },
  {
    "id": 119,
    "name": "Shri Mata Vaishno Devi University, Katra, Jammu & Kashmir",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 1780,
              "ews": 752,
              "obc": 1040,
              "sc": 456,
              "st": 202
            },
            "2023": {
              "general": 1744,
              "ews": 736,
              "obc": 1019,
              "sc": 446,
              "st": 197
            },
            "2022": {
              "general": 1708,
              "ews": 721,
              "obc": 998,
              "sc": 437,
              "st": 193
            },
            "2021": {
              "general": 1673,
              "ews": 706,
              "obc": 977,
              "sc": 428,
              "st": 189
            },
            "2020": {
              "general": 1637,
              "ews": 691,
              "obc": 956,
              "sc": 419,
              "st": 185
            }
          }
        },
        "fees": 150000,
        "seats": 99
      },
      {
        "name": "B.Tech in Mathematics and Computing",
        "code": "BMC",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 64804,
              "ews": 10804,
              "obc": 24297,
              "sc": 12976,
              "st": 6812
            },
            "2023": {
              "general": 63507,
              "ews": 10587,
              "obc": 23811,
              "sc": 12716,
              "st": 6675
            },
            "2022": {
              "general": 62211,
              "ews": 10371,
              "obc": 23325,
              "sc": 12456,
              "st": 6539
            },
            "2021": {
              "general": 60915,
              "ews": 10155,
              "obc": 22839,
              "sc": 12197,
              "st": 6403
            },
            "2020": {
              "general": 59619,
              "ews": 9939,
              "obc": 22353,
              "sc": 11937,
              "st": 6267
            }
          }
        },
        "fees": 150000,
        "seats": 99
      },
      {
        "name": "Bio Technology",
        "code": "BT",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 84922,
              "ews": 15870,
              "obc": 31544,
              "sc": 14717,
              "st": 7227
            },
            "2023": {
              "general": 83223,
              "ews": 15552,
              "obc": 30913,
              "sc": 14422,
              "st": 7082
            },
            "2022": {
              "general": 81525,
              "ews": 15235,
              "obc": 30282,
              "sc": 14128,
              "st": 6937
            },
            "2021": {
              "general": 79826,
              "ews": 14917,
              "obc": 29651,
              "sc": 13833,
              "st": 6793
            },
            "2020": {
              "general": 78128,
              "ews": 14600,
              "obc": 29020,
              "sc": 13539,
              "st": 6648
            }
          }
        },
        "fees": 150000,
        "seats": 99
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 92789,
              "ews": 16665,
              "obc": 31717,
              "sc": 15348,
              "st": 6680
            },
            "2023": {
              "general": 90933,
              "ews": 16331,
              "obc": 31082,
              "sc": 15041,
              "st": 6546
            },
            "2022": {
              "general": 89077,
              "ews": 15998,
              "obc": 30448,
              "sc": 14734,
              "st": 6412
            },
            "2021": {
              "general": 87221,
              "ews": 15665,
              "obc": 29813,
              "sc": 14427,
              "st": 6279
            },
            "2020": {
              "general": 85365,
              "ews": 15331,
              "obc": 29179,
              "sc": 14120,
              "st": 6145
            }
          }
        },
        "fees": 150000,
        "seats": 99
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 58592,
              "ews": 10476,
              "obc": 22490,
              "sc": 11813,
              "st": 5787
            },
            "2023": {
              "general": 57420,
              "ews": 10266,
              "obc": 22040,
              "sc": 11576,
              "st": 5671
            },
            "2022": {
              "general": 56248,
              "ews": 10056,
              "obc": 21590,
              "sc": 11340,
              "st": 5555
            },
            "2021": {
              "general": 55076,
              "ews": 9847,
              "obc": 21140,
              "sc": 11104,
              "st": 5439
            },
            "2020": {
              "general": 53904,
              "ews": 9637,
              "obc": 20690,
              "sc": 10867,
              "st": 5324
            }
          }
        },
        "fees": 150000,
        "seats": 99
      },
      {
        "name": "Electrical Engineering",
        "code": "EE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 77791,
              "ews": 13637,
              "obc": 28396,
              "sc": 14236,
              "st": 6958
            },
            "2023": {
              "general": 76235,
              "ews": 13364,
              "obc": 27828,
              "sc": 13951,
              "st": 6818
            },
            "2022": {
              "general": 74679,
              "ews": 13091,
              "obc": 27260,
              "sc": 13666,
              "st": 6679
            },
            "2021": {
              "general": 73123,
              "ews": 12818,
              "obc": 26692,
              "sc": 13381,
              "st": 6540
            },
            "2020": {
              "general": 71567,
              "ews": 12546,
              "obc": 26124,
              "sc": 13097,
              "st": 6401
            }
          }
        },
        "fees": 150000,
        "seats": 99
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 73241,
              "ews": 12926,
              "obc": 25883,
              "sc": 14076,
              "st": 7226
            },
            "2023": {
              "general": 71776,
              "ews": 12667,
              "obc": 25365,
              "sc": 13794,
              "st": 7081
            },
            "2022": {
              "general": 70311,
              "ews": 12408,
              "obc": 24847,
              "sc": 13512,
              "st": 6936
            },
            "2021": {
              "general": 68846,
              "ews": 12150,
              "obc": 24330,
              "sc": 13231,
              "st": 6792
            },
            "2020": {
              "general": 67381,
              "ews": 11891,
              "obc": 23812,
              "sc": 12949,
              "st": 6647
            }
          }
        },
        "fees": 150000,
        "seats": 99
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 85627,
              "ews": 15344,
              "obc": 30670,
              "sc": 14790,
              "st": 7475
            },
            "2023": {
              "general": 83914,
              "ews": 15037,
              "obc": 30056,
              "sc": 14494,
              "st": 7325
            },
            "2022": {
              "general": 82201,
              "ews": 14730,
              "obc": 29443,
              "sc": 14198,
              "st": 7176
            },
            "2021": {
              "general": 80489,
              "ews": 14423,
              "obc": 28829,
              "sc": 13902,
              "st": 7026
            },
            "2020": {
              "general": 78776,
              "ews": 14116,
              "obc": 28216,
              "sc": 13606,
              "st": 6877
            }
          }
        },
        "fees": 150000,
        "seats": 99
      }
    ]
  },
  {
    "id": 120,
    "name": "University of Hyderabad",
    "type": "GFTI",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 31207,
              "ews": 5859,
              "obc": 13867,
              "sc": 6804,
              "st": 2939
            },
            "2023": {
              "general": 30582,
              "ews": 5741,
              "obc": 13589,
              "sc": 6667,
              "st": 2880
            },
            "2022": {
              "general": 29958,
              "ews": 5624,
              "obc": 13312,
              "sc": 6531,
              "st": 2821
            },
            "2021": {
              "general": 29334,
              "ews": 5507,
              "obc": 13034,
              "sc": 6395,
              "st": 2762
            },
            "2020": {
              "general": 28710,
              "ews": 5390,
              "obc": 12757,
              "sc": 6259,
              "st": 2703
            }
          }
        },
        "fees": 150000,
        "seats": 60
      },
      {
        "name": "Materials Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 65649,
              "ews": 12482,
              "obc": 23228,
              "sc": 12127,
              "st": 5347
            },
            "2023": {
              "general": 64336,
              "ews": 12232,
              "obc": 22763,
              "sc": 11884,
              "st": 5240
            },
            "2022": {
              "general": 63023,
              "ews": 11982,
              "obc": 22298,
              "sc": 11641,
              "st": 5133
            },
            "2021": {
              "general": 61710,
              "ews": 11733,
              "obc": 21834,
              "sc": 11399,
              "st": 5026
            },
            "2020": {
              "general": 60397,
              "ews": 11483,
              "obc": 21369,
              "sc": 11156,
              "st": 4919
            }
          }
        },
        "fees": 150000,
        "seats": 60
      }
    ]
  },
  {
    "id": 121,
    "name": "Visvesvaraya National Institute of Technology, Nagpur",
    "type": "NIT",
    "state": "Unknown",
    "city": "Unknown",
    "branches": [
      {
        "name": "Architecture",
        "code": "A",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 1002,
              "ews": 398,
              "obc": 659,
              "sc": 319,
              "st": 211
            },
            "2023": {
              "general": 981,
              "ews": 390,
              "obc": 645,
              "sc": 312,
              "st": 206
            },
            "2022": {
              "general": 961,
              "ews": 382,
              "obc": 632,
              "sc": 306,
              "st": 202
            },
            "2021": {
              "general": 941,
              "ews": 374,
              "obc": 619,
              "sc": 299,
              "st": 198
            },
            "2020": {
              "general": 921,
              "ews": 366,
              "obc": 606,
              "sc": 293,
              "st": 194
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "Chemical Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 28353,
              "ews": 4845,
              "obc": 10541,
              "sc": 5598,
              "st": 2086
            },
            "2023": {
              "general": 27785,
              "ews": 4748,
              "obc": 10330,
              "sc": 5486,
              "st": 2044
            },
            "2022": {
              "general": 27218,
              "ews": 4651,
              "obc": 10119,
              "sc": 5374,
              "st": 2002
            },
            "2021": {
              "general": 26651,
              "ews": 4554,
              "obc": 9908,
              "sc": 5262,
              "st": 1960
            },
            "2020": {
              "general": 26084,
              "ews": 4457,
              "obc": 9697,
              "sc": 5150,
              "st": 1919
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "Civil Engineering",
        "code": "CE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 34643,
              "ews": 5799,
              "obc": 11819,
              "sc": 5703,
              "st": 1231
            },
            "2023": {
              "general": 33950,
              "ews": 5683,
              "obc": 11582,
              "sc": 5588,
              "st": 1206
            },
            "2022": {
              "general": 33257,
              "ews": 5567,
              "obc": 11346,
              "sc": 5474,
              "st": 1181
            },
            "2021": {
              "general": 32564,
              "ews": 5451,
              "obc": 11109,
              "sc": 5360,
              "st": 1157
            },
            "2020": {
              "general": 31871,
              "ews": 5335,
              "obc": 10873,
              "sc": 5246,
              "st": 1132
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "Computer Science and Engineering",
        "code": "CSE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 5438,
              "ews": 801,
              "obc": 1903,
              "sc": 1610,
              "st": 376
            },
            "2023": {
              "general": 5329,
              "ews": 784,
              "obc": 1864,
              "sc": 1577,
              "st": 368
            },
            "2022": {
              "general": 5220,
              "ews": 768,
              "obc": 1826,
              "sc": 1545,
              "st": 360
            },
            "2021": {
              "general": 5111,
              "ews": 752,
              "obc": 1788,
              "sc": 1513,
              "st": 353
            },
            "2020": {
              "general": 5002,
              "ews": 736,
              "obc": 1750,
              "sc": 1481,
              "st": 345
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "Electrical and Electronics Engineering",
        "code": "EEE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 14199,
              "ews": 2373,
              "obc": 5071,
              "sc": 3393,
              "st": 1092
            },
            "2023": {
              "general": 13915,
              "ews": 2325,
              "obc": 4969,
              "sc": 3325,
              "st": 1070
            },
            "2022": {
              "general": 13631,
              "ews": 2278,
              "obc": 4868,
              "sc": 3257,
              "st": 1048
            },
            "2021": {
              "general": 13347,
              "ews": 2230,
              "obc": 4766,
              "sc": 3189,
              "st": 1026
            },
            "2020": {
              "general": 13063,
              "ews": 2183,
              "obc": 4665,
              "sc": 3121,
              "st": 1004
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "Electronics and Communication Engineering",
        "code": "ECE",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 9297,
              "ews": 1448,
              "obc": 3789,
              "sc": 2469,
              "st": 672
            },
            "2023": {
              "general": 9111,
              "ews": 1419,
              "obc": 3713,
              "sc": 2419,
              "st": 658
            },
            "2022": {
              "general": 8925,
              "ews": 1390,
              "obc": 3637,
              "sc": 2370,
              "st": 645
            },
            "2021": {
              "general": 8739,
              "ews": 1361,
              "obc": 3561,
              "sc": 2320,
              "st": 631
            },
            "2020": {
              "general": 8553,
              "ews": 1332,
              "obc": 3485,
              "sc": 2271,
              "st": 618
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "Mechanical Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 21774,
              "ews": 3616,
              "obc": 8131,
              "sc": 4870,
              "st": 1584
            },
            "2023": {
              "general": 21338,
              "ews": 3543,
              "obc": 7968,
              "sc": 4772,
              "st": 1552
            },
            "2022": {
              "general": 20903,
              "ews": 3471,
              "obc": 7805,
              "sc": 4675,
              "st": 1520
            },
            "2021": {
              "general": 20467,
              "ews": 3399,
              "obc": 7643,
              "sc": 4577,
              "st": 1488
            },
            "2020": {
              "general": 20032,
              "ews": 3326,
              "obc": 7480,
              "sc": 4480,
              "st": 1457
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "Metallurgical and Materials Engineering",
        "code": "MME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 40495,
              "ews": 6764,
              "obc": 13915,
              "sc": 6988,
              "st": 2687
            },
            "2023": {
              "general": 39685,
              "ews": 6628,
              "obc": 13636,
              "sc": 6848,
              "st": 2633
            },
            "2022": {
              "general": 38875,
              "ews": 6493,
              "obc": 13358,
              "sc": 6708,
              "st": 2579
            },
            "2021": {
              "general": 38065,
              "ews": 6358,
              "obc": 13080,
              "sc": 6568,
              "st": 2525
            },
            "2020": {
              "general": 37255,
              "ews": 6222,
              "obc": 12801,
              "sc": 6428,
              "st": 2472
            }
          }
        },
        "fees": 150000,
        "seats": 61
      },
      {
        "name": "Mining Engineering",
        "code": "ME",
        "cutoffs": {
          "jeeMain": {
            "2024": {
              "general": 43375,
              "ews": 7382,
              "obc": 14531,
              "sc": 6568,
              "st": 2833
            },
            "2023": {
              "general": 42507,
              "ews": 7234,
              "obc": 14240,
              "sc": 6436,
              "st": 2776
            },
            "2022": {
              "general": 41640,
              "ews": 7086,
              "obc": 13949,
              "sc": 6305,
              "st": 2719
            },
            "2021": {
              "general": 40772,
              "ews": 6939,
              "obc": 13659,
              "sc": 6173,
              "st": 2663
            },
            "2020": {
              "general": 39905,
              "ews": 6791,
              "obc": 13368,
              "sc": 6042,
              "st": 2606
            }
          }
        },
        "fees": 150000,
        "seats": 61
      }
    ]
  }
];

export const states = [
  "All States",
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Delhi", "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
  "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
  "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan",
  "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh",
  "Uttarakhand", "West Bengal", "Jammu and Kashmir", "Puducherry", "Unknown"
];

export const collegeTypes = ["All Types", "IIT", "NIT", "IIIT", "GFTI", "Private"];

export const branches = [
  "All Branches",
  "Computer Science and Engineering",
  "Electronics and Communication Engineering",
  "Electrical Engineering",
  "Mechanical Engineering",
  "Civil Engineering",
  "Chemical Engineering",
  "Information Technology",
  "Aerospace Engineering",
  "Engineering Physics",
  "Biotechnology",
  "Production Engineering",
  "Metallurgical Engineering"
];

export const categories = ["General", "OBC-NCL", "SC", "ST", "EWS"];

export const examTypes = ["JEE Main", "JEE Advanced"];
